/* eslint-disable no-prototype-builtins */
import axios from "axios";
import moment from "moment";
import $ from "jquery";
import queryString from "query-string";
import { getCreditsByPlanHandler, getUserProfileHandler } from "@redux/User/userDetails.action";
import { getSidebarCountData } from "@redux/Sidebar/sidebarCount.action";
import React, { createContext } from "react";
import { Modal } from "react-bootstrap";
import ReactCountryFlag from "react-country-flag";
import { Info } from "react-feather";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import LoaderImg from "../../../src/assets/images/loader.gif";
import UpgradeIconSmall from "../../../src/assets/images/zap-icon.svg";
import "../../../src/assets/scss/intel.scss";
import IntelLayout from "../../../src/components/layout/layout";
import trackingEventDictionary from "../../../src/core/dictionary/tracking-event";
import { setRedirectionIdsArrayHandler, appliedSelectAllHandler } from "@redux/User/userDetailsSlice";
import { upgradePlansDictionary } from "../../../src/core/dictionary/upgrade-plans";
import { analyticsTypeDictionary as analyticsType, categoryType, CONTINENT_LIST, countryTypeDictionary, crmList, filterTypeDictionary as filterType, globalAPIDictionary as globalApiEndPoints, hsCodeTypeDictionary, matchTypeOptionsDictionary as search_type_options, redirectionCompanyTypeDictionary as redirectionCompanyTypeEnum, redirectionInCountryDictionary as redirectionTypeEnum, requestObjectTypeDictionary as requestObjectType, searchPhraseDictionary, tabHeadingDictionary as tabKeywords, timeFrameOptions, redirectionTypePayload, redirectingProfileEnum, redirectionTypeKey } from "../../../src/core/global/global-country-dictionary";
import { buildFilterTrackingEvent, generateTrackingObject, getBoxFilterList, getDefaultSortValue, getFirstLetterCapital, getHSCodeFilterList, getLocalizeFilterAlternateKeyObject, getLocalizeFilterList, getNormalFilterList, getProximityFilterList, getRadioFilterList, getRangeFilterList, getSliderFilterList, getTeuFilterList, getUpgradeCheckboxFilterList, getWeightFilterList, globalPendoEventForCompanyRedirection, mapFiltersArray, mapMonthObject, mapReloadTeuFiltersArray, mapReloadWeightFiltersArray, mapSearchFromDate, mapSearchToDate, mapTeuFiltersArray, mapWeightFiltersArray, mapYearDatesInCalendar, printValueChecker, categoryNameChecker, commaFormaterFixed, getRedirectProfileType } from "../../../src/core/global/global-country-functions";
import { trademoTrackingEvents } from "../../../src/core/global/trademo-tracking";
import LocalStorageService from "../../../src/core/services/local-storage.service";
import SessionStorageService from "../../../src/core/services/session-storage.service";
import { generateQueryString, getInternationalNumberSystem, getObjectKeyByValue } from "../../../src/core/utility/utility";
import MatchedColumnUs from "../../shared/country-components/matched-column";
import commaFormat from "../../utils/commaFormat";
import FormatDate from "../../utils/formatDate";
import { getIntelUrl } from "../../utils/intelUrl";
import { getPaymentsUrl } from "../../utils/paymentsUrl";
import globalErrorHandling, { getTitleCase, handleUnits, canViewIndiaIec, IEC_GRID_KEYS } from "../../utils/utils";
import ViewAllAnalyticsComponent from "../../shared/analytics-components/view-all-analytics";
import ViewAllTrends from "../../shared/analytics-components/view-all-trends";
import FilterInfoModal from "../../shared/country-components/filterInfoModal";
import HSCodeText from "../../shared/country-components/hs-code-text";
import NudgePopup from "../../shared/country-components/nudgePopup";
import ArrayListField from "../../shared/country-components/array-list-field";
import ShipmentsCompanyName from "../../shared/country-components/shipments-company-name";
import UniqueImporterExporterCompanyName from "../../shared/country-components/unique-importer-exporter-company-name";
import ViewShipment from "../../components/ViewShipments/view-shipments";
import { globalCountryDetailsDictionary } from "../../core/global/global-country-details";
import { CountryCodeOneToOneMap, HIDE_PORT_PROFILE_UPSELL } from "@core/dictionary/global";
import * as Sentry from "@sentry/browser";
import RightPanel from "./components/RightPanel/RightPanel";
import { connect } from "react-redux";
import RedirectProfile from "@shared/country-components/redirect-profile";
import RedirectSampleProfile from "@components/templates/Profile/ProfileLocked/RedirectSampleProfile";
import { appliedFilterHandler, filterObjectHandler, filterLoaderHandler, shipmentsCachingHandler, importerCachingHandler, exporterCachingHandler, analyticsCachingData, resetCachingData, filterMustNotHandler, selectedFilterListHandler, logisticsCachingHandler, searchParametersHandler, dateParametersHandler, planDetailsHandler } from "../../redux/Shipment/shipmentSlice.jsx";
import { secondUIUEStyleHandler, setLevelTwoDatahandler } from "./utils";
import { consigneeFacilityFilter, shipperFacilityFilter } from "@containers/CompanyProfile/utils/enum.js";
import { filterTypeDictionary } from "@core/dictionary/filter-type";
import { getProfileTypeEnum, profileTypeEnum } from "@components/templates/Profile/ProfileHeader/profile-enum";
import AddFavModal from "@shared/AddFavModal";
import { profileType, secondLevelRowsDropdown } from "@utils/enum";
import { timeFrameQuaterly, timeFrameYearly } from "./utils/helper";
import ApplyFilterIcon from "@assets/images/applyFilterIcon.svg";
import { analyticsDashletConfig, selectedAnalyticsDashlet } from "@redux/Analytics/analyticsDashletConfigSlice";
import { globalNudgeObjectPopupData } from "@core/dictionary/intel-nudge";
import PanelTopFilter from "./components/LeftPanel/PanelTopFilter/PanelTopFilter";
import PrimarySearchCard from "@shared/country-components/search-container/primarySearchCard";
import { getApiUrl } from "@utils/baseUrl";
import GetInTouchLimit from "@components/templates/GetInTouchLimit/GetInTouchLimit";
import Supademo from "@routes/intel/onboarding-screens/onboarding/Supademo";
import { handlePatch, toShowOnboarding, updateOnboardingStatus } from "@routes/intel/onboarding-screens/onboarding/utils";
import { LOB_ENUM } from "@routes/intel/ProductOnboarding/utils";
import PostSearchResults from "./components/LeftPanel/PostSearchResults/PostSearchResults";
import RecentSearches from "@containers/SearchHistory/RecentSearch";
import SavedSearches from "@containers/SearchHistory/SaveSearch";
// import { countryDetails } from "@core/dictionary/global";
// import TopSearches from "@containers/SearchHistory/TopSearch";
import { multipleSearchSeparators } from "@containers/SearchHistory/constants";
export const ContextData = createContext({});
// End of the above code

let nudgePopupTimers = {}; // per-key timeout ids, so scheduling one nudge (from any component sharing this method) can't cancel another's pending popup
const clearAllNudgePopupTimers = () => {
  Object.values(nudgePopupTimers).forEach((timer) => clearTimeout(timer));
  nudgePopupTimers = {};
};
const ARRAY_LIST_FIELDS = ["derived_shipper_jurisdiction_country", "derived_shipper_jurisdiction_country_region", "derived_is_exporter"];

class Shipments extends React.Component {
  constructor(props) {
    super(props);
    this.spanRef = React.createRef();
    this.defaultData = props.defaultData;
    this.showUiTrends = this.defaultData.showUiTrends;
    this.showTwoLevel = this.defaultData.showTwoLevel;
    this.analyticDropdownOptions = props.analyticDropdownOptions;
    this.trendsDropdownOptions = props.trendsDropdownOptions;
    this.importer_exporter_graph_sort__options = this.defaultData.importer_exporter_graph_sort__options ? this.defaultData.importer_exporter_graph_sort__options : [];
    this.boxRangeFilterList = props.defaultData.boxRangeFilterList ? { ...props.defaultData.boxRangeFilterList } : {};
    this.mainLabelOptions = props.mainLabelOptions;
    this.localStorageService = LocalStorageService.getService();
    this.sessionStorageService = SessionStorageService.getService();
    this.filterTypeEnum = { ...this.defaultData.filterObj };
    this.filterMapList = [...this.defaultData.normalfilterList];
    this.mapHighLightedColumnList = [...this.defaultData.highLightedColumnList];
    this.emptyFilterTextEnum = { ...this.defaultData.emptyFilterText };
    this.emptyFilterObj = { ...this.defaultData.emptyFilterObj };
    this.searchedFilterDic = { ...this.defaultData.searchedFilter };
    this.selectAllObj = { ...this.defaultData.selectAll };
    this.localisationFilterObj = { ...this.defaultData.localisationFilterObj };
    this.defaultBooleanFilterObject = {
      ...this.defaultData.defaultBooleanFilterObj,
    };
    this.booleanFilterObject = { ...this.defaultData.booleanFilterObj };
    this.searchCardHeaderOptions = [...this.defaultData.searchCategoryList];
    this.specialFields = { ...this.defaultData.specialFields };
    this.upgradePlansDictionary = { ...upgradePlansDictionary };
    this.normalFilterList = getNormalFilterList(this.filterMapList);
    this.hsCodeFilterList = getHSCodeFilterList(this.filterMapList);
    this.radioFilterList = getRadioFilterList(this.filterMapList);
    this.sliderFilterList = getSliderFilterList(this.filterMapList);
    this.localizeFilterList = getLocalizeFilterList(this.filterMapList);
    this.proximityFilterList = getProximityFilterList(this.filterMapList);
    this.boxFilterList = getBoxFilterList(this.filterMapList);
    this.rangeFilterList = getRangeFilterList(this.filterMapList);
    this.weightFilterList = getWeightFilterList(this.filterMapList);
    this.alternateLocaliseFilterObj = getLocalizeFilterAlternateKeyObject(this.filterMapList);
    this.upgradeCheckboxFilterList = getUpgradeCheckboxFilterList(this.filterMapList);
    this.teuFilterList = getTeuFilterList(this.filterMapList);
    this.shipmentDefaultSortValue = getDefaultSortValue(this.defaultData.shipmentSorting);
    this.importerDefaultSortValue = getDefaultSortValue(this.defaultData.importerSorting);
    this.exporterDefaultSortValue = getDefaultSortValue(this.defaultData.exporterSorting);
    this.logisticsDefaultSortValue = getDefaultSortValue(this?.defaultData?.logisticsSorting ?? []);
    this.specialTooltipKeywords = {
      ...this.defaultData.specialTooltipKeywords,
    };
    this.isUIGridNew = this.defaultData.isUIGridNew;
    this.isUEGridNew = this.defaultData.isUEGridNew;
    this.showBolFilter = this.defaultData.showBolFilter;
    this.count = 0;

    this.state = {
      userDetails: {},
      redirectingCompanyImporterId: [],
      redirectingCompanyExporterId: [],
      redirectingCompanyLogisticsId: [],
      redirectingProfileId: [],
      redirectingProfilePartnerId: [],
      redirectingProfileType: null,
      redirectingProfilePartnerType: null,
      redirectingProfileName: "",
      redirectingProfilePartnerName: "",
      searchedItem: "",
      showOnboardingModal: false,
      selectedFilterList: [],
      mouseFilterList: [],
      excludedFilter: {},
      showToolTips: false,
      showUSExportsDataModal: false,
      currentUserPlan: "",
      currentTab: tabKeywords.analytics,
      originalFromDate: null,
      originalEndDate: null,
      filterFromDate: null,
      filterEndDate: null,
      getUserPlanCount: 0,
      isSorting: false,
      latestActualArrivalDate: null,
      paidPlanDateRange: {},
      searchQueryString: "",
      lastProximityCalled: false,
      showZipcodeOverridePopup: false,
      proximityClicked: false, // used to handle default page in proximity search
      proximityApplied: false,
      searchedProximityFilterData: {},
      proximityFilterDetails: {},
      countryType: this.defaultData.countryType,
      categoryName: {},
      // End of the Global Variables
      savedSearchShow: false,
      planId: {},
      intelHeaderDataSource: {},
      loading: false,
      searchPaginationOptions: {
        rowsPerPageText: "Result per page",
        paginationRowsPerPageOptions: [25, 50, 100],
      },
      lastActualArrivalDate: moment("2021-04-01"),
      showSearchLimitModal: false,
      maxsearchCount: null,
      showUpgradeModal: false,
      isReloadSearchClicked: false,
      upgradePopopContent: "",
      allCategoriesSearch: "",
      productSearch: "",
      hsCodeSearch: "",
      shipperSearch: "",
      consigneeSearch: "",
      productSearchLength: 0,
      search_includes: [],
      clearButton: false,
      defaultTrendsData: [],
      analyticsTrends_mustnot_Data: [],
      isTrendsActive: false,
      trendsTab: false,
      currentTimeFrame: timeFrameOptions[0],
      currentExporterFrame: timeFrameOptions[0],
      currentLogisticsFrame: timeFrameOptions[0],
      exporterTrendsTab: false,
      logisticsTrendsTab: false,
      dynamicTrendsData: [],
      impDefaultSort: "teu",
      expDefaultSort: "teu",
      logisticsDefaultSort: "teu",
      tempObj: {},
      searchInclude: false,
      searchKey: this.searchCardHeaderOptions[0].value === searchPhraseDictionary.allCategory ? searchPhraseDictionary.entire_bill_of_lading : searchPhraseDictionary.entire_bill_of_lading,
      searchQueryType: search_type_options[0].value,
      searchTypeStr: "basic",
      sortValue: this.defaultData.customShipmentGrid === true ? null : "date",
      sortOrderValue: "desc",
      size: 59,
      perPage: 25,
      paginationFetchSize: null,
      currentPage: 1,
      dynamicTrendsHeader: [],
      fromAccutalArrivalDate: null,
      toAccutalArrivalDate: null,
      mainFromAccutalArrivalDate: null,
      mainToAccutalArrivalDate: null,
      totalSearchCount: 0,
      isSearchButtonCalled: false,
      finalReqObj: {},
      isTableVisible: false,
      downloadSearchError: false,
      isLoaderActive: false,
      selectedSearchRowData: [],
      prospectShipper: [],
      isFilterApplied: false,
      isFilterClick: false,
      isFilterAppliedStarter: false,
      isSearch: true,
      isRedirect: false,
      reloadSaveSearchData: {},
      showEmailAlertModal: false,
      showDownloadShipmentModal: false,
      isSelectAllButtonCalled: false,
      data: [],
      from: 0,
      prospectExporter: [],
      prospectImporter: [],
      prospectLogistics: [],
      uniqueExportersData: [],
      uniqueImportersData: [],
      uniqueLogisticsData: [],
      selectedExporterRowData: [],
      selectedImporterRowData: [],
      selectedLogisticsRowData: [],
      totalUniqueExporter: 0,
      localTotalUniqueExporter: 0,
      totalUniqueImporter: 0,
      localTotalUniqueImporter: 0,
      totalUniqueLogistics: 0,
      localTotalUniqueLogistics: 0,
      analyticsData: [],
      localSearchData: [],
      localTotalSearchCount: 0,
      zeroCountData: "",
      zeroFilterData: "",
      zeroCountUpgrade: null,
      zeroCountyear: null,
      zeroCountDateRange: [],
      totalUniqueShipper: 0,
      uniqueShipperData: [...[]],
      showSavedSearchModal: false,
      analyticsPresent: false,
      shipmentPresent: false,
      currentPlanAccess: {},
      searchCardParams: {
        searchedItem: "",
        searchInclude: "",
        currentKey: "",
        matchType: "",
      },
      isParentCompany: false,
      parentCompanyNames: [],
      isExcludeBlankShipper: false,
      addToFaV: false,
      showSaveSearchButton: false,
      isSupplierFilter: true,
      isSupplierFilterFlag: true,
      mustNotIncludeExporter: [],
      mustNotIncludeImporter: [],
      mustNotIncludeLogistics: [],
      importerMongoIds: [],
      exporterMongoIds: [],
      exporterSortOrderValue: "desc",
      exporterSortValue: this.exporterDefaultSortValue.value,
      importerSortOrderValue: "desc",
      importerSortValue: this.importerDefaultSortValue.value,
      logisticsSortOrderValue: "desc",
      logisticsSortValue: this.logisticsDefaultSortValue.value,
      internalSortOrder: "",
      exporterCurrentPage: 1,
      importerCurrentPage: 1,
      logisticsCurrentPage: 1,
      uniqueExporterpaginationOptions: {
        rowsPerPageText: "Result per page",
        paginationRowsPerPageOptions: [25, 50, 100],
      },
      uniqueImporterpaginationOptions: {
        rowsPerPageText: "Result per page",
        paginationRowsPerPageOptions: [25, 50, 100],
      },
      uniqueLogisticspaginationOptions: {
        rowsPerPageText: "Result per page",
        paginationRowsPerPageOptions: [25, 50, 100],
      },
      exporterPerPage: 25,
      importerPerPage: 25,
      logisticsPerPage: 25,
      rangeUniqueContainerChanged: false,
      minNoOfUniqueContainer: null,
      maxNoOfUniqueContainer: null,
      updatedMinNoOfUniqueContainer: null,
      updatedMaxNoOfUniqueContainer: null,
      searchedFilter: { ...this.searchedFilterDic },
      filterObj: { ...this.emptyFilterObj },
      mainFilterObject: { ...this.emptyFilterObj },
      searchStateFilterObj: { ...this.emptyFilterObj },
      searchedStateFilterObject: { ...this.emptyFilterObj },
      appliedStateFilterObject: { ...this.emptyFilterObj },
      appliedBooleanFilterObject: { ...this.defaultBooleanFilterObject },
      selecetedBooleanFilterObject: { ...this.defaultBooleanFilterObject },
      appliedBoxFilterObj: { ...this.defaultData.boxFilterObj },
      selectedBoxFilterObj: { ...this.defaultData.boxFilterObj },
      defaultBoxFilterObj: { ...this.defaultData.boxFilterObj },
      selectedFilterObject: { ...this.emptyFilterObj },
      selectedFilterLabelObject: { ...this.emptyFilterObj },
      selectAllObj: { ...this.selectAllObj },
      selectedsearchHSCode: [],
      selectedsearchProductKeyword: [],
      selectedsearchCompany: [],
      selectedsearchCompanyConsignee: [],
      selectAllDownloadFromPopup: false,
      viewAllAnalyticsFlag: true,
      viewAllFinalSearchReqObj: {},
      isEmailShipments: false,
      minValue: null,
      maxValue: null,
      minWeight: null,
      maxWeight: null,
      updatedminValue: null,
      updatedmaxValue: null,
      updatedminWeight: null,
      updatedmaxWeight: null,
      valueChanged: false,
      weightChanged: false,
      existingUniqueImpExpReqObj: {},
      isImporterTableVisible: true,
      isExporterTableVisible: true,
      isLogisticsTableVisible: true,
      isTrademoAccount: false,
      viewAllTrends: false,
      expTempObj: {},
      logisticsTempObj: {},
      currentKeyViewTrendItem: [],
      importer_exporter_graph_sort__options: this.importer_exporter_graph_sort__options,
      searchTableColumns: [],
      exporterTableColumn: [],
      importerTableColumn: [],
      logisticsTableColumn: [],
      istableLoader: false,
      isMerged: false,
      mergedId: "",
      defaultUiUeTwoLevelSelctedHeading: this.defaultData.defaultUeUiSecondLevelKey,
      defaultUlTwoLevelSelectedHeading: this.defaultData.defaultSecondLevelLogisticsTabKey,
      showDropdown: false,
      ueTwoLevel: false,
      uiTwoLevel: false,
      ulTwoLevel: false,
      defaultPage: 1,
      viewAllPerPage: 10,
      dataCount: 0,
      setPagination: "",
      secondLevelData: [],
      secondLevelCurrrentpage: 1,
      showPopup: false,
      isSubsidiaryIncluded: false,
      isSubs: false,
      selectedRows: [],
      defaultLoad: true,
      analyticsLoader: false,
      newLoader: false,
      userFirstPlan: {},
      nudgePopupStateObj: { ...globalNudgeObjectPopupData },
      showNudgePopup: false,
      currentNudgePopupKey: null,
      upgradeText: "",
      showInfoModal: false,
      modalFilterContent: {},
      hsCodeList: [],
      dataList: [],
      count: 0,
      showMultiCountryTopNudge: false,
      redirectionHsCodeValue: "",
      includeFilter: [],
      excludeFilter: [],
      country: "",
      showMergePopUp: false,
      showExportOptions: false,
      isSalesforceUser: this.localStorageService.getUserDetails().is_salesforce_active !== null && this.localStorageService.getUserDetails().is_salesforce_active !== undefined ? this.localStorageService.getUserDetails().is_salesforce_active : false,
      isHubspotUser: this.localStorageService.getUserDetails().is_hubspot_active !== null && this.localStorageService.getUserDetails().is_hubspot_active !== undefined ? this.localStorageService.getUserDetails().is_hubspot_active : false,
      isZohoUser: this.localStorageService.getUserDetails().is_zoho_active !== null && this.localStorageService.getUserDetails().is_zoho_active !== undefined ? this.localStorageService.getUserDetails().is_zoho_active : false,
      customShipmentGridConfigurationList: {},
      customShipmentGridSelectedList: null,
      isReloadFromDashboard: false,
      showNotification: false,
      selectedTab: "",
      selectAllChecked: false,
      analysisKey: null,
      isSideBarOpen: false,
      showMoreOptions: false,
      showCrmNudgePopup: false,
      showCrmPopuList: false,
      dataSourceOption: [],
      showHeaderDropdown: false,
      currentProduct: "",
      userProductAccess: [],
      appliedContinentList: CONTINENT_LIST,
      selectAllCheck: false,
      options: {},
      appliedOptions: {},
      continentList: CONTINENT_LIST,
      selectedDataSet: [],
      type: "shipments",
      customShipmentGridSelectedListBol: null,
      customShipmentGridConfigurationListBol: {},
      defaultType: "shipments",
      isShipmentLoader: false,
      totalCustomShipments: 0,
      customTypeLoader: false,
      isZeroDataSource: true,
      countryCount: 0,
      filterData: {},
      showDataSource: false,
      userInfo: {},
      newIntelLoader: false,
      reloadRecentData: {},
      isReloadRecentSearchClicked: false,
      twoLevelLoader: false,
      lastRequestType: null,
      mainFilterDataList: {},
      filterLabelOnHover: null,
      existingSearchReqObj: {},
      inflectionWordList: [],
      profileId: "",
      analytcisSelectedRows: [],
      showFavModal: false,
      showReloadLastSearch: false,
      lastLogoutDetails: {},
      derivedConsigneeMasterNameAndIdMapping: [],
      derivedShipperMasterNameAndIdMapping: [],
      secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
      zeroCountDataObj: {},
      redirectionIdFromAutoSuggest: {},
      redirectionTypeKey: "",
      dynamicImporterTrendsData: [],
      dynamicExporterTrendsData: [],
      dynamicLogisticsTrendsData: [],
      isDateChanged: false,
      showGetInTouch: false,
      currOnboardingObj: "how_to_search",
      onboardingInitiator: "landing",
      onboardingData: {},
      isIntFilterApplied: false,
      isClickedPostSearchSugg: false,
      gettingPostSearchResults: false,
      recentSearchData: [],
      searchHistoryData: {},
      isSearchHistoryLoading: true,
    };
  }
  // Below Method is used at the time of mounting the component
  componentDidMount() {
    try {
      // onboardingData/nudge-eligibility used to be resolved inside the getSearchResult response
      // handler, which only ran when an initial search auto-fired on landing. That auto-search
      // was removed in favor of the Recent/Saved Searches default view, so resolve both here
      // instead, independent of whether the user performs a search.
      this.getOnboardingDetails();
      this.getShowOnboarding();
      const searchUrlParams = this.props.location.search;
      let importer = new URLSearchParams(searchUrlParams).get("toImporter");
      let exporter = new URLSearchParams(searchUrlParams).get("toExporter");
      let analysis = new URLSearchParams(searchUrlParams).get("toAnalytics");
      localStorage.setItem("reset", "false");

      if (new URLSearchParams(searchUrlParams).get("isReload")) {
        this.setState({
          isReloadFromDashboard: true,
        });
      }
      this.mapSearchTableColumn();
      this.setState({
        searchQueryString: searchUrlParams,
        categoryName: categoryNameChecker(this.filterMapList, this.defaultData.countryType),
        isIntFilterApplied: (!!this.state.uniqueImportExporterShipment && this.state.uniqueImportExporterShipment.length > 0) || (!!this.state.uniqueImportExporterWeight && this.state.uniqueImportExporterWeight.length > 0) || (!!this.state.uniqueImportExporterTeu && this.state.uniqueImportExporterTeu.length > 0) || (!!this.state.uniqueImportExporterValue && this.state.uniqueImportExporterValue.length > 0) ? true : false,
      });
      if (new URLSearchParams(searchUrlParams).get("companyImporterId")) {
        this.setState({
          excludedFilter: {
            [this.specialFields.consignee]: true,
          },
        });
      }
      if (new URLSearchParams(searchUrlParams).get("isSubsidiaryIncluded")) {
        setTimeout(() => {
          this.setState({
            isSubsidiaryIncluded: new URLSearchParams(searchUrlParams).get("isSubsidiaryIncluded") === "true" ? true : false,
            isSubs: new URLSearchParams(searchUrlParams).get("isSubsidiaryIncluded") === "true" ? true : false,
          });
        }, 50);
      }
      if (new URLSearchParams(searchUrlParams).get("companyExporterId")) {
        this.setState({
          excludedFilter: {
            [this.specialFields.shipper]: true,
          },
        });
      }
      this.setState({
        currentTab: importer === "true" ? tabKeywords.importers : exporter === "true" ? tabKeywords.exporters : analysis === "true" ? tabKeywords.analytics : tabKeywords.analytics,
      });
      this.fillDataHandler(this.filterMapList && this.filterMapList[0] && this.filterMapList[0].categoryName ? this.filterMapList[0].categoryName : "", "defaultData");
      if (new URLSearchParams(searchUrlParams).get("redirectingFrom") === "port" || new URLSearchParams(searchUrlParams).get("redirectingFrom") === "logistics" || new URLSearchParams(searchUrlParams).get("redirectingFrom") === "company" || new URLSearchParams(searchUrlParams).get("redirectingFrom") === "company-profile" || new URLSearchParams(searchUrlParams).get("redirectingFrom") === profileTypeEnum.tradeLanes) {
        let isMerged = new URLSearchParams(this.props.location.search).get("isMerged");
        let mergedId = new URLSearchParams(this.props.location.search).get("mergedID");
        if (new URLSearchParams(this.props.location.search).get("redirectingProfile") === "consignee") {
          this.setState({
            redirectionCompanyType: redirectionCompanyTypeEnum.importer.value,
          });
        } else {
          this.setState({
            redirectionCompanyType: redirectionCompanyTypeEnum.exporter.value,
          });
        }
        if (this.defaultData?.showFacilityFilter && new URLSearchParams(searchUrlParams).get("redirectingFrom") === "company") {
          if (new URLSearchParams(this.props.location.search).get("redirectingProfile") === "consignee") {
            let proximityFilterIndex = this.filterMapList.findIndex((filterType) => filterType.type === filterTypeDictionary.proximityFilter);
            if (proximityFilterIndex > -1) {
              this.filterMapList.splice(proximityFilterIndex + 1, 0, consigneeFacilityFilter);
            } else {
              this.filterMapList.push(consigneeFacilityFilter);
            }
            this.setState({
              redirectionCompanyType: redirectionCompanyTypeEnum.importer.value,
            });
          }
          if (new URLSearchParams(this.props.location.search).get("redirectingProfile") === "shipper") {
            let proximityFilterIndex = this.filterMapList.findIndex((filterType) => filterType.type === filterTypeDictionary.proximityFilter);
            if (proximityFilterIndex > -1) {
              this.filterMapList.splice(proximityFilterIndex + 1, 0, shipperFacilityFilter);
            } else {
              this.filterMapList.push(shipperFacilityFilter);
            }
            this.setState({
              redirectionCompanyType: redirectionCompanyTypeEnum.exporter.value,
            });
          }
        }
        let redirectingProfileId = "";
        let redirectingProfilePartnerId = "";
        if (new URLSearchParams(searchUrlParams).get("redirectingProfileIds")) {
          redirectingProfileId = new URLSearchParams(searchUrlParams).get("redirectingProfileIds");
        }
        if (new URLSearchParams(searchUrlParams).get("redirectingProfilePartnerIds")) {
          redirectingProfilePartnerId = new URLSearchParams(searchUrlParams).get("redirectingProfilePartnerIds");
        }
        this.setState({
          redirectingProfileId: redirectingProfileId ? (redirectingProfileId.includes("$$$") ? redirectingProfileId.split("$$$") : [redirectingProfileId]) : [],
          redirectingProfilePartnerId: redirectingProfilePartnerId ? [redirectingProfilePartnerId] : [],
          redirectingProfileType: this.specialFields[new URLSearchParams(searchUrlParams).get("redirectingProfile")],
          redirectingProfilePartnerType: this.specialFields[new URLSearchParams(searchUrlParams).get("redirectingProfilePartner")],
          redirectingProfileName: new URLSearchParams(searchUrlParams).get("profileName"),
          redirectionType: new URLSearchParams(searchUrlParams).get("redirectingFrom"),
          currentTab: tabKeywords.shipments,
          isRedirect: true,
          isMerged: isMerged === "true",
          mergedId: mergedId,
        });
      } else if (new URLSearchParams(searchUrlParams).get("comingFrom") === redirectionTypeEnum.email) {
        let id = new URLSearchParams(searchUrlParams).get("id");
        let fromDate = new URLSearchParams(searchUrlParams).get("fromDate");
        let toDate = new URLSearchParams(searchUrlParams).get("toDate");
        let isAdd = false;
        let importer = new URLSearchParams(searchUrlParams).get("toImporter");
        let exporter = new URLSearchParams(searchUrlParams).get("toExporter");
        let analysis = new URLSearchParams(searchUrlParams).get("toAnalytics");
        if (moment().utcOffset() >= 0) {
          isAdd = false;
        } else {
          isAdd = true;
        }
        this.setState({
          fromAccutalArrivalDate: fromDate,
          toAccutalArrivalDate: toDate,
          latestActualArrivalDate: toDate,
          is_from_alert: true,

          currentTab: importer === "true" ? tabKeywords.importers : exporter === "true" ? tabKeywords.exporters : analysis === "true" ? tabKeywords.analytics : tabKeywords.shipments,
          paidPlanDateRange: mapYearDatesInCalendar(isAdd, toDate, this.defaultData.countryType.toLowerCase() === countryTypeDictionary.export.toLowerCase() ? this.state.userCredit?.export_start_date : this.state.userCredit?.import_start_date),
        });
        if (this.defaultData && this.defaultData.picker && this.defaultData.picker.monthPicker) {
          this.setState({
            monthObject: mapMonthObject(toDate, !!this && !!this.state && !!this.state.userCredit && !!this.state.userCredit.searchFromDate && this.state.userCredit.searchFromDate !== "" ? this.state.userCredit.searchFromDate : !!this.state.userCredit && !!this.state.userCredit.searchFromDateExports ? this.state.userCredit.searchFromDateExports : fromDate && fromDate !== "" ? fromDate : "2021-01"),
          });
        }

        this.getSavedSearchFromEmail(id);
      } else if (new URLSearchParams(searchUrlParams).get("redirectingFrom") === redirectionTypeEnum.itemNumber) {
        this.setState({
          redirectingItemNumber: new URLSearchParams(searchUrlParams).get("itemNumber"),
          redirectingItemNumberId: new URLSearchParams(searchUrlParams).get("itemNumberId"),
          redirectionType: redirectionTypeEnum.itemNumber,
          currentTab: tabKeywords.shipments,
          isRedirect: true,
        });
      } else if (new URLSearchParams(searchUrlParams).get("redirectingFrom") === redirectionTypeEnum.hsCodeProfile) {
        this.setState({
          redirectionHsCodeValue: new URLSearchParams(searchUrlParams).get("hsCode"),
          isRedirect: true,
          redirectionType: redirectionTypeEnum.hsCodeProfile,
        });
      }
      // trigger for Reduction function
      this.getUserPlanDetails();
      this.props.appliedFilterHandler({ ...this.emptyFilterObj });
      this.props.filterObjectHandler({ ...this.emptyFilterObj });
      this.props.selectedFilterListHandler({});
      this.props.appliedSelectAllDataSource({ import: false, export: false });
      this.getRecentSearches();
    } catch (err) {
      Sentry.captureException(err);
    }
  }

  getOnboardingDetails = async () => {
    const response = await axios.get(getApiUrl("user_profile_details/"));
    const onboardingData = response.data.data;
    localStorage.setItem("onboarding", JSON.stringify(onboardingData));
    this.setState({
      onboardingData: JSON.parse(localStorage.getItem("onboarding")),
    });
  };

  getShowOnboarding = async () => {
    const res = await toShowOnboarding();
    this.setState({
      showOnboardingModal: res,
    });
    if (!res) {
      this.handleNudgePopup("hs_classifier", "event");
      this.handleNudgePopup("compare_tariff", "event");
      if (!this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter")) this.handleNudgePopup("company_search", "event");
      if (this.isIntelHubNudgeEligible()) this.handleNudgePopup("intel_hub", "event");
      this.handleNudgePopup("product_search", "event");
      this.handleNudgePopup("hermes_chat", "event");
    }
    return res;
  };

  isIntelHubNudgeEligible = () => {
    const lob = this.props.userDetails?.userData?.line_of_business;
    return lob === LOB_ENUM.BUSINESS_DEVELOPMENT || lob === LOB_ENUM.EXPORT || lob === LOB_ENUM.IMPORT || lob === LOB_ENUM.EXPORT_AND_IMPORT;
  };

  getFilterDataHandler = async () => {
    const searchUrlParams = this.props.location.search;
    let appliedFiltersClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.appliedFilter));
    let filterObjectClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.filterObject));
    try {
      if (new URLSearchParams(searchUrlParams).get("redirectingFrom") === redirectionTypeEnum.companyProfile || new URLSearchParams(searchUrlParams).get("redirectingFrom") === "port" || new URLSearchParams(searchUrlParams).get("redirectingFrom") === "logistics" || this.state.isChemicalPresent || new URLSearchParams(searchUrlParams).get("redirectingFrom") === profileTypeEnum.tradeLanes || new URLSearchParams(searchUrlParams).get("redirectingFrom") === "company") {
        let searchRequestObj = {};
        if (!this.state.isReloadSearchClicked) {
          searchRequestObj = {
            ...JSON.parse(JSON.stringify(this.state.existingSearchReqObj)),
            companyImporterId: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectingCompanyImporterId ? this.state.redirectingCompanyImporterId : [],
            companyExporterId: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectingCompanyExporterId ? this.state.redirectingCompanyExporterId : [],
            companyLogisticsId: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectingCompanyLogisticsId ? this.state.redirectingCompanyLogisticsId : [],
            redirectingProfile: this.state.isRedirect && new URLSearchParams(this.props.location.search).get("redirectingProfile") ? redirectionTypePayload[new URLSearchParams(this.props.location.search).get("redirectingProfile")] : "",
            redirectingProfilePartner: this.state.isRedirect && new URLSearchParams(this.props.location.search).get("redirectingProfilePartner") ? redirectionTypePayload[new URLSearchParams(this.props.location.search).get("redirectingProfilePartner")] : "",
            redirectingProfileIds: this.state.isRedirect && this.state.redirectingProfileId ? this.state.redirectingProfileId : [],
            redirectingProfilePartnerIds: this.state.isRedirect && this.state.redirectingProfilePartnerId ? this.state.redirectingProfilePartnerId : [],
          };
        } else {
          searchRequestObj = {
            ...JSON.parse(JSON.stringify(this.state.existingSearchReqObj)),
            redirectingProfile: new URLSearchParams(this.props.location.search).get("redirectingProfile") ? redirectionTypePayload[new URLSearchParams(this.props.location.search).get("redirectingProfile")] : "",
          };
        }
        this.setState({
          isFilterApplied: true,
        });
        searchRequestObj.isFilterDataIncludes = true;
        searchRequestObj.companyType = "";
        searchRequestObj.is_from_autosuggest = this.state.isSelectedFromAutoSuggest ? true : false;
        searchRequestObj.redirection_profile_id = this.state.redirectionIdFromAutoSuggest[this.state.searchedItem];
        let res = await axios.post(this.defaultData.apiEndPoints.getSearchResult, searchRequestObj);
        if (res?.data?.dataset_modification_info && res?.data?.dataset_modification_info?.is_date_conflict) {
          this.getUserPlanDetails();
        }
        if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyExporterId && this.state.redirectingCompanyExporterId.length && this.filterTypeEnum[this.specialFields.shipper] && res.data[this.specialFields.shipper]) {
          appliedFiltersClone[this.filterTypeEnum[this.specialFields.shipper]] = res.data[this.specialFields.shipper].map((filter) => filter.key);
          filterObjectClone[this.filterTypeEnum[this.specialFields.shipper]] = res.data[this.specialFields.shipper];
        }
        if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyImporterId && this.state.redirectingCompanyImporterId.length && this.filterTypeEnum[this.specialFields.consignee] && res.data[this.specialFields.consignee]) {
          appliedFiltersClone[this.filterTypeEnum[this.specialFields.consignee]] = res.data[this.specialFields.consignee].map((filter) => filter.key);
          filterObjectClone[this.filterTypeEnum[this.specialFields.consignee]] = res.data[this.specialFields.consignee];
        }
        if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyLogisticsId && this.state.redirectingCompanyLogisticsId.length && this.filterTypeEnum[this.specialFields.logistic] && res.data[this.specialFields.logistic]) {
          appliedFiltersClone[this.filterTypeEnum[this.specialFields.logistic]] = res.data[this.specialFields.logistic].map((filter) => filter.key);
          filterObjectClone[this.filterTypeEnum[this.specialFields.logistic]] = res.data[this.specialFields.logistic];
        }
        if (this.state.isChemicalPresent && res.data.applied_filters) {
          appliedFiltersClone[this.filterTypeEnum[this.specialFields.productCategory]] = ["Chemicals, Pharma and Allied Industries"];
        }
        // else {
        //   appliedFiltersClone[this.filterTypeEnum[this.specialFields.sections]] = [];
        // }
        if (this.state.redirectingProfileType && res.data[this.state.redirectingProfileType]) {
          if (this.localisationFilterObj[this.state.redirectingProfileType]) {
            appliedFiltersClone[this.localisationFilterObj[this.state.redirectingProfileType]] = [];
            appliedFiltersClone[this.state.redirectingProfileType] = res.data[this.state.redirectingProfileType].map((filter) => filter.region.map((region) => region.key)).flat();
            filterObjectClone[this.state.redirectingProfileType] = res.data[this.state.redirectingProfileType];
          } else {
            appliedFiltersClone[this.state.redirectingProfileType] = res.data[this.state.redirectingProfileType].map((filter) => filter.key);
            filterObjectClone[this.state.redirectingProfileType] = res.data[this.state.redirectingProfileType];
          }
        }
        if (this.state.redirectingProfilePartnerType && res.data[this.state.redirectingProfilePartnerType]) {
          if (this.localisationFilterObj[this.state.redirectingProfilePartnerType]) {
            appliedFiltersClone[this.localisationFilterObj[this.state.redirectingProfilePartnerType]] = [];
            appliedFiltersClone[this.state.redirectingProfilePartnerType] = res.data[this.state.redirectingProfilePartnerType].map((filter) => filter.region.map((region) => region.key)).flat();
            filterObjectClone[this.state.redirectingProfilePartnerType] = res.data[this.state.redirectingProfilePartnerType];
          } else {
            appliedFiltersClone[this.state.redirectingProfilePartnerType] = res.data[this.state.redirectingProfilePartnerType].map((filter) => filter.key);
            filterObjectClone[this.state.redirectingProfilePartnerType] = res.data[this.state.redirectingProfilePartnerType];
          }
        }
        this.props.appliedFilterHandler(appliedFiltersClone);
        this.props.filterObjectHandler(filterObjectClone);
      }
      // else {
      //   appliedFiltersClone[this.filterTypeEnum[this.specialFields.sections]] = [];
      //   this.props.appliedFilterHandler(appliedFiltersClone);
      // }
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      // dispatch(filterLoaderHandler(false));
    }
  };

  settingSearchButtonClicked = (val) => {
    this.setState({
      isSearchButtonCalled: val,
    });
  };
  // End of the Above Code
  // below function is used to store Nudge popup status coming from BE during mounting
  callNudgeStatus = (isUpdated = false) => {
    let nudgeCacheStates = JSON.parse(localStorage.getItem("nudgeCache"));
    if (!isUpdated && nudgeCacheStates && Object.keys(nudgeCacheStates).length > 0) {
      const cachedData = JSON.parse(JSON.stringify(nudgeCacheStates));
      this.setState({ nudgePopupStateObj: cachedData });
      return;
    }
    //the below condition is for making api call when no cache is present
    axios
      .get(globalApiEndPoints.featureNudge + `?plan_id=${this.state.currentUserPlan}`)
      .then((res) => {
        if (res.data && Array.isArray(res.data) && res.data.length) {
          let tempObj = JSON.parse(JSON.stringify(this.state.nudgePopupStateObj));
          res.data.forEach((item) => {
            if (item.feature && this.state && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(item.feature) && item.feature !== (tempObj.renewal_banner?.key || "")) {
              if (!tempObj[item.feature]) {
                tempObj[item.feature] = {};
              }
              tempObj[item.feature].shouldPop = item.should_pop !== undefined ? item.should_pop : false;
              tempObj[item.feature].header = item.text?.header || "";
              tempObj[item.feature].headerOnTop = item.text?.headerOnTop || false;
              tempObj[item.feature].description = item.text?.sub || "";
              tempObj[item.feature].countries = item.countries || "";
              tempObj[item.feature].subText1 = item.text?.subText1 || "";
              tempObj[item.feature].subheaders = item.text?.subheaders || "";
              tempObj[item.feature].highlightedText = item.text?.highlightedText || "";
            }
            if (item.feature === (tempObj.renewal_banner?.key || "") && item.priority === 1) {
              if (!tempObj[item.feature]) {
                tempObj[item.feature] = {};
              }
              tempObj[item.feature].shouldPop = item.should_pop !== undefined ? item.should_pop : false;
              tempObj[item.feature].header = item.text?.header || "";
              tempObj[item.feature].headerOnTop = item.text?.headerOnTop || false;
              tempObj[item.feature].description = item.text?.sub || "";
              tempObj[item.feature].planId = this.state.currentUserPlan;
              tempObj[item.feature].subText1 = item.text?.subText1 || "";
              tempObj[item.feature].subheaders = item.text?.subheaders || "";
              tempObj[item.feature].highlightedText = item.text?.highlightedText || "";
              tempObj[item.feature].countries = item.countries || "";
            }
          });
          this.setState({ nudgePopupStateObj: tempObj }, () => {
            if (isUpdated) {
              this.handleNudgePopup("hermes_chat", "event");
            }
          });
          localStorage.setItem("nudgeCache", JSON.stringify(tempObj));
        }
      })
      .catch(() => {
        toast.error("Something went wrong, Please try after sometime !!!");
      });
  };
  // end of above code
  // below function is handling nudge popup operations
  handleNudgePopup = (key, callingFrom, event, isPoped) => {
    if (!key) return;
    if (callingFrom && callingFrom === "event") {
      // checking if function called from pre render event
      if (nudgePopupTimers[key]) {
        clearTimeout(nudgePopupTimers[key]);
      }
      nudgePopupTimers[key] = setTimeout(() => {
        if (key === "saved_search" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false && this.state.isLoaderActive === false && !(!!this.state.redirectingCompanyName && this.state.redirectingCompanyName !== "") && ((!!this.props.shipmentDetails.appliedFilter && this.checkforFilters(this.props.shipmentDetails.appliedFilter)) || (!!this.state.searchedItem && this.state.searchedItem !== ""))) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "notification_center" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "all_app" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "glossary" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "second_level" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false && (this.state.isImporterTableVisible === false || this.state.trendsTab === true || this.defaultData.showUiUeLevelTwo || this.state.isExporterTableVisible === false || this.state.exporterTrendsTab === true || this.state.logisticsTrendsTab === true || this.state.isLogisticsTableVisible === false || this.defaultData.showUiUeLevelTwo) && !!this.props.shipmentDetails.appliedFilter && this.checkforFilters(this.props.shipmentDetails.appliedFilter)) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "intel_controls" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false && (this.state.isImporterTableVisible === false || this.state.trendsTab === true || this.defaultData.showUiUeLevelTwo || this.state.isExporterTableVisible === false || this.state.exporterTrendsTab === true || this.state.logisticsTrendsTab === true || this.state.isLogisticsTableVisible === false || this.defaultData.showUiUeLevelTwo) && !!this.props.shipmentDetails.appliedFilter && this.checkforFilters(this.props.shipmentDetails.appliedFilter)) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: false,
          });
        } else if (key === "crm" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showCrmNudgePopup: true,
          });
        } else if (key === "new_credit_system" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "hs_classifier" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "compare_tariff" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "company_search" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "intel_hub" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "product_search" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        } else if (key === "hermes_chat" && this.state.currentNudgePopupKey === null && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key) && this.state.nudgePopupStateObj[key].shouldPop === true && this.state.showNudgePopup === false) {
          this.setState({
            currentNudgePopupKey: key,
            showNudgePopup: true,
          });
        }
      }, this.state.nudgePopupStateObj[key]?.timer ?? 4000);
    } else if (callingFrom && callingFrom === "popup") {
      // checking if function called from post popup render event
      axios.get(globalApiEndPoints.featureNudgeUpdate + `?is_popped=${isPoped !== undefined ? isPoped : true}&feature_name=${key}`);
      this.setState({
        showNudgePopup: false,
      });
      let tempObj = JSON.parse(JSON.stringify(this.state.nudgePopupStateObj));
      if (this.state && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(key)) {
        tempObj[key]["shouldPop"] = false;
      }
      localStorage.setItem("nudgeCache", JSON.stringify(tempObj));

      this.setState({ nudgePopupStateObj: { ...tempObj } });
      if (event && event === "apply") {
        // checking if user wants to move to next step from popup
        if (key === "saved_search") {
          this.setState({ savedSearchShow: true });
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeSaveSearchContinueSaveSearch);
        } else if (key === "notification_center") {
          setTimeout(() => {
            this.setState({
              showNotification: true,
            });
          }, 500);
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeNotificationCentreViewNotification);
        } else if (key === "all_app") {
          let el = document.getElementById("header-product-linking");
          let el2 = document.getElementById("all-app");
          el.classList.add("show");
          el2.classList.add("show");
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeProductNavigationShow);
        } else if (key === "second_level") {
          if (this.state.currentTab === tabKeywords.importers) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeUniqueImporter2ndLevelAnalyticsEnable);
            this.setState({
              isLoaderActive: true,
              importerPerPage: 25,
              uiTwoLevel: true,
              defaultPage: 1,
              defaultTrendsData: [],
              selectedRows: [],
              showDropdown: false,
              secondLevelData: [],
              importerToggleRows: !this.state.importerToggleRows,
              prospectImporter: [],
              importerCurrentPage: 1,
            });
            setTimeout(() => {
              this.setState({
                importerToggleRows: false,
              });
              this.getUniqueImporterData(requestObjectType.importers);
            }, 100);
          } else if (this.state.currentTab === tabKeywords.exporters) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeUniqueExporter2ndLevelAnalyticsEnable);
            this.setState({
              isLoaderActive: true,
              exporterPerPage: 25,
              ueTwoLevel: true,
              defaultPage: 1,
              defaultTrendsData: [],
              selectedRows: [],
              showDropdown: false,
              secondLevelData: [],
              exporterToggleRows: !this.state.exporterToggleRows,
              prospectExporter: [],
              exporterCurrentPage: 1,
            });
            setTimeout(() => {
              this.setState({
                exporterToggleRows: false,
              });
              this.getUniqueExporterData(requestObjectType.exporters);
            }, 100);
          } else if (this.state.currentTab === tabKeywords.logistics) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeUniqueLogistics2ndLevelAnalyticsEnable);
            this.setState({
              isLoaderActive: true,
              logisticsPerPage: 25,
              ulTwoLevel: true,
              defaultPage: 1,
              defaultTrendsData: [],
              selectedRows: [],
              showDropdown: false,
              secondLevelData: [],
              logisticsToggleRows: !this.state.logisticsToggleRows,
              prospectLogistics: [],
              logisticsCurrentPage: 1,
            });
            setTimeout(() => {
              this.setState({
                logisticsToggleRows: false,
              });
              this.getUniqueLogisticsData(requestObjectType.logistics);
            }, 100);
          }
        } else if (key === "new_credit_system") {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.newCreditPoolNudgeLearnMore);
          window.open("/help-center?target=faqs", "_blank");
        } else if (key === "hs_classifier") {
          window.location.href = "/hs-classifier";
        } else if (key === "compare_tariff") {
          window.location.href = "/compare-tariff";
        } else if (key === "company_search") {
          window.location.href = `/company-search?country=${this.defaultData.country_small ?? this.defaultData.countryShortHand}&type=${this.defaultData.countryType}`;
        } else if (key === "intel_hub") {
          window.location.href = "/ai-recommendations";
        } else if (key === "hermes_chat") {
          window.location.href = `/hermes-chat?country=${this.defaultData.country_small ?? this.defaultData.countryShortHand}&type=${this.defaultData.countryType}`;
        } else if (key === "product_search") {
          window.location.href = "/product-search";
        }
        this.setState({ currentNudgePopupKey: null });
      } else if (event && event === "close") {
        // checking if user wants to close the popup
        if (key === "saved_search") {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeSaveSearchRemindmeLater);
        } else if (key === "notification_center") {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeNotificationCentreClose);
        } else if (key === "second_level") {
          if (this.state.currentTab === tabKeywords.importers) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeUniqueImporter2ndLevelAnalyticsClose);
          } else if (this.state.currentTab === tabKeywords.exporters) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeUniqueExporter2ndLevelAnalyticsClose);
          } else if (this.state.currentTab === tabKeywords.logistics) {
            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeUniqueLogistics2ndLevelAnalyticsClose);
          }
        } else if (key === "crm") {
          // this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeNotificationCentreClose);
        } else if (key === "all_app") {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.featureNudgeProductNavigationClose);
        } else if (key === "new_credit_system") {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.newCreditPoolNudgeClose);
        }
        this.setState({ currentNudgePopupKey: null });
      }
    }
  };
  // end of above code
  onboardingPopupClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    this.setState({
      showOnboardingModal: false,
    });
    updateOnboardingStatus("show_onboarding_steps", false);
  };

  getTourState = (val) => {
    if (!val) {
      this.setState({
        showToolTips: true,
      });
    } else {
      this.setState({
        showToolTips: false,
      });
    }
  };

  // to handle apply and reset configuration change of shipment grid
  applyCustomShipmentGrid = (data, isReset, type) => {
    this.setState({
      isLoaderActive: true,
      data: [],
    });
    if (isReset === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.resetDefaultViewButton);
    } else {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.saveConfigurationApply);
    }
    let reqObj = {
      is_reset: isReset ? isReset : false,
      user_selection_list: !isReset && data && Array.isArray(data) ? data : [],
      trade_direction: this.defaultData.manyCountryType ? this.defaultData.manyCountryType : "imports",
      country: this.defaultData.countryShortHand ? this.defaultData.countryShortHand.toLowerCase() : this.defaultData.countryCode ? this.defaultData.countryCode.toLowerCase() : "us",
      customType: type,
    };
    axios
      .post(globalApiEndPoints.setUserCustomGrid, reqObj)
      .then((res) => {
        this.setState({
          isLoaderActive: false,
        });
        if (res && res.data) {
          this.setState({
            isLoaderActive: false,
            defaultType: this.state.type,
          });
          if (!isReset && res.data.user_selection_list && res.data.user_selection_list.length) {
            if (this.state.type === "bol") {
              this.setState({
                customShipmentGridSelectedListBol: [...res.data.user_selection_list],
              });
            } else {
              this.setState({
                customShipmentGridSelectedList: [...res.data.user_selection_list],
              });
              let cachedGridData = JSON.parse(sessionStorage.getItem("gridCache")) || {};
              const countryKey = `${this.defaultData.country_small}_${this.defaultData.countryType}`;
              if (cachedGridData[countryKey]) {
                const newCacheData = {
                  ...cachedGridData,
                  [countryKey]: {
                    ...cachedGridData[countryKey],
                    data: {
                      ...cachedGridData[countryKey]?.data,
                      user_selection_list: [...res.data.user_selection_list],
                    },
                  },
                };
                sessionStorage.setItem("gridCache", JSON.stringify(newCacheData));
              }
            }
            toast.success(res.data.message ? res.data.message : "Success");
          } else if (isReset && res.data.default_configuration && res.data.default_configuration.length) {
            if (this.state.type === "bol") {
              this.setState({
                customShipmentGridSelectedListBol: null,
              });
            } else {
              this.setState({
                customShipmentGridSelectedList: null,
              });
            }
            let cachedGridData = JSON.parse(sessionStorage.getItem("gridCache")) || {};
            const countryKey = `${this.defaultData.country_small}_${this.defaultData.countryType}`;
            if (cachedGridData[countryKey]) {
              const newCacheData = {
                ...cachedGridData,
                [countryKey]: {
                  ...cachedGridData[countryKey],
                  data: {
                    ...cachedGridData[countryKey]?.data,
                    user_selection_list: [...res.data.user_selection_list],
                  },
                },
              };
              sessionStorage.setItem("gridCache", JSON.stringify(newCacheData));
            }

            setTimeout(() => {
              this.getCustomShipmentGridData("trigger", res.data.message);
            }, 200);
          } else {
            toast.error("Something went wrong! Please try again.");
          }
        } else {
          toast.error("Something went wrong! Please try again.");
        }
      })
      .then(() => {
        const requestObject = this.creatingRequestObject(requestObjectType.search);
        this.callingSearchAPI(requestObject, requestObjectType.search);
      })
      .catch(() => {
        toast.error("Something went wrong! Please try again.");
        this.setState({
          isLoaderActive: false,
        });
      });
  };
  // calling BE API to get custom shipment grid data
  getCustomShipmentGridData = (type, message) => {
    let gridCacheStates = JSON.parse(sessionStorage.getItem("gridCache"));
    if (this.state.customShipmentGridSelectedList && Array.isArray(this.state.customShipmentGridSelectedList) && this.state.type !== "bol") {
      if (gridCacheStates && gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`]) {
        let cachedGridData = gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`];
        let tempListCached = cachedGridData.data.user_selection_list && Array.isArray(cachedGridData.data.user_selection_list) ? cachedGridData.data.user_selection_list.map((item) => ({ ...item })) : [];
        this.mapCustomShipmentGridData([...tempListCached]);
      } else {
        this.mapCustomShipmentGridData([...this.state.customShipmentGridSelectedList]);
      }
      return;
    } else if (this.state.customShipmentGridSelectedListBol && Array.isArray(this.state.customShipmentGridSelectedListBol) && this.state.type === "bol") {
      if (gridCacheStates && gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`]) {
        let cachedGridData = gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`];
        let tempBolListCached = cachedGridData?.data?.user_selection_list_bol && Array.isArray(cachedGridData?.data?.user_selection_list_bol) ? cachedGridData.data.user_selection_list_bol.map((item) => ({ ...item })) : [];
        this.mapCustomShipmentGridData([...tempBolListCached]);
      } else {
        this.mapCustomShipmentGridData([...this.state.customShipmentGridSelectedListBol]);
      }

      return;
    }
    this.setState({
      isLoaderActive: true,
    });
    let queryString =
      "?" +
      generateQueryString({
        country: this.defaultData.countryShortHand ? this.defaultData.countryShortHand.toLowerCase() : this.defaultData.countryCode ? this.defaultData.countryCode.toLowerCase() : "us",
        trade_direction: this.defaultData.manyCountryType ? this.defaultData.manyCountryType : "imports",
      });
    if (gridCacheStates && gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`]) {
      let resData = gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`];
      let tempList = resData.data.user_selection_list && Array.isArray(resData.data.user_selection_list) ? resData.data.user_selection_list.map((item) => ({ ...item })) : [];

      let tempBolList = resData?.data?.user_selection_list_bol && Array.isArray(resData?.data?.user_selection_list_bol) ? resData.data.user_selection_list_bol.map((item) => ({ ...item })) : [];
      this.props.analyticsDashletConfig(resData.data?.analytics_dashlet?.configurable_dashlets || []);
      this.props.selectedAnalyticsDashlet(resData.data?.analytics_dashlet?.user_selection_dashlets || []);

      this.setState(
        {
          customShipmentGridSelectedList: [...tempList],
          customShipmentGridConfigurationList: resData.data.configurable_fields ? resData.data.configurable_fields : {},
          customShipmentGridSelectedListBol: tempBolList,
          customShipmentGridConfigurationListBol: resData.data.configurable_fields_bol ? resData.data.configurable_fields_bol : {},
          type: resData?.data?.customType ? resData.data.customType : "shipments",
          defaultType: resData?.data?.customType ? resData.data.customType : "shipments",
          isLoaderActive: false,
        },
        () => {
          if (type === "trigger") toast.success(message);
        }
      );
    } else {
      axios
        .get(globalApiEndPoints.getCustomizedShipmentGrid + queryString)
        .then((res) => {
          if (res && res.data && res.data.data) {
            let tempList = res.data.data.user_selection_list && Array.isArray(res.data.data.user_selection_list) ? res.data.data.user_selection_list.map((item) => ({ ...item })) : [];

            let tempBolList = res?.data?.data?.user_selection_list_bol && Array.isArray(res?.data?.data?.user_selection_list_bol) ? res.data.data.user_selection_list_bol.map((item) => ({ ...item })) : [];
            this.props.analyticsDashletConfig(res.data.data?.analytics_dashlet?.configurable_dashlets || []);
            this.props.selectedAnalyticsDashlet(res.data.data?.analytics_dashlet?.user_selection_dashlets || []);

            this.setState(
              {
                customShipmentGridSelectedList: [...tempList],
                customShipmentGridConfigurationList: res.data.data.configurable_fields ? res.data.data.configurable_fields : {},
                customShipmentGridSelectedListBol: tempBolList,
                customShipmentGridConfigurationListBol: res.data.data.configurable_fields_bol ? res.data.data.configurable_fields_bol : {},
                type: res?.data?.data?.customType ? res.data.data.customType : "shipments",
                defaultType: res?.data?.data?.customType ? res.data.data.customType : "shipments",
                isLoaderActive: false,
              },
              () => {
                if (type === "trigger") toast.success(message);
              }
            );
            let cachedGridData = gridCacheStates || {};
            const newCacheData = {
              ...cachedGridData,
              [`${this.defaultData.country_small}_${this.defaultData.countryType}`]: res.data,
            };
            sessionStorage.setItem("gridCache", JSON.stringify(newCacheData));

            // Use the pre-cloned tempList
            this.mapCustomShipmentGridData(tempList);
          } else {
            this.setState({
              customShipmentGridSelectedList: [],
            });
            toast.error("Something wrong! Please try again.");
          }
        })
        .catch(() => {
          this.setState({
            isLoaderActive: false,
          });
          toast.error("Something went wrong! Please try again.");
        });
    }
  };

  //
  // used to map shipment grid columns in case of custom shipment grid
  getCanViewIec = () => {
    return canViewIndiaIec(this.props.userDetails?.userData?.email ?? "", this.props.userDetails?.creditDetails);
  };

  mapCustomShipmentGridData = (data) => {
    if (!data || !Array.isArray(data)) return;
    const canViewIec = this.getCanViewIec();
    //defualt columns
    let tempArr = [
      {
        key: "",
        name: "View",
        selector: "",
        isSticky: "start",
        left: "38px",
        width: "60px",
        cell: (row) => (
          <div
            data-tip="View Details"
            data-for="detailview-tooltip"
            onClick={() => {
              this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabViewDetailedShipment);
            }}>
            <ViewShipment
              type={this.state.type}
              redirectionIdsArr={this.props.redirectionIdsArr}
              setRedirectionIdsArrayHandler={this.props.setRedirectionIdsArrayHandler}
              rowData={row}
              viewShipmentDetails={this.defaultData.viewShipmentDetails}
              defaultData={this.defaultData}
              apiEndPoints={this.defaultData.apiEndPoints}
              countryName={this.defaultData?.countryShortHand || this.defaultData.country_small}
              countryType={this.defaultData.countryType}
              currentUserPlan={this.state.currentUserPlan}
              isSalesForceRedirection={this.state.isSalesForceRedirection}
              analyticsCountryID={this.defaultData.analyticsCountryID}
              pathname={this.props.location.pathname}
              isRedirect={this.state.isRedirect}
              redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
              redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
              clearNudgePopupTimer={() => {
                clearAllNudgePopupTimers();
                this.setState({ showNudgePopup: false });
              }}
              callNudgeHandler={() => this.handleNudgePopup("saved_search", "event")}
            />
          </div>
        ),
      },
      { key: "s_no", name: "S No", selector: "s_no", width: "40px" },
    ];
    // show matching field columns in case of search or filter applied
    if (!!this && !!this.state && !!this.state.isSearchButtonCalled && !!this.state.isSearchButtonCalled && this.state.isSearchButtonCalled === true && !!this.state?.existingSearchReqObj && this?.state?.existingSearchReqObj?.search) {
      let obj = {
        key: "matched_column",
        grow: 2,
        omit: true,
        name: "Matching Fields",
        width: "120px",
        selector: (row) => <MatchedColumnUs rowData={row} searchData={[]} searchedItem={this.state.searchedItem} type={this.state.searchToggle} inflectionWordList={this.state.inflectionWordList} />,
      };
      tempArr.push(obj);
    }
    let tempSorting = [];
    let tempSortKey = {};
    // dynamic columns mapping
    for (let i = 0; i < data.length; i++) {
      if (!canViewIec && IEC_GRID_KEYS.includes(data[i]?.field_name?.[0])) continue;
      // handling dynamic sorting
      if (data[i].sortable === true && data[i].field_name && data[i].field_name[0]) {
        let tempObj = {};
        tempSortKey[data[i].field_name[0]] = data[i].field_name[0];
        tempObj.columnKey = data[i].field_name[0];
        tempObj.value = data[i].field_name[0];
        tempObj.isDefault = false;
        tempObj.width = "120px";
        tempObj.maWidth = "120px";
        tempObj.miWidth = "120px";
        if (data[i].special_handling_field_type === "date") {
          tempObj.isDefault = true;
          this.shipmentDefaultSortValue = this.shipmentDefaultSortValue ? this.shipmentDefaultSortValue : data[i].field_name[0];
          if (!this.state.sortValue || data.filter((item) => item.field_name && item.field_name[0] && item.field_name[0] === this.state.sortValue).length === 0) {
            this.setState({
              sortValue: data[i].field_name[0],
            });
          }
        }
        tempSorting.push({ ...tempObj });
      }
      let obj = {};
      data[i].selector = data[i].field_name && data[i].field_name[0] ? data[i].field_name[0] : ""; // handle for hs code type component
      data[i].alternateSelector = data[i].field_name && data[i].field_name[1] ? data[i].field_name[1] : ""; // handle for hs code type component
      obj.key = data[i].field_name && data[i].field_name[0] ? data[i].field_name[0] : "";
      obj.sortable = data[i].sortable === true ? true : false;

      const globalPlanCheck = this?.props?.userDetails?.userData?.planIds?.find((planId) => planId.navigate === "search");
      const redirectionType = getRedirectProfileType(data[i]?.redirectionType);
      // inserting name of column
      obj.name = (
        <div className="d-flex align-items-center">
          {data[i].label_name ? data[i].label_name : "Field"}
          {data[i].header_tool_tip_text && typeof data[i].header_tool_tip_text === "string" && !this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter") ? (
            <div>
              <Info className="mx-1" color="#8C8C8C" size={13} data-tip={data[i].header_tool_tip_text} data-for="xyz" />
              <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="xyz" />
            </div>
          ) : (
            <></>
          )}
          {HIDE_PORT_PROFILE_UPSELL && getProfileTypeEnum[redirectionType] === profileTypeEnum.ports ? null : <RedirectSampleProfile redirectionType={redirectionType} />}
        </div>
      );
      // inserting value of columns
      obj.selector = (row) => (
        // handling date

        <span>
          {data[i].special_handling_field_type === "date" && data[i].field_name && data[i].field_name[0] && row[data[i].field_name[0]] ? (
            row[data[i].field_name[0]] === "NA" ? (
              "NA"
            ) : this.defaultData.picker.monthPicker ? (
              FormatDate(row[data[i].field_name[0]], "MMM, YYYY")
            ) : (
              FormatDate(row[data[i].field_name[0]], "MMM DD, YYYY")
            )
          ) : // handling data source in multi country
          data[i].special_handling_field_type === "dataSource" && data[i].field_name && data[i].field_name[0] && row[data[i].field_name[0]] ? (
            <span>
              <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={CountryCodeOneToOneMap[row["countryCode"].toLowerCase()] ? CountryCodeOneToOneMap[row["countryCode"].toLowerCase()] : row["countryCode"]} svg />
              <span className="text-capitalize">{row.data_source_label || row[data[i].field_name[0]]}</span>
            </span>
          ) : // handling hscode
          data[i].special_handling_field_type === "hsCode" ? (
            <HSCodeText hsCodeFieldObject={data[i]} type={hsCodeTypeDictionary.shipment} rowData={row} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} currentUserPlan={this.state.currentUserPlan} dataSource={this.defaultData.analyticsCountryID} />
          ) : // handling shipper - consignee name
          data[i].hyperlink_field && data[i].hyperlink_field !== "" ? (
            <>
              {data[i]?.redirectionType && redirectionTypePayload[getRedirectProfileType(data[i].redirectionType)] ? (
                <RedirectProfile profileType={getRedirectProfileType(data[i].redirectionType)} profileId={row[data[i].hyperlink_field]} profileName={row[data[i].field_name[0]]} dataSource={this.defaultData.analyticsCountryID} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} tooltipField={row[data[i]?.tooltip_field]} />
              ) : (
                <ShipmentsCompanyName
                  name={data[i].label_name ? data[i].label_name : ""}
                  rowData={row}
                  companyIdKey={this.state.isSalesForceRedirection ? null : data[i].hyperlink_field}
                  companyKey={data[i].field_name && data[i].field_name[1] && typeof data[i].field_name[1] === "string" ? data[i].field_name[1].trim() : ""}
                  derivedCompanyKey={data[i].field_name && data[i].field_name[0] && typeof data[i].field_name[0] === "string" ? data[i].field_name[0].trim() : ""}
                  countryName={this.defaultData.countryCaps}
                  countryType={this.defaultData.countryType}
                  isRedirect={this.state.isRedirect}
                  currentUserPlan={this.state.currentUserPlan}
                  pathname={this.props.location.pathname}
                  analyticsCountryID={this.defaultData.analyticsCountryID}
                  shipmentConsigneeStandardizedName={trackingEventDictionary.shipmentsTabConsigneeStandardizedName}
                  shipmentShipperStandardizedName={trackingEventDictionary.shipmentsTabShipperStandardizedName}
                  redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                  redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                  redirectingCompanyLogisticsId={this.state.redirectingCompanyLogisticsId}
                />
              )}
            </>
          ) : // handling array list fields with per-line display and load more
          data[i].field_name && data[i].field_name[0] && ARRAY_LIST_FIELDS.includes(data[i].field_name[0]) && Array.isArray(row[data[i].field_name[0]]) ? (
            <ArrayListField values={row[data[i].field_name[0]]} />
          ) : // handling when response is array, product keyword to be specific
          data[i].field_name && data[i].field_name[0] && row[data[i].field_name[0]] && Array.isArray(row[data[i].field_name[0]]) ? (
            row[data[i].field_name[0]].filter((item) => item.trim() !== "").length === 0 ? (
              "NA"
            ) : row[data[i].field_name[0]].join(", ").length > 50 ? (
              <span className="text-capitalize" data-for="grid-cell-tooltip" data-tip={row[data[i].field_name[0]].join(", ")}>
                {row[data[i].field_name[0]]
                  .filter((item) => typeof item === "string" && item.trim() !== "")
                  .join(", ")
                  .slice(0, 50)
                  .toLowerCase()}
                ...
              </span>
            ) : (
              <span className="text-capitalize">
                {row[data[i].field_name[0]]
                  .filter((item) => typeof item === "string" && item.trim() !== "")
                  .join(", ")
                  .toLowerCase()}
              </span>
            )
          ) : // handling shipper type for logistic provider
          data[i].field_name && data[i].field_name[0] && (row[data[i].field_name[0]] || (row[data[i].field_name[0]] === 0 && data[i].special_handling_field_type === "zero_field")) ? (
            typeof row[data[i].field_name[0]] === "string" && row[data[i].field_name[0]].toLowerCase() !== "na" && data[i].is_capital !== true ? (
              <span data-for="grid-cell-tooltip" data-tip={data[i].tooltip_field && data[i].tooltip_field[0] && row[data[i].tooltip_field[0]] ? (data[i].tooltip_prefix_text ? data[i].tooltip_prefix_text + ": " + row[data[i].tooltip_field[0]] : row[data[i].tooltip_field[0]]) : row[data[i].field_name[0]].length > 50 ? row[data[i].field_name[0]] : ""} className="text-capitalize">
                {row[data[i].field_name[0]].toLowerCase().slice(0, 50)}
                {row[data[i].field_name[0]].length > 50 ? "..." : ""}
              </span>
            ) : typeof row[data[i].field_name[0]] === "number" ? (
              <>{data[i].sortable ? <span data-tip={data[i].tooltip_field[0] ? (data[i].tooltip_field[1] && row[data[i].tooltip_field[1]] ? row[data[i].tooltip_field[0]] + " " + row[data[i].tooltip_field[1]] : row[data[i].tooltip_field[0]]) : ""}>{row[data[i].field_name[0]] !== 0 ? (typeof row[data[i].field_name[0]] === "number" && !Number.isInteger(row[data[i].field_name[0]]) ? (commaFormaterFixed(row[data[i].field_name[0]].toFixed(2)) === "0.00" ? "0" : commaFormaterFixed(row[data[i].field_name[0]].toFixed(2))) : commaFormaterFixed(row[data[i].field_name[0]])) : row[data[i].field_name[0]]} </span> : <span>{commaFormaterFixed(row[data[i].field_name[0]])}</span>}</>
            ) : typeof row[data[i].field_name[0]] === "string" && row[data[i].field_name[0]].length > 50 ? (
              <span data-for="grid-cell-tooltip" data-tip={data[i].tooltip_field && data[i].tooltip_field[0] && row[data[i].tooltip_field[0]] ? row[data[i].tooltip_field[0]] : row[data[i].field_name[0]]}>
                {row[data[i].field_name[0]].slice(0, 50)}...
              </span>
            ) : (
              <span data-tip={data[i].tooltip_field && data[i].tooltip_field[0] && row[data[i].tooltip_field[0]] ? row[data[i].tooltip_field[0]] : ""}> {data[i].is_capital === true && typeof row[data[i].field_name[0]] === "string" ? row[data[i].field_name[0]].toUpperCase() : row[data[i].field_name[0]]} </span>
            )
          ) : //handling shipment value = 0 type field
          data[i].special_handling_field_type === "shipment-value" ? (
            <span>
              <span data-for="shipment-value-tooltip" data-tip={row[data[i]?.tooltip_field[0]]} className="text-capitalize">
                {row[data[i].field_name[0]]}
              </span>
            </span>
          ) : data[i].field_type === "optional" && data[i].field_name[1] && row[data[i].field_name[1]] ? (
            handleUnits(row[data[i].field_name[1]].toLowerCase())
          ) : data[i].field_name && row[data[i].field_name] === 0 ? (
            "0"
          ) : (
            "NA"
          )}
          {
            // handling units for field like quantity
            row[data[i].field_name[0]] && data[i].field_name[1] && row[data[i].field_name[1]] && data[i].field_type && data[i].field_type.toLowerCase() === "concatination" ? <span> {handleUnits(row[data[i].field_name[1]].toLowerCase())}</span> : <></>
          }
        </span>
      );
      if (obj?.key?.includes("data_source") && globalPlanCheck?.productId === globalCountryDetailsDictionary?.global_plan?.product_id);
      else tempArr.push(obj);
    }
    // updating dynamic sorting dictionaries
    this.defaultData.sortKeyMap = { ...tempSortKey };
    this.defaultData.shipmentSorting = [...tempSorting];

    // updating dynamic column
    this.setState({
      searchTableColumns: [...tempArr],
    });
  };
  mapSearchTableColumn = () => {
    const canViewIec = this.getCanViewIec();
    try {
      if (this.defaultData && this.defaultData.customShipmentGrid === true) {
        this.getCustomShipmentGridData();
      } else if (this.defaultData && this.defaultData.searchTableColumns && this.defaultData.searchTableColumns.length) {
        setTimeout(() => {
          let tempArr = [];
          let executionArray = [];
          if (!!this && !!this.state && !this.state.searchToggle) {
            if (!!this && !!this.state && !!this.state.isSearchButtonCalled && !!this.state.isSearchButtonCalled && this.state.isSearchButtonCalled === true && !!this.state.existingSearchReqObj && !!this.state.existingSearchReqObj.data && this.state.existingSearchReqObj.data.length !== 0) {
              executionArray = [...this.defaultData.searchTableColumns];
            } else {
              executionArray = this.defaultData.searchTableColumns.filter((item) => {
                return !!item && !!item.type && item.type !== "" ? item.type.toLowerCase() !== "matchingField".toLowerCase() : item;
              });
            }
          } else {
            if (!!this && !!this.state && !!this.state.isSearchButtonCalled && !!this.state.isSearchButtonCalled && this.state.isSearchButtonCalled === true && !!this.state.existingSearchReqObj && !!this.state.existingSearchReqObj.search && this.state.existingSearchReqObj.search !== "") {
              executionArray = [...this.defaultData.searchTableColumns];
            } else {
              executionArray = this.defaultData.searchTableColumns.filter((item) => {
                return !!item && !!item.type && item.type !== "" ? item.type.toLowerCase() !== "matchingField".toLowerCase() : item;
              });
            }
          }

          for (let i = 0; i < executionArray.length; i++) {
            let obj = {};
            obj.key = executionArray[i].key;
            if (executionArray[i].altKey) {
              obj.altKey = executionArray[i].altKey;
            }
            obj.name = (
              <div className="d-flex align-items-center">
                {executionArray[i].name}
                {executionArray[i].isInfoText === true && executionArray[i].infoText !== "" ? (
                  <div>
                    <Info className="mx-1" color="#8C8C8C" size={13} data-tip={executionArray[i].infoText} data-for="xyz" />
                    <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="xyz" />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            );
            obj.selector = executionArray[i].selector;
            if (executionArray[i].wrap) obj.wrap = executionArray[i].wrap;
            if (executionArray[i].maxWidth) obj.maxWidth = executionArray[i].maxWidth;
            if (executionArray[i].minWidth) obj.minWidth = executionArray[i].minWidth;
            if (executionArray[i].maWidth) obj.maWidth = executionArray[i].maWidth;
            if (executionArray[i].miWidth) obj.miWidth = executionArray[i].miWidth;
            if (executionArray[i].grow !== undefined) obj.grow = executionArray[i].grow;
            if (executionArray[i].sortable !== undefined) obj.sortable = executionArray[i].sortable;
            if (executionArray[i].button !== undefined) obj.button = executionArray[i].button;
            if (executionArray[i].type && executionArray[i].type === "viewShipment") {
              obj.isSticky = "start";
              obj.left = "38px";
              obj.cell = (row) => (
                <div
                  data-tip="View Details"
                  data-for="detailview-tooltip"
                  onClick={() => {
                    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabViewDetailedShipment);
                  }}>
                  <ViewShipment
                    rowData={row}
                    viewShipmentDetails={this.defaultData.viewShipmentDetails}
                    defaultData={this.defaultData}
                    apiEndPoints={this.defaultData.apiEndPoints}
                    countryName={this.defaultData?.countryShortHand || this.defaultData.country_small}
                    countryType={this.defaultData.countryType}
                    currentUserPlan={this.state.currentUserPlan}
                    isSalesForceRedirection={this.state.isSalesForceRedirection}
                    analyticsCountryID={this.defaultData.analyticsCountryID}
                    pathname={this.props.location.pathname}
                    isRedirect={this.state.isRedirect}
                    redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                    redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                    clearNudgePopupTimer={() => {
                      clearAllNudgePopupTimers();
                      this.setState({ showNudgePopup: false });
                    }}
                    callNudgeHandler={() => this.handleNudgePopup("saved_search", "event")}
                  />
                </div>
              );
            } else if (executionArray[i].type && executionArray[i].type === "matchingField") {
              obj[!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true ? "selector" : "format"] = (row) => <MatchedColumnUs rowData={row} searchData={[]} searchedItem={this.state.searchedItem} inflectionWordList={this.state.inflectionWordList} />;
            } else if (executionArray[i].type && executionArray[i].type === "companyRedirect") {
              obj[!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true ? "selector" : "format"] = (row) => (
                <div>
                  <ShipmentsCompanyName name={executionArray[i].name} rowData={row} companyIdKey={this.state.isSalesForceRedirection ? null : executionArray[i].id} companyKey={executionArray[i].alternateSelector} derivedCompanyKey={executionArray[i].selector} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} isRedirect={this.state.isRedirect} currentUserPlan={this.state.currentUserPlan} pathname={this.props.location.pathname} analyticsCountryID={this.defaultData.analyticsCountryID} shipmentConsigneeStandardizedName={trackingEventDictionary.shipmentsTabConsigneeStandardizedName} shipmentShipperStandardizedName={trackingEventDictionary.shipmentsTabShipperStandardizedName} redirectingCompanyExporterId={this.state.redirectingCompanyExporterId} redirectingCompanyImporterId={this.state.redirectingCompanyImporterId} redirectingCompanyLogisticsId={this.state.redirectingCompanyLogisticsId} />
                </div>
              );
            } else if (executionArray[i].type && executionArray[i].type === "teu") {
              obj[!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true ? "selector" : "format"] = (row) => (
                <div className="w-100 m-0" data-tip={row[executionArray[i].isTeuPresent] === true ? (!row.hasOwnProperty("teu") ? "To view TEU, you would need to upgrade to higher plan." : row[executionArray[i].selector]) : "NA"}>
                  {row[executionArray[i].isTeuPresent] && !row[executionArray[i].hasOwnProperty("teu")] ? (
                    <span>
                      <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                      <span className="ml-1">
                        <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                      </span>
                    </span>
                  ) : null}
                  {row[executionArray[i].isTeuPresent] && row[executionArray[i].hasOwnProperty("teu")] ? <span>{row[executionArray[i].selector]}</span> : null}
                  {!row[executionArray[i].isTeuPresent] ? <span>NA</span> : null}
                </div>
              );
            } else if (executionArray[i].type && executionArray[i].type === "conditionalBlur") {
              obj[!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true ? "selector" : "format"] = (row) => (
                <>
                  {executionArray[i].selector.toLowerCase().includes("hs_code") === true ? (
                    <HSCodeText hsCodeFieldObject={executionArray[i]} type={hsCodeTypeDictionary.shipment} rowData={row} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} currentUserPlan={this.state.currentUserPlan} analyticsCountryID={this.defaultData.analyticsCountryID} pathname={this.props.location.pathname} />
                  ) : (
                    <div className="w-100 m-0" data-tip={executionArray[i].valueCheckField && row[executionArray[i].valueCheckField] === true ? (!(row[executionArray[i].selector] || row[executionArray[i].selector] === 0) ? (executionArray[i].upgradeText ? executionArray[i].upgradeText : "To view, you would need to upgrade to higher plan.") : "") : executionArray[i].alternateSelector && executionArray[i].alternateValueCheckField && row[executionArray[i].alternateValueCheckField] === true ? (!row[executionArray[i].alternateSelector] ? (executionArray[i].upgradeText ? executionArray[i].upgradeText : "To view, you would need to upgrade to higher plan.") : row[executionArray[i].alternateSelector]) : ""}>
                      {(row[executionArray[i].valueCheckField] && (row[executionArray[i].selector] === undefined || row[executionArray[i].selector] === null)) || (row[executionArray[i].alternateValueCheckField] && !row[executionArray[i].alternateSelector]) ? (
                        <span>
                          <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                          <span className="ml-1">
                            <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                          </span>
                        </span>
                      ) : (
                        <></>
                      )}
                      {/* Below is the Targeted Code */}
                      {(executionArray[i].valueCheckField && row[executionArray[i].valueCheckField] && (row[executionArray[i].selector] !== undefined || row[executionArray[i].selector] !== null)) || (!executionArray[i].valueCheckField && row[executionArray[i].selector]) ? (
                        <span data-tip={row[executionArray[i].selector] ? row[executionArray[i].selector] : ""} data-for="hs-code-tooltip" className="text-break">
                          {!!executionArray[i].isCommaFormat && !!row[executionArray[i].selector] ? (
                            commaFormaterFixed(typeof row[executionArray[i].selector] === "number" ? row[executionArray[i].selector].toFixed(executionArray[i].fixedValueUpto ? executionArray[i].fixedValueUpto : 2) : row[executionArray[i].selector])
                          ) : executionArray[i].isSliceEnabled === true && executionArray[i].sliceLength !== 0 && row[executionArray[i].selector] ? (
                            <>
                              {Array.isArray(row[executionArray[i].selector]) === true ? (
                                <>
                                  {row[executionArray[i].selector].join(" ").slice(0, executionArray[i].sliceLength)}
                                  {row[executionArray[i].selector].join(" ").length > executionArray[i].sliceLength ? "..." : ""}{" "}
                                </>
                              ) : (
                                row[executionArray[i].selector].slice(0, executionArray[i].sliceLength)
                              )}
                              {row[executionArray[i].selector].length > executionArray[i].sliceLength ? "..." : ""}
                            </>
                          ) : row[executionArray[i].selector] ? (
                            row[executionArray[i].selector]
                          ) : (
                            "NA"
                          )}{" "}
                        </span>
                      ) : row[executionArray[i].alternateValueCheckField] && row[executionArray[i].alternateSelector] ? (
                        <span data-tip={row[executionArray[i].alternateSelector] ? row[executionArray[i].alternateSelector] : ""} data-for="hs-code-tooltip" className="text-break">
                          {!!executionArray[i].isCommaFormat && !!row[executionArray[i].alternateSelector] ? (
                            commaFormaterFixed(typeof row[executionArray[i].alternateSelector] === "number" ? row[executionArray[i].alternateSelector].toFixed(executionArray[i].fixedValueUpto ? executionArray[i].fixedValueUpto : 2) : row[executionArray[i].alternateSelector])
                          ) : executionArray[i].isSliceEnabled === true && executionArray[i].sliceLength !== 0 && row[executionArray[i].alternateSelector] ? (
                            <>
                              {Array.isArray(row[executionArray[i].alternateSelector]) === true ? (
                                <>
                                  {row[executionArray[i].alternateSelector].join(" ").slice(0, executionArray[i].sliceLength)}
                                  {row[executionArray[i].alternateSelector].join(" ").length > executionArray[i].sliceLength ? "..." : ""}{" "}
                                </>
                              ) : (
                                row[executionArray[i].alternateSelector].slice(0, executionArray[i].sliceLength)
                              )}
                              {row[executionArray[i].alternateSelector].length > executionArray[i].sliceLength ? "..." : ""}
                            </>
                          ) : row[executionArray[i].alternateSelector] ? (
                            row[executionArray[i].alternateSelector]
                          ) : (
                            "NA"
                          )}{" "}
                        </span>
                      ) : (
                        <></>
                      )}
                      {/* End of the above code */}
                      {!row[executionArray[i].valueCheckField] && !executionArray[i].alternateValueCheckField ? <span>NA</span> : ""}
                    </div>
                  )}
                </>
              );
            } else if (this.defaultData.searchTableColumns[i].type && this.defaultData.searchTableColumns[i].type === "dataSource") {
              obj.selector = (row) => (
                <div className="d-flex align-items-center">
                  <ReactCountryFlag className="trademo-search-flag mr-2" countryCode={row[this.defaultData.searchTableColumns[i].dataSourceCountryCode]} svg />
                  <span>{row[this.defaultData.searchTableColumns[i].selector] ? (row[this.defaultData.searchTableColumns[i].selector].includes("us") === true || row[this.defaultData.searchTableColumns[i].selector].includes("uk") === true ? row[this.defaultData.searchTableColumns[i].selector].split(" ")[0].toUpperCase() + " " + getFirstLetterCapital(row[this.defaultData.searchTableColumns[i].selector].split(" ")[1]) : getFirstLetterCapital(row[this.defaultData.searchTableColumns[i].selector])) : "NA"}</span>
                </div>
              );
            } else {
              obj[!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true ? "selector" : "format"] = (row) => (
                <>
                  {executionArray[i].selector.toLowerCase().includes("hs_code") === true ? (
                    <>{<HSCodeText hsCodeFieldObject={executionArray[i]} type={hsCodeTypeDictionary.shipment} rowData={row} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} currentUserPlan={this.state.currentUserPlan} dataSource={this.defaultData.analyticsCountryID} />}</>
                  ) : (
                    <div className="text-capitalize" data-tip={row[executionArray[i].tooltipValue]} data-for="default-cell-tooltip">
                      {!row[executionArray[i].selector] && !executionArray[i].alternateSelector ? (
                        "NA"
                      ) : executionArray[i].isSliceEnabled === true && executionArray[i].sliceLength !== 0 && row[executionArray[i].selector] ? (
                        <>
                          {Array.isArray(row[executionArray[i].selector]) === true ? (
                            <>
                              {row[executionArray[i].selector].join(" ").slice(0, executionArray[i].sliceLength)}
                              {row[executionArray[i].selector].join(" ").length > executionArray[i].sliceLength ? "..." : ""}{" "}
                            </>
                          ) : (
                            row[executionArray[i].selector].slice(0, executionArray[i].sliceLength)
                          )}
                          {row[executionArray[i].selector].length > executionArray[i].sliceLength ? "..." : ""}
                        </>
                      ) : row[executionArray[i].selector] !== undefined && executionArray[i].isCommaFormat ? (
                        commaFormaterFixed(typeof row[executionArray[i].selector] === "number" ? row[executionArray[i].selector].toFixed(executionArray[i].fixedValueUpto ? executionArray[i].fixedValueUpto : 2) : row[executionArray[i].selector])
                      ) : row[executionArray[i].selector] && executionArray[i].dateFormat ? (
                        FormatDate(row[executionArray[i].selector], executionArray[i].dateFormat)
                      ) : row[executionArray[i].selector] && executionArray[i].isFirstLetterCapital === true ? (
                        getFirstLetterCapital(row[executionArray[i].selector])
                      ) : ARRAY_LIST_FIELDS.includes(executionArray[i].selector) && Array.isArray(row[executionArray[i].selector]) ? (
                        <ArrayListField values={row[executionArray[i].selector]} />
                      ) : row[executionArray[i].selector] ? (
                        typeof row[executionArray[i].selector] === "string" ? (
                          row[executionArray[i].selector].toLowerCase()
                        ) : (
                          row[executionArray[i].selector]
                        )
                      ) : row[executionArray[i].alternateSelector] ? (
                        row[executionArray[i].alternateSelector]
                      ) : (
                        "NA"
                      )}
                      {row[executionArray[i].selector] && row[executionArray[i].secondarySelector] ? " " + row[executionArray[i].secondarySelector].toUpperCase() : ""}
                      {!!row[executionArray[i].alternateSelector] && !!row[executionArray[i].alternateSelectorUnit] ? " " + row[executionArray[i].alternateSelectorUnit].toLowerCase() : ""}
                    </div>
                  )}
                </>
              );
            }
            tempArr.push(obj);
          }
          this.setState({
            searchTableColumns: [...tempArr],
          });
        }, 100);
      }
      if (this.defaultData && this.defaultData.exporterTableColumn && this.defaultData.exporterTableColumn.length) {
        let tempArr = [];
        for (let i = 0; i < this.defaultData.exporterTableColumn.length; i++) {
          let obj = {};
          obj.key = this.defaultData.exporterTableColumn[i].key;
          if (this.defaultData.exporterTableColumn[i].showUiUeTwoLevel) {
            if (this.state.ueTwoLevel) {
              obj.omit = !this.defaultData.exporterTableColumn[i].showUiUeTwoLevel;
            } else {
              obj.omit = this.defaultData.exporterTableColumn[i].showUiUeTwoLevel;
            }
          } else if (!this.defaultData.exporterTableColumn[i].showUiUeTwoLevel && this.defaultData.exporterTableColumn[i].hasOwnProperty("showUiUeTwoLevel")) {
            if (this.state.ueTwoLevel) {
              obj.omit = !this.defaultData.exporterTableColumn[i].showUiUeTwoLevel;
            } else {
              obj.omit = this.defaultData.exporterTableColumn[i].showUiUeTwoLevel;
            }
          }
          if (this.defaultData.showUiUeLevelTwo && this.state.ueTwoLevel && this.defaultData.exporterTableColumn[i].selector === "subKey") {
            let twoColumnMappingForUE = { ...this.defaultData.twoColumnMapping };
            if (this.state.currentTab === tabKeywords.exporters && this.defaultData.showUiUeLevelTwo && this.state.ueTwoLevel) {
              delete twoColumnMappingForUE.derived_shipper_master_name;
            }
            obj.name = (
              <div className="position-relative twolevel">
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalyticsAttribute);
                    e.stopPropagation();
                    this.setState({ showDropdown: !this.state.showDropdown });
                    setTimeout(() => {
                      this.mapSearchTableColumn();
                    }, 100);
                  }}>
                  <span>{this.defaultData.twoColumnMapping[this.state.defaultUiUeTwoLevelSelctedHeading]}</span>
                  <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1674122072/intel/icons/edit_iohyzc.svg" />
                </div>
                {this.state.showDropdown ? (
                  <div className="position-absolute twoLevelPopOver">
                    {Object.keys(twoColumnMappingForUE).map((item) =>
                      item !== this.state.defaultUiUeTwoLevelSelctedHeading.key ? (
                        <div
                          key={item}
                          onClick={() => {
                            this.setState({
                              showDropdown: false,
                              defaultUiUeTwoLevelSelctedHeading: item,
                              defaultTrendsData: [],
                              mustNotIncludeExporter: [],
                              secondLevelData: [],
                              currentPage: 1,
                              defaultPage: 1,
                            });
                            setTimeout(() => {
                              this.getUniqueExporterData(requestObjectType.exporters);
                              this.mapSearchTableColumn();
                            }, 100);
                          }}
                          className={`px-2 twolevel_option_icons cursor-pointer ${item === this.state.defaultUiUeTwoLevelSelctedHeading ? "py-2 twolevel_option_icons-selected" : "py-2"}`}>
                          <p className="d-flex justify-content-between m-0 ">
                            <span className="cursor-pointer">{item !== this.state.defaultUiUeTwoLevelSelctedHeading.key ? this.defaultData.twoColumnMapping[item] : ""}</span>
                            <span>{item === this.state.defaultUiUeTwoLevelSelctedHeading ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                          </p>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          } else if (this.defaultData.showUiUeLevelTwo && this.state.ueTwoLevel && this.defaultData.exporterTableColumn[i].isNameVariable) {
            let currentExporterSortName = "";
            for (let j = 0; j < this.defaultData.exporterSorting.length; j++) {
              if (this.defaultData.exporterSorting[j].value === this.state.exporterSortValue) {
                currentExporterSortName = this.defaultData.exporterSorting[j].name;
              }
            }
            obj.name = this.defaultData.exporterTableColumn[i].name + " " + currentExporterSortName;
          } else {
            obj.name = this.defaultData.exporterTableColumn[i].name === "Company Name & IEC Number" && this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter") ? "Company Name" : this.defaultData.exporterTableColumn[i].name;
          }
          if (this?.defaultData?.exporterTableColumn[i]?.name === "S No.") {
            obj.isSticky = "start";
            obj.left = "38px";
          }
          obj.selector = this.defaultData.exporterTableColumn[i].selector;
          if (this.defaultData.exporterTableColumn[i].wrap) obj.wrap = this.defaultData.exporterTableColumn[i].wrap;
          if (this.defaultData.exporterTableColumn[i].maxWidth) obj.maxWidth = this.defaultData.exporterTableColumn[i].maxWidth;
          if (this.defaultData.exporterTableColumn[i].minWidth) obj.minWidth = this.defaultData.exporterTableColumn[i].minWidth;
          if (this.defaultData.exporterTableColumn[i].grow !== undefined) obj.grow = this.defaultData.exporterTableColumn[i].grow;
          if (this.defaultData.exporterTableColumn[i].sortable !== undefined && this.state && this.state.currentPlanAccess) {
            obj.sortable = this.state.currentPlanAccess[this.defaultData.exporterTableColumn[i].selector] === false ? false : this.state.ueTwoLevel && !this.state.exporterTrendsTab ? false : this.defaultData.exporterTableColumn[i].sortable;
          }
          if (this.defaultData.exporterTableColumn[i].button !== undefined) obj.button = this.defaultData.exporterTableColumn[i].button;
          if (this.defaultData.exporterTableColumn[i].type && this.defaultData.exporterTableColumn[i].type === "companyRedirect") {
            if (!!this.defaultData.exporterTableColumn[i].fixedLengthUptoTrend && this.defaultData.exporterTableColumn[i].fixedLengthUptoTrend) {
              this.setState({
                fixedLengthUptoTrend: this.defaultData.exporterTableColumn[i].fixedLengthUptoTrend,
              });
            }
            obj.isSticky = "start";
            obj.left = "97px";
            obj.selector = (row) =>
              this.state.ueTwoLevel || this.state.uiTwoLevel || this.state.ulTwoLevel ? (
                row.sno === 1 ? (
                  <>
                    <UniqueImporterExporterCompanyName
                      isRedirect={this.state.isRedirect}
                      redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                      redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                      redirectingCompanyLogisticsId={this.state.redirectingCompanyLogisticsId}
                      isTrendsTab={this.state.currentTab === tabKeywords.importers ? this.state.trendsTab : this.state.currentTab === tabKeywords.exporters ? this.state.exporterTrendsTab : this.state.logisticsTrendsTab}
                      isTwoLevel={this.state.currentTab === tabKeywords.importers ? this.state.uiTwoLevel : this.state.currentTab === tabKeywords.exporters ? this.state.ueTwoLevel : this.state.ulTwoLevel}
                      currentUserPlan={this.state.currentUserPlan}
                      currentTab={this.state.currentTab}
                      pathname={this.props.location.pathname}
                      analyticsCountryID={this.defaultData.analyticsCountryID}
                      rowData={row}
                      companyIdKey={this.state.isSalesForceRedirection ? null : this.defaultData.exporterTableColumn[i].id}
                      countryName={this.defaultData.countryCaps}
                      countryType={this.defaultData.countryType}
                      showTwoLevel={this.state.ueTwoLevel}
                      fixedLengthUpto={this.defaultData.exporterTableColumn[i].fixedLengthUptoRank ? this.defaultData.exporterTableColumn[i].fixedLengthUptoRank : null}
                      defaultData={this.defaultData}
                      nthRow={this.defaultData.exporterTableColumn[i]}
                      canViewIec={canViewIec}
                    />
                    <div className="custom-style-UIUE-total d-flex align-items-start flex-column">
                      <div>{this.state.exporterSortValue === "weight" ? "Total Weight" : this.state.exporterSortValue === "date" ? "Total Shipments" : this.state.exporterSortValue === "shipment_value" ? "Total Shipment Value" : "Total TEUs"}</div>
                      <div>{this.state.exporterSortValue === "weight" ? "(" + commaFormat(row.parent_weight ? row.parent_weight : !!row.parent_weight && !!row.parent_weight.value ? row.parent_weight.value : "NA") + ")" : this.state.exporterSortValue === "date" ? "(" + commaFormat(row.parent_doc_count) + ")" : this.state.exporterSortValue === "shipment_value" ? "(" + commaFormat(row.parent_shipment_value ? (Number.isInteger(row.parent_shipment_value) ? row.parent_shipment_value : row.parent_shipment_value.toFixed(2)) : !!row.parent_shipment_value && !!row.parent_shipment_value.value ? row.parent_shipment_value.value : "NA") + ")" : "(" + commaFormat(row.parent_teu ? (Number.isInteger(row.parent_teu) ? row.parent_teu : row.parent_teu.value === 0 ? "0" : row.parent_teu.toFixed(2)) : !!row.parent_teu && !!row.parent_teu.value ? row.parent_teu.value : "NA") + ")"}</div>
                    </div>
                    {this.defaultData.exporterTableColumn[i]?.selector3 && (
                      <div data-tooltip-id={`address-tooltip`} data-tooltip-content={getTitleCase(row[this.defaultData.exporterTableColumn[i].selector3])} className="tw-mt-1 tw-text-wrap tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-1">
                        {getTitleCase(row[this.defaultData.exporterTableColumn[i].selector3])}
                      </div>
                    )}
                    {this.defaultData.exporterTableColumn[i]?.selector1 && (
                      <div className="tw-mt-1 tw-text-xs tw-text-gray-900 tw-capitalize tw-flex tw-items-center">
                        {row[this.defaultData.exporterTableColumn[i].selector2] !== "" && getTitleCase(row[this.defaultData.exporterTableColumn[i].selector2]) + ", "}
                        {getTitleCase(row[this.defaultData.exporterTableColumn[i].selector1])}
                        <ReactCountryFlag className="trademo-search-flag ml-1" countryCode={row[this.defaultData.exporterTableColumn[i].selector1Code]} svg />
                      </div>
                    )}
                  </>
                ) : (
                  ""
                )
              ) : (
                <>
                  <UniqueImporterExporterCompanyName
                    isRedirect={this.state.isRedirect}
                    redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                    redirectingCompanyLogisticsId={this.state.redirectingCompanyLogisticsId}
                    redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                    isTrendsTab={this.state.currentTab === tabKeywords.importers ? this.state.trendsTab : this.state.currentTab === tabKeywords.exporters ? this.state.exporterTrendsTab : this.state.logisticsTrendsTab}
                    isTwoLevel={this.state.currentTab === tabKeywords.importers ? this.state.uiTwoLevel : this.state.currentTab === tabKeywords.exporters ? this.state.ueTwoLevel : this.state.ulTwoLevel}
                    currentUserPlan={this.state.currentUserPlan}
                    currentTab={this.state.currentTab}
                    pathname={this.props.location.pathname}
                    analyticsCountryID={this.defaultData.analyticsCountryID}
                    rowData={row}
                    companyIdKey={this.state.isSalesForceRedirection ? null : this.defaultData.exporterTableColumn[i].id}
                    countryName={this.defaultData.countryCaps}
                    countryType={this.defaultData.countryType}
                    defaultData={this.defaultData}
                    nthRow={this.defaultData.exporterTableColumn[i]}
                    canViewIec={canViewIec}
                  />
                  {this.defaultData.exporterTableColumn[i]?.selector3 && (
                    <div data-tooltip-id={`address-tooltip`} data-tooltip-content={getTitleCase(row[this.defaultData.exporterTableColumn[i].selector3])} className="tw-mt-1 tw-text-wrap tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-1">
                      {getTitleCase(row[this.defaultData.exporterTableColumn[i].selector3])}
                    </div>
                  )}
                  {this.defaultData.exporterTableColumn[i]?.selector1 && (
                    <div className="tw-mt-1 tw-text-xs tw-text-gray-900 tw-capitalize tw-flex tw-items-center">
                      {row[this.defaultData.exporterTableColumn[i].selector2] !== "" && getTitleCase(row[this.defaultData.exporterTableColumn[i].selector2]) + ", "}
                      {getTitleCase(row[this.defaultData.exporterTableColumn[i].selector1])}
                      <ReactCountryFlag className="trademo-search-flag ml-1" countryCode={row[this.defaultData.exporterTableColumn[i].selector1Code]} svg />
                    </div>
                  )}
                </>
              );
          } else if (this.defaultData.exporterTableColumn[i].type && this.defaultData.exporterTableColumn[i].type === "conditionalBlur") {
            obj.selector = (row) =>
              !!this.state && !!this.state.currentPlanAccess && this.state.currentPlanAccess[this.defaultData.exporterTableColumn[i].selector] === false ? (
                <>
                  <span data-for="teuHide" data-tip={this.defaultData.exporterTableColumn[i].upgradeText ? this.defaultData.exporterTableColumn[i].upgradeText : "To view, you would need to upgrade to higher plan."}>
                    <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span className="ml-1">
                      <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                    </span>
                  </span>
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="teuHide" />
                </>
              ) : (
                <div data-tip={this.defaultData.exporterTableColumn[i].tooltipValue ? this.defaultData.exporterTableColumn[i].tooltipValue : ""}>
                  {!this.defaultData.exporterTableColumn[i].selector
                    ? "NA"
                    : row[this.defaultData.exporterTableColumn[i].selector] && this.defaultData.exporterTableColumn[i].isCommaFormat
                      ? !!row[this.defaultData.exporterTableColumn[i].selector].value || !!(row[this.defaultData.exporterTableColumn[i].selector].value === 0)
                        ? commaFormat(row[this.defaultData.exporterTableColumn[i].selector].value)
                        : typeof row[this.defaultData.exporterTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.exporterTableColumn[i].selector])
                          ? commaFormat(row[this.defaultData.exporterTableColumn[i].selector].toFixed(2))
                          : commaFormat(row[this.defaultData.exporterTableColumn[i].selector])
                      : row[this.defaultData.exporterTableColumn[i].selector] && this.defaultData.exporterTableColumn[i].dateFormat
                        ? FormatDate(row[this.defaultData.exporterTableColumn[i].selector], this.defaultData.exporterTableColumn[i].dateFormat)
                        : row[this.defaultData.exporterTableColumn[i].selector] && this.defaultData.exporterTableColumn[i].isFirstLetterCapital === true
                          ? getFirstLetterCapital(row[this.defaultData.exporterTableColumn[i].selector])
                          : row[this.defaultData.exporterTableColumn[i].selector]
                            ? row[this.defaultData.exporterTableColumn[i].selector]
                            : "NA"}
                  {row[this.defaultData.exporterTableColumn[i].selector] && row[this.defaultData.exporterTableColumn[i].secondarySelector] ? row[this.defaultData.exporterTableColumn[i].secondarySelector] : ""}
                </div>
              );
          } else if (this.defaultData.showUiUeLevelTwo && this.state.ueTwoLevel && this.defaultData.exporterTableColumn[i].selector === "subKey" && !!this.state.defaultUiUeTwoLevelSelctedHeading && this.state.defaultUiUeTwoLevelSelctedHeading.includes("trade_")) {
            obj.grow = 3;
            obj.format = (row) => (
              <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                  ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 47
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 47) + "..."
                    : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                  : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 47
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 47) + "..."
                      : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                    : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                      ? (row.field1 + " → " + row.field2).length > 47
                        ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 47) + "..."
                        : (row.field1 + " → " + row.field2).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string"
                        ? row.field1.toUpperCase()
                        : "NA"}
                <ReactTooltip
                  getContent={[
                    (dataTip) => {
                      return (
                        <span>
                          {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                          {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                          {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                        </span>
                      );
                    },
                    100,
                  ]}
                  className="trademo-tooltip"
                  backgroundColor="#8C8C8C"
                  textColor="#FFFFFF"
                  place="top"
                  id="sub-key1"
                />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
              </div>
            );
          } else if (this.defaultData.exporterTableColumn[i].selector === "oldest_shipment_date" || this.defaultData.exporterTableColumn[i].selector === "recent_shipment_date") {
            obj.selector = (row) => <div>{!this.defaultData.exporterTableColumn[i].selector ? "NA" : moment(row[this.defaultData.exporterTableColumn[i].selector]).format("MMM DD, YYYY")}</div>;
          } else if (this.defaultData.exporterTableColumn[i].selector !== "subKey") {
            obj.selector = (row) => (
              <div data-tip={this.defaultData.exporterTableColumn[i].tooltipValue ? this.defaultData.exporterTableColumn[i].tooltipValue : ""}>
                {!this.defaultData.exporterTableColumn[i].selector
                  ? "NA"
                  : row[this.defaultData.exporterTableColumn[i].selector] && this.defaultData.exporterTableColumn[i].isCommaFormat
                    ? !!row[this.defaultData.exporterTableColumn[i].selector].value || !!(row[this.defaultData.exporterTableColumn[i].selector].value === 0)
                      ? commaFormat(row[this.defaultData.exporterTableColumn[i].selector].value)
                      : typeof row[this.defaultData.exporterTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.exporterTableColumn[i].selector])
                        ? commaFormat(row[this.defaultData.exporterTableColumn[i].selector].toFixed(2))
                        : commaFormat(row[this.defaultData.exporterTableColumn[i].selector])
                    : row[this.defaultData.exporterTableColumn[i].selector] && this.defaultData.exporterTableColumn[i].dateFormat
                      ? FormatDate(row[this.defaultData.exporterTableColumn[i].selector], this.defaultData.exporterTableColumn[i].dateFormat)
                      : row[this.defaultData.exporterTableColumn[i].selector] && this.defaultData.exporterTableColumn[i].isFirstLetterCapital === true
                        ? getFirstLetterCapital(row[this.defaultData.exporterTableColumn[i].selector])
                        : row[this.defaultData.exporterTableColumn[i].selector]
                          ? typeof row[this.defaultData.exporterTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.exporterTableColumn[i].selector])
                            ? row[this.defaultData.exporterTableColumn[i].selector].toFixed(2)
                            : row[this.defaultData.exporterTableColumn[i].selector]
                          : "NA"}
                {row[this.defaultData.exporterTableColumn[i].selector] && row[this.defaultData.exporterTableColumn[i].secondarySelector] ? row[this.defaultData.exporterTableColumn[i].secondarySelector] : ""}
              </div>
            );
          }
          tempArr.push(obj);
        }
        if (this.defaultData.showUiUeLevelTwo && this.state.ueTwoLevel) {
          tempArr.forEach((item) => {
            if (item.selector === "subKey") {
              item.grow = 2;
              item.selector = (row) => (
                <div className="text-capitalize">
                  <p data-tip={row.subKey} data-for="sub-key">
                    {row.subKey ? (typeof row.subKey === "string" ? row.subKey.toUpperCase().slice(0, 52) : row.subKey.slice(0, 52)) : ""}
                    {!!row.subKey && row.subKey.length > 52 ? "..." : ""}
                  </p>
                  <div className="position-relative">
                    <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                      {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 47
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 47) + "..."
                          : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                        : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 47
                            ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 47) + "..."
                            : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                          : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                            ? (row.field1 + " → " + row.field2).length > 47
                              ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 47) + "..."
                              : (row.field1 + " → " + row.field2).toUpperCase()
                            : !!row && !!row.field1 && typeof row.field1 === "string"
                              ? row.field1.toUpperCase()
                              : ""}
                    </div>
                  </div>
                  <ReactTooltip
                    getContent={[
                      (dataTip) => {
                        return (
                          <span>
                            {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                            {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                            {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                          </span>
                        );
                      },
                      100,
                    ]}
                    className="trademo-tooltip"
                    backgroundColor="#8C8C8C"
                    textColor="#FFFFFF"
                    place="top"
                    id="sub-key"
                  />
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                </div>
              );
            }
          });
        }
        if (this.isUEGridNew) {
          if (!this.state.ueTwoLevel) {
            let index = tempArr.findIndex((item) => item.key === "subKey");
            if (index > -1) {
              tempArr.splice(index, 1);
            }
            let mktIndex = tempArr.findIndex((item) => item.key === "market_share");
            if (mktIndex > -1) {
              tempArr.splice(mktIndex, 1);
            }
          }
        }
        if (this.state.ueTwoLevel) {
          let index = tempArr.findIndex((item) => item.key === "id" || item.name === "S No.");
          if (index > -1) {
            tempArr.splice(index, 1);
          }
        }

        if (!this.state.ueTwoLevel) {
          let Object = {
            key: "Apply Filter",
            omit: false,
            name: <div>Apply Filter</div>,
            maxWidth: "100",
            minWidth: "100",
            grow: 0,
            selector: (row) => (
              <div
                onClick={() => {
                  this.applyUIUEFilterHandler([{ company_name: row.key, company_id: row?.hashed_id || row?.shipper_company_id }]);
                  this.checkPendoEventForCompanyRedirection(new URLSearchParams(this.props.location.search).get("redirectingFrom") ? `${new URLSearchParams(this.props.location.search).get("redirectingFrom")}_redirection_unique_exporter_tab_rank_apply_filter` : trackingEventDictionary.uniqueExporterTabRankApplyFilter);
                }}>
                <img src={ApplyFilterIcon} />
              </div>
            ),
            isSticky: "end",
          };
          tempArr.push(Object);
        }
        this.setState({
          exporterTableColumn: [...tempArr],
        });
      }
      if (this.defaultData && this.defaultData.importerTableColumn && this.defaultData.importerTableColumn.length) {
        let tempArr = [];
        for (let i = 0; i < this.defaultData.importerTableColumn.length; i++) {
          let obj = {};
          obj.key = this.defaultData.importerTableColumn[i].key;
          if (this.defaultData.importerTableColumn[i].showUiUeTwoLevel) {
            if (this.state.uiTwoLevel) {
              obj.omit = !this.defaultData.importerTableColumn[i].showUiUeTwoLevel;
            } else {
              obj.omit = this.defaultData.importerTableColumn[i].showUiUeTwoLevel;
            }
          } else if (!this.defaultData.importerTableColumn[i].showUiUeTwoLevel && this.defaultData.importerTableColumn[i].hasOwnProperty("showUiUeTwoLevel")) {
            if (this.state.uiTwoLevel) {
              obj.omit = !this.defaultData.importerTableColumn[i].showUiUeTwoLevel;
            } else {
              obj.omit = this.defaultData.importerTableColumn[i].showUiUeTwoLevel;
            }
          }
          if (this.defaultData.showUiUeLevelTwo && this.state.uiTwoLevel && this.defaultData.importerTableColumn[i].selector === "subKey") {
            let twoColumnMappingForUI = { ...this.defaultData.twoColumnMapping };
            if (this.state.currentTab === tabKeywords.importers && this.defaultData.showUiUeLevelTwo && this.state.uiTwoLevel) {
              delete twoColumnMappingForUI.derived_consignee_master_name;
            }
            obj.name = (
              <div className="position-relative twolevel">
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalyticsAttributeOpen);
                    e.stopPropagation();
                    this.setState({ showDropdown: !this.state.showDropdown });
                    setTimeout(() => {
                      this.mapSearchTableColumn();
                    }, 100);
                  }}>
                  <span>{this.defaultData.twoColumnMapping[this.state.defaultUiUeTwoLevelSelctedHeading]}</span>
                  <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1674122072/intel/icons/edit_iohyzc.svg" />
                </div>
                {this.state.showDropdown ? (
                  <div className="position-absolute twoLevelPopOver">
                    {Object.keys(twoColumnMappingForUI).map((item) =>
                      item !== this.state.defaultUiUeTwoLevelSelctedHeading.key ? (
                        <div
                          key={item}
                          onClick={() => {
                            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalyticsAttributeSelect);
                            this.setState({
                              showDropdown: false,
                              defaultUiUeTwoLevelSelctedHeading: item,
                              defaultTrendsData: [],
                              mustNotIncludeImporter: [],
                              secondLevelData: [],
                              currentPage: 1,
                              defaultPage: 1,
                            });
                            setTimeout(() => {
                              this.getUniqueImporterData(requestObjectType.importers);
                              this.mapSearchTableColumn();
                            }, 100);
                          }}
                          className={`px-2 twolevel_option_icons cursor-pointer ${item === this.state.defaultUiUeTwoLevelSelctedHeading ? "py-2 twolevel_option_icons-selected" : "py-2"}`}>
                          <p className="d-flex justify-content-between m-0 ">
                            <span className="cursor-pointer">{item !== this.state.defaultUiUeTwoLevelSelctedHeading.key ? this.defaultData.twoColumnMapping[item] : ""}</span>
                            <span>{item === this.state.defaultUiUeTwoLevelSelctedHeading ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                          </p>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          } else if (this.defaultData.showUiUeLevelTwo && this.state.uiTwoLevel && this.defaultData.importerTableColumn[i].isNameVariable) {
            let currentImporterSortName = "";
            for (let j = 0; j < this.defaultData.importerSorting.length; j++) {
              if (this.defaultData.importerSorting[j].value === this.state.importerSortValue) {
                currentImporterSortName = this.defaultData.importerSorting[j].name;
              }
            }
            obj.name = this.defaultData.importerTableColumn[i].name + " " + currentImporterSortName;
          } else {
            obj.name = this.defaultData.importerTableColumn[i].name === "Company Name & IEC Number" && this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter") ? "Company Name" : this.defaultData.importerTableColumn[i].name;
          }
          if (this.defaultData.importerTableColumn[i].name === "S No.") {
            obj.isSticky = "start";
            obj.left = "38px";
          }
          obj.selector = this.defaultData.importerTableColumn[i].selector;
          if (this.defaultData.importerTableColumn[i].wrap) obj.wrap = this.defaultData.importerTableColumn[i].wrap;
          if (this.defaultData.importerTableColumn[i].maxWidth) obj.maxWidth = this.defaultData.importerTableColumn[i].maxWidth;
          if (this.defaultData.importerTableColumn[i].minWidth) obj.minWidth = this.defaultData.importerTableColumn[i].minWidth;
          if (this.defaultData.importerTableColumn[i].grow !== undefined) obj.grow = this.defaultData.importerTableColumn[i].grow;
          if (this.defaultData.importerTableColumn[i].sortable !== undefined && this.state && this.state.currentPlanAccess) {
            obj.sortable = this.state.currentPlanAccess[this.defaultData.importerTableColumn[i].selector] === false ? false : this.state.uiTwoLevel && !this.state.trendsTab ? false : this.defaultData.importerTableColumn[i].sortable;
          }
          if (this.defaultData.importerTableColumn[i].button !== undefined) obj.button = this.defaultData.importerTableColumn[i].button;
          if (this.defaultData.importerTableColumn[i].type && this.defaultData.importerTableColumn[i].type === "companyRedirect") {
            if (!!this.defaultData.importerTableColumn[i].fixedLengthUptoTrend && this.defaultData.importerTableColumn[i].fixedLengthUptoTrend) {
              this.setState({
                fixedLengthUptoTrend: this.defaultData.importerTableColumn[i].fixedLengthUptoTrend,
              });
            }
            obj.isSticky = "start";
            obj.left = "97px";
            obj.selector = (row) =>
              this.state.ueTwoLevel || this.state.uiTwoLevel || this.state.ulTwoLevel ? (
                row.sno === 1 ? (
                  <>
                    <UniqueImporterExporterCompanyName
                      isRedirect={this.state.isRedirect}
                      redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                      redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                      redirectingCompanyLogisticsId={this.state.redirectingCompanyLogisticsId}
                      isTrendsTab={this.state.currentTab === tabKeywords.importers ? this.state.trendsTab : this.state.currentTab === tabKeywords.exporters ? this.state.exporterTrendsTab : this.state.logisticsTrendsTab}
                      isTwoLevel={this.state.currentTab === tabKeywords.importers ? this.state.uiTwoLevel : this.state.currentTab === tabKeywords.exporters ? this.state.ueTwoLevel : this.state.ulTwoLevel}
                      currentUserPlan={this.state.currentUserPlan}
                      currentTab={this.state.currentTab}
                      pathname={this.props.location.pathname}
                      analyticsCountryID={this.defaultData.analyticsCountryID}
                      rowData={row}
                      companyIdKey={this.state.isSalesForceRedirection ? null : this.defaultData.importerTableColumn[i].id}
                      countryName={this.defaultData.countryCaps}
                      countryType={this.defaultData.countryType}
                      showTwoLevel={this.state.uiTwoLevel}
                      fixedLengthUpto={this.defaultData.importerTableColumn[i].fixedLengthUptoRank ? this.defaultData.importerTableColumn[i].fixedLengthUptoRank : null}
                      defaultData={this.defaultData}
                      nthRow={this.defaultData.importerTableColumn[i]}
                      canViewIec={canViewIec}
                    />
                    <div className="custom-style-UIUE-total d-flex align-items-start flex-column">
                      <div>{this.state.importerSortValue === "weight" ? "Total Weight" : this.state.importerSortValue === "date" ? "Total Shipments" : this.state.importerSortValue === "shipment_value" ? "Total Shipment Value" : "Total TEUs"}</div>
                      <div>{this.state.importerSortValue === "weight" ? "(" + commaFormat(row.parent_weight ? row.parent_weight : !!row.parent_weight && !!row.parent_weight.value ? row.parent_weight.value : "NA") + ")" : this.state.importerSortValue === "date" ? "(" + commaFormat(row.parent_doc_count) + ")" : this.state.importerSortValue === "shipment_value" ? "(" + commaFormat(row.parent_shipment_value ? (Number.isInteger(row.parent_shipment_value) ? row.parent_shipment_value : row.parent_shipment_value.toFixed(2)) : !!row.parent_shipment_value && !!row.parent_shipment_value.value ? row.parent_shipment_value.value : "NA") + ")" : "(" + commaFormat(row.parent_teu ? (Number.isInteger(row.parent_teu) ? row.parent_teu : row.parent_teu.toFixed(2)) : !!row.parent_teu && !!row.parent_teu.value ? row.parent_teu.value : "NA") + ")"}</div>
                    </div>
                    {this.defaultData.importerTableColumn[i]?.selector3 && (
                      <div data-tooltip-id={`address-tooltip`} data-tooltip-content={getTitleCase(row[this.defaultData.importerTableColumn[i].selector3])} className="tw-mt-1 tw-text-wrap tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-1">
                        {getTitleCase(row[this.defaultData.importerTableColumn[i].selector3])}
                      </div>
                    )}
                    {this.defaultData.importerTableColumn[i]?.selector1 && (
                      <div className="tw-mt-1 tw-text-xs tw-text-gray-900 tw-capitalize tw-flex tw-items-center">
                        {row[this.defaultData.importerTableColumn[i].selector2] !== "" && getTitleCase(row[this.defaultData.importerTableColumn[i].selector2]) + ", "}
                        {getTitleCase(row[this.defaultData.importerTableColumn[i].selector1])}
                        <ReactCountryFlag className="trademo-search-flag ml-1" countryCode={row[this.defaultData.importerTableColumn[i].selector1Code]} svg />
                      </div>
                    )}
                  </>
                ) : (
                  ""
                )
              ) : (
                <>
                  <UniqueImporterExporterCompanyName
                    isRedirect={this.state.isRedirect}
                    redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                    redirectingCompanyLogisticsId={this.state.redirectingCompanyLogisticsId}
                    redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                    isTrendsTab={this.state.currentTab === tabKeywords.importers ? this.state.trendsTab : this.state.currentTab === tabKeywords.exporters ? this.state.exporterTrendsTab : this.state.logisticsTrendsTab}
                    isTwoLevel={this.state.currentTab === tabKeywords.importers ? this.state.uiTwoLevel : this.state.currentTab === tabKeywords.exporters ? this.state.ueTwoLevel : this.state.ulTwoLevel}
                    currentUserPlan={this.state.currentUserPlan}
                    currentTab={this.state.currentTab}
                    pathname={this.props.location.pathname}
                    analyticsCountryID={this.defaultData.analyticsCountryID}
                    rowData={row}
                    companyIdKey={this.state.isSalesForceRedirection ? null : this.defaultData.importerTableColumn[i].id}
                    countryName={this.defaultData.countryCaps}
                    countryType={this.defaultData.countryType}
                    defaultData={this.defaultData}
                    nthRow={this.defaultData.importerTableColumn[i]}
                    canViewIec={canViewIec}
                  />
                  {this.defaultData.importerTableColumn[i]?.selector3 && (
                    <div data-tooltip-id={`address-tooltip`} data-tooltip-content={getTitleCase(row[this.defaultData.importerTableColumn[i].selector3])} className="tw-mt-1 tw-text-wrap tw-text-xs tw-text-gray-600 tw-capitalize tw-line-clamp-1">
                      {getTitleCase(row[this.defaultData.importerTableColumn[i].selector3])}
                    </div>
                  )}
                  {this.defaultData.importerTableColumn[i]?.selector1 && (
                    <div className="tw-mt-1 tw-text-xs tw-text-gray-900 tw-capitalize tw-flex tw-items-center">
                      {row[this.defaultData.importerTableColumn[i].selector2] !== "" && getTitleCase(row[this.defaultData.importerTableColumn[i].selector2]) + ", "}
                      {getTitleCase(row[this.defaultData.importerTableColumn[i].selector1])}
                      <ReactCountryFlag className="trademo-search-flag ml-1" countryCode={row[this.defaultData.importerTableColumn[i].selector1Code]} svg />
                    </div>
                  )}
                </>
              );
          } else if (this.defaultData.importerTableColumn[i].type && this.defaultData.importerTableColumn[i].type === "conditionalBlur") {
            obj.selector = (row) =>
              !!this.state && !!this.state.currentPlanAccess && this.state.currentPlanAccess[this.defaultData.importerTableColumn[i].selector] === false ? (
                <>
                  <span data-for="teuHide" data-tip={this.defaultData.importerTableColumn[i].upgradeText ? this.defaultData.importerTableColumn[i].upgradeText : "To view, you would need to upgrade to higher plan."}>
                    <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span className="ml-1">
                      <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                    </span>
                  </span>
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="teuHide" />
                </>
              ) : (
                <div data-tip={this.defaultData.importerTableColumn[i].tooltipValue ? this.defaultData.importerTableColumn[i].tooltipValue : ""}>
                  {!this.defaultData.importerTableColumn[i].selector
                    ? ""
                    : row[this.defaultData.importerTableColumn[i].selector] && this.defaultData.importerTableColumn[i].isCommaFormat
                      ? !!row[this.defaultData.importerTableColumn[i].selector].value || !!(row[this.defaultData.importerTableColumn[i].selector].value === 0)
                        ? commaFormat(row[this.defaultData.importerTableColumn[i].selector].value)
                        : typeof row[this.defaultData.importerTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.importerTableColumn[i].selector])
                          ? commaFormat(row[this.defaultData.importerTableColumn[i].selector].toFixed(2))
                          : commaFormat(row[this.defaultData.importerTableColumn[i].selector])
                      : row[this.defaultData.importerTableColumn[i].selector] && this.defaultData.importerTableColumn[i].dateFormat
                        ? FormatDate(row[this.defaultData.importerTableColumn[i].selector], this.defaultData.importerTableColumn[i].dateFormat)
                        : row[this.defaultData.importerTableColumn[i].selector] && this.defaultData.importerTableColumn[i].isFirstLetterCapital === true
                          ? getFirstLetterCapital(row[this.defaultData.importerTableColumn[i].selector])
                          : row[this.defaultData.importerTableColumn[i].selector]
                            ? row[this.defaultData.importerTableColumn[i].selector]
                            : "NA"}
                  {row[this.defaultData.importerTableColumn[i].selector] && row[this.defaultData.importerTableColumn[i].secondarySelector] ? row[this.defaultData.importerTableColumn[i].secondarySelector] : ""}
                </div>
              );
          } else if (this.defaultData.showUiUeLevelTwo && this.state.uiTwoLevel && this.defaultData.importerTableColumn[i].selector === "subKey" && !!this.state.defaultUiUeTwoLevelSelctedHeading && this.state.defaultUiUeTwoLevelSelctedHeading.includes("trade_")) {
            obj.grow = 3;
            obj.format = (row) => (
              <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                  ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 47
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 47) + "..."
                    : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                  : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 47
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 47) + "..."
                      : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                    : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                      ? (row.field1 + " → " + row.field2).length > 47
                        ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 47) + "..."
                        : (row.field1 + " → " + row.field2).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string"
                        ? row.field1.toUpperCase()
                        : "NA"}
                <ReactTooltip
                  getContent={[
                    (dataTip) => {
                      return (
                        <span>
                          {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                          {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                          {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                        </span>
                      );
                    },
                    100,
                  ]}
                  className="trademo-tooltip"
                  backgroundColor="#8C8C8C"
                  textColor="#FFFFFF"
                  place="top"
                  id="sub-key"
                />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
              </div>
            );
          } else if (this.defaultData.importerTableColumn[i].selector === "oldest_shipment_date" || this.defaultData.importerTableColumn[i].selector === "recent_shipment_date") {
            obj.selector = (row) => <div>{!this.defaultData.importerTableColumn[i].selector ? "NA" : moment(row[this.defaultData.importerTableColumn[i].selector]).format("MMM DD, YYYY")}</div>;
          } else if (this.defaultData.importerTableColumn[i].selector !== "subKey") {
            obj.selector = (row) => (
              <div data-tip={this.defaultData.importerTableColumn[i].tooltipValue ? this.defaultData.importerTableColumn[i].tooltipValue : ""}>
                {!this.defaultData.importerTableColumn[i].selector
                  ? ""
                  : row[this.defaultData.importerTableColumn[i].selector] && this.defaultData.importerTableColumn[i].isCommaFormat
                    ? !!row[this.defaultData.importerTableColumn[i].selector].value || !!(row[this.defaultData.importerTableColumn[i].selector].value === 0)
                      ? commaFormat(row[this.defaultData.importerTableColumn[i].selector].value)
                      : typeof row[this.defaultData.importerTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.importerTableColumn[i].selector])
                        ? commaFormat(row[this.defaultData.importerTableColumn[i].selector].toFixed(2))
                        : commaFormat(row[this.defaultData.importerTableColumn[i].selector])
                    : row[this.defaultData.importerTableColumn[i].selector] && this.defaultData.importerTableColumn[i].dateFormat
                      ? FormatDate(row[this.defaultData.importerTableColumn[i].selector], this.defaultData.importerTableColumn[i].dateFormat)
                      : row[this.defaultData.importerTableColumn[i].selector] && this.defaultData.importerTableColumn[i].isFirstLetterCapital === true
                        ? getFirstLetterCapital(row[this.defaultData.importerTableColumn[i].selector])
                        : row[this.defaultData.importerTableColumn[i].selector]
                          ? typeof row[this.defaultData.importerTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.importerTableColumn[i].selector])
                            ? row[this.defaultData.importerTableColumn[i].selector].toFixed(2)
                            : row[this.defaultData.importerTableColumn[i].selector]
                          : "NA"}
                {row[this.defaultData.importerTableColumn[i].selector] && row[this.defaultData.importerTableColumn[i].secondarySelector] ? row[this.defaultData.importerTableColumn[i].secondarySelector] : ""}
              </div>
            );
          }
          tempArr.push(obj);
        }
        if (this.defaultData.showUiUeLevelTwo && this.state.uiTwoLevel) {
          tempArr.forEach((item) => {
            if (item.selector === "subKey") {
              item.grow = 2;
              item.selector = (row) => (
                <div className="text-capitalize">
                  <p data-tip={row.subKey} data-for="sub-key" className={`m-0 d-flex align-items-center ${row.subKey ? "h-100" : ""}`}>
                    {row.subKey ? (typeof row.subKey === "string" ? row.subKey.toUpperCase().slice(0, 52) : row.subKey.slice(0, 52)) : ""}
                    {!!row.subKey && row.subKey.length > 52 ? "..." : ""}
                  </p>
                  <div className="position-relative">
                    <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                      {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 47
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 47) + "..."
                          : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                        : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 47
                            ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 47) + "..."
                            : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                          : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                            ? (row.field1 + " → " + row.field2).length > 47
                              ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 47) + "..."
                              : (row.field1 + " → " + row.field2).toUpperCase()
                            : !!row && !!row.field1 && typeof row.field1 === "string"
                              ? row.field1.toUpperCase()
                              : ""}
                    </div>
                  </div>
                  <ReactTooltip
                    getContent={[
                      (dataTip) => {
                        return (
                          <span>
                            {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                            {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                            {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                          </span>
                        );
                      },
                      100,
                    ]}
                    className="trademo-tooltip"
                    backgroundColor="#8C8C8C"
                    textColor="#FFFFFF"
                    place="top"
                    id="sub-key"
                  />
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                </div>
              );
            }
          });
        }
        if (this.isUIGridNew) {
          if (!this.state.uiTwoLevel) {
            let index = tempArr.findIndex((item) => item.key === "subKey");
            if (index > -1) {
              tempArr.splice(index, 1);
            }
            let mktIndex = tempArr.findIndex((item) => item.key === "market_share");
            if (mktIndex > -1) {
              tempArr.splice(mktIndex, 1);
            }
          }
        }

        if (!this.state.uiTwoLevel) {
          let Object = {
            key: "Apply Filter",
            omit: false,
            name: <div>Apply Filter</div>,
            maxWidth: "100px",
            minWidth: "100px",
            grow: 0,
            selector: (row) => (
              <div
                onClick={() => {
                  this.applyUIUEFilterHandler([{ company_name: row.key, company_id: row?.hashed_id || row?.consignee_company_id }]);
                  this.checkPendoEventForCompanyRedirection(new URLSearchParams(this.props.location.search).get("redirectingFrom") ? `${new URLSearchParams(this.props.location.search).get("redirectingFrom")}_redirection_unique_importer_tab_rank_apply_filter` : trackingEventDictionary.uniqueImporterTabRankApplyFilter);
                }}>
                <img src={ApplyFilterIcon} />
              </div>
            ),
            isSticky: "end",
          };
          tempArr.push(Object);
        }
        this.setState({
          importerTableColumn: [...tempArr],
        });
      }
      if (this.defaultData && this.defaultData.logisticsTableColumn && this.defaultData.logisticsTableColumn.length) {
        let tempArr = [];
        for (let i = 0; i < this.defaultData.logisticsTableColumn.length; i++) {
          let obj = {};
          obj.key = this.defaultData.logisticsTableColumn[i].key;

          if (this.defaultData.logisticsTableColumn[i].showUiUeTwoLevel) {
            if (this.state.ulTwoLevel) {
              obj.omit = !this.defaultData.logisticsTableColumn[i].showUiUeTwoLevel;
            } else {
              obj.omit = this.defaultData.logisticsTableColumn[i].showUiUeTwoLevel;
            }
          } else if (!this.defaultData.logisticsTableColumn[i].showUiUeTwoLevel && this.defaultData.logisticsTableColumn[i].hasOwnProperty("showUiUeTwoLevel")) {
            if (this.state.ulTwoLevel) {
              obj.omit = !this.defaultData.logisticsTableColumn[i].showUiUeTwoLevel;
            } else {
              obj.omit = this.defaultData.logisticsTableColumn[i].showUiUeTwoLevel;
            }
          }
          if (this.defaultData.showUiUeLevelTwo && this.state.ulTwoLevel && this.defaultData.logisticsTableColumn[i].selector === "subKey") {
            let twoColumnMappingForUL = { ...this.defaultData.twoColumnMapping };
            if (this.state.currentTab === tabKeywords.logistics && this.defaultData.showUiUeLevelTwo && this.state.ulTwoLevel) {
              delete twoColumnMappingForUL.derived_shipper_master_name;
            }
            obj.name = (
              <div className="position-relative twolevel">
                <div
                  className="cursor-pointer"
                  onClick={(e) => {
                    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank2ndLevelAnalyticsAttribute);
                    e.stopPropagation();
                    this.setState({ showDropdown: !this.state.showDropdown });
                    setTimeout(() => {
                      this.mapSearchTableColumn();
                    }, 100);
                  }}>
                  <span>{this.defaultData.twoColumnMapping[this.state.defaultUlTwoLevelSelectedHeading]}</span>
                  <img className="ml-2" src="https://res.cloudinary.com/drzta9shk/image/upload/v1674122072/intel/icons/edit_iohyzc.svg" />
                </div>
                {this.state.showDropdown ? (
                  <div className="position-absolute twoLevelPopOver">
                    {Object.keys(twoColumnMappingForUL).map((item) =>
                      item !== this.state.defaultUlTwoLevelSelectedHeading.key ? (
                        <div
                          key={item}
                          onClick={() => {
                            this.setState({
                              showDropdown: false,
                              defaultUlTwoLevelSelectedHeading: item,
                              defaultTrendsData: [],
                              mustNotIncludeLogistics: [],
                              secondLevelData: [],
                              currentPage: 1,
                              defaultPage: 1,
                            });
                            setTimeout(() => {
                              this.getUniqueLogisticsData(requestObjectType.logistics);
                              this.mapSearchTableColumn();
                            }, 100);
                          }}
                          className={`px-2 twolevel_option_icons cursor-pointer ${item === this.state.defaultUlTwoLevelSelectedHeading ? "py-2 twolevel_option_icons-selected" : "py-2"}`}>
                          <p className="d-flex justify-content-between m-0 ">
                            <span className="cursor-pointer">{item !== this.state.defaultUlTwoLevelSelectedHeading.key ? this.defaultData.twoColumnMapping[item] : ""}</span>
                            <span>{item === this.state.defaultUlTwoLevelSelectedHeading ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                          </p>
                        </div>
                      ) : (
                        ""
                      )
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            );
          } else if (this.defaultData.showUiUeLevelTwo && this.state.ulTwoLevel && this.defaultData.logisticsTableColumn[i].isNameVariable) {
            let currentLogisticsSortName = "";
            for (let j = 0; j < this.defaultData.logisticsSorting.length; j++) {
              if (this.defaultData.logisticsSorting[j].value === this.state.logisticsSortValue) {
                currentLogisticsSortName = this.defaultData.logisticsSorting[j].name;
              }
            }
            obj.name = this.defaultData.logisticsTableColumn[i].name + " " + currentLogisticsSortName;
          } else {
            obj.name = this.defaultData.logisticsTableColumn[i].name;
          }
          if (this?.defaultData?.logisticsTableColumn[i]?.name === "S No.") {
            obj.isSticky = "start";
            obj.left = "38px";
          }
          obj.selector = this.defaultData.logisticsTableColumn[i].selector;
          if (this.defaultData.logisticsTableColumn[i].wrap) obj.wrap = this.defaultData.logisticsTableColumn[i].wrap;
          if (this.defaultData.logisticsTableColumn[i].maxWidth) obj.maxWidth = this.defaultData.logisticsTableColumn[i].maxWidth;
          if (this.defaultData.logisticsTableColumn[i].minWidth) obj.minWidth = this.defaultData.logisticsTableColumn[i].minWidth;
          if (this.defaultData.logisticsTableColumn[i].grow !== undefined) obj.grow = this.defaultData.logisticsTableColumn[i].grow;
          if (this.defaultData.logisticsTableColumn[i].sortable !== undefined && this.state && this.state.currentPlanAccess) {
            obj.sortable = this.state.currentPlanAccess[this.defaultData.logisticsTableColumn[i].selector] === false ? false : this.state.ulTwoLevel && !this.state.logisticsTrendsTab ? false : this.defaultData.logisticsTableColumn[i].sortable;
          }
          if (this.defaultData.logisticsTableColumn[i].button !== undefined) obj.button = this.defaultData.logisticsTableColumn[i].button;
          if (this.defaultData.logisticsTableColumn[i].type && this.defaultData.logisticsTableColumn[i].type === "companyRedirect") {
            if (!!this.defaultData.logisticsTableColumn[i].fixedLengthUptoTrend && this.defaultData.logisticsTableColumn[i].fixedLengthUptoTrend) {
              this.setState({
                fixedLengthUptoTrend: this.defaultData.logisticsTableColumn[i].fixedLengthUptoTrend,
              });
            }
            obj.isSticky = "start";
            obj.left = "97px";
            obj.selector = (row) =>
              this.state.ulTwoLevel || this.state.uiTwoLevel || this.state.ueTwoLevel ? (
                row.sno === 1 ? (
                  <div>
                    <RedirectProfile profileType={redirectionTypeKey[row.company_type[0].split(" ").join("_")]} profileId={row.hashed_id} profileName={row.key} dataSource={this.defaultData.analyticsCountryID} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} />
                    <div className="custom-style-UIUE-total d-flex align-items-start flex-column">
                      <div>{this.state.logisticsSortValue === "weight" ? "Total Weight" : this.state.logisticsSortValue === "date" ? "Total Shipments" : this.state.logisticsSortValue === "shipment_value" ? "Total Shipment Value" : "Total TEUs"}</div>
                      <div>{this.state.logisticsSortValue === "weight" ? "(" + commaFormat(row.parent_weight ? row.parent_weight : !!row.parent_weight && !!row.parent_weight.value ? row.parent_weight.value : "NA") + ")" : this.state.logisticsSortValue === "date" ? "(" + commaFormat(row.parent_doc_count) + ")" : this.state.logisticsSortValue === "shipment_value" ? "(" + commaFormat(row.parent_shipment_value ? row.parent_shipment_value : !!row.parent_shipment_value && !!row.parent_shipment_value.value ? row.parent_shipment_value.value : "NA") + ")" : "(" + commaFormat(row.parent_teu ? row.parent_teu : !!row.parent_teu && !!row.parent_teu.value ? row.parent_teu.value : "NA") + ")"}</div>
                    </div>
                  </div>
                ) : (
                  ""
                )
              ) : (
                <RedirectProfile profileType={redirectionTypeKey[row.company_type[0].split(" ").join("_")]} profileId={row.hashed_id} profileName={row.key} dataSource={this.defaultData.analyticsCountryID} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} />
              );
          } else if (this.defaultData.logisticsTableColumn[i].type && this.defaultData.logisticsTableColumn[i].selector === "company_type") {
            obj.isSticky = "start";
            obj.left = "97px";
            obj.selector = (row) =>
              this.state.ulTwoLevel ? (
                row.sno === 1 ? (
                  !!this.state && !!this.state.currentPlanAccess && this.state.currentPlanAccess[this.defaultData.logisticsTableColumn[i].selector] === false ? (
                    <>
                      <span data-for="teuHide" data-tip={this.defaultData.logisticsTableColumn[i].upgradeText ? this.defaultData.logisticsTableColumn[i].upgradeText : "To view, you would need to upgrade to higher plan."}>
                        <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <span className="ml-1">
                          <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                        </span>
                      </span>
                      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="teuHide" />
                    </>
                  ) : (
                    <div data-tip={this.defaultData.logisticsTableColumn[i].tooltipValue ? this.defaultData.logisticsTableColumn[i].tooltipValue : ""}>
                      {!this.defaultData.logisticsTableColumn[i].selector
                        ? "NA"
                        : row[this.defaultData.logisticsTableColumn[i].selector] && this.defaultData.logisticsTableColumn[i].isCommaFormat
                          ? !!row[this.defaultData.logisticsTableColumn[i].selector].value || !!(row[this.defaultData.logisticsTableColumn[i].selector].value === 0)
                            ? commaFormat(row[this.defaultData.logisticsTableColumn[i].selector].value)
                            : row[this.defaultData.logisticsTableColumn[i].selector]?.length
                              ? row[this.defaultData.logisticsTableColumn[i].selector].map((item, index) => {
                                  const typeCompany = item.includes(" ") ? <span className="text-capitalize">{item}</span> : item.toUpperCase();

                                  if (index === 0) {
                                    return (
                                      <div className="d-flex align-items-baseline" key={row.id}>
                                        <span className="tw-block tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-mr-1 tw-w-fit tw-mb-0.5">
                                          {typeCompany}
                                          {row.company_type.length > 1 && (
                                            <ReactTooltip id={`tooltip-${row.id}`} place="top" effect="solid" className="trademo-tooltip !tw-w-fit" backgroundColor="#8C8C8C" textColor="#FFFFFF">
                                              {row.company_type.slice(1).map((item) => {
                                                return (
                                                  <div className="text-capitalize" key={item}>
                                                    {item}
                                                  </div>
                                                );
                                              })}
                                            </ReactTooltip>
                                          )}
                                        </span>
                                        <div>
                                          {row.company_type.length > 1 && (
                                            <span data-tip data-for={`tooltip-${row.id}`} className="tw-bg-gray-200 tw-border tw-rounded-[14px] tw-py-[1.6px] tw-px-[4.8px] tw-cursor-pointer tw-font-medium tw-text-gray-600">
                                              +{row.company_type.length - 1}
                                            </span>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                  return null;
                                })
                              : ""
                          : ""}
                    </div>
                  )
                ) : (
                  ""
                )
              ) : !!this.state && !!this.state.currentPlanAccess && this.state.currentPlanAccess[this.defaultData.logisticsTableColumn[i].selector] === false ? (
                <>
                  <span data-for="teuHide" data-tip={this.defaultData.logisticsTableColumn[i].upgradeText ? this.defaultData.logisticsTableColumn[i].upgradeText : "To view, you would need to upgrade to higher plan."}>
                    <span className="blur-effect">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                    <span className="ml-1">
                      <img src={UpgradeIconSmall} alt="..." className="img-fluid" />
                    </span>
                  </span>
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="teuHide" />
                </>
              ) : (
                <div data-tip={this.defaultData.logisticsTableColumn[i].tooltipValue ? this.defaultData.logisticsTableColumn[i].tooltipValue : ""}>
                  {!this.defaultData.logisticsTableColumn[i].selector
                    ? "NA"
                    : row[this.defaultData.logisticsTableColumn[i].selector] && this.defaultData.logisticsTableColumn[i].isCommaFormat
                      ? !!row[this.defaultData.logisticsTableColumn[i].selector].value || !!(row[this.defaultData.logisticsTableColumn[i].selector].value === 0)
                        ? commaFormat(row[this.defaultData.logisticsTableColumn[i].selector].value)
                        : row[this.defaultData.logisticsTableColumn[i].selector]?.length
                          ? row[this.defaultData.logisticsTableColumn[i].selector].map((item) => {
                              const typeCompany = item.includes(" ")
                                ? item
                                    .split(" ")
                                    .map((word) => word[0].toUpperCase() + word.slice(1))
                                    .join(" ")
                                : item.toUpperCase();
                              return (
                                <span key={typeCompany} className="tw-bg-gray-200 tw-font-medium tw-border tw-rounded-[14px] tw-py-[3.2px] tw-px-2 tw-mr-1">
                                  {typeCompany}
                                </span>
                              );
                            })
                          : ""
                      : ""}
                </div>
              );
          } else if (this.defaultData.showUiUeLevelTwo && this.state.ulTwoLevel && this.defaultData.logisticsTableColumn[i].selector === "subKey" && !!this.state.defaultUlTwoLevelSelectedHeading && this.state.defaultUlTwoLevelSelectedHeading.includes("trade_")) {
            obj.grow = 3;
            obj.format = (row) => (
              <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                  ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 47
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 47) + "..."
                    : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                  : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 47
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 47) + "..."
                      : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                    : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                      ? (row.field1 + " → " + row.field2).length > 47
                        ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 47) + "..."
                        : (row.field1 + " → " + row.field2).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string"
                        ? row.field1.toUpperCase()
                        : "NA"}
                <ReactTooltip
                  getContent={[
                    (dataTip) => {
                      return (
                        <span>
                          {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                          {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                          {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                        </span>
                      );
                    },
                    100,
                  ]}
                  className="trademo-tooltip"
                  backgroundColor="#8C8C8C"
                  textColor="#FFFFFF"
                  place="top"
                  id="sub-key1"
                />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
              </div>
            );
          } else if (this.defaultData.logisticsTableColumn[i].selector !== "subKey") {
            obj.selector = (row) => (
              <div data-tip={this.defaultData.logisticsTableColumn[i].tooltipValue ? this.defaultData.logisticsTableColumn[i].tooltipValue : ""}>
                {!this.defaultData.logisticsTableColumn[i].selector
                  ? "NA"
                  : row[this.defaultData.logisticsTableColumn[i].selector] && this.defaultData.logisticsTableColumn[i].isCommaFormat
                    ? !!row[this.defaultData.logisticsTableColumn[i].selector].value || !!(row[this.defaultData.logisticsTableColumn[i].selector].value === 0)
                      ? commaFormat(row[this.defaultData.logisticsTableColumn[i].selector].value)
                      : commaFormat(row[this.defaultData.logisticsTableColumn[i].selector])
                    : row[this.defaultData.logisticsTableColumn[i].selector] && this.defaultData.logisticsTableColumn[i].dateFormat
                      ? FormatDate(row[this.defaultData.logisticsTableColumn[i].selector], this.defaultData.logisticsTableColumn[i].dateFormat)
                      : row[this.defaultData.logisticsTableColumn[i].selector] && this.defaultData.logisticsTableColumn[i].isFirstLetterCapital === true
                        ? getFirstLetterCapital(row[this.defaultData.logisticsTableColumn[i].selector])
                        : row[this.defaultData.logisticsTableColumn[i].selector]
                          ? typeof row[this.defaultData.logisticsTableColumn[i].selector] === "number" && !Number.isInteger(row[this.defaultData.logisticsTableColumn[i].selector])
                            ? row[this.defaultData.logisticsTableColumn[i].selector].toFixed(2)
                            : row[this.defaultData.logisticsTableColumn[i].selector]
                          : "NA"}
                {row[this.defaultData.logisticsTableColumn[i].selector] && row[this.defaultData.logisticsTableColumn[i].secondarySelector] ? row[this.defaultData.logisticsTableColumn[i].secondarySelector] : ""}
              </div>
            );
          }
          tempArr.push(obj);
        }
        if (this.defaultData.showUiUeLevelTwo && this.state.ulTwoLevel) {
          tempArr.forEach((item) => {
            if (item.selector === "subKey") {
              item.grow = 2;
              item.selector = (row) => (
                <div className="text-capitalize">
                  <p data-tip={row.subKey} data-for="sub-key">
                    {row.subKey ? (typeof row.subKey === "string" ? row.subKey.toUpperCase().slice(0, 52) : row.subKey.slice(0, 52)) : ""}
                    {!!row.subKey && row.subKey.length > 52 ? "..." : ""}
                  </p>
                  <div className="position-relative">
                    <div data-for="sub-key1" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                      {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 47
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 47) + "..."
                          : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                        : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                          ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 47
                            ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 47) + "..."
                            : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                          : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                            ? (row.field1 + " → " + row.field2).length > 47
                              ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 47) + "..."
                              : (row.field1 + " → " + row.field2).toUpperCase()
                            : !!row && !!row.field1 && typeof row.field1 === "string"
                              ? row.field1.toUpperCase()
                              : ""}
                    </div>
                  </div>
                  <ReactTooltip
                    getContent={[
                      (dataTip) => {
                        return (
                          <span>
                            {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                            {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                            {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                          </span>
                        );
                      },
                      100,
                    ]}
                    className="trademo-tooltip"
                    backgroundColor="#8C8C8C"
                    textColor="#FFFFFF"
                    place="top"
                    id="sub-key"
                  />
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                  <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
                </div>
              );
            }
          });
        }
        if (this.isUEGridNew) {
          if (!this.state.ulTwoLevel) {
            let index = tempArr.findIndex((item) => item.key === "subKey");
            if (index > -1) {
              tempArr.splice(index, 1);
            }
            let mktIndex = tempArr.findIndex((item) => item.key === "market_share");
            if (mktIndex > -1) {
              tempArr.splice(mktIndex, 1);
            }
          }
        }
        if (this.state.ulTwoLevel) {
          tempArr = tempArr.filter((item) => !(item.key === "id" || item.name === "S No."));
        }
        this.setState({
          logisticsTableColumn: [...tempArr],
        });
      }
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  checkIfFilterApplied = (searchPayload) => {
    let flag = false;
    for (const [key] of Object.entries(JSON.parse(JSON.stringify(this.state.filterObj)))) {
      if (searchPayload[key] && (!this.booleanFilterObject[key] || searchPayload[key] !== this.defaultBooleanFilterObject?.[key]) && key !== "dataSource") {
        flag = true;
        break;
      }
    }
    return flag;
  };

  // Below method is called when filters is applied on the Unique Importer and Exporter
  gettingDataFromUIEFilter = (data) => {
    //The below code is for setting the internal filter state
    this.setState({
      uniqueImportExporterShipment: data?.uniqueImportExporterShipment && Array.isArray(data?.uniqueImportExporterShipment) ? data?.uniqueImportExporterShipment : [],
      uniqueImportExporterTeu: data?.uniqueImportExporterTeu && Array.isArray(data?.uniqueImportExporterTeu) ? data?.uniqueImportExporterTeu : [],
      uniqueImportExporterValue: data?.uniqueImportExporterValue && Array.isArray(data?.uniqueImportExporterValue) ? data?.uniqueImportExporterValue : [],
      uniqueImportExporterWeight: data?.uniqueImportExporterWeight && Array.isArray(data?.uniqueImportExporterWeight) ? data?.uniqueImportExporterWeight : [],
    });

    //The end of code for setting the internal filter state
    // TODO:Shubham
    this.setState({
      exporterCurrentPage: 1,
      importerPerPage: 25,
      exporterPerPage: 25,
      importerCurrentPage: 1,
      logisticsCurrentPage: 1,
      logisticsPerPage: 25,
      secondLevelData: [],
      currentPage: 1,
      defaultPage: 1,
    });

    let tempObj = {};
    if (this.state.currentTab !== tabKeywords.logistics) {
      for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
        if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
          tempObj[this.defaultData.internalFilterList[i].key] = !!data && !!data[this.defaultData.internalFilterList[i].key] && data[this.defaultData.internalFilterList[i].key].length > 0 ? data[this.defaultData.internalFilterList[i].key] : [];
        }
      }
    }

    if (this.state.currentTab === tabKeywords.importers) {
      this.setState({ tempObj: tempObj });
      if (this.state.isRedirect) {
        this.defaultData.importerSorting.map((item) => {
          if (data.selector === item.columnKey) {
            this.setState({
              importerSortValue: item.value,
            });
          }
        });
      }
      this.setState(
        {
          mustNotIncludeImporter: [...[]],
          downloadFromValue: 1,
          downloadToValue: 100,
          importerSortOrderValue: "desc",
          importerSortValue: data.sort_key ? data.sort_key : this.importerDefaultSortValue.value,
          internalSortOrder: data.sort_order ?? "",
          isEmailShipments: false,
          tempObj: tempObj,
        },
        () => {
          this.getUniqueImporterData(requestObjectType.importers);
        }
      );
    }
    if (this.state.currentTab === tabKeywords.exporters) {
      if (this.state.isRedirect) {
        this.defaultData.exporterSorting.map((item) => {
          if (data.selector === item.columnKey) {
            this.setState({
              exporterSortValue: item.value,
            });
          }
        });
      }

      this.setState(
        {
          mustNotIncludeExporter: [],
          downloadFromValue: 1,
          downloadToValue: 100,
          exporterSortOrderValue: "desc",
          exporterSortValue: data.sort_key ? data.sort_key : this.importerDefaultSortValue.value,
          internalSortOrder: data.sort_order ?? "",
          isEmailShipments: false,
          expTempObj: tempObj,
        },
        () => {
          this.getUniqueExporterData(requestObjectType.exporters);
        }
      );
    }
    if (this.state.currentTab === tabKeywords.logistics) {
      if (this.state.isRedirect) {
        this.defaultData.logisticsSorting.map((item) => {
          if (data.selector === item.columnKey) {
            this.setState({
              logisticsSortValue: item.value,
            });
          }
        });
      }

      this.setState(
        {
          mustNotIncludeLogistics: [],
          downloadFromValue: 1,
          downloadToValue: 100,
          logisticsSortOrderValue: "desc",
          isEmailShipments: false,
          logisticsFilter: [...data],
        },
        () => {
          this.getUniqueLogisticsData(requestObjectType.logistics);
        }
      );
    }
  };
  // End of the above code
  // Below Method is used to get the user plan details
  getUserPlan = async (type) => {
    // TODO: Need to uncomment below code and Delete the Uncommented code
    try {
      let queryString = generateQueryString({ product_id: this.defaultData.product_id ? this.defaultData.product_id : "trademo_US" });
      if (!!queryString && queryString !== "") {
        queryString = "?" + queryString;
      }
      const apiUrl = globalApiEndPoints.getUserPlanDetails + queryString;
      let res = await axios.get(apiUrl);
      this.setState({
        isFreeTrial: res?.data?.data?.[0]?.is_free_trial,
      });
      if (res?.data?.last_logout_page) {
        this.setState({
          lastLogoutDetails: JSON.parse(JSON.stringify(res.data.last_logout_page)),
        });
      }
      if (res?.data?.isUpdated) {
        this.props.getCreditsByPlan();
        this.props.getUserProfile({ isUpdated: true });
        this.props.getSidebarCount();
        this.callNudgeStatus(true);
      }
      if (!!res && !!res.data.message && (res.data.message.includes("not subscribed") || res.data.message.toLowerCase().includes("trying to access beyond current subscription"))) {
        this.upgradeUSExportPopupShow();
        toast.error("Trying to access beyond current subscription!!");
        return false;
      }
      if (!!res && !!res.data && !!res.data.data && !!res.data.data.length > 0) {
        const localStoragePlan = {
          user_active_plan: res.data.data[0].user_active_plan,
        };
        if (!!res.data.data[0].user_active_plan && res.data.data[0].user_active_plan !== "") {
          this.setState({
            currentUserPlan: res.data.data[0].user_active_plan,
            userFirstPlan: res.data.data[0],
          });
          if (this.upgradePlansDictionary && this.upgradePlansDictionary[res.data.data[0].user_active_plan] && this.upgradePlansDictionary[res.data.data[0].user_active_plan].defaultTab) {
            this.setState({
              currentTab: this.defaultData.countryType.toLowerCase() === "import" || this.defaultData.countryType.toLowerCase() === "imports" ? this.upgradePlansDictionary[res.data.data[0].user_active_plan].defaultTab : this.upgradePlansDictionary[res.data.data[0].user_active_plan].defaultTab,
            });
          } else if (res.data.data[0].user_active_plan.includes("pro")) {
            this.setState({
              currentTab: tabKeywords.shipments,
            });
          } else if (res.data.data[0].user_active_plan.includes("starter")) {
            this.setState({
              currentTab: tabKeywords.shipments,
            });
          } else if (res.data.data[0].user_active_plan === this.upgradePlansDictionary.trademo_intel_us_pro_lite.key) {
            this.setState({
              currentTab: tabKeywords.importers,
            });
          }
        }
        this.localStorageService.setDataToLocalStorage("userCurrentPlan", localStoragePlan);
        if (type !== "Download" && type !== "Email" && type !== "PreviousState") {
          if (!!res.data.data[0] && ((!!res.data.data[0].searchFromDateExports && res.data.data[0].searchToDateExports && res.data.data[0].searchFromDateExports !== "" && res.data.data[0].searchToDateExports !== "") || (!!res.data.data[0].searchFromDate && res.data.data[0].searchToDate && res.data.data[0].searchFromDate !== "" && res.data.data[0].searchToDate !== ""))) {
            const tempFromDate = this.defaultData.countryType.toLowerCase() === countryTypeDictionary.import.toLowerCase() ? res.data.data[0].searchFromDate : res.data.data[0].searchFromDateExports;
            const tempToDate = this.defaultData.countryType.toLowerCase() === countryTypeDictionary.import.toLowerCase() ? res.data.data[0].searchToDate : res.data.data[0].searchToDateExports;
            let originalFromDates = this.defaultData.countryType.toLowerCase() === countryTypeDictionary.import.toLowerCase() && res.data.data[0].defaultSearchFromDate ? moment(res.data.data[0].defaultSearchFromDate) : this.defaultData.countryType.toLowerCase() === countryTypeDictionary.export.toLowerCase() && res.data.data[0].defaultSearchFromDateExports ? moment(res.data.data[0].defaultSearchFromDateExports) : moment(tempFromDate);
            let isAdd = false;
            if (moment().utcOffset() >= 0) {
              isAdd = false;
            } else {
              isAdd = true;
            }
            const userCreditResponse = res.data?.data?.[0] ?? null;
            const creditQuotaResponse = res.data?.credit_details ?? null;
            const {
              defaultData,
              state: { searchQueryString, fromAccutalArrivalDate },
            } = this;

            const { picker, countryType } = defaultData || {};

            const isImport = countryType?.toLowerCase() === countryTypeDictionary.import.toLowerCase();
            const isExport = countryType?.toLowerCase() === countryTypeDictionary.export.toLowerCase();

            const getSearchFromDate = () => {
              const firstDataItem = res?.data?.data?.[0];
              if (isImport && firstDataItem?.searchFromDate) return firstDataItem.defaultSearchFromDateImport;
              if (firstDataItem?.searchFromDateExports) return firstDataItem.searchFromDateExports;
              return "2021-01";
            };

            const newState = {
              userCredit: userCreditResponse,
              creditQuota: creditQuotaResponse,
              originalFromDate: originalFromDates,
              originalEndDate: moment(tempToDate),
              filterFromDate: moment(tempFromDate),
              filterEndDate: moment(tempToDate),
              latestActualArrivalDate: moment(tempToDate).toDate(),
              fromAccutalArrivalDate: mapSearchFromDate(countryType, searchQueryString, userCreditResponse, fromAccutalArrivalDate, originalFromDates),
              toAccutalArrivalDate: mapSearchToDate(countryType, searchQueryString, userCreditResponse, fromAccutalArrivalDate, tempToDate),
              paidPlanDateRange: mapYearDatesInCalendar(isAdd, tempToDate, isExport ? res.data.data?.[0]?.export_start_date : res.data.data?.[0]?.import_start_date),
            };
            if (picker?.monthPicker) {
              newState.monthObject = mapMonthObject(tempToDate, getSearchFromDate(), tempFromDate);
            }
            if (this.props.shipmentDetails?.searchParameters?.redirectionId) {
              this.setState({
                redirectionIdFromAutoSuggest: this.props.shipmentDetails?.searchParameters?.redirectionId,
              });
            }
            //user created logic
            const userCreatedData = this.props.userDetails.userData.createdDate;
            const userData = {
              userCreatedData: userCreatedData,
              featureLaunchDate: "2025-08-20T00:00:00.000Z",
            };
            if (!this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter") && userData.userCreatedData < userData.featureLaunchDate) {
              this.handleNudgePopup("new_credit_system", "event");
            }
            this.setState(newState, () => {
              this.settingInitialPayloadHandler();
            });
          } else {
            toast.error("Something went Wrong. Please try again after somme time.");
          }
        } else {
          this.setState({
            userCredit: res.data.data[0],
            creditQuota: res.data.credit_details,
          });
        }
      } else {
        if (this.state.getUserPlanCount < 5) {
          // Need to check this Code later
          const tempCount = this.state.getUserPlanCount;
          setTimeout(() => {
            this.setState({
              getUserPlanCount: tempCount + 1,
            });
            this.getUserPlan("1222");
          }, 2000);
        }
      }
      this.callNudgeStatus();
    } catch (err) {
      Sentry.captureException(err);
    }
  };
  // End of the above code
  // Below code is used to get the arrival Date Data

  settingInitialPayloadHandler = async () => {
    const isReloadFromDashboard = !!queryString.parse(window.location.search).isReload && queryString.parse(window.location.search).isReload === "true" ? true : false;
    const recentSearch = !!queryString.parse(window.location.search).searchType && queryString.parse(window.location.search).searchType === "recent" ? true : false;
    const topSearch = !!queryString.parse(window.location.search).searchType && queryString.parse(window.location.search).searchType === "topSearch" ? true : false;
    const zeroSearch = !!queryString.parse(window.location.search).searchType && queryString.parse(window.location.search).searchType === "zeroSearch" ? true : false;
    const topsearchredfromemail = !!queryString.parse(window.location.search).topsearchredfromemail && queryString.parse(window.location.search).topsearchredfromemail !== "" ? true : false;
    const classifierSearch = !!queryString.parse(window.location.search).searchType && queryString.parse(window.location.search).searchType === "classifier" ? true : false;
    const universalSearch = !!queryString.parse(window.location.search).searchType && queryString.parse(window.location.search).searchType === "universal" ? true : false;
    const reloadSavedSearchData = JSON.parse(localStorage.getItem("reloadSavedSearch"));
    let matchTypeValue = "contains";
    if (isReloadFromDashboard) {
      matchTypeValue = reloadSavedSearchData?.search_type || "contains";
    }
    if (!this.props.shipmentDetails?.searchParameters?.comingFrom) {
      this.props.searchParametersHandler({
        searchCategory: "",
        searchedItem: "",
        dataSource: this.defaultData.country_small === "multicountry" ? "multi_country" : this.defaultData.redirectionID.slice(0, this.defaultData.redirectionID.length - 1),
        matchType: matchTypeValue,
        redirectionId: this?.state?.redirectionIdFromAutoSuggest ?? {},
      });
    }

    if (topSearch && JSON.parse(localStorage.getItem("topSearch"))) {
      const data = JSON.parse(localStorage.getItem("topSearch"));
      this.reloadTopSearch(data);
    } else if (recentSearch === true && JSON.parse(localStorage.getItem("recentSearch"))) {
      const data = JSON.parse(localStorage.getItem("recentSearch"));
      this.reloadRecentSearch(data);
      let searchCategory = data?.key;
      if (searchCategory === tabKeywords.importers || searchCategory === tabKeywords.exporters) {
        this.setState({
          currentTab: searchCategory,
        });
      }
    } else if (classifierSearch === true && localStorage.getItem("classifierSearch") && JSON.parse(localStorage.getItem("classifierSearch"))) {
      const data = JSON.parse(localStorage.getItem("classifierSearch"));
      const hscode = data.hscode || "";

      const classifierData = {
        searchParameters: {
          searchCategory: "product_hscode",
          matchType: "contains",
          searchedItem: hscode,
          dataSource: "multi_country",
        },
        redirectionTab: data?.classification_type === "import" ? tabKeywords.exporters : data?.classification_type === "export" ? tabKeywords.importers : tabKeywords.shipments,
      };
      this.callingSearchResult(requestObjectType.search, undefined, undefined, classifierData);
      localStorage.removeItem("classifierSearch");
    } else if (isReloadFromDashboard === true && this.localStorageService.getReloadSavedSearchData()) {
      const data = this.normalizeSavedSearchPayload(this.localStorageService.getReloadSavedSearchData());
      this.reloadSaveSearches(data);
    } else if (zeroSearch === true && sessionStorage.getItem("handleGoToAllDatasets") && JSON.parse(sessionStorage.getItem("handleGoToAllDatasets"))) {
      let temp = JSON.parse(sessionStorage.getItem("handleGoToAllDatasets"));
      sessionStorage.removeItem("handleGoToAllDatasets");
      this.handleGoToAllCategory(temp);
    } else if (topsearchredfromemail === true) {
      const searched_item = queryString.parse(window.location.search).topsearchredfromemail;
      let requestObject = {
        search: searched_item,
        is_chemical: false,
        key: "entire_bill_of_lading",
        category_name: "All Categories",
      };
      this.reloadTopSearch(requestObject);
    } else if (queryString.parse(window.location.search).toAnalytics === "true" && queryString.parse(window.location.search).searchedItem) {
      const searchedItem = queryString.parse(window.location.search).searchedItem;
      const rawKey = queryString.parse(window.location.search).currentKey || "product_description";
      const currentKey = rawKey === "product_hscode" ? "product_hscode" : "product_description";
      const matchType = queryString.parse(window.location.search).matchType || "contains";

      const analyticsFilterKey = new URLSearchParams(window.location.search).get("analyticsFilterKey");
      const analyticsFilterValue = new URLSearchParams(window.location.search).get("analyticsFilterValue");
      const analyticsFilterKey2 = new URLSearchParams(window.location.search).get("analyticsFilterKey2");
      const analyticsFilterValue2 = new URLSearchParams(window.location.search).get("analyticsFilterValue2");

      if (analyticsFilterKey && analyticsFilterValue) {
        const appliedFilterClone = { ...this.props.shipmentDetails.appliedFilter };
        let tempIncludeFilter = [...this.state.includeFilter];
        let tempExcludeFilter = [...this.state.excludeFilter];

        appliedFilterClone[analyticsFilterKey] = analyticsFilterValue.split(",");
        [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, analyticsFilterKey);

        if (analyticsFilterKey2 && analyticsFilterValue2) {
          appliedFilterClone[analyticsFilterKey2] = analyticsFilterValue2.split(",");
          [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, analyticsFilterKey2);
        }

        this.setState({ includeFilter: tempIncludeFilter, excludeFilter: tempExcludeFilter, isFilterApplied: true });
        await this.props.appliedFilterHandler(appliedFilterClone);
      }

      this.callingSearchResult(requestObjectType.search, undefined, undefined, {
        searchParameters: {
          searchCategory: currentKey,
          matchType,
          searchedItem,
          dataSource: "multi_country",
        },
        redirectionTab: tabKeywords.analytics,
      });
    } else if (queryString.parse(window.location.search).redirectingFrom === "company" && queryString.parse(window.location.search).searchedItem) {
      const { searchedItem, currentKey: rawKey, matchType, fromDate, toDate } = queryString.parse(window.location.search);
      const currentKey = rawKey === "product_hscode" ? "product_hscode" : rawKey === "product_and_hscode" ? "product_and_hscode" : "product_description";
      if (fromDate && toDate) {
        this.setState({ fromAccutalArrivalDate: moment(fromDate).toDate(), toAccutalArrivalDate: moment(toDate).toDate() });
      }
      this.callingSearchResult(requestObjectType.search, undefined, undefined, {
        searchParameters: { searchCategory: currentKey, matchType: matchType || "contains", searchedItem, dataSource: "multi_country" },
      });
    }
    // else {
    //   this.callingSearchResult(requestObjectType.search);
    // }
    else if (universalSearch === true) {
      // Universal Search (clicked from the Reload Saved Search modal): restore the old
      // default behavior of auto-running the default search and showing the default search
      // data, instead of landing on the recent/saved searches default view.
      this.callingSearchResult(requestObjectType.search);
      // Strip the query params so a refresh/back doesn't re-trigger the universal flow.
      this.props.history.replace({
        pathname: this.props.location.pathname,
        search: "",
      });
    } else if (this.state.isRedirect || this.props.shipmentDetails?.searchParameters?.comingFrom) {
      this.callingSearchResult(requestObjectType.search);
    }
  };
  // End of the above code
  // below code is for Getting the Analytics Data
  getAnalyticsData = (type, data) => {
    if (this.state && this.state.currentPlanAccess && this.state.currentPlanAccess.is_analytics_tab === false) return;
    this.setState({
      analyticsData: [],
      analyticsPresent: false,
      isLoaderActive: true,
      analyticsLoader: true,
    });
    let requestObject = {};
    if (Object.keys(this.state.finalReqObj).length !== 0 && type !== requestObjectType.filter) {
      requestObject = JSON.parse(JSON.stringify(this.state.finalReqObj));
      if (this.props.shipmentDetails?.searchParameters?.searchedItem !== "") {
        this.props.searchParametersHandler({
          searchCategory: this.props.shipmentDetails?.searchParameters?.searchCategory,
          searchedItem: this.props.shipmentDetails?.searchParameters?.searchedItem,
          dataSource: this.props.shipmentDetails?.searchParameters?.dataSource,
          matchType: this.props.shipmentDetails?.searchParameters?.matchType,
          redirectionId: this.props.shipmentDetails?.searchParameters?.redirectionId,
        });
      }
    } else {
      requestObject = this.creatingRequestObject(requestObjectType.analytics);
    }
    let searchUrlParams = window.location.search;
    let analysis = new URLSearchParams(searchUrlParams).get("toAnalytics");
    let sortId = new URLSearchParams(searchUrlParams).get("sort");
    // reloadSaveSearchData
    requestObject.analysis = !!data && data !== "" ? data : analysis === "true" ? sortId || this.state.reloadSaveSearchData?.search_data?.analysis : this.state.analysisKey ? this.state.analysisKey : null;
    if (!requestObject.analysis) requestObject.analysis = "shipments";
    requestObject.companyType = "";
    requestObject.analyticsField = true;
    requestObject.industry = this.props.userDetails?.userData?.industry || localStorage.getItem("industry") || "others";
    const apiUrl = this.defaultData.apiEndPoints.getAnalyticsData;
    this.setState({
      finalReqObj: requestObject,
      isLoaderActive: true,
      analyticsLoader: true,
      analysisKey: requestObject.analysis,
    });
    //sort by tracking events data
    const redirectionFrom = new URLSearchParams(searchUrlParams).get("redirectingFrom");
    const dataSource = this.defaultData.analyticsCountryID;
    const pathName = this.props.location.pathname;
    const currentUserPlan = this.state.currentUserPlan;
    //sort by tracking event
    if (data) {
      if (redirectionFrom) {
        let event = trackingEventDictionary["redirectedFromAnalyticsTabSortBy"];
        if (this.state.redirectionHsCodeValue) {
          event = event.replace("redirectedFrom", "hs_code_profile");
        } else if (redirectionFrom === profileTypeEnum.company) {
          event = event.replace("redirectedFrom", "company");
        } else if (redirectionFrom === profileTypeEnum.tradeLanes) {
          event = event.replace("redirectedFrom", "tradelane");
        } else if (redirectionFrom === profileTypeEnum.ports) {
          event = event.replace("redirectedFrom", "ports");
        } else if (redirectionFrom === profileTypeEnum.logistics) {
          event = event.replace("redirectedFrom", "logistics_company");
        }

        trademoTrackingEvents(`${event}_${data}`, generateTrackingObject(dataSource, pathName, currentUserPlan));
      } else {
        trademoTrackingEvents(`${trackingEventDictionary.analyticsTabSortBy}_${data}`, generateTrackingObject(dataSource, pathName, currentUserPlan));
      }
    }

    axios
      .post(apiUrl, requestObject)
      .then(
        (res) => {
          let analyticsCachingDataClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.analyticsCaching));
          if (!!res && !!res.data) {
            this.setState({
              analyticsData: res.data,
              analyticsPresent: true,
            });
            if (this.state.shipmentPresent) this.setState({ isLoaderActive: false });
            if (!type || type !== requestObjectType.filter) {
              this.setState({
                storedAnalyticsData: res.data,
              });
            }
          }
          analyticsCachingDataClone = JSON.parse(JSON.stringify(res.data));
          this.props.analyticsCachingData(analyticsCachingDataClone);
          setTimeout(() => {
            const searchUrlParams = this.props.location.search;
            let analytics_keys = new URLSearchParams(searchUrlParams).get("analyticsKey");
            if (!!analytics_keys && !!document.getElementById(analytics_keys)) {
              let element = document.getElementById(analytics_keys);
              let rect = element.getBoundingClientRect();
              window.scrollTo(0, rect.top - 60);
            }
          }, 300);
        },
        () => {
          toast.error("Something went wrong! Please try again.");
        }
      )
      .catch(() => toast.error("Something went wrong! Please try again."))
      .finally(() => {
        this.setState({
          isLoaderActive: false,
          analyticsLoader: false,
        });
      });
  };
  // Below Code used to show US Upgrade Popup
  upgradeUSExportPopupShow = () => {
    this.setState({
      showUSExportsDataModal: true,
    });
  };

  changeDurationHandler(data) {
    let reqObject = JSON.parse(JSON.stringify(this.state.finalReqObj));
    reqObject.companyType = this.state.currentTab === requestObjectType.exporters.toLowerCase() ? "shipper" : this.state.currentTab === requestObjectType.importers.toLowerCase() ? "consignee" : this.state.currentTab === requestObjectType.logistics.toLowerCase() ? "logistic" : "";

    if (Object.keys(this.state.tempObj).length || Object.keys(this.state.expTempObj).length) {
      if (this.state.currentTab === tabKeywords.importers) {
        reqObject = { ...reqObject, ...this.state.tempObj };
        reqObject.must_not = [];
      } else if (this.state.currentTab === tabKeywords.exporters) {
        reqObject = { ...reqObject, ...this.state.expTempObj };
        reqObject.must_not = [];
      } else if (this.state.currentTab === tabKeywords.logistics) {
        reqObject = { ...reqObject, ...this.state.logisticsTempObj };
        reqObject.must_not = [];
      }
    }
    if (this.defaultData.showUiUeLevelTwo) {
      if (this.state.currentTab === tabKeywords.importers) {
        reqObject.isSecondLevelAnalytics = this.state.uiTwoLevel;
        if (this.state.uiTwoLevel) {
          reqObject.subAnalyticsField = this.state.defaultUiUeTwoLevelSelctedHeading;
        }
      } else if (this.state.currentTab === tabKeywords.exporters) {
        reqObject.isSecondLevelAnalytics = this.state.ueTwoLevel;
        if (this.state.ueTwoLevel) {
          reqObject.subAnalyticsField = this.state.defaultUiUeTwoLevelSelctedHeading;
        }
      } else if (this.state.currentTab === tabKeywords.logistics) {
        reqObject.isSecondLevelAnalytics = this.state.ulTwoLevel;
        if (this.state.ulTwoLevel) {
          reqObject.subAnalyticsField = this.state.defaultUlTwoLevelSelectedHeading;
        }
      }
    }
    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        reqObject[this.defaultData.internalFilterList[i].key] = !!this.state && !!this.state.tempObj[this.defaultData.internalFilterList[i].key] && this.state.tempObj[this.defaultData.internalFilterList[i].key].length > 0 ? this.state.tempObj[this.defaultData.internalFilterList[i].key] : [];
      }
    }
    reqObject.must_not = [];
    if (this.state.currentTab === tabKeywords.importers || this.state.currentTab === tabKeywords.exporters) {
      reqObject.secondLevelCompanyIds = this.state.currentTab === tabKeywords.importers ? this.state.importerMongoIds.slice(0, 20) : this.state.currentTab === tabKeywords.exporters ? this.state.exporterMongoIds.slice(0, 20) : [];
    }
    this.setState(
      {
        isLoaderActive: true,
        prospectExporter: [],
        prospectImporter: [],
        prospectLogistics: [],
        clearBotton: !this.state.clearBotton,
        importerCurrentPage: 1,
        exporterCurrentPage: 1,
        logisticsCurrentPage: 1,
        currentPage: 1,
        defaultPage: 1,
        impDefaultSort: tabKeywords.importers === this.state.currentTab.toLowerCase() ? data : this.state.impDefaultSort,
        expDefaultSort: tabKeywords.exporters === this.state.currentTab.toLowerCase() ? data : this.state.expDefaultSort,
        logisticsDefaultSort: tabKeywords.logistics === this.state.currentTab.toLowerCase() ? data : this.state.logisticsDefaultSort,
      },
      () => {
        this.viewTrends(reqObject, "", "");
      }
    );
  }

  // End of the above code
  // below code is for handling the Exporter Table and Graph Toggle
  setExporterTableToggle = (thisData) => {
    if (this.state.currentTab === tabKeywords.importers) {
      // Track Event for Importer Graph for Company Importers
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.companyShipmentsPageUniqueImportersTabNetworkGraph);
      this.setState({
        isImporterTableVisible: thisData,
        trendsTab: false,
        prospectImporter: [],
        prospectExporter: [],
        prospectLogistics: [],
        importerCurrentPage: 1,
        exporterCurrentPage: 1,
        logisticsCurrentPage: 1,
        currentPage: 1,
        defaultPage: 1,
        mustNotIncludeExporter: [...[]],
        mustNotIncludeImporter: [...[]],
        mustNotIncludeLogistics: [...[]],
      });
    } else if (this.state.currentTab === tabKeywords.exporters) {
      // Track Event for Exporter Graph for Company Exporters
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.companyShipmentsPageUniqueExportersTabNetworkGraph);
      this.setState({
        isExporterTableVisible: thisData,
        exporterTrendsTab: false,
        prospectImporter: [],
        prospectExporter: [],
        prospectLogistics: [],
        importerCurrentPage: 1,
        exporterCurrentPage: 1,
        logisticsCurrentPage: 1,
        currentPage: 1,
        defaultPage: 1,
        mustNotIncludeExporter: [...[]],
        mustNotIncludeImporter: [...[]],
        mustNotIncludeLogistics: [...[]],
      });
    } else if (this.state.currentTab === tabKeywords.logistics) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.companyShipmentsPageUniqueLogisticsTabNetworkGraph);
      this.setState({
        isLogisticsTableVisible: thisData,
        logisticsTrendsTab: false,
        prospectImporter: [],
        prospectExporter: [],
        prospectLogistics: [],
        importerCurrentPage: 1,
        exporterCurrentPage: 1,
        logisticsCurrentPage: 1,
        currentPage: 1,
        defaultPage: 1,
        mustNotIncludeExporter: [...[]],
        mustNotIncludeImporter: [...[]],
        mustNotIncludeLogistics: [...[]],
      });
    }
  };
  // End of the above code
  // TODO:Shubham
  // Below code is for creating the request Object

  creatingRequestObject(type, data) {
    try {
      let requestObjIncludeFilter = !!this.state.includeFilter && this.state.includeFilter.map((item) => (this.localisationFilterObj[item] ? this.localisationFilterObj[item] : item));
      let requestObjExcludeFilter = !!this.state.excludeFilter && this.state.excludeFilter.map((item) => (this.localisationFilterObj[item] ? this.localisationFilterObj[item] : item));
      let tempRequestObject = {
        from: type === requestObjectType.pagination ? this.state.from : 0,
        size: 200,
        sort: this.state.currentTab === tabKeywords.importers ? this.state.importerSortValue : this.state.currentTab === tabKeywords.exporters ? this.state.exporterSortValue : this.state.currentTab === tabKeywords.logistics ? this.state.logisticsSortValue : this.state.currentTab === tabKeywords.shipments ? (this.state.sortValue ? this.state.sortValue : "date") : "date",
        search_type: this.state.searchTypeStr ? this.state.searchTypeStr : "basic",
        order: this.state.currentTab === tabKeywords.importers ? this.state.importerSortOrderValue : this.state.currentTab === tabKeywords.exporters ? this.state.exporterSortOrderValue : this.state.currentTab === tabKeywords.logistics ? this.state.logisticsSortOrderValue : this.state.currentTab === tabKeywords.shipments ? this.state.sortOrderValue : "desc",
        companyType: type === requestObjectType.exporters ? "shipper" : type === requestObjectType.importers ? "consignee" : type === requestObjectType.logistics ? "logistic" : "",
        analyticsField: type === requestObjectType.analytics ? true : false,
        reload: !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? true : false,
        is_from_alert: !!this.state && !!this.state.is_from_alert && this.state.is_from_alert !== "" ? this.state.is_from_alert : "",
        companyImporterId: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectingCompanyImporterId ? this.state.redirectingCompanyImporterId : [],
        companyExporterId: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectingCompanyExporterId ? this.state.redirectingCompanyExporterId : [],
        companyLogisticsId: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectingCompanyLogisticsId ? this.state.redirectingCompanyLogisticsId : [],
        hscode_profile_key: !!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && !!this.state.redirectionHsCodeValue ? this.state.redirectionHsCodeValue : !!data && data.search_data && data.search_data.hscode_profile_key ? data.search_data.hscode_profile_key : "",
        companyKey: "",
        companyPageNo: 1,
        searchEnable: type === requestObjectType.search && this.state.isFreeTrial ? true : false,
        must_not: [],
        isMerged: this.state.isMerged,
        isSubsidiaryIncluded: this.state.isSubs,
        hsCodeLevel: this.state.hsCodeList ? this.state.hsCodeList : [],
        includeFilters: requestObjIncludeFilter,
        excludeFilters: requestObjExcludeFilter,
        search_includes: [],
        customType: this.state.type,
        redirectingProfile: this.state.isRedirect && new URLSearchParams(this.props.location.search).get("redirectingProfile") ? redirectionTypePayload[new URLSearchParams(this.props.location.search).get("redirectingProfile")] : "",
        redirectingProfilePartner: this.state.isRedirect && new URLSearchParams(this.props.location.search).get("redirectingProfilePartner") ? redirectionTypePayload[new URLSearchParams(this.props.location.search).get("redirectingProfilePartner")] : "",
        redirectingProfileIds: this.state.isReloadSearchClicked && data?.search_data && data?.search_data?.redirectingProfileIds && data?.search_data?.redirectingProfileIds?.length > 0 ? data?.search_data?.redirectingProfileIds : this.state.isRedirect && this.state.redirectingProfileId ? this.state.redirectingProfileId : [],
        redirectingProfilePartnerIds: this.state.isRedirect && this.state.redirectingProfilePartnerId ? this.state.redirectingProfilePartnerId : [],
        is_from_autosuggest: this.state.isSelectedFromAutoSuggest ? true : false,
        redirection_profile_id: this.state.isReloadSearchClicked && data && data.search_data && data.search_data.redirection_profile_id ? data.search_data.redirection_profile_id : this.state.redirectionIdFromAutoSuggest[this.state.searchedItem],
      };
      if (this.state.isMerged) {
        tempRequestObject.mergedID = +this.state.mergedId;
      }

      if (this.state.currentTab === tabKeywords.logistics && this.state.logisticsFilter?.length > 0) {
        tempRequestObject.logisticsType = this.state.logisticsFilter;
      }
      if (!!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true && this.state.redirectingItemNumberId && this.state.redirectingItemNumber) {
        if (this.defaultData.country_small === globalCountryDetailsDictionary.ru_import.country_small || this.defaultData.country_small === globalCountryDetailsDictionary.global_plan.country_small) {
          tempRequestObject.declarationNumber = this.state.redirectingItemNumberId;
        } else {
          tempRequestObject.exportId = this.state.redirectingItemNumberId;
        }
        tempRequestObject.itemNumber = this.state.redirectingItemNumber;
      }
      const isSearchOrReload = type === requestObjectType.search || type === requestObjectType.reloadSearch || (!!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true);
      // For filter/pagination etc. use the "main" dates locked in at search time; fall back to the
      // currently selected range when no search has been performed yet (filter-first flow).
      const fromDateRaw = isSearchOrReload ? this.state.fromAccutalArrivalDate : (this.state.mainFromAccutalArrivalDate ?? this.state.fromAccutalArrivalDate);
      const toDateRaw = isSearchOrReload ? this.state.toAccutalArrivalDate : (this.state.mainToAccutalArrivalDate ?? this.state.toAccutalArrivalDate);
      const dateFormat = this.defaultData && this.defaultData.picker && this.defaultData.picker.monthPicker ? "YYYY-MM" : "YYYY-MM-DD";
      tempRequestObject.fromDate = fromDateRaw && moment(fromDateRaw).isValid() ? moment(fromDateRaw).format(dateFormat) : "";
      tempRequestObject.toDate = toDateRaw && moment(toDateRaw).isValid() ? moment(toDateRaw).format(dateFormat) : "";

      tempRequestObject.search = this.state.searchedItem ? this.state.searchedItem : "";
      tempRequestObject.key = this.state.searchKey;
      tempRequestObject.queryType = this.state.searchQueryType;
      for (let i = 0; i < this.filterMapList.length; i++) {
        if (!!this.filterMapList[i].key && this.boxFilterList.includes(this.filterMapList[i].key) === true) {
          tempRequestObject[this.filterMapList[i].key] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[this.filterMapList[i].key] !== undefined ? data.search_data[this.filterMapList[i].key] : []) : [...this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key]];
        } else if (this.hsCodeFilterList.includes(this.filterMapList[i].key) === true) {
          if (this.filterMapList[i].altKey) {
            //this is added to handle where key are different in payload and response-arindam
            tempRequestObject[this.filterMapList[i].altKey] = type === requestObjectType.reloadSearch && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && data.search_data[this.filterMapList[i].key] ? data.search_data[this.filterMapList[i].key] : []) : Array.isArray(this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key]) && this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key].length > 0 ? [...this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key]] : [];
          } else {
            tempRequestObject[this.filterMapList[i].key] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && data.search_data[this.filterMapList[i].key] ? data.search_data[this.filterMapList[i].key] : []) : Array.isArray(this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key]) && this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key].length > 0 ? [...this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key]] : [];
          }
        } else if (!!this.filterMapList[i].key && this.teuFilterList.includes(this.filterMapList[i].key)) {
          tempRequestObject[this.filterMapList[i].key] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[this.filterMapList[i].key] && data.search_data[this.filterMapList[i].key] !== "" ? mapReloadTeuFiltersArray(data.search_data[this.filterMapList[i].key]) : []) : this.state.isFilterApplied ? mapTeuFiltersArray(this.state.filterObj[this.filterMapList[i].key]) : [];
        } else if (!!this.filterMapList[i].key && this.weightFilterList.includes(this.filterMapList[i].key)) {
          tempRequestObject[this.filterMapList[i].key] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[this.filterMapList[i].key] && data.search_data[this.filterMapList[i].key] !== "" ? mapReloadWeightFiltersArray(data.search_data[this.filterMapList[i].key]) : []) : this.state.isFilterApplied ? mapWeightFiltersArray(this.state.filterObj[this.filterMapList[i].key]) : [];
        } else if (!!this.filterMapList[i].key && this.proximityFilterList.includes(this.filterMapList[i].key) === true) {
          tempRequestObject[this.filterMapList[i].key] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[this.filterMapList[i].key] && data.search_data[this.filterMapList[i].key] !== "" ? data.search_data[this.filterMapList[i].key] : []) : this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key];
        } else if (!!this.filterMapList[i].key && this.radioFilterList.includes(this.filterMapList[i].key) === true) {
          tempRequestObject[this.filterMapList[i].key] = true;
        } else {
          tempRequestObject[this.filterMapList[i].key] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[this.filterMapList[i].key] && data.search_data[this.filterMapList[i].key] !== "" ? data.search_data[this.filterMapList[i].key] : []) : this.props.shipmentDetails.appliedFilter[this.filterMapList[i].key];
          if (this.filterMapList[i].additionalKey) tempRequestObject[this.filterMapList[i].additionalKey] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[this.filterMapList[i].additionalKey] && data.search_data[this.filterMapList[i].additionalKey] !== "" ? data.search_data[this.filterMapList[i].additionalKey] : []) : this.props.shipmentDetails.appliedFilter[this.filterMapList[i].additionalKey];

          if (tempRequestObject[this.filterMapList[i].key] && tempRequestObject[this.filterMapList[i].key].length > 0 && requestObjIncludeFilter && requestObjIncludeFilter.includes(this.filterMapList[i].key) === false && requestObjExcludeFilter && requestObjExcludeFilter.includes(this.filterMapList[i].key) === false && this.state.redirectingCompanyName && this.state.redirectingCompanyName !== "") {
            requestObjIncludeFilter.push(this.filterMapList[i].key);
          }
        }
      }

      if (type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true) {
        this.setState({
          isChemicalPresent: data.search_data.key === searchPhraseDictionary.chemical_description ? true : data.search_data.is_chemical,
        });
      }
      if (type === requestObjectType.reloadSearch && !!this.state.isReloadRecentSearchClicked && this.state.isReloadRecentSearchClicked === true) {
        this.setState({ isChemicalPresent: data.category_name === "Chemical" });
      }
      if (!!this.defaultData && this.defaultData.isProductChemicalPresent === true && this.state.isChemicalPresent === true) {
        tempRequestObject.is_chemical = true;
      } else {
        tempRequestObject.is_chemical = false;
      }
      if (this.state.isChemicalPresent && this.state.searchKey === searchPhraseDictionary.chemical_description) tempRequestObject[this.filterTypeEnum[this.specialFields.productCategory]] = ["Chemicals, Pharma and Allied Industries"];

      // localization filter setting here
      for (const [key, value] of Object.entries(this.localisationFilterObj)) {
        tempRequestObject[key] = [];
        tempRequestObject[value] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && !!data.search_data[value] && data.search_data[value] !== "" ? data.search_data[value] : []) : this.props.shipmentDetails.appliedFilter[key];
        if (tempRequestObject[value].length > 0 && requestObjIncludeFilter && requestObjIncludeFilter.includes(value) === false && requestObjExcludeFilter && requestObjExcludeFilter.includes(value) === false && this.state.redirectingCompanyName && this.state.redirectingCompanyName !== "") {
          requestObjIncludeFilter.push(value);
        }
      }

      // Boolean filter setting here
      for (const key1 of Object.keys(this.booleanFilterObject)) {
        tempRequestObject[key1] = type === requestObjectType.reloadSearch && !!this.state.isReloadSearchClicked && this.state.isReloadSearchClicked === true ? (!!data && !!data.search_data && data.search_data[key1] !== undefined ? data.search_data[key1] : this.defaultBooleanFilterObject[key1]) : this.state.isFilterApplied ? this.props.shipmentDetails.appliedFilter[key1] : this.defaultBooleanFilterObject[key1];
      }
      const searchUrlParams = this.props.location.search;
      // DataSource Filter For sending it to the payload
      for (let property in tempRequestObject) {
        if (tempRequestObject[property] && Array.isArray(tempRequestObject[property]) && !tempRequestObject[property].length) {
          if (!tempRequestObject[this.localisationFilterObj[property]] || (Array.isArray(tempRequestObject[this.localisationFilterObj[property]]) && !tempRequestObject[this.localisationFilterObj[property]].length)) {
            delete tempRequestObject[property];
          }
        }
      }

      if (new URLSearchParams(searchUrlParams).get("companyExporterId")) {
        tempRequestObject[this.specialFields.shipper] = [];
      }
      if (new URLSearchParams(searchUrlParams).get("companyImporterId")) {
        tempRequestObject[this.specialFields.consignee] = [];
      }
      if (this.state.redirectingProfileType) {
        if (this.localisationFilterObj[this.state.redirectingProfileType]) {
          tempRequestObject[this.localisationFilterObj[this.state.redirectingProfileType]] = [];
          tempRequestObject[this.state.redirectingProfileType] = [];
        } else {
          tempRequestObject[this.state.redirectingProfileType] = [];
        }
      }
      if (this.state.redirectingProfilePartnerType) {
        if (this.localisationFilterObj[this.state.redirectingProfilePartnerType]) {
          tempRequestObject[this.localisationFilterObj[this.state.redirectingProfilePartnerType]] = [];
          tempRequestObject[this.state.redirectingProfilePartnerType] = [];
        } else {
          tempRequestObject[this.state.redirectingProfilePartnerType] = [];
        }
      }
      let selectedDataSource = JSON.parse(sessionStorage.getItem("selectedCountry"));
      if (window.location.href.includes("all-country-shipments")) {
        let data = selectedDataSource?.data?.map((item) => {
          if (item?.dataSource) {
            return item?.dataSource;
          }
        });
        // When session is absent (e.g. first load from Company Profile redirect), build the
        // datasource list from the user's SUBSCRIBED datasets so the backend does not fall back
        // to all subscribed indices. Prefer subscribed direct datasets; if the user has none
        // (e.g. a Mirror-only subscription like India Mirror), fall back to subscribed mirror
        // datasets so we never send unsubscribed datasets or drop the only entitlement.
        if (!data?.filter(Boolean).length) {
          const dataSourceListClone = this.props.userDetails.creditDetails?.dataSourceList || {};
          const directDataSources = [];
          const mirrorDataSources = [];
          Object.keys(dataSourceListClone).forEach((option) => {
            Object.keys(dataSourceListClone[option]).forEach((cntryData) => {
              const entry = dataSourceListClone[option][cntryData];
              if (!entry?.dataSource || entry?.dataSourceInfo?.is_subscribed !== true) {
                return;
              }
              if (entry?.continent === "MIRROR") {
                mirrorDataSources.push(entry.dataSource);
              } else {
                directDataSources.push(entry.dataSource);
              }
            });
          });
          if (directDataSources.length) {
            data = directDataSources;
          } else if (mirrorDataSources.length) {
            data = mirrorDataSources;
          }
        }
        tempRequestObject.dataSource = data;
      }
      if (type === requestObjectType.reloadSearch && data?.search_data?.dataSource?.length > 0) {
        tempRequestObject.dataSource = data.search_data.dataSource;
        this.multiCountrySessionExistHandler(data?.search_data?.dataSource);
      }
      tempRequestObject.derivedConsigneeMasterNameAndIdMapping = this.state.derivedConsigneeMasterNameAndIdMapping;
      tempRequestObject.derivedShipperMasterNameAndIdMapping = this.state.derivedShipperMasterNameAndIdMapping;
      if (this.props.shipmentDetails?.searchParameters) {
        tempRequestObject.search = this.props.shipmentDetails?.searchParameters?.searchedItem && this.props.shipmentDetails?.searchParameters?.searchedItem !== "" ? this.props.shipmentDetails?.searchParameters?.searchedItem : this.state.searchedItem;
        tempRequestObject.key = this.props.shipmentDetails?.searchParameters?.searchCategory !== "" ? this.props.shipmentDetails?.searchParameters?.searchCategory : this.state.searchKey;
        tempRequestObject.queryType = this.props.shipmentDetails?.searchParameters?.matchType !== "" ? this.props.shipmentDetails?.searchParameters?.matchType : this.state.searchQueryType;
        if (this.props.shipmentDetails?.searchParameters?.searchedItem !== "") {
          this.setState({
            isSearchButtonCalled: true,
            searchKey: this.props.shipmentDetails?.searchParameters?.searchCategory,
            searchedItem: this.props.shipmentDetails?.searchParameters?.searchedItem,
            searchQueryType: this.props.shipmentDetails?.searchParameters?.matchType,
            searchCardParams: {
              searchedItem: this.props.shipmentDetails?.searchParameters?.searchedItem,
              searchInclude: false,
              currentKey: this.props.shipmentDetails?.searchParameters?.searchCategory,
              matchType: this.props.shipmentDetails?.searchParameters?.matchType,
            },
          });
          this.props.searchParametersHandler({
            searchCategory: this.props.shipmentDetails?.searchParameters?.searchCategory,
            searchedItem: this.props.shipmentDetails?.searchParameters?.searchedItem,
            dataSource: this.props.shipmentDetails?.searchParameters?.dataSource,
            matchType: this.props.shipmentDetails?.searchParameters?.matchType,
            redirectionId: this.props.shipmentDetails?.searchParameters?.redirectionId,
          });
        }
      }

      this.setState({
        existingSearchReqObj: tempRequestObject,
      });

      return tempRequestObject;
    } catch (err) {
      Sentry.captureException(err);
    }
  }

  multiCountrySessionExistHandler = (appliedDataSource) => {
    let selectedCountryClone = [...appliedDataSource];
    let optionsClone = JSON.parse(JSON.stringify(this.props.userDetails.creditDetails?.dataSourceList || []));
    let appliedCountryList = [];
    Object.keys(optionsClone).forEach((option) => {
      Object.keys(optionsClone[option]).forEach((cntryData) => {
        selectedCountryClone.forEach((item) => {
          if (this.state.isRedirect) {
            appliedCountryList.push(optionsClone[option][cntryData]);
          } else {
            if (optionsClone[option][cntryData].dataSource === item) {
              appliedCountryList.push(optionsClone[option][cntryData]);
              optionsClone[option][cntryData]["isChecked"] = true;
            }
          }
        });
      });
    });
    sessionStorage.setItem("selectedCountry", JSON.stringify({ data: appliedCountryList }));
  };
  // End of the above code
  //Below code is for email view shipment
  normalizeSavedSearchPayload = (rawData) => {
    const payload = rawData && typeof rawData === "object" ? { ...rawData } : {};
    const normalisedSearchData = payload?.search_data || payload?.search_payload || {};
    return {
      ...payload,
      search_data: normalisedSearchData,
    };
  };

  getSavedSearchFromEmail(data) {
    let queryString = "?id=" + data;
    const apiUrl = this.defaultData.apiEndPoints.getSavedSearchPayloadById + queryString;
    axios.get(apiUrl).then((res) => {
      setTimeout(() => {
        this.reloadSaveSearches(this.normalizeSavedSearchPayload(res.data));
      }, 100);
    });
  }

  reloadRecentSearch(data) {
    const fromDate = this.state.fromAccutalArrivalDate;
    const toDate = this.state.toAccutalArrivalDate;
    this.setState({
      mainFromAccutalArrivalDate: fromDate,
      mainToAccutalArrivalDate: toDate,
    });
    this.setState({
      searchKey: !!data && !!data.key && data.key !== "" ? data.key : "",
      searchedItem: !!data && !!data.user_search && !!data.user_search && data.user_search !== "" ? data.user_search : "",
      searchQueryType: "contains",
      reloadRecentData: { ...data },
      isReloadRecentSearchClicked: true,
      isChemicalPresent: data.is_chemical,
      currentTab: tabKeywords.shipments,
      isSearchButtonCalled: true,
      searchCardParams: {
        searchedItem: !!data && !!data.user_search && !!data.user_search && data.user_search !== "" ? data.user_search : "",
        searchInclude: false,
        currentKey: !!data && !!data.key && data.key !== "" ? data.key : "",
        matchType: data.queryType,
      },
      redirectionIdFromAutoSuggest: data && data.redirection_profile_id && data.user_search ? { [data.user_search]: data.redirection_profile_id } : "",
      isClickedPostSearchSugg: data && data?.redirection_profile_id && data?.redirection_profile_id !== "" ? true : false,
    });
    this.props.searchParametersHandler({
      searchCategory: data.key,
      searchedItem: data.user_search,
      dataSource: "multi_country",
      matchType: data.queryType,
      redirectionId: data && data.redirection_profile_id && data.user_search ? { [data.user_search]: data.redirection_profile_id } : "",
    });
    setTimeout(() => {
      this.callingPostSearchResults();
      this.callingSearchResult(requestObjectType.search);
    }, 100);
  }

  // Reload handler for the in-page search-history landing. When the picked search belongs to the
  // dataset already loaded on this page we reload in place (no full refresh / re-bootstrap); when it
  // targets a different dataset a navigation is unavoidable, so we fall back to the same-tab open.
  handleHistoryReload = (kind, data, url) => {
    let samePage = false;
    try {
      const targetPath = new URL(url, window.location.origin).pathname.replace(/^\/+|\/+$/g, "");
      const currentPath = window.location.pathname.replace(/^\/+|\/+$/g, "");
      samePage = !!targetPath && targetPath === currentPath;
    } catch (e) {
      samePage = false;
    }
    if (!samePage) {
      window.open(url, "_self");
      return;
    }
    this.setState({ isTableVisible: true }, () => {
      if (kind === "top") this.reloadTopSearch(data);
      else if (kind === "saved") this.reloadSaveSearches(data);
      else this.reloadRecentSearch(data);
    });
  };

  handleGoToAllDatasets() {
    let tempReqObj = JSON.parse(JSON.stringify(this.state.finalReqObj));
    if (this.defaultData.picker.monthPicker) {
      if (tempReqObj.fromDate.length === 7) tempReqObj.fromDate = tempReqObj.fromDate + "-01";
      if (tempReqObj.toDate.length === 7) tempReqObj.toDate = tempReqObj.toDate + "-01";
    }
    sessionStorage.setItem("handleGoToAllDatasets", JSON.stringify(tempReqObj));
    sessionStorage.removeItem("selectedCountry");
    window.location.href = "/all-country-shipments?searchType=zeroSearch";
  }

  handleGoToAllCategory(storedData) {
    let data = {};
    data.search_data = storedData ? JSON.parse(JSON.stringify(storedData)) : JSON.parse(JSON.stringify(this.state.finalReqObj));
    if (storedData) {
      this.setState({
        fromAccutalArrivalDate: data?.search_data?.fromDate,
        toAccutalArrivalDate: data?.search_data?.toDate,
      });
    }
    this.setState(
      {
        reloadSaveSearchData: { ...data },
        isSearchButtonCalled: true,
        isReloadSearchClicked: true,
        searchKey: storedData ? data?.search_data?.key : "entire_bill_of_lading",
        searchedItem: data?.search_data?.search || "",
        searchQueryType: data?.search_data?.queryType || "contains",
        reloadRecentData: { ...data },
        isReloadRecentSearchClicked: true,
        isChemicalPresent: data?.search_data?.is_chemical,
        currentTab: tabKeywords.shipments,
        searchCardParams: {
          searchedItem: data?.search_data?.search || "",
          searchInclude: false,
          currentKey: storedData ? data?.search_data?.key : "entire_bill_of_lading",
          matchType: data?.search_data?.queryType || "contains",
        },
      },
      () => {
        const requestObject = this.creatingRequestObject(requestObjectType.reloadSearch, data);
        requestObject.key = storedData ? data?.search_data?.key : "entire_bill_of_lading";
        requestObject.search = data?.search_data?.search;
        requestObject.fromDate = data?.search_data?.fromDate;
        requestObject.toDate = data?.search_data?.toDate;
        requestObject.is_from_alternate_suggestion = true;
        this.callingSearchAPI(requestObject, requestObjectType.search);
      }
    );
  }

  reloadTopSearch(data) {
    const fromDate = this.state.fromAccutalArrivalDate;
    const toDate = this.state.toAccutalArrivalDate;
    this.setState({
      mainFromAccutalArrivalDate: fromDate,
      mainToAccutalArrivalDate: toDate,
    });
    this.setState({
      searchKey: !!data && !!data.key && data.key !== "" ? data.key : "",
      searchedItem: !!data && !!data.search && !!data.search && data.search !== "" ? data.search : "",
      searchQueryType: "contains",
      reloadRecentData: { ...data },
      isReloadRecentSearchClicked: true,
      isChemicalPresent: data.is_chemical,
      currentTab: tabKeywords.shipments,
      isSearchButtonCalled: true,
      searchCardParams: {
        searchedItem: !!data && !!data.user_search && !!data.user_search && data.user_search !== "" ? data.user_search : "",
        searchInclude: false,
        currentKey: !!data && !!data.key && data.key !== "" ? data.key : "",
        matchType: "contains",
      },
      redirectionIdFromAutoSuggest: data && data.redirection_profile_id && data.search ? { [data.search]: data.redirection_profile_id } : "",
    });
    this.props.searchParametersHandler({
      searchCategory: data?.key ?? "",
      searchedItem: data?.search,
      dataSource: "multi_country",
      matchType: "contains",
      redirectionId: data && data.redirection_profile_id && data.search ? { [data.search]: data.redirection_profile_id } : "",
    });
    setTimeout(() => {
      const requestObject = this.creatingRequestObject(requestObjectType.reloadSearch, data);
      this.callingSearchAPI(requestObject, requestObjectType.reloadSearch);
    }, 100);
  }

  // End of the above codex
  // Below code is used for reload the saved search
  reloadSaveSearches = async (savedSearchData) => {
    const data = this.normalizeSavedSearchPayload(savedSearchData);
    const searchData = data?.search_data || {};
    const searchUrlParams = this.props.location.search;
    let importer = new URLSearchParams(searchUrlParams).get("toImporter");
    let exporter = new URLSearchParams(searchUrlParams).get("toExporter");
    let analysis = new URLSearchParams(searchUrlParams).get("toAnalytics");
    let requestObjIncludeFilter = searchData?.includeFilters ? searchData?.includeFilters.map((item) => (this.alternateLocaliseFilterObj[item] ? this.alternateLocaliseFilterObj[item] : item)) : [];
    let requestObjExcludeFilter = searchData?.excludeFilters ? searchData?.excludeFilters.map((item) => (this.alternateLocaliseFilterObj[item] ? this.alternateLocaliseFilterObj[item] : item)) : [];

    const fromDate = this.state.fromAccutalArrivalDate;
    const toDate = this.state.toAccutalArrivalDate;
    this.setState({
      mainFromAccutalArrivalDate: fromDate,
      mainToAccutalArrivalDate: toDate,
    });

    const picker = {
      startDate: this.state.paidPlanDateRange[data?.date_range] ? this.state.paidPlanDateRange[data?.date_range]?.[0] : data?.date_range?.includes("to") && data?.date_range?.split("to")[0],
      endDate: this.state.paidPlanDateRange[data?.date_range] ? this.state.paidPlanDateRange[data?.date_range]?.[1] : data?.date_range?.includes("to") && data?.date_range?.split("to")[1],
    };
    if (data.date_range && picker.startDate && picker.endDate && fromDate <= moment(picker.startDate)) {
      this.setState({
        fromAccutalArrivalDate: picker.startDate,
        toAccutalArrivalDate: data.date_range === "Year to Date" ? moment(picker.endDate).subtract(1, "days").toDate() : toDate >= moment(picker.endDate) ? picker.endDate : moment(picker.endDate).subtract(1, "days").toDate(),
      });
    }
    if (searchData?.key === "product_description" && searchData?.search) {
      let productKeyArr = [];
      for (let i = 0; i < searchData.search.split("||").length; i++) {
        let tempObj = {};
        tempObj.label = searchData.search.split("||")[i].split("|")[0];
        tempObj.value = searchData.search.split("||")[i].split("|")[1];
        productKeyArr.push(tempObj);
      }
      if (productKeyArr.length === 1) {
        this.setState({
          searchInclude: true,
        });
      }
    }
    // end of above code
    this.setState({
      searchKey: searchData?.key || "",
      searchQueryType: searchData?.queryType || "",
      searchedItem: searchData?.search || "",
    });
    this.setState({
      isReloadSearchClicked: true,
    });
    let appliedFilterClone = { ...this.emptyFilterObj };
    let selectedFilterListClone = { ...this.emptyFilterObj };
    for (const key of Object.keys(this.filterTypeEnum)) {
      if (searchData?.[key]) {
        if (this.localisationFilterObj[key]) {
          appliedFilterClone[key] = searchData[this.localisationFilterObj[key]];
        } else {
          appliedFilterClone[key] = searchData[key];
          selectedFilterListClone[key] = searchData[key];
        }
      }
    }

    this.setState(
      {
        reloadSaveSearchData: { ...data },
        currentTab: importer === "true" ? tabKeywords.importers : exporter === "true" ? tabKeywords.exporters : analysis === "true" ? tabKeywords.analytics : tabKeywords.shipments,
        isLoaderActive: true,
        lastRequestType: requestObjectType.reloadSearch,
        data: [],
        searchTypeStr: searchData?.search_type || "basic",
        isRedirect: searchData?.redirectingProfileIds && searchData?.redirectingProfileIds.length > 0 ? true : this.state.redirectingCompanyName || this.state.redirectionHsCodeValue ? this.state.isRedirect : false,
        isReloadSearchClicked: true,
        rangeUniqueContainerChanged: true,
        searchInclude: false,
        includeFilter: requestObjIncludeFilter,
        excludeFilter: requestObjExcludeFilter,
        exporterTab: null,
        importerTab: null,
        isChemicalPresent: !!searchData?.is_chemical,
        derivedConsigneeMasterNameAndIdMapping: searchData?.derivedConsigneeMasterNameAndIdMapping?.length ? searchData?.derivedConsigneeMasterNameAndIdMapping : [],
        derivedShipperMasterNameAndIdMapping: searchData?.derivedShipperMasterNameAndIdMapping?.length ? searchData?.derivedShipperMasterNameAndIdMapping : [],
        redirectionIdFromAutoSuggest: searchData?.redirection_profile_id && searchData?.search ? { [searchData.search]: searchData.redirection_profile_id } : "",
      },
      async () => {
        await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, ...appliedFilterClone });
        const requestObject = this.creatingRequestObject(requestObjectType.reloadSearch, data);
        if (searchData?.is_from_alternate_suggestion) {
          requestObject.is_from_alternate_suggestion = true;
        }
        if (data?.url?.includes("redirectingFrom") && !this.props.location.search.includes("isReload")) {
          this.localStorageService.setDataToLocalStorage("reloadSavedSearch", data);
          window.location.href = data.url + "&isReload=true";
        } else await this.callingSearchAPI(requestObject, requestObjectType.search);
      }
    );
  };
  // End of the above code
  // Below code is for the calling the Search Result
  callingSearchResult(type, analyticsType, tempFilterObject, combinedData) {
    const shouldSyncTabWithSearchKey = type === requestObjectType.search || type === requestObjectType.reloadSearch;
    if (shouldSyncTabWithSearchKey && (this.state.searchKey === tabKeywords.importers || this.state.searchKey === tabKeywords.exporters)) {
      this.setState({
        currentTab: this.state.searchKey,
      });
    }
    if (combinedData?.redirectionTab) {
      this.setState({
        currentTab: combinedData?.redirectionTab,
      });
    }
    if (combinedData?.from || combinedData?.to) {
      this.setState({
        fromAccutalArrivalDate: combinedData?.from,
        toAccutalArrivalDate: combinedData?.to,
      });
    }

    if (combinedData?.searchParameters?.searchedItem !== "" && combinedData !== undefined) {
      let data = combinedData?.searchParameters;
      this.props.searchParametersHandler({
        searchCategory: data?.searchCategory,
        searchedItem: data?.searchedItem,
        dataSource: "multi_country",
        matchType: data?.matchType,
      });

      this.setState({
        isSearchButtonCalled: true,
        searchKey: data?.searchCategory,
        searchedItem: data?.searchedItem,
        searchQueryType: data?.matchType,
        searchCardParams: {
          searchedItem: data?.searchedItem,
          searchInclude: false,
          currentKey: data?.searchCategory,
          matchType: data?.matchType,
        },
      });
    }

    try {
      if (type === requestObjectType.search) {
        const fromDate = this.state.fromAccutalArrivalDate;
        const toDate = this.state.toAccutalArrivalDate;
        this.setState(
          {
            data: [...[]],
            currentPage: 1,
            defaultPage: 1,
            mainFromAccutalArrivalDate: fromDate,
            mainToAccutalArrivalDate: toDate,
          },
          () => this.settingTabHandler(type, analyticsType, tempFilterObject, combinedData?.redirectionTab)
        );
      } else if (type === requestObjectType.filter) {
        this.setState(
          {
            data: [...[]],
          },
          () => this.settingTabHandler(type, analyticsType, tempFilterObject)
        );
      }
    } catch (err) {
      Sentry.captureException(err);
      toast.error("Something went wrong!");
    }
  }

  getRecentSearches = async () => {
    try {
      const { data } = await axios.post(getApiUrl("userDashboard"), { section_type: "user_history" });
      const stateUpdate = { searchHistoryData: data || {}, isSearchHistoryLoading: false };
      if (data?.recentSearchResponse && data?.recentSearchResponse?.count > 0) {
        const mainData = data.recentSearchResponse.data;
        stateUpdate.recentSearchData = [].concat(...mainData.map((item) => item.row_data));
      }
      this.setState(stateUpdate);
    } catch (err) {
      this.setState({ isSearchHistoryLoading: false });
      toast.error("Something went wrong. Please try again later !!!");
    }
  };

  callingPostSearchResults = async () => {
    const response = await axios.post(globalApiEndPoints.getPostSearchResults, {
      user_search: this.state.searchedItem,
      category: this.state.searchKey === searchPhraseDictionary.product_description ? "product" : this.state.searchKey === searchPhraseDictionary.product_hscode ? "hs_code" : "",
    });

    this.setState({
      gettingPostSearchResults: true,
      postSearchData: response.data,
    });
  };
  settingTabHandler = (type, analyticsType, tempFilterObject, redirectionTab) => {
    const requestObject = this.creatingRequestObject(type, null, tempFilterObject);
    requestObject.sort = this.state.sortValue ? this.state.sortValue : "date";
    if (this.state.isFilterAppliedStarter && this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter")) {
      requestObject.isFilterApplied = this.state.isFilterAppliedStarter;
      this.setState({
        isFilterAppliedStarter: false,
      });
    }

    // this code is used when we come back from shipment distribution
    for (let property in requestObject) {
      if (requestObject[property] && Array.isArray(requestObject[property]) && !requestObject[property].length) {
        if (!requestObject[this.localisationFilterObj[property]] || (Array.isArray(requestObject[this.localisationFilterObj[property]]) && !requestObject[this.localisationFilterObj[property]].length)) {
          delete requestObject[property];
        }
      }
    }
    if (this.state.redirectingProfileType) {
      if (this.localisationFilterObj[this.state.redirectingProfileType]) {
        requestObject[this.localisationFilterObj[this.state.redirectingProfileType]] = [];
        requestObject[this.state.redirectingProfileType] = [];
      } else {
        requestObject[this.state.redirectingProfileType] = [];
      }
    }
    if (this.state.redirectingProfilePartnerType) {
      if (this.localisationFilterObj[this.state.redirectingProfilePartnerType]) {
        requestObject[this.localisationFilterObj[this.state.redirectingProfilePartnerType]] = [];
        requestObject[this.state.redirectingProfilePartnerType] = [];
      } else {
        requestObject[this.state.redirectingProfilePartnerType] = [];
      }
    }
    //end of the above code
    this.callingSearchAPI(requestObject, type);
    if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyExporterId && this.state.redirectingCompanyExporterId.length) {
      if (new URLSearchParams(window.location.search).get("isSubsidiaryIncluded")) {
        requestObject[this.specialFields.shipper] = [];
      }
    }
    if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyImporterId && this.state.redirectingCompanyImporterId.length) {
      if (new URLSearchParams(window.location.search).get("isSubsidiaryIncluded")) {
        requestObject[this.specialFields.consignee] = [];
      }
    }
    if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyLogisticsId && this.state.redirectingCompanyLogisticsId.length) {
      if (new URLSearchParams(window.location.search).get("isSubsidiaryIncluded")) {
        requestObject[this.specialFields.logistic] = [];
      }
    }
    const effectiveTab = redirectionTab || this.state.currentTab;
    if (effectiveTab === tabKeywords.analytics || effectiveTab === tabKeywords.reports) {
      this.setState(
        {
          finalReqObj: requestObject,
        },
        () => this.getAnalyticsData(requestObjectType.search, analyticsType)
      );
    }
    if (this.state.currentTab === tabKeywords.exporters) {
      this.setState(
        {
          mustNotIncludeExporter: [...[]],
          exporterCurrentPage: 1,
          uniqueExportersData: [...[]],
          currentPage: 1,
          defaultPage: 1,
          finalReqObj: requestObject,
        },
        () => this.getUniqueExporterData(requestObjectType.exporters)
      );
    }
    if (this.state.currentTab === tabKeywords.importers) {
      if (this.state.currentUserPlan === this.upgradePlansDictionary.trademo_intel_us_pro_lite.key) {
        this.setState({
          importerSortValue: "date",
          exporterSortValue: "date",
          logisticsSortValue: "date",
        });
      }
      this.setState(
        {
          mustNotIncludeImporter: [...[]],
          importerCurrentPage: 1,
          uniqueImportersData: [...[]],
          currentPage: 1,
          defaultPage: 1,
          finalReqObj: requestObject,
        },
        () => {
          this.getUniqueImporterData(requestObjectType.importers);
        }
      );
    }
    if (this.state.currentTab === tabKeywords.logistics) {
      this.setState(
        {
          mustNotIncludeLogistics: [...[]],
          logisticsCurrentPage: 1,
          uniqueLogisticsData: [...[]],
          currentPage: 1,
          defaultPage: 1,
          finalReqObj: requestObject,
        },
        () => this.getUniqueLogisticsData(requestObjectType.logistics)
      );
    }

    // }, 100);
  };
  // End of the above code
  // Below Code is for calling the Search API
  callingSearchAPI = async (searchRequestObj, type) => {
    try {
      this.props.resetCachingData();
      const searchUrlParams = this.props.location.search;
      let importer = new URLSearchParams(searchUrlParams).get("toImporter");
      let exporter = new URLSearchParams(searchUrlParams).get("toExporter");
      let analysis = new URLSearchParams(searchUrlParams).get("toAnalytics");
      let logistics = new URLSearchParams(searchUrlParams).get("toLogistics");
      if (this.state.isSubs) {
        searchRequestObj.isSubsidiaryIncluded = true;
      } else {
        searchRequestObj.isSubsidiaryIncluded = false;
      }
      for (let property in searchRequestObj) {
        if (searchRequestObj[property] && Array.isArray(searchRequestObj[property]) && !searchRequestObj[property].length) {
          if (!searchRequestObj[this.localisationFilterObj[property]] || (Array.isArray(searchRequestObj[this.localisationFilterObj[property]]) && !searchRequestObj[this.localisationFilterObj[property]].length)) {
            delete searchRequestObj[property];
          }
        }
      }

      if (new URLSearchParams(searchUrlParams).get("companyExporterId")) {
        searchRequestObj[this.specialFields.shipper] = [];
      }
      if (new URLSearchParams(searchUrlParams).get("companyImporterId")) {
        searchRequestObj[this.specialFields.consignee] = [];
      }
      if (new URLSearchParams(searchUrlParams).get("companyLogisticsId")) {
        searchRequestObj[this.specialFields.logistic] = [];
      }
      if (this.state.redirectingProfileType) {
        if (this.localisationFilterObj[this.state.redirectingProfileType]) {
          searchRequestObj[this.localisationFilterObj[this.state.redirectingProfileType]] = [];
          searchRequestObj[this.state.redirectingProfileType] = [];
        } else {
          searchRequestObj[this.state.redirectingProfileType] = [];
        }
      }
      if (this.state.redirectingProfilePartnerType) {
        if (this.localisationFilterObj[this.state.redirectingProfilePartnerType]) {
          searchRequestObj[this.localisationFilterObj[this.state.redirectingProfilePartnerType]] = [];
          searchRequestObj[this.state.redirectingProfilePartnerType] = [];
        } else {
          searchRequestObj[this.state.redirectingProfilePartnerType] = [];
        }
      }
      if (this.state.isChemicalPresent) {
        searchRequestObj[this.specialFields.productCategory] = searchRequestObj[this.specialFields.productCategory] ? searchRequestObj[this.specialFields.productCategory] : [];
      }
      //  else {
      //   searchRequestObj[this.specialFields.sections] = [];
      // }

      searchRequestObj.isFilterDataIncludes = false;
      searchRequestObj.is_from_autosuggest = this.state.isSelectedFromAutoSuggest ? true : false;
      searchRequestObj.redirection_profile_id = this.state.redirectionIdFromAutoSuggest[this.state.searchedItem];
      let tempSearchObj = JSON.parse(JSON.stringify(searchRequestObj));
      delete tempSearchObj.is_from_alternate_suggestion;
      this.setState(
        {
          finalReqObj: JSON.parse(JSON.stringify(tempSearchObj)),
          isLoaderActive: true,
          shipmentPresent: false,
          isShipmentLoader: true,
          newIntelLoader: true,
          redirectionTypeKey: "",
        },
        () => {
          this.getFilterDataHandler();
        }
      );
      axios
        .post(this.defaultData.apiEndPoints.getSearchResult, searchRequestObj)
        .then(
          (res) => {
            this.setState({
              filterData: res.data,
              onboardingData: JSON.parse(localStorage.getItem("onboarding")),
            });
            this.getShowOnboarding();
            if (res?.data?.dataset_modification_info && res?.data?.dataset_modification_info?.is_date_conflict) {
              this.getUserPlanDetails();
            }
            if (this.sessionStorageService.getShowReloadLastSearchModal() === true) {
              if (this.state.lastLogoutDetails?.search_payload && Object.keys(this.state.lastLogoutDetails?.search_payload).length > 0 && (this.checkIfFilterApplied(this.state.lastLogoutDetails?.search_payload) || this.state.lastLogoutDetails?.search_payload?.search) && this.localStorageService.getActiveTabIds()?.length < 2) {
                this.setState({
                  showReloadLastSearch: true,
                });
              }
              this.sessionStorageService.setShowReloadLastSearchModal(false);
            }
            if (res.data.redirection_type_key) {
              this.setState({
                redirectionTypeKey: res.data.redirection_type_key,
              });
            } else {
              this.setState({
                redirectionTypeKey: "",
              });
            }
            if (type === requestObjectType.search) {
              this.setState({
                isParentCompany: res.data.isParentCompany,
                parentCompanyNames: res.data.parentCompanyNames,
                inflectionWordList: res.data.inflection_word_list ?? [],
              });
            }
            if (type === requestObjectType.search || type === requestObjectType.reload || !type) {
              this.setState({
                mainFilterDataList: res.data,
                inflectionWordList: res.data.inflection_word_list ?? [],
              });
            }
            let gridCacheStates = JSON.parse(sessionStorage.getItem("gridCache"));

            if (this.state.customShipmentGridSelectedList && this.state.customShipmentGridSelectedList.length && this.state.type !== "bol") {
              if (gridCacheStates && gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`]) {
                let cachedGridData = gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`];
                let tempListCached = cachedGridData.data.user_selection_list && Array.isArray(cachedGridData.data.user_selection_list) ? cachedGridData.data.user_selection_list.map((item) => ({ ...item })) : [];
                this.mapCustomShipmentGridData([...tempListCached]);
              } else {
                this.mapCustomShipmentGridData([...this.state.customShipmentGridSelectedList]);
              }
            } else if (this.state.customShipmentGridSelectedListBol && this.state.customShipmentGridSelectedListBol.length && this.state.type === "bol") {
              if (gridCacheStates && gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`]) {
                let cachedGridData = gridCacheStates[`${this.defaultData.country_small}_${this.defaultData.countryType}`];
                let tempBolListCached = cachedGridData?.data?.user_selection_list_bol && Array.isArray(cachedGridData?.data?.user_selection_list_bol) ? cachedGridData.data.user_selection_list_bol.map((item) => ({ ...item })) : [];
                this.mapCustomShipmentGridData([...tempBolListCached]);
              } else {
                this.mapCustomShipmentGridData([...this.state.customShipmentGridSelectedListBol]);
              }
            }
            this.fillDataHandler(this.filterMapList && this.filterMapList[0] && this.filterMapList[0].categoryName ? this.filterMapList[0].categoryName : "", "defaultData");
            if (!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true && type === requestObjectType.pagination) {
              if (importer || exporter || analysis) {
                this.setState({
                  isLoaderActive: true,
                });
                if (importer === "true" && this.state.defaultLoad) {
                  this.fetchUniqueImporter();
                } else if (exporter === "true" && this.state.defaultLoad) {
                  this.fetchUniqueExporter();
                } else if (analysis === "true" && this.state.defaultLoad) {
                  this.fetchSummaryData("search");
                }
              }
              this.setState({
                isTableVisible: true,
                prospectExporter: [...[]],
                prospectImporter: [...[]],
                prospectLogistics: [...[]],
                isSorting: false,
              });
            } else {
              this.setState({
                isTableVisible: true,
                selectedSearchRowData: [...[]],
                prospectExporter: [...[]],
                prospectImporter: [...[]],
                prospectLogistics: [...[]],
                isSorting: false,
              });
            }
            if (importer || exporter || analysis || logistics) {
              this.setState({
                isLoaderActive: true,
              });
              if (importer === "true" && this.state.defaultLoad) {
                this.fetchUniqueImporter();
              } else if (exporter === "true" && this.state.defaultLoad) {
                this.fetchUniqueExporter();
              } else if (logistics === "true" && this.state.defaultLoad) {
                this.fetchUniqueLogistics();
              } else if (analysis === "true" && this.state.defaultLoad) {
                this.fetchSummaryData("search");
              }
            }
            if (type === requestObjectType.filter || type === requestObjectType.reloadSearch) {
              this.setState({
                isFilterApplied: true,
                isFilterClick: true,
              });
            }
            if (!!res && !!res.data && !!res.data.status && res.data.status.toLowerCase() === "success".toLowerCase()) {
              if (!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true && type === requestObjectType.pagination) {
                this.setState({
                  totalSearchCount: this.state.type === "bol" ? res.data.total_custom_shipments : res.data.totalShipments,
                  shipmentPresent: true,
                  totalCustomShipments: res.data.totalShipments,
                });
              } else {
                this.setState({
                  totalSearchCount: this.state.type === "bol" ? res.data.total_custom_shipments : res.data.totalShipments,
                  totalCustomShipments: res.data.totalShipments,
                  selectedSearchRowData: [],
                  shipmentPresent: true,
                });
              }

              if (this.state.analyticsPresent && this.state.currentTab === tabKeywords.analytics && !importer && !exporter && !analysis) {
                this.setState({
                  isLoaderActive: false,
                });
              } else if (this.state.currentTab !== tabKeywords.analytics && !importer && !exporter && !analysis) {
                this.setState({
                  isLoaderActive: false,
                });
              }
              if (res.data.planDetails) {
                this.setState({
                  currentPlanAccess: this.props.userDetails?.creditDetails?.planAccess,
                });
                this.props.planDetailsHandler(res.data.planDetails);
                let importer_exporter_graph_sort__options_clone = JSON.parse(JSON.stringify(this.state.importer_exporter_graph_sort__options));
                importer_exporter_graph_sort__options_clone = importer_exporter_graph_sort__options_clone.filter((item) => {
                  if (res.data.planDetails[item.value] !== false) {
                    return item;
                  }
                });
                this.setState({
                  importer_exporter_graph_sort__options: importer_exporter_graph_sort__options_clone,
                });
              }
              if (res.data.totalShipments > 0 || res.data.total_custom_shipments > 0) {
                let tempData = [];
                let searchResultArray = [...this.state.data];
                this.setState({
                  isSearch: false,
                  data: tempData,
                  zeroFilterData: "",
                });
                const serialNumberStartIndex = type === requestObjectType.pagination ? this.state.from : 0;
                res.data.data.map((dataObj, index) => {
                  this.closeFilterButtonStickyCalled(null);
                  // Maping of Search Data
                  dataObj._source.s_no = serialNumberStartIndex + index + 1;
                  dataObj._source.highlight = { ...dataObj.highlight };
                  dataObj._source.matched_column = this.mapHighLightedColumn(dataObj._source.highlight, this.state.searchedItem);
                  for (let key in this.defaultData.specialMappingFields) {
                    dataObj._source[key] = printValueChecker(dataObj._source, this.defaultData.specialMappingFields[key]);
                  }
                  const tempSearchObj = {
                    search: this.state.searchedItem,
                    key: this.state.searchKey,
                    queryType: this.state.searchQueryType,
                    type: this.state.searchTypeStr,
                  };
                  dataObj._source.tempObject = tempSearchObj;
                  searchResultArray.push(dataObj._source);
                });
                tempData = JSON.parse(JSON.stringify(searchResultArray));
                if (type === requestObjectType.search || type === requestObjectType.reloadSearch || type === requestObjectType.pagination) {
                  this.setState({
                    data: tempData,
                    localSearchData: tempData,
                    localTotalSearchCount: this.state.type === "bol" ? res.data.total_custom_shipments : res.data.totalShipments,
                  });
                } else if (type === requestObjectType.filter) {
                  this.setState({
                    data: tempData,
                  });
                }
                if (type === requestObjectType.search || type === requestObjectType.reloadSearch) {
                  this.setState({
                    localTotalUniqueExporter: res.data.exporterCount,
                    totalUniqueExporter: res.data.exporterCount,
                    localTotalUniqueImporter: res.data.importerCount,
                    totalUniqueImporter: res.data.importerCount,
                    localTotalUniqueLogistics: res.data.logisticsCount,
                    totalUniqueLogistics: res.data.logisticsCount,
                  });
                }
                if (type === requestObjectType.filter) {
                  this.setState({
                    totalUniqueExporter: res.data.exporterCount,
                    totalUniqueImporter: res.data.importerCount,
                    totalUniqueLogistics: res.data.logisticsCount,
                  });
                }

                if (!!this.state.searchedProximityFilterData.selectedZipcode && this.state.searchedProximityFilterData.length) {
                  this.setState({
                    isFilterApplied: true,
                  });
                }
                this.setState({
                  isLoaderActive: true,
                  isTableVisible: false,
                  currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                });
                setTimeout(() => {
                  this.setState({
                    isLoaderActive: false,
                    isTableVisible: true,
                    currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                  });
                }, 10);
                $('[data-toggle="tooltip"]').tooltip();
              } else {
                // This is when the total Shipments is 0
                if (!!res.data && !!res.data.zeroCount && Object.keys(res.data.zeroCount).length !== 0) {
                  this.setState({
                    zeroCountUpgrade: res.data.zeroCount.upgrade,
                    zeroCountDataObj: JSON.parse(JSON.stringify(res.data.zeroCount)),
                  });
                  let isZeroDataSource = true;

                  for (let property in this.props.shipmentDetails.appliedFilter) {
                    if (this.props.shipmentDetails.appliedFilter[property].length) {
                      isZeroDataSource = false;
                      break;
                    }
                  }
                  if ((!this.state.existingSearchReqObj?.dataSource?.length || res.data.zeroCount?.all_data_source_count?.count > 0 || res.data.zeroCount?.all_category_count?.count > 0) && isZeroDataSource) {
                    isZeroDataSource = false;
                  }
                  this.setState({
                    isZeroDataSource: isZeroDataSource,
                  });
                  if (res.data.zeroCount.upgrade === true) {
                    let tempArray = [...res.data.zeroCount.years_count];
                    tempArray.reverse();
                    if (new Date().getFullYear() - tempArray[0].key === 1) {
                      this.setState({
                        zeroCountyear: tempArray[0].key,
                        zeroCountData: tempArray[0].count,
                        zeroFilterData: res.data.zeroCount.count_without_filter ? res.data.zeroCount.count_without_filter.count : 0,
                      });
                    } else {
                      let tempCount = 0;
                      tempArray.forEach((item) => {
                        tempCount = tempCount + item.count;
                      });
                      this.setState({
                        zeroCountyear: tempArray[tempArray.length - 1].key,
                        zeroCountData: tempCount,
                        zeroFilterData: res.data.zeroCount.count_without_filter ? res.data.zeroCount.count_without_filter.count : 0,
                      });
                    }
                  } else {
                    this.setState({
                      zeroCountData: res.data.zeroCount.years_count[0].count,
                      zeroCountDateRange: !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && res.data.zeroCount.years_count[0].key ? res.data.zeroCount.years_count[0].key.split(" - ") : "",
                      zeroFilterData: res.data.zeroCount.count_without_filter ? res.data.zeroCount.count_without_filter.count : 0,
                    });
                    let d1 = !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && !!res.data.zeroCount.years_count[0].key && res.data.zeroCount.years_count[0].key.split(" - ").length && !!res.data.zeroCount.years_count[0].key.split(" - ")[0] && !!res.data.zeroCount.years_count[0].key.split(" - ")[0].split("-").length ? res.data.zeroCount.years_count[0].key.split(" - ")[0].split("-")[2] : "";
                    let m1 = !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && !!res.data.zeroCount.years_count[0].key && res.data.zeroCount.years_count[0].key.split(" - ").length && !!res.data.zeroCount.years_count[0].key.split(" - ")[0] && !!res.data.zeroCount.years_count[0].key.split(" - ")[0].split("-").length ? res.data.zeroCount.years_count[0].key.split(" - ")[0].split("-")[1] : "";
                    let y1 = !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && !!res.data.zeroCount.years_count[0].key && res.data.zeroCount.years_count[0].key.split(" - ").length && !!res.data.zeroCount.years_count[0].key.split(" - ")[0] && !!res.data.zeroCount.years_count[0].key.split(" - ")[0].split("-").length ? res.data.zeroCount.years_count[0].key.split(" - ")[0].split("-")[0] : "";
                    let d2 = !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && !!res.data.zeroCount.years_count[0].key && !!res.data.zeroCount.years_count[0].key.split(" - ").length && !!res.data.zeroCount.years_count[0].key.split(" - ")[1] && !!res.data.zeroCount.years_count[0].key.split(" - ")[1].split("-").length ? res.data.zeroCount.years_count[0].key.split(" - ")[1].split("-")[2] : "";
                    let m2 = !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && !!res.data.zeroCount.years_count[0].key && !!res.data.zeroCount.years_count[0].key.split(" - ").length && !!res.data.zeroCount.years_count[0].key.split(" - ")[1] && !!res.data.zeroCount.years_count[0].key.split(" - ")[1].split("-").length ? res.data.zeroCount.years_count[0].key.split(" - ")[1].split("-")[1] : "";
                    let y2 = !!res.data.zeroCount.years_count && !!res.data.zeroCount.years_count[0] && !!res.data.zeroCount.years_count[0].key && !!res.data.zeroCount.years_count[0].key.split(" - ").length && !!res.data.zeroCount.years_count[0].key.split(" - ")[1] && !!res.data.zeroCount.years_count[0].key.split(" - ")[1].split("-").length ? res.data.zeroCount.years_count[0].key.split(" - ")[1].split("-")[0] : "";
                    let months = Math.abs(m2 - m1 + 12 * (y2 - y1));
                    if (this.defaultData.picker.monthPicker) {
                      this.setState({
                        zeroCountDateRange: [
                          { month: m1, year: y1 },
                          { month: m2, year: y2 },
                        ],
                      });
                    } else {
                      this.setState({
                        zeroCountDateRange: [
                          { day: d1, month: m1, year: y1 },
                          { day: d2, month: m2, year: y2 },
                        ],
                      });
                    }
                    this.setState({
                      zeroCountData: res.data.zeroCount.years_count[0].count,
                      zeroFilterData: res.data.zeroCount.count_without_filter ? res.data.zeroCount.count_without_filter.count : 0,
                      zeroCountyear: months > 12 ? Math.floor(months / 12) + ` year${Math.floor(months / 12) > 1 ? "s" : ""}` : months + " months",
                    });

                    this.setState({
                      isLoaderActive: false,
                      data: [...[]],
                      totalUniqueShipper: 0,
                      uniqueShipperData: [...[]],
                    });
                    if (type === requestObjectType.filter) {
                      this.setState({
                        isFilterApplied: true,
                      });
                    }
                    this.setState({
                      isTableVisible: false,
                      currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                    });
                    setTimeout(() => {
                      this.setState({
                        isTableVisible: true,
                        currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                      });
                    }, 10);
                  }
                  let tempData = [];
                  let searchResultArray = [...this.state.data];
                  this.setState({
                    isSearch: false,
                    data: tempData,
                  });
                  res.data.data.map((dataObj, index) => {
                    this.closeFilterButtonStickyCalled(null);
                    // Maping of Search Data
                    dataObj._source.s_no = this.state.from + index + 1;
                    dataObj._source.highlight = { ...dataObj.highlight };
                    dataObj._source.matched_column = this.mapHighLightedColumn(dataObj._source.highlight, this.state.searchedItem);
                    for (let key in this.defaultData.specialMappingFields) {
                      dataObj._source[key] = printValueChecker(dataObj._source, this.defaultData.specialMappingFields[key]);
                    }
                    dataObj._source.derived_shipment_value = !!dataObj._source.derived_shipment_value && dataObj._source.derived_shipment_value !== null ? dataObj._source.derived_shipment_value : dataObj._source.derived_shipment_value_is_present === true ? "Estimated Shipment Value Exist" : "Not Available";
                    dataObj._source.derived_hs_codes_string = !!dataObj._source.derived_hs_codes_string && dataObj._source.derived_hs_codes_string !== "" ? dataObj._source.derived_hs_codes_string : !!dataObj._source.derived_hs_codes_string_estimated && dataObj._source.derived_hs_codes_string_estimated !== "" ? dataObj._source.derived_hs_codes_string_estimated : dataObj._source.derived_hs_codes_string_estimated_is_present === true ? "Estimated HSCode" : "Not Available";
                    const tempSearchObj = {
                      search: this.state.searchedItem,
                      key: this.state.searchKey,
                      queryType: this.state.searchQueryType,
                      type: this.state.searchTypeStr,
                    };
                    dataObj._source.tempObject = tempSearchObj;
                    searchResultArray.push(dataObj._source);
                  });
                  tempData = [...searchResultArray];
                  if (type === requestObjectType.search || type === requestObjectType.reloadSearch || type === requestObjectType.pagination) {
                    this.setState({
                      data: tempData,
                      localSearchData: tempData,
                      localTotalSearchCount: this.state.type === "bol" ? res.data.total_custom_shipments : res.data.totalShipments,
                    });
                  } else if (type === requestObjectType.filter) {
                    this.setState({
                      data: tempData,
                    });
                  }
                  if (type === requestObjectType.search || type === requestObjectType.reloadSearch) {
                    this.setState({
                      localTotalUniqueExporter: res.data.exporterCount,
                      totalUniqueExporter: res.data.exporterCount,
                      localTotalUniqueImporter: res.data.importerCount,
                      totalUniqueImporter: res.data.importerCount,
                      localTotalUniqueLogistics: res.data.logisticsCount,
                      totalUniqueLogistics: res.data.logisticsCount,
                    });
                  }
                  if (type === requestObjectType.filter) {
                    this.setState({
                      totalUniqueExporter: res.data.exporterCount,
                      totalUniqueImporter: res.data.importerCount,
                      totalUniqueLogistics: res.data.logisticsCount,
                    });
                  }
                  if (!!this.state.searchedProximityFilterData.selectedZipcode && this.state.searchedProximityFilterData.length) {
                    this.setState({
                      isFilterApplied: true,
                    });
                  }
                  this.setState({
                    isLoaderActive: true,
                    isTableVisible: false,
                    currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                  });
                  setTimeout(() => {
                    this.setState({
                      isLoaderActive: false,
                      isTableVisible: true,
                      currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                    });
                  }, 10);
                  $('[data-toggle="tooltip"]').tooltip();
                  this.setState({
                    currentPage: type === requestObjectType.pagination ? this.state.currentPage : 1,
                    perPage: 25,
                  });
                } else {
                  this.setState({
                    isLoaderActive: false,
                  });
                  if (type === requestObjectType.filter) {
                    this.setState({
                      isFilterApplied: false,
                    });
                  }
                  toast.error(res.data.message);
                }
              }
            } else {
              this.setState({
                isLoaderActive: false,
              });
              toast.error(res.data.message);
            }
          },
          () => {
            this.closeFilterButtonStickyCalled(null);
            this.setState({
              isLoaderActive: false,
            });
            toast.error("Something went wrong. Please try again later !!!");
            if (type === requestObjectType.filter) {
              this.setState({
                isFilterApplied: false,
              });
            }
          }
        )
        .finally(() => {
          this.setState({
            isShipmentLoader: false,
            newIntelLoader: false,
          });
        });
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  // end of the above code

  // Below code is used for close the Filter Sticky Button
  closeFilterButtonStickyCalled = () => {
    if (document.getElementById("searchContainer")) {
      document.getElementById("searchContainer").style.height = "";
      document.getElementById("searchContainer").style.overflowY = "";
    }
    if (document.getElementById("searchIndividualFilterPanel")) {
      document.getElementById("searchIndividualFilterPanel").style.display = "none";
    }
    if (document.body) {
      document.body.style.zIndex = "0";
    }
  };
  // End of the above code
  // Below Method is used for maping the complete array
  mapEntireSearchResult(startValue, endValue, dataArr, completeArr) {
    for (let i = startValue; i < endValue; i++) {
      completeArr[i] = { ...dataArr[i] };
    }
    return completeArr;
  }
  // end of the above code
  // Below code is for the mapping the Highlight Column
  mapHighLightedColumn(data) {
    const uniqueLabels = new Set();
    let matchedColumn = [];
    if (!!data && data.length !== 0) {
      this.mapHighLightedColumnList.map((item) => {
        if (data[item.key]) {
          let tempData = {};
          tempData.label = item.label ? item.label : "Data";
          tempData.key = Array.isArray(data[item.key]) ? data[item.key].join(" ") : data[item.key];
          if (!uniqueLabels.has(tempData.label)) {
            matchedColumn.push(tempData);
            uniqueLabels.add(tempData.label);
          }
        }
      });
    }
    return matchedColumn;
  }

  // End of the Above code
  searchBottonCalledForChemical(isChemical) {
    this.setState({
      isChemicalPresent: isChemical ? true : false,
    });
    if (!isChemical && (!!this.state.finalReqObj.is_chemical || this.state.finalReqObj.key === searchPhraseDictionary.chemical_description)) {
      let tempApplied = { ...this.props.shipmentDetails.appliedFilter };
      let tempSelected = { ...this.state.selectedFilterLabelObject };
      let tempFilter = { ...this.state.filterObj };
      for (let i = 0; i <= tempApplied[this.specialFields.productCategory].length; i++) {
        if (!!tempApplied[this.specialFields.productCategory] && !!this.specialFields.productCategory && !!tempApplied[this.specialFields.productCategory][i] ? tempApplied[this.specialFields.productCategory][i].includes("06") : false) {
          tempApplied[this.specialFields.productCategory].splice(i, 1);
        }
      }
      for (let i = 0; i <= tempSelected[this.specialFields.productCategory].length; i++) {
        if (!!tempSelected[this.specialFields.productCategory] && !!this.specialFields.productCategory && !!tempSelected[this.specialFields.productCategory][i] ? tempSelected[this.specialFields.productCategory][i].includes("06") : false) {
          tempSelected[this.specialFields.productCategory].splice(i, 1);
        }
      }
      for (let i = 0; i <= tempFilter[this.specialFields.productCategory].length; i++) {
        if (!!tempFilter[this.specialFields.productCategory] && !!this.specialFields.productCategory && !!tempFilter[this.specialFields.productCategory][i] && tempFilter[this.specialFields.productCategory][i].key.includes("06")) {
          tempFilter[this.specialFields.productCategory][i].isChecked = false;
        }
      }
      this.setState({
        appliedStateFilterObject: tempApplied,
        selectedFilterLabelObject: tempSelected,
      });
    }
  }
  // Below code is for the Search Submit Button Called (Capture Search Botton Event)
  searchSubmitClicked(searchedItem, searchInclude, currentKey, matchType, isSelectedFromAutoSuggest, redirectionId) {
    // ::Tracking: Below code is for the Tracking of the Search Button Event
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.searchShipmentBottonClicked);
    // End of the above code
    this.searchBottonCalled(searchedItem, searchInclude, currentKey, matchType, "button-clicked", isSelectedFromAutoSuggest, redirectionId);
  }
  // End of the above code
  // Below code is used when search button is clicked
  searchBottonCalled(searchedItem, searchInclude, currentKey, matchType, comingFrom, isSelectedFromAutoSuggest, redirectionId) {
    //comingFrom is added for primary and adv toggle
    // TODO:Shubham
    let Diff = (new Date(this.state.toAccutalArrivalDate) - new Date(this.state.fromAccutalArrivalDate)) / (1000 * 3600 * 24);
    let tempObj = {};
    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        tempObj[this.defaultData.internalFilterList[i].key] = [...[]];
      }
    }
    this.setState(
      {
        searchedItem: searchedItem ? searchedItem : "",
        searchInclude: searchInclude !== undefined ? searchInclude : false,
        showSaveSearchButton: searchedItem && searchedItem !== "" ? true : false,
        currentTab: this.state.currentUserPlan === this.upgradePlansDictionary.trademo_intel_us_pro_lite.key ? tabKeywords.importers : this.state.currentTab,
        isSupplierFilter: true,
        isSupplierFilterFlag: true,
        selectedTab: this.state.searchCardParams.currentKey,
        currentTimeFrame: Diff >= timeFrameYearly ? timeFrameOptions[0] : Diff >= timeFrameQuaterly ? timeFrameOptions[2] : timeFrameOptions[1],
        currentExporterFrame: Diff >= timeFrameYearly ? timeFrameOptions[0] : Diff >= timeFrameQuaterly ? timeFrameOptions[2] : timeFrameOptions[1],
        currentLogisticsFrame: Diff >= timeFrameYearly ? timeFrameOptions[0] : Diff >= timeFrameQuaterly ? timeFrameOptions[2] : timeFrameOptions[1],
        lastRequestType: requestObjectType.search,
        isShipmentLoader: true,
        newIntelLoader: true,
        isChemicalPresent: currentKey === searchPhraseDictionary.chemical_description ? true : false,
        analyticsData: [],
        secondLevelData: [],
        isLoaderActive: true,
        from: 0,
        isSearchButtonCalled: true,
        isReloadSearchClicked: false,
        isFilterApplied: this.checkforFilters(this.props.shipmentDetails.appliedFilter) || (!!this.state.searchedProximityFilterData.selectedZipcode && this.state.searchedProximityFilterData.selectedZipcode.length > 0) ? true : false,
        search_includes: [],
        isExcludeBlankShipper: false,
        mustNotIncludeExporter: [],
        mustNotIncludeImporter: [],
        mustNotIncludeLogistics: [],
        selectedExporterRowData: [],
        selectedImporterRowData: [],
        selectedLogisticsRowData: [],
        exporterCurrentPage: 1,
        importerCurrentPage: 1,
        logisticsCurrentPage: 1,
        exporterPerPage: 25,
        importerPerPage: 25,
        logisticsPerPage: 25,
        exporterTab: null,
        importerTab: null,
        logisticsTab: null,
        trendsTab: false,
        exporterTrendsTab: false,
        logisticsTrendsTab: false,
        tempObj: tempObj,
        zeroCountData: "",
        zeroFilterData: "",
        currentPage: 1,
        defaultPage: 1,
        isSelectedFromAutoSuggest: isSelectedFromAutoSuggest,
        searchKey: currentKey ? currentKey : this.state.searchKey,
        searchQueryType: matchType ? matchType : this.state.searchQueryType,
        redirectionIdFromAutoSuggest: redirectionId ? redirectionId : {},
        importerMongoIds: [],
        exporterMongoIds: [],
        isClickedPostSearchSugg: isSelectedFromAutoSuggest === false && Object.keys(redirectionId).includes(searchedItem) && Object.values(redirectionId).filter((value) => value !== null).length > 0 ? true : false,
      },
      () => {
        if (this.state.searchedItem !== "") this.callingPostSearchResults();
        this.callingSearchResult(comingFrom && comingFrom === "toggle" ? (this.state.from !== 0 ? requestObjectType.pagination : requestObjectType.filter) : requestObjectType.search);
      }
    );
  }
  // End of the above code
  // Below Code is used when user click on the upgrade now button
  upgradeNow = () => {
    window.location.href = getPaymentsUrl() + "payment?T=" + this.localStorageService.getAccessToken() + "&I=" + this.localStorageService.getSessionID() + "&D=" + this.localStorageService.getSessionExpiryDate() + "&type=plans&P=" + this.localStorageService.getUserProduct();
  };

  searchButtonLoaderHandler = () => {
    this.setState({
      isShipmentLoader: true,
      newIntelLoader: true,
    });
  };

  // Below code is for the select Date Range Picker
  selectDateRangePicker = (dateData) => {
    switch (dateData && dateData.chosenLabel ? dateData.chosenLabel : "") {
      case "Last 1 Month":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerLast1Month);
        break;
      case "Last 3 Months":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerLast3Month);
        break;
      case "Year to Date":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerYearToDate);
        break;
      case "Last 1 Year":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerLast1Year);
        break;
      case "Last 3 Years":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerLast3Year);
        break;
      case "Last 2 Years":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerLast2Year);
        break;
      case "All Data":
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePickerAllata);
        break;
      default:
        break;
    }

    switch (dateData && dateData.chosenLabel ? dateData.chosenLabel : "") {
      case "Last 1 Month":
        this.setState({
          upgradeText: "1-Month",
        });
        break;
      case "Last 3 Months":
        this.setState({
          upgradeText: "3-Month",
        });
        break;
      case "Year to Date":
        this.setState({
          upgradeText: "1-Year",
        });
        break;
      case "Last 1 Year":
        this.setState({
          upgradeText: "1-Year",
        });
        break;
      case "Last 3 Years":
        this.setState({
          upgradeText: "3-Year",
        });
        break;
      case "Last 2 Years":
        this.setState({
          upgradeText: "2-Year",
        });
        break;
      case "All Data":
        this.setState({
          upgradeText: "All-Data",
        });
        break;
      default:
        this.setState({
          upgradeText: null,
        });
        break;
    }
    // upgradeText
    if (!(!!dateData && !!dateData.startDate && !!dateData.endDate)) {
      return false;
    }
    const picker = {
      startDate: dateData.startDate,
      endDate: dateData.endDate,
    };
    const userCreditData = { ...this.state.userCredit };
    const tempFromDateDatePicker = this.defaultData.countryType.toLowerCase() === countryTypeDictionary.import.toLowerCase() ? userCreditData.searchFromDate : userCreditData.searchFromDateExports;
    const tempToDateDatePicker = this.defaultData.countryType.toLowerCase() === countryTypeDictionary.import.toLowerCase() ? userCreditData.searchToDate : userCreditData.searchFromToExports;
    const tempSearchFromDate = moment(tempFromDateDatePicker).format("YYYY-MM-DD");
    const tempStartDate = moment(picker.startDate).format("YYYY-MM-DD");
    const temmpSearchToDate = moment(tempToDateDatePicker).format("YYYY-MM-DD");
    const tempEndDate = moment(picker.endDate).format("YYYY-MM-DD");
    //start
    const importStartDate = this.defaultData.countryCaps === "MULTICOUNTRY" || this.defaultData.countryCaps === "GLOBAL DATA" ? userCreditData.searchFromDate : "";
    const importDate = moment(importStartDate).format("YYYY-MM-DD");
    //for multi country and global plan
    const checkForMultiandGlobal = this.defaultData.countryCaps === "MULTICOUNTRY" || this.defaultData.countryCaps === "GLOBAL DATA";
    let diffOfAvailableStartDates = moment.duration(moment(temmpSearchToDate).diff(moment(importDate))).asDays() / 365;
    let diffOfSelectedDatesInYear = moment.duration(moment(tempEndDate).diff(moment(tempStartDate))).asDays() / 365;
    if (checkForMultiandGlobal && diffOfAvailableStartDates >= diffOfSelectedDatesInYear && userCreditData.user_active_plan.includes("pro")) {
      this.setState(
        {
          fromAccutalArrivalDate: picker.startDate,
          toAccutalArrivalDate: picker.endDate,
          isLoaderActive: true,
          isDateChanged: true,
        },
        () => {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datepickerApplyClicked);
          // End of the above code
          if (this.state.isReloadSearchClicked) {
            setTimeout(() => {
              this.searchBottonCalled(this.state.searchedItem, this.state.searchInclude, this.state.searchKey, this.state.matchType, "", this.state.isSelectedFromAutoSuggest, this.state.redirectionIdFromAutoSuggest);
            }, 250);
          } else {
            const { searchedItem, searchInclude, currentKey, matchType } = this.state.searchCardParams;
            let searchKey = currentKey;
            if (currentKey === this.searchCardHeaderOptions[0].value) {
              searchKey = searchPhraseDictionary.entire_bill_of_lading;
            }
            setTimeout(() => {
              this.searchBottonCalled(searchedItem, searchInclude, searchKey, this.state.searchQueryType || matchType, "", this.state.isSelectedFromAutoSuggest, this.state.redirectionIdFromAutoSuggest);
            }, 250);
          }
        }
      );
    } //end
    //below is for normal single dataset
    else if (moment.utc(tempSearchFromDate).valueOf() <= moment.utc(tempStartDate).valueOf() && moment.utc(tempStartDate).valueOf() <= moment.utc(temmpSearchToDate).valueOf() && moment.utc(tempSearchFromDate).valueOf() <= moment.utc(tempEndDate).valueOf() && moment.utc(tempEndDate).valueOf() <= moment.utc(temmpSearchToDate).valueOf()) {
      this.setState(
        {
          fromAccutalArrivalDate: picker.startDate,
          toAccutalArrivalDate: picker.endDate,
          isLoaderActive: true,
          isDateChanged: true,
        },
        () => {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datepickerApplyClicked);
          // End of the above code
          if (this.state.isReloadSearchClicked) {
            setTimeout(() => {
              this.searchBottonCalled(this.state.searchedItem, this.state.searchInclude, this.state.searchKey, this.state.matchType, "", this.state.isSelectedFromAutoSuggest, this.state.redirectionIdFromAutoSuggest);
            }, 250);
          } else {
            const { searchedItem, searchInclude, currentKey, matchType } = this.state.searchCardParams;
            let searchKey = currentKey;
            if (currentKey === this.searchCardHeaderOptions[0].value) {
              searchKey = searchPhraseDictionary.entire_bill_of_lading;
            }
            setTimeout(() => {
              this.searchBottonCalled(searchedItem, searchInclude, searchKey, this.state.searchQueryType || matchType, "", this.state.isSelectedFromAutoSuggest, this.state.redirectionIdFromAutoSuggest);
            }, 250);
          }
        }
      );
    } else {
      const formDate = this.state.fromAccutalArrivalDate;
      const toDate = this.state.toAccutalArrivalDate;
      const latestActualArrivalDate = this.state.latestActualArrivalDate;
      this.setState({
        latestActualArrivalDate: null,
      });
      setTimeout(() => {
        this.setState({
          latestActualArrivalDate: latestActualArrivalDate,
          fromAccutalArrivalDate: formDate,
          toAccutalArrivalDate: toDate,
          isDateChanged: true,
        });
      });
      if (userCreditData.user_active_plan) {
        this.upgradePopupShow(this.upgradePlansDictionary.trademo_intel_us_free.upgradeMessageArrivalDate, userCreditData.user_active_plan);
        return false;
      }
    }
  };
  // End of the above code
  // Below Code used to show Upgrade Popup
  upgradePopupShow = (data) => {
    let text = data;
    if (this.state.upgradeText === null) {
      text = "Data view beyond 1-year requires an upgrade to your current plan subscription.";
    }
    this.setState({
      showUpgradeModal: true,
      upgradePopopContent: text,
    });
  };
  setShipmentLoader = (val) => {
    this.setState({
      isLoaderActive: val,
    });
  };
  upgradePopupClose = () => {
    this.setState({
      showUpgradeModal: false,
      upgradePopopContent: "",
    });
  };
  // End of the above code
  // Below code is used when popup need to show when limit got exceed
  searchLimitPopupShow = (data) => {
    this.setState({
      showSearchLimitModal: true,
      maxsearchCount: data,
    });
  };
  // End of the above code
  // Below code is used for closing the Limit Popup
  searchLimitPopupClose = () => {
    this.setState({
      showSearchLimitModal: false,
      maxsearchCount: null,
    });
  };
  // End of the above code
  // Below code is used for the Navigate user to plans page
  callNavigationToPlans = () => {
    let url = getPaymentsUrl() + "payment?T=" + this.localStorageService.getAccessToken() + "&I=" + this.localStorageService.getSessionID() + "&D=" + this.localStorageService.getSessionExpiryDate() + "&type=plans&P=" + this.localStorageService.getUserProduct() + "&OId=" + this.localStorageService.getOptionId();
    window.location.href = url;
  };
  // End of the above code
  // Below code is for the hadle the zero search
  handleZeroDataSearch = (dateData, callingFrom) => {
    if (!!dateData && dateData.length !== 0) {
      const picker = {
        startDate: this.defaultData.picker.monthPicker ? new Date(dateData[0].year, dateData[0].month - 1) : new Date(dateData[0].year, dateData[0].month - 1, dateData[0].day),
        endDate: this.defaultData.picker.monthPicker ? new Date(dateData[1].year, dateData[1].month - 1) : new Date(dateData[1].year, dateData[1].month - 1, dateData[1].day),
      };
      if (callingFrom && callingFrom === "zeroSearch" && this.state.currentPlanAccess && this.state.currentPlanAccess.shipments !== false) {
        this.setState({
          currentTab: tabKeywords.shipments,
        });
      }
      this.setState({
        fromAccutalArrivalDate: null,
        toAccutalArrivalDate: null,
      });
      setTimeout(() => {
        if (this.defaultData && this.defaultData.picker && this.defaultData.picker.monthPicker) {
          this.monthRangePickerDismiss({
            from: { year: +dateData[0].year, month: +dateData[0].month },
            to: { year: +dateData[1].year, month: +dateData[1].month },
          });
        } else {
          this.setState({
            fromAccutalArrivalDate: moment(picker.startDate).toDate(),
            toAccutalArrivalDate: moment(picker.endDate).toDate(),
          });
        }
      }, 100);
      if (!this.defaultData || !this.defaultData.picker || !this.defaultData.picker.monthPicker) {
        setTimeout(() => {
          const { searchedItem, searchInclude, currentKey, matchType } = this.state.searchCardParams;
          this.searchBottonCalled(searchedItem, searchInclude, currentKey, matchType);
        }, 500);
      }
    }
  };
  // End of the above code
  // below code is used for reset Filters
  resetFilter = (callingFrom) => {
    // Full "reset all" should return the page to its initial no-search state (search bar + filters
    // + search history) instead of re-running a search.
    const isFullReset = callingFrom === "resetAll";
    if (!!this && !!this.state && !!this.state.isRedirect && this.state.isRedirect === true) {
      let appliedStateFilterObjectClone = { ...this.emptyFilterObj };
      let selectedFilterLabelObjectClone = { ...this.emptyFilterObj };
      if (this.state.excludedFilter[this.specialFields.consignee]) {
        selectedFilterLabelObjectClone[this.specialFields.consignee] = this.state.selectedFilterLabelObject[this.specialFields.consignee];
        appliedStateFilterObjectClone[this.specialFields.consignee] = this.props.shipmentDetails.appliedFilter[this.specialFields.consignee];
      } else if (this.state.excludedFilter[this.specialFields.shipper]) {
        appliedStateFilterObjectClone[this.specialFields.shipper] = this.props.shipmentDetails.appliedFilter[this.specialFields.shipper];
        selectedFilterLabelObjectClone[this.specialFields.shipper] = this.state.selectedFilterLabelObject[this.specialFields.shipper];
      }
      this.setState({
        appliedStateFilterObject: { ...appliedStateFilterObjectClone },
        selectedFilterLabelObject: { ...selectedFilterLabelObjectClone },
      });
    } else {
      this.setState({
        appliedStateFilterObject: { ...this.emptyFilterObj },
        selectedFilterLabelObject: { ...this.emptyFilterObj },
      });
    }
    if (callingFrom && callingFrom === "zeroSearch" && this.state.currentPlanAccess && this.state.currentPlanAccess.shipments !== false) {
      this.setState({
        currentTab: tabKeywords.shipments,
      });
    }
    this.props.appliedFilterHandler({ ...this.emptyFilterObj });
    this.props.filterObjectHandler({ ...this.emptyFilterObj });
    this.props.selectedFilterListHandler({});

    // TODO:Shubham
    let tempObj = {};
    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        tempObj[this.defaultData.internalFilterList[i].key] = [...[]];
      }
    }
    this.setState(
      {
        data: [...this.state.localSearchData],
        analyticsData: this.state.storedAnalyticsData,
        totalSearchCount: this.state.localTotalSearchCount,
        totalUniqueExporter: this.state.localTotalUniqueExporter,
        totalUniqueImporter: this.state.localTotalUniqueImporter,
        totalUniqueLogistics: this.state.localTotalUniqueLogistics,
        filterEndDate: this.state.originalEndDate,
        filterFromDate: this.state.originalFromDate,
        uniqueExportersData: this.state.localUniqueShippersData,
        uniqueImportersData: this.state.localUniqueConsigneeData,
        uniqueLogisticsData: this.state.localUniqueLogisticData,
        uniqueImportExporterShipment: [...[]],
        uniqueImportExporterWeight: [...[]],
        uniqueImportExporterTeu: [...[]],
        uniqueImportExporterValue: [...[]],
        uniqueLogisticsTypeFilter: [...[]],
        selectedSearchRowData: [...[]],
        prospectExporter: [...[]],
        prospectImporter: [...[]],
        prospectLogistics: [...[]],
        isSupplierFilter: true,
        isFilterApplied: false,
        isSupplierFilterFlag: true,
        appliedBooleanFilterObject: { ...this.defaultBooleanFilterObject },
        selecetedBooleanFilterObject: { ...this.defaultBooleanFilterObject },
        currentPage: 1,
        defaultPage: 1,
        mustNotIncludeExporter: [...[]],
        mustNotIncludeImporter: [...[]],
        mustNotIncludeLogistics: [...[]],
        exporterSortOrderValue: "desc",
        exporterSortValue: this.exporterDefaultSortValue.value,
        importerSortOrderValue: "desc",
        importerSortValue: this.importerDefaultSortValue.value,
        logisticsSortOrderValue: "desc",
        logisticsSortValue: this.logisticsDefaultSortValue.value,
        selectedExporterRowData: [...[]],
        isTableVisible: isFullReset ? false : true,
        exporterCurrentPage: 1,
        importerCurrentPage: 1,
        logisticsCurrentPage: 1,
        exporterPerPage: 25,
        importerPerPage: 25,
        logisticsPerPage: 25,
        from: 0,
        exporterTab: null,
        importerTab: null,
        logisticsTab: null,
        zeroCountData: "",
        zeroFilterData: "",
        searchedProximityFilterData: {},
        expTempObj: {},
        secondLevelData: [],
        includeFilter: [],
        excludeFilter: [],
        tempObj: tempObj,
        derivedShipperMasterNameAndIdMapping: [],
        derivedConsigneeMasterNameAndIdMapping: [],
        logisticsTempObj: {},
        ...(isFullReset ? { existingSearchReqObj: {}, finalReqObj: {} } : {}),
      },
      () => {
        if (isFullReset) {
          // Back to the initial no-search state — refresh the search history instead of searching.
          this.setState({ isSearchHistoryLoading: true }, () => this.getRecentSearches());
        } else {
          this.callingSearchResult(requestObjectType.search);
        }
      }
    );
  };

  resetAll = () => {
    this.props.searchParametersHandler({
      searchCategory: "",
      searchedItem: "",
      dataSource: this.defaultData.redirectionID.slice(0, this.defaultData.redirectionID.length - 1),
      matchType: "contains",
      redirectionId: {},
    });
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.resetAllSearchesAndFilter);
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: "",
    });
    localStorage.setItem("reset", "true");
    this.setState(
      {
        searchCardParams: {
          searchedItem: "",
          searchInclude: "",
          currentKey: "",
          matchType: "",
        },
        isDateChanged: false,
        searchKey: searchPhraseDictionary.entire_bill_of_lading,
        searchedItem: "",
        searchQueryType: "contains",
        from: 0,
        sortValue: "date",
        searchTypeStr: "basic",
        sortOrderValue: "desc",
        isReloadSearchClicked: false,
        is_from_alert: "",
        redirectingCompanyImporterId: [],
        redirectingCompanyExporterId: [],
        redirectingCompanyLogisticsId: [],
        isRedirect: false,
        companyKey: "",
        companyPageNo: 1,
        must_not: [],
        isMerged: false,
        isSubs: false,
        hsCodeList: [],
        type: "shipments",
        search_includes: [],
        isSelectedFromAutoSuggest: false,
        isClickedPostSearchSugg: false,
        isChemicalPresent: false,
        currentTab: tabKeywords.analytics,
      },
      () => this.resetFilter("resetAll")
    );
  };
  // End of the Above code
  // Below Code used to close Download Shipment Popup
  downloadImpExpPopupClose = () => {
    this.setState({
      showDownloadImpExpModal: false,
    });
  };
  // End of the above code
  // Below Method is used to call Filter API
  callForFilter = async (thisData, item, tempFilterObject) => {
    //Below code is for pendo Tracking
    // if (this.state.redirectingCompanyImporterId.length || this.state.redirectingCompanyExporterId.length || this.state.redirectingCompanyLogisticsId) {
    //   this.checkPendoEventForCompanyRedirection(`company_redirection_filter_${this.defaultData.country_small}_${this.defaultData.countryType}s_${!!item && !!item.label && !!item.label.replaceAll(" ", "_").toLowerCase() ? item.label.replaceAll(" ", "_").toLowerCase() : ""}_apply`);
    // } else {
    //   this.checkPendoEventForCompanyRedirection(`filter_${this.defaultData.country_small}_${this.defaultData.countryType}s_${!!item && !!item.label && !!item.label.replaceAll(" ", "_").toLowerCase() ? item.label.replaceAll(" ", "_").toLowerCase() : ""}_apply`);
    // }
    //End of the above code
    // TODO:Shubham

    let tempObj = {};
    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        tempObj[this.defaultData.internalFilterList[i].key] = [...[]];
      }
    }
    this.setState(
      {
        isLoaderActive: true,
        isTableVisible: false,
        isSupplierFilter: this.state.isSupplierFilterFlag,
        isSupplierFilterFlag: this.state.isSupplierFilterFlag,
        isFilterClick: true,
        isFilterApplied: true,
        appliedBooleanFilterObject: {
          ...this.state.selecetedBooleanFilterObject,
        },
        selecetedBooleanFilterObject: {
          ...this.state.selecetedBooleanFilterObject,
        },
        appliedBoxFilterObj: { ...this.state.selectedBoxFilterObj },
        currentPage: 1,
        defaultPage: 1,
        mustNotIncludeExporter: [],
        mustNotIncludeImporter: [],
        mustNotIncludeLogistics: [],
        exporterCurrentPage: 1,
        importerCurrentPage: 1,
        logisticsCurrentPage: 1,
        exporterPerPage: 25,
        importerPerPage: 25,
        logisticsPerPage: 25,
        analyticsData: [],
        data: [...[]],
        from: 0,
        uniqueExportersData: [],
        uniqueImportersData: [],
        uniqueLogisticsData: [],
        exporterTab: null,
        importerTab: null,
        logisticsTab: null,
        ueTwoLevel: this.state.ueTwoLevel,
        uiTwoLevel: this.state.uiTwoLevel,
        ulTwoLevel: this.state.ulTwoLevel,
        country: "",
        tempObj: tempObj,
      },
      () => {
        this.callingSearchResult(requestObjectType.filter, null, tempFilterObject);
      }
    );
  };
  // end of the above code
  // Below code is fot display Shipment Tab
  displayShipmentTab = () => {
    // ::Tracking: Below code is for adding the event on click of Shipment tab
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentTab);
    // End of the above code
    this.setState({
      currentTab: tabKeywords.shipments,
      mustNotIncludeExporter: [...[]],
      mustNotIncludeImporter: [...[]],
      mustNotIncludeLogistics: [...[]],
      analyticsData: [],
      selectedExporterRowData: [...[]],
      selectedImporterRowData: [...[]],
      selectedLogisticsRowData: [...[]],
      uniqueExportersData: [...[]],
      uniqueImportersData: [...[]],
      uniqueLogisticsData: [...[]],
      exporterCurrentPage: 1,
      importerCurrentPage: 1,
      logisticsCurrentPage: 1,
      exporterPerPage: 25,
      importerPerPage: 25,
      logisticsPerPage: 25,
      trendsTab: false,
      exporterTrendsTab: false,
      logisticsTrendsTab: false,
      currentPage: 1,
      defaultPage: 1,
    });
  };
  // End of the code
  // Below code is for fetching the Unique Exporter Data
  fetchUniqueExporter = () => {
    // TODO:Shubham
    this.setState({
      isLoaderActive: true,
      currentTab: tabKeywords.exporters,
      exporterSortOrderValue: "desc",
      exporterSortValue: this.state.currentUserPlan === this.upgradePlansDictionary.trademo_intel_us_pro_lite.key ? "date" : this.exporterDefaultSortValue.value,
      selectedExporterRowData: [...[]],
      analyticsData: [],
      exporterCurrentPage: 1,
      exporterPerPage: 25,
      prospectExporter: [...[]],
      trendsTab: false,
      exporterTrendsTab: false,
      logisticsTrendsTab: false,
      uiTwoLevel: false,
      ueTwoLevel: false,
      ulTwoLevel: false,
      defaultTrendsData: [],
      secondLevelData: [],
      currentPage: 1,
      defaultPage: 1,
      defaultUiUeTwoLevelSelctedHeading: this.defaultData.defaultUeUiSecondLevelKey,
      secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
    });
    let tempObj = {};
    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        tempObj[this.defaultData.internalFilterList[i].key] = !!this.state.exporterTab && !!this.state.exporterTab[this.defaultData.internalFilterList[i].key] ? this.state.exporterTab[this.defaultData.internalFilterList[i].key] : [];
      }
    }
    this.setState(tempObj);
    setTimeout(() => {
      // End of the above code
      this.getUniqueExporterData(requestObjectType.exporters);
    }, 100);
  };
  // End of the above code
  // Below code if for fetching Unique Logistics Data
  fetchUniqueLogistics = () => {
    // TODO:Shubham
    this.setState(
      {
        isLoaderActive: true,
        currentTab: tabKeywords.logistics,
        logisticsSortOrderValue: "desc",
        logisticsSortValue: this.state.currentUserPlan === this.upgradePlansDictionary.trademo_intel_us_pro_lite.key ? "doc_count" : this.logisticsDefaultSortValue.value,
        selectedLogisticsRowData: [...[]],
        analyticsData: [],
        logisticsCurrentPage: 1,
        logisticsPerPage: 25,
        prospectLogistics: [...[]],
        trendsTab: false,
        exporterTrendsTab: false,
        logisticsTrendsTab: false,
        uiTwoLevel: false,
        ueTwoLevel: false,
        ulTwoLevel: false,
        defaultTrendsData: [],
        secondLevelData: [],
        currentPage: 1,
        defaultPage: 1,
        defaultUiUeTwoLevelSelctedHeading: this.defaultData.defaultUeUiSecondLevelKey,
        defaultUlTwoLevelSelectedHeading: this.defaultData.defaultSecondLevelLogisticsTabKey,
        secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
      },
      () => {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTab);
        this.getUniqueLogisticsData(requestObjectType.logistics);
      }
    );
  };
  // Below code is for fetching the Unique Exporter Data
  fetchUniqueImporter = () => {
    let tempObj = {};
    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        tempObj[this.defaultData.internalFilterList[i].key] = !!this.state.importerTab && !!this.state.importerTab[this.defaultData.internalFilterList[i].key] ? this.state.importerTab[this.defaultData.internalFilterList[i].key] : [];
      }
    }
    this.setState(
      {
        isLoaderActive: true,
        currentTab: tabKeywords.importers,
        importerSortOrderValue: "desc",
        importerSortValue: this.state.currentUserPlan === this.upgradePlansDictionary.trademo_intel_us_pro_lite.key ? "date" : this.importerDefaultSortValue.value,
        selectedImporterRowData: [...[]],
        analyticsData: [],
        importerCurrentPage: 1,
        importerPerPage: 25,
        prospectImporter: [...[]],
        trendsTab: false,
        exporterTrendsTab: false,
        logisticsTrendsTab: false,
        uiTwoLevel: false,
        ueTwoLevel: false,
        ulTwoLevel: false,
        defaultTrendsData: [],
        secondLevelData: [],
        currentPage: 1,
        defaultPage: 1,
        defaultUiUeTwoLevelSelctedHeading: this.defaultData.defaultUeUiSecondLevelKey,
        tempObj: tempObj,
        secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
      },
      () => {
        this.getUniqueImporterData(requestObjectType.importers);
      }
    );
  };
  // End of the above code
  // Below Code for the Get Unique Importer Data
  getUniqueImporterData = async (type, pagination, sort) => {
    if (this.state.mustNotIncludeImporter.length > this.state.totalUniqueImporter || (this.defaultData && this.defaultData.tabKeyWords && this.defaultData.tabKeyWords.importers === false)) {
      return false;
    }
    this.setState({
      isLoaderActive: true,
    });
    const searchUrlParams = this.props.location.search;
    let importer = new URLSearchParams(searchUrlParams).get("toImporter");
    let sortId = new URLSearchParams(searchUrlParams).get("sort");
    let uniqueImporterRequestObj = {};
    uniqueImporterRequestObj = this.creatingRequestObject(type);
    uniqueImporterRequestObj.must_not = pagination === "toggle" ? [] : [...this.state.mustNotIncludeImporter];
    uniqueImporterRequestObj.companyType = "consignee";

    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        uniqueImporterRequestObj[this.defaultData.internalFilterList[i].key] = !!this.state.importerTab && !!this.state.importerTab[this.defaultData.internalFilterList[i].key] ? this.state.importerTab[this.defaultData.internalFilterList[i].key] : [];
      }
    }
    if (this.showUiTrends) {
      if (Object.keys(this.state.tempObj).length) {
        uniqueImporterRequestObj = {
          ...uniqueImporterRequestObj,
          ...this.state.tempObj,
        };
      }
    }
    uniqueImporterRequestObj.order = this.state.importerSortOrderValue;
    uniqueImporterRequestObj.sort = this.state.importerSortValue;
    uniqueImporterRequestObj.internalSortOrder = this.state.internalSortOrder;
    if (importer === "true" && this.state.defaultLoad) {
      uniqueImporterRequestObj.sort = sortId;
      this.setState({
        importerSortValue: sortId,
        defaultLoad: false,
      });
    }
    this.setState({
      finalReqObj: uniqueImporterRequestObj,
      existingUniqueImpExpReqObj: this.creatingRequestObject(type),
    });
    let uniqueImporterRequestObjClone = JSON.parse(JSON.stringify(uniqueImporterRequestObj));
    if (this.defaultData.showUiUeLevelTwo) {
      uniqueImporterRequestObjClone.isSecondLevelAnalytics = this.state.uiTwoLevel;
      if (this.state.uiTwoLevel) {
        uniqueImporterRequestObjClone.secondLevelCompanyIds = this.state.importerMongoIds.slice(0, 20);
        uniqueImporterRequestObjClone.subAnalyticsField = this.state.defaultUiUeTwoLevelSelctedHeading;
        uniqueImporterRequestObjClone.sub_data_size = this.state.secondLevelRowDropdownValue.value;
        uniqueImporterRequestObjClone.must_not = [];
      }
    }
    if (sort) {
      uniqueImporterRequestObjClone.order = sort.sortDirection;
      uniqueImporterRequestObjClone.sort = sort.sortField;
      await this.viewTrends(uniqueImporterRequestObjClone, pagination, type);
    } else {
      if (this.state.uiTwoLevel) {
        const c = await this.viewTrends(uniqueImporterRequestObjClone, pagination, type, { isSecondLevelAnalytics: false });
        let mustNot = c?.data?.must_not?.slice(0, 20) || [];
        uniqueImporterRequestObjClone.secondLevelCompanyIds = mustNot;
        await this.viewTrends(uniqueImporterRequestObjClone, pagination, type, { isSecondLevelAnalytics: true });
      } else {
        await this.viewTrends(uniqueImporterRequestObjClone, pagination, type, { isSecondLevelAnalytics: false });
      }
    }
  };
  // End of the above code
  // Below Code for the Get Unique Exporter Data
  getUniqueExporterData = async (type, pagination, sort) => {
    if (this.state.mustNotIncludeExporter.length > this.state.totalUniqueExporter || (this.defaultData && this.defaultData.tabKeyWords && this.defaultData.tabKeyWords.exporters === false)) {
      return false;
    }
    this.setState({
      isLoaderActive: true,
    });
    let uniqueExporterRequestObj = {};
    uniqueExporterRequestObj = this.creatingRequestObject(type);
    uniqueExporterRequestObj.must_not = pagination === "toggle" ? [] : [...this.state.mustNotIncludeExporter];
    uniqueExporterRequestObj.companyType = "shipper";
    // TODO:Shubham
    const searchUrlParams = this.props.location.search;
    let exporter = new URLSearchParams(searchUrlParams).get("toExporter");
    let sortId = new URLSearchParams(searchUrlParams).get("sort");

    for (let i = 0; i < this.defaultData.internalFilterList.length; i++) {
      if (!!this && !!this.defaultData && !!this.defaultData.internalFilterList[i] && !!this.defaultData.internalFilterList[i].isVisible && this.defaultData.internalFilterList[i].isVisible === true) {
        uniqueExporterRequestObj[this.defaultData.internalFilterList[i].key] = !!this.state.exporterTab && !!this.state.exporterTab[this.defaultData.internalFilterList[i].key] ? this.state.exporterTab[this.defaultData.internalFilterList[i].key] : [];
      }
    }
    if (this.showUiTrends) {
      if (Object.keys(this.state.expTempObj).length) {
        uniqueExporterRequestObj = {
          ...uniqueExporterRequestObj,
          ...this.state.expTempObj,
        };
      }
    }
    uniqueExporterRequestObj.order = this.state.exporterSortOrderValue;
    uniqueExporterRequestObj.sort = this.state.exporterSortValue;
    uniqueExporterRequestObj.internalSortOrder = this.state.internalSortOrder;
    if (exporter === "true" && this.state.defaultLoad) {
      uniqueExporterRequestObj.sort = sortId;
      this.setState({
        exporterSortValue: sortId,
        defaultLoad: false,
      });
    }
    this.setState({
      finalReqObj: uniqueExporterRequestObj,
      existingUniqueImpExpReqObj: this.creatingRequestObject(type),
    });
    let uniqueExporterRequestObjClone = JSON.parse(JSON.stringify(uniqueExporterRequestObj));
    if (this.defaultData.showUiUeLevelTwo) {
      uniqueExporterRequestObjClone.isSecondLevelAnalytics = this.state.ueTwoLevel;
      if (this.state.ueTwoLevel) {
        uniqueExporterRequestObjClone.secondLevelCompanyIds = this.state.exporterMongoIds.slice(0, 20);
        uniqueExporterRequestObjClone.subAnalyticsField = this.state.defaultUiUeTwoLevelSelctedHeading;
        uniqueExporterRequestObjClone.sub_data_size = this.state.secondLevelRowDropdownValue.value;
        uniqueExporterRequestObjClone.must_not = [];
      }
    }
    if (sort) {
      uniqueExporterRequestObjClone.order = sort.sortDirection;
      uniqueExporterRequestObjClone.sort = sort.sortField;
      await this.viewTrends(uniqueExporterRequestObjClone, pagination, type);
    } else {
      if (this.state.ueTwoLevel) {
        const c = await this.viewTrends(uniqueExporterRequestObjClone, pagination, type, { isSecondLevelAnalytics: false });
        let mustNot = c?.data?.must_not?.slice(0, 20) || [];
        uniqueExporterRequestObjClone.secondLevelCompanyIds = mustNot;
        await this.viewTrends(uniqueExporterRequestObjClone, pagination, type, { isSecondLevelAnalytics: true });
      } else {
        await this.viewTrends(uniqueExporterRequestObjClone, pagination, type, { isSecondLevelAnalytics: false });
      }
    }
  };
  getUniqueLogisticsData(type, pagination, sort) {
    if (this.state.mustNotIncludeLogistics.length > this.state.totalUniqueLogistics || (this.defaultData && this.defaultData.tabKeyWords && this.defaultData.tabKeyWords.logistics === false)) {
      return false;
    }
    this.setState({
      isLoaderActive: true,
    });
    let uniqueLogisticsRequestObj = {};
    uniqueLogisticsRequestObj = this.creatingRequestObject(type);
    uniqueLogisticsRequestObj.must_not = [...this.state.mustNotIncludeLogistics];
    uniqueLogisticsRequestObj.companyType = "logistic";
    const searchUrlParams = this.props.location.search;
    let logistics = new URLSearchParams(searchUrlParams).get("toLogistics");
    let sortId = new URLSearchParams(searchUrlParams).get("sort");

    if (this.state.logisticsFilter?.length > 0) uniqueLogisticsRequestObj["logisticsType"] = (this.state.logisticsFilter && [...this.state.logisticsFilter]) || [];

    if (this.showUiTrends) {
      if (Object.keys(this.state.expTempObj).length) {
        uniqueLogisticsRequestObj = {
          ...uniqueLogisticsRequestObj,
          ...this.state.expTempObj,
        };
      }
    }
    uniqueLogisticsRequestObj.order = this.state.logisticsSortOrderValue;
    uniqueLogisticsRequestObj.sort = this.state.logisticsSortValue;
    if (logistics === "true" && this.state.defaultLoad) {
      uniqueLogisticsRequestObj.sort = sortId;
      this.setState({
        logisticsSortValue: sortId,
        defaultLoad: false,
      });
    }
    this.setState({
      finalReqObj: uniqueLogisticsRequestObj,
      existingUniqueImpExpReqObj: this.creatingRequestObject(type),
    });
    let uniqueLogisticsRequestObjClone = JSON.parse(JSON.stringify(uniqueLogisticsRequestObj));
    if (this.defaultData.showUiUeLevelTwo) {
      uniqueLogisticsRequestObjClone.isSecondLevelAnalytics = this.state.ulTwoLevel;
      if (this.state.ulTwoLevel) {
        uniqueLogisticsRequestObjClone.subAnalyticsField = this.state.defaultUlTwoLevelSelectedHeading;
        uniqueLogisticsRequestObjClone.sub_data_size = this.state.secondLevelRowDropdownValue.value;
        uniqueLogisticsRequestObjClone.must_not = [];
      }
    }
    if (sort) {
      uniqueLogisticsRequestObjClone.order = sort.sortDirection;
      uniqueLogisticsRequestObjClone.sort = sort.sortField;
      this.viewTrends(uniqueLogisticsRequestObjClone, pagination, type);
    } else {
      this.viewTrends(uniqueLogisticsRequestObjClone, pagination, type);
    }
  }
  // End of the above code
  // Below code is for fetching the Analytics Data
  fetchSummaryData = (callingFrom) => {
    if (!callingFrom || callingFrom !== "search") {
      this.setState({
        currentTab: tabKeywords.analytics,
      });
    }
    this.setState({
      mustNotIncludeExporter: [],
      mustNotIncludeImporter: [],
      isLoaderActive: true,
      analyticsLoader: true,
    });
    // ::Tracking: Below code is for adding the event on click of Shipment tab
    // End of the above code
    this.getAnalyticsData(requestObjectType.search);
  };
  // End of the above code
  // Below code is used for showing the Save Search
  saveSearchShow = () => {
    this.setState({
      savedSearchShow: true,
      savedSearchName: this.state.searchedItem,
    });
  };
  // End of the above code
  emailXls = (requestObj, downloadShipmentPopupClose) => {
    this.setState({
      isDownloadLoaderActive: true,
    });
    requestObj.file_name = "Shipments_" + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    if (this.defaultData.showBolFilter && requestObj.companyType === "") {
      requestObj.customType = this.state.type;
    }

    const downloadShipmentApiUrl = this.defaultData.apiEndPoints.downloadShipmentsApi;
    axios.post(downloadShipmentApiUrl, requestObj).then(
      (res) => {
        this.setState({
          isDownloadLoaderActive: false,
        });
        if (!!res && !!res.data && !!res.data.status && res.data.status === "success") {
          toast.success(res.data.message);
          this.getUserPlan("Download");
          downloadShipmentPopupClose();
        } else {
          globalErrorHandling(res);
        }
      },
      (error) => {
        toast.error(error?.response?.data?.message ? error.response.data.message : "Something went wrong. Please try again later !!!");
        this.setState({
          isDownloadLoaderActive: false,
        });
      }
    );
  };
  // Below code is for the Downloading of the XLS without having data
  downloadingNotHavingData = (requestObj, downloadShipmentPopupClose) => {
    requestObj.file_name = "Shipments_" + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    if (this.defaultData.showBolFilter && requestObj.companyType === "") {
      requestObj.customType = this.state.type;
    }
    const downloadShipmentApiUrl = this.defaultData.apiEndPoints.downloadShipmentsApi;
    axios
      .post(downloadShipmentApiUrl, requestObj)
      .then(({ data }) => {
        window.open(data?.file_url);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong. Please try again later!");
      })
      .finally(() => {
        this.getUserPlan("Download");
      });
    downloadShipmentPopupClose();
  };
  // End of the above code
  // Below code is for download shipments
  downloadSearch = (type, data, downloadShipmentPopupClose, isCustomGridDownload) => {
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabSelectionStripDownload);
    if (this.state.selectedSearchRowData.length <= 0) {
      toast.error("Please select atleast one shipment.");
      return false;
    }
    const totalCount = this.state.creditQuota.download_credits.credits_consumed + this.state.selectedSearchRowData.length;
    if (totalCount > this.state.creditQuota.download_credits.credit_limit) {
      toast.error(`You do not have sufficient credits available to download ${this.state.selectedSearchRowData.length} shipments.`);
    } else {
      if (type === "XLS") {
        const downloadXlsRequestObj = {
          data_download: this.state.selectedSearchRowData,
        };
        downloadXlsRequestObj.companyType = "";
        downloadXlsRequestObj.isCustomGridDownload = isCustomGridDownload;
        downloadXlsRequestObj._payload = this.state.existingSearchReqObj;
        if (this.state.isRedirect === true) {
          downloadXlsRequestObj._payload[this.state.redirectingCompanyImporterId && this.state.redirectingCompanyImporterId.length ? this.specialFields.consignee : this.specialFields.shipper] = mapFiltersArray(this.state.filterObj[this.state.redirectingCompanyImporterId && this.state.redirectingCompanyImporterId.length ? this.specialFields.consignee : this.specialFields.shipper]);
          if (this.state.redirectingProfileId && this.state.redirectingProfileId.length) {
            downloadXlsRequestObj._payload[this.state.redirectingProfileType] = mapFiltersArray(this.state.filterObj[this.state.redirectingProfileType]);
          }
          if (this.state.redirectingProfilePartnerId && this.state.redirectingProfilePartnerId.length) {
            downloadXlsRequestObj._payload[this.state.redirectingProfilePartnerType] = mapFiltersArray(this.state.filterObj[this.state.redirectingProfilePartnerType]);
          }
        }
        this.downloadingNotHavingData(downloadXlsRequestObj, downloadShipmentPopupClose);
      }
    }
  };
  // End of the above code
  // Below code is for sorting the Shipments
  handleSorting = (column, sortDirection) => {
    this.setState({
      isLoaderActive: true,
      sortOrderValue: sortDirection,
      currentPage: 1,
      defaultPage: 1,
      from: 0,
      isSorting: true,
    });
    this.defaultData.shipmentSorting.map((item) => {
      if (column.selector === item.columnKey) {
        this.setState({
          sortValue: item.value,
        });
      }
    });
    this.setState({
      data: [...[]],
      currentPage: 1,
      defaultPage: 1,
    });
    setTimeout(() => {
      this.callingSearchResult(requestObjectType.filter);
    }, 100);
  };

  handleSortingClone = (column, sortDirection) => {
    this.setState({
      isLoaderActive: true,
      sortOrderValue: sortDirection,
      currentPage: 1,
      defaultPage: 1,
      from: 0,
      isSorting: true,
    });
    this.defaultData.shipmentSorting.map((item) => {
      if (column === item.value) {
        this.setState({
          sortValue: item.value,
        });
      }
    });
    this.setState({
      data: [...[]],
      currentPage: 1,
      defaultPage: 1,
    });
    setTimeout(() => {
      this.callingSearchResult(requestObjectType.filter);
    }, 100);
  };

  // End of the above code
  // Below code is used to get the Setected Search Row
  selectedSearchFun = (data) => {
    if (!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true) {
      return false;
    }
    if (this.state.totalSearchCount === data.length) {
      this.setState({
        isSelectAllButtonCalled: true,
      });
    }
    this.setState({
      selectedSearchRowData: [...data],
    });
  };
  // End of the above code
  // Below method is used to handle the search per page value change in the search Table
  handleSearchPerRowsChange(perPage, page) {
    const tempValue = Math.ceil((page * this.state.perPage + 1) / perPage);
    const requiredValue = tempValue * perPage;
    if ((this.state.data[requiredValue] === undefined || this.state.data[requiredValue].s_no === undefined || (tempValue * perPage - perPage > 0 && this.state.data[requiredValue - perPage].s_no === undefined)) && Math.max(tempValue * perPage, this.state.totalSearchCount) === this.state.totalSearchCount && tempValue * perPage !== this.state.totalSearchCount) {
      let finalRequiredValue = tempValue * perPage;
      if (!(this.state.data[requiredValue - perPage] && this.state.data[requiredValue - perPage].s_no !== undefined)) {
        finalRequiredValue = requiredValue - 60;
      }
      this.setState({
        fromCount: finalRequiredValue,
        currentPage: tempValue,
        perPage: perPage,
        isLoaderActive: true,
      });
      setTimeout(() => {
        const requestObject = this.creatingRequestObject(requestObjectType.pagination);
        this.callingSearchAPI(requestObject, requestObjectType.pagination);
      }, 100);
    } else {
      this.setState({
        perPage: perPage,
        currentPage: tempValue,
      });
    }
  }
  // End of the Above Code
  // Below method is used to handle the search page change in the Search Table
  handleSearchPageChange = (page) => {
    const requiredValue = page * this.state.perPage;
    if ((this.state.data[requiredValue] === undefined || this.state.data[requiredValue].s_no === undefined || (page * this.state.perPage - this.state.perPage > 0 && this.state.data[requiredValue - this.state.perPage].s_no === undefined)) && Math.max(page * this.state.perPage, this.state.totalSearchCount) === this.state.totalSearchCount && page * this.state.perPage !== this.state.totalSearchCount) {
      let finalRequiredValue = page * this.state.perPage;
      if (!(this.state.data[requiredValue - this.state.perPage] && this.state.data[requiredValue - this.state.perPage].s_no !== undefined)) {
        finalRequiredValue = requiredValue - 60;
      }
      this.setState({
        from: finalRequiredValue,
        isLoaderActive: true,
        currentPage: page,
      });
      setTimeout(() => {
        const requestObject = this.creatingRequestObject(requestObjectType.pagination);
        this.callingSearchAPI(requestObject, requestObjectType.pagination);
      }, 100);
    } else {
      this.setState({
        isTableVisible: false,
        currentPage: page,
      });
      setTimeout(() => {
        this.setState({
          isTableVisible: true,
          currentPage: page,
        });
      }, 10);
    }
  };

  // End of the above code
  // Below code is for the clear Individual Filter
  clearIndividualFilter = async (filterData) => {
    let filterLabelName = this.filterTypeEnum[filterData.key];
    let additionalFilterLabelName = this.filterTypeEnum[filterData?.additionalKey];
    let filterObjectClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.filterObject));
    let tempExcludeFilterArr = this.state.excludeFilter.filter((item) => item !== filterLabelName);
    let tempIncludeFilterArr = this.state.includeFilter.filter((item) => item !== filterLabelName);
    tempIncludeFilterArr = tempIncludeFilterArr.filter((item) => item !== additionalFilterLabelName);
    let tempAppliedTempBooleanObj = JSON.parse(JSON.stringify(this.state.appliedBooleanFilterObject));
    if (filterData.type === filterType.radioFilter) {
      tempAppliedTempBooleanObj[filterLabelName] = this.defaultBooleanFilterObject?.[filterLabelName];
      await this.props.filterObjectHandler({ ...filterObjectClone, [filterLabelName]: this.defaultBooleanFilterObject?.[filterLabelName] });
      await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [filterLabelName]: this.defaultBooleanFilterObject?.[filterLabelName] });
    } else {
      await this.props.filterObjectHandler({ ...filterObjectClone, [filterLabelName]: [], [additionalFilterLabelName]: [] });
      await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [filterLabelName]: [], [additionalFilterLabelName]: [] });
      await this.props.selectedFilterListHandler({ ...this.props.shipmentDetails.selectedFilterList, [filterLabelName]: [], [additionalFilterLabelName]: [] });
    }
    this.setState(
      {
        appliedBooleanFilterObject: JSON.parse(JSON.stringify(tempAppliedTempBooleanObj)),
        excludeFilter: tempExcludeFilterArr,
        includeFilter: tempIncludeFilterArr,
        uniqueImportExporterShipment: [...[]],
        uniqueImportExporterWeight: [...[]],
        uniqueImportExporterTeu: [...[]],
        uniqueImportExporterValue: [...[]],
        uniqueLogisticsTypeFilter: [...[]],
        selectedExporterRowData: [],
        selectedImporterRowData: [],
        selectedLogisticsRowData: [],
        derivedShipperMasterNameAndIdMapping: filterData.key === this.specialFields.shipper ? [] : this.state.derivedShipperMasterNameAndIdMapping,
        derivedConsigneeMasterNameAndIdMapping: filterData.key === this.specialFields.consignee ? [] : this.state.derivedConsigneeMasterNameAndIdMapping,
      },
      () => {
        this.callingSearchResult(requestObjectType.filter);
      }
    );
  };
  // End of the above code
  // Below code is used for the View All Filter
  viewAllFilter = (thisData, data) => {
    // ::Tracking: Below code is for adding the event of open filter
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.openFilter);
    this.trackFilterEvent(thisData, "open");
    // End of the above code
    if (this.state.currentPlanAccess[thisData] === false) {
      return this.setState({
        showUpgradeModal: true,
        upgradePopopContent: "To access this filter please upgrade to higher plan",
      });
    }
    if ((!!data && data === "proximity") || this.state.proximityApplied === true) {
      this.setState({
        proximityClicked: true,
      });
    } else {
      this.setState({
        proximityClicked: false,
      });
    }
    this.setState({
      filterModuleSelected: thisData,
    });
    if (document.getElementById("searchIndividualFilterPanel")) {
      document.getElementById("searchIndividualFilterPanel").style.display = "block";
    }
  };
  //end of the above code
  // Below Method is used for close Filter View All Popup
  closeViewAllFilter = () => {
    if (document.getElementById("searchIndividualFilterPanel")) {
      document.getElementById("searchIndividualFilterPanel").style.display = "none";
    }
    this.setState({
      filterModuleSelected: "",
    });
    this.props.filterMustNotHandler([]);
    // this.props.selectedFilterListHandler({});
  };
  // End of the above code

  // Below code is for Save Selected Filter
  saveSelectedFilter = async (thisData, isProximity, event, item, fltrList, selectedFilterIds) => {
    this.setState({
      isFilterAppliedStarter: true,
      showZipcodeOverridePopup: false,
      lastRequestType: requestObjectType.filter,
    });
    if (item.hasOwnProperty("additionalType") && item.additionalType === "multiSelectRangeFilter") {
      await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [thisData]: selectedFilterIds, [item.additionalKey]: [] });
    } else await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [thisData]: selectedFilterIds });
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.applyFilter);
    this.trackFilterEvent(item, "apply");
    let tempFilterObject = JSON.parse(JSON.stringify(this.state.filterObj));
    let tempMainFilterObject = JSON.parse(JSON.stringify(this.state.mainFilterObject));
    let tempSelectedLabelFilterObject = JSON.parse(JSON.stringify(this.state.selectedFilterLabelObject));
    let tempIncludeFilter = [...this.state.includeFilter];
    let tempExcludeFilter = [...this.state.excludeFilter];

    if (tempIncludeFilter.includes(thisData) && event === "false") {
      tempIncludeFilter = tempIncludeFilter.filter((data) => data !== thisData);
    }
    if (tempIncludeFilter.includes(thisData) === false && event === "true") {
      tempIncludeFilter.push(thisData);
    }
    if (tempExcludeFilter.includes(thisData) && event === "true") {
      tempExcludeFilter = tempExcludeFilter.filter((data) => data !== thisData);
    }
    if (tempExcludeFilter.includes(thisData) === false && event === "false") {
      tempExcludeFilter.push(thisData);
    }
    if (item.hasOwnProperty("additionalType") && item.additionalType === "multiSelectRangeFilter") {
      tempIncludeFilter = tempIncludeFilter.filter((data) => data !== item.additionalKey);
    }
    this.fillDataHandler(this.filterMapList && this.filterMapList[0] && this.filterMapList[0].categoryName ? this.filterMapList[0].categoryName : "", "defaultData");
    if (document.getElementById("searchIndividualFilterPanel")) {
      document.getElementById("searchIndividualFilterPanel").style.display = "none";
    }
    this.setState(
      {
        filterObj: JSON.parse(JSON.stringify(tempFilterObject)),
        mainFilterObject: JSON.parse(JSON.stringify(tempMainFilterObject)),
        tempObj: {},
        expTempObj: {},
        includeFilter: tempIncludeFilter,
        excludeFilter: tempExcludeFilter,
        selectedExporterRowData: [],
        selectedImporterRowData: [],
        selectedLogisticsRowData: [],
        selectedFilterLabelObject: tempSelectedLabelFilterObject,
        proximityApplied: isProximity,
        filterModuleSelected: "",
      },
      () => {
        this.callForFilter(this, null, tempFilterObject);
      }
    );
  };

  // end of above code
  mapBooleanFilter = (data, type, item) => {
    let tempBooleanObj = { ...this.state.selecetedBooleanFilterObject };
    tempBooleanObj[type] = data;
    this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [type]: data });
    this.trackFilterEvent(item, "apply");

    this.setState(
      {
        selecetedBooleanFilterObject: tempBooleanObj,
      },
      () => {
        this.callForFilter("", item);
      }
    );
  };
  // Below code is used for mapping the selected Data in the filter

  // End of the above code
  goBackRedirectUser = () => {
    window.location.reload();
  };
  // End of above code
  updateVariables = (updatedState) => {
    this.setState(updatedState);
  };
  // Method which is used to search HS Code In Filter
  searchHscodeInFilter = (data) => {
    const searchedValue = data.toLowerCase();
    let searchedResultArr;
    this.setState({
      searchedFilterHscode: searchedValue,
    });
    if (searchedValue.length > 2) {
      searchedResultArr = this.state.mainFilterObject[this.specialFields.hscode].filter((item) => {
        if (!!item.values && item.values.length > 0) {
          for (let i = 0; i < item.values.length; i++) {
            if (item.values[i].key === searchedValue || (searchedValue.length === 3 && searchedValue === item.values[i].key.slice(0, 3))) {
              return Object.keys(item.values[i]).some(() => item.values[i].key.toLowerCase().includes(searchedValue));
            }
          }
        }
      });
    } else {
      searchedResultArr = this.state.mainFilterObject[this.specialFields.hscode].filter((item) => {
        return Object.keys(item).some(() => item.key.toLowerCase().includes(searchedValue));
      });
    }
    let tempFilterObject = { ...this.state.filterObj };
    tempFilterObject[this.specialFields.hscode] = searchedResultArr;
    this.setState({
      filterObj: tempFilterObject,
    });
  };
  // End of the above code
  // Below code is used when user select the Impoherter Rows
  selectedExporterRowFun = (data) => {
    // this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabCheckbox);
    this.setState({
      prospectExporter: data,
      selectedExporterRowData: data,
    });
  };
  selectedLogisticsRowFun = (data) => {
    this.setState({
      prospectLogistics: data,
      selectedLogisticsRowData: data,
    });
  };
  // end of the above code
  // Below code is used when user select the Impoherter Rows

  selectedImporterRowFunClone = (data) => {
    // this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabCheckbox);
    this.setState({
      prospectImporter: data,
      selectedImporterRowData: data,
    });
  };

  selectedLogisticsRowFunClone = (data) => {
    this.setState({
      prospectLogistics: data,
      selectedLogisticsRowData: data,
    });
  };
  // end of the above code
  // below code is for handling sort in unique importer and unique exporter grid
  handleExporterSorting = (type, column, sortDirection) => {
    if ((column && column.key && column.key.includes("doc_count")) || (typeof column?.selector !== "function" && column?.selector?.includes("doc_count"))) {
      if (this.state.exporterTrendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsSortByShipments);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSortByShipments);
      }
    } else if ((column && column.key && column.key.includes("teu")) || (typeof column?.selector !== "function" && column?.selector?.includes("teu"))) {
      if (this.state.exporterTrendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsSortByTeus);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSortByTeus);
      }
    } else if ((column && column.key && column.key.includes("weight")) || (typeof column?.selector !== "function" && column?.selector?.includes("weight"))) {
      if (this.state.exporterTrendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsSortByWeight);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSortByWeight);
      }
    } else if ((column && column.key && column.key.includes("value")) || (typeof column?.selector !== "function" && column?.selector?.includes("value"))) {
      if (this.state.exporterTrendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsSortByValue);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSortByValue);
      }
    }
    this.setState({
      exporterSortOrderValue: sortDirection,
      exporterCurrentPage: 1,
      isLoaderActive: true,
      mustNotIncludeExporter: [],
      isSorting: true,
      prospectExporter: [],
      secondLevelData: [],
      clearBotton: !this.state.clearBotton,
      selectedExporterRowData: [],
      currentPage: 1,
      defaultPage: 1,
    });

    this.defaultData.exporterSorting.map((item) => {
      if (column.selector === item.columnKey) {
        this.setState({
          exporterSortValue: item.value,
        });
      } else if (column.value === item.columnKey) {
        this.setState({
          exporterSortValue: item.value,
        });
      } else if (column.key === item.columnKey) {
        this.setState({
          exporterSortValue: item.value,
        });
      }
    });
    setTimeout(() => {
      this.setState({
        defaultTrendsData: [],
        secondLevelData: [],
      });
      this.getUniqueExporterData(requestObjectType.exporters);
      this.mapSearchTableColumn();
    }, 200);
  };

  handleExporterSortingClone = (column, sortDirection) => {
    this.setState({
      exporterSortOrderValue: sortDirection,
      exporterCurrentPage: 1,
      isLoaderActive: true,
      mustNotIncludeExporter: [],
      isSorting: true,
      prospectExporter: [],
      secondLevelData: [],
      clearBotton: !this.state.clearBotton,
      selectedExporterRowData: [],
      currentPage: 1,
      defaultPage: 1,
    });
    this.defaultData.exporterSorting.map((item) => {
      if (column === item.value) {
        this.setState({
          exporterSortValue: item.value,
        });
      }
    });
    setTimeout(() => {
      this.setState({
        defaultTrendsData: [],
        secondLevelData: [],
        selectedExporterRowData: [],
      });
      this.getUniqueExporterData(requestObjectType.exporters);
      this.mapSearchTableColumn();
    }, 200);
  };

  handleLogisticsSorting = (type, column, sortDirection) => {
    if ((column && column.key && column.key.includes("doc_count")) || (typeof column?.selector !== "function" && column?.selector?.includes("doc_count"))) {
      if (this.state.logisticsTrendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsSortByShipments);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSortByShipments);
      }
    }
    this.setState({
      logisticsSortOrderValue: sortDirection,
      logisticsCurrentPage: 1,
      isLoaderActive: true,
      mustNotIncludeLogistics: [],
      isSorting: true,
      prospectLogistics: [],
      secondLevelData: [],
      clearBotton: !this.state.clearBotton,
      selectedLogisticsRowData: [],
      currentPage: 1,
      defaultPage: 1,
    });
    this.defaultData.logisticsSorting.map((item) => {
      if (column.key === item.columnKey) {
        this.setState({
          logisticsSortValue: item.value,
        });
      }
    });
    setTimeout(() => {
      this.setState({
        defaultTrendsData: [],
        secondLevelData: [],
      });
      this.getUniqueLogisticsData(requestObjectType.logistics);
      this.mapSearchTableColumn();
    }, 200);
  };

  handleLogisticsSortingClone = (column, sortDirection) => {
    this.setState({
      logisticsSortOrderValue: sortDirection,
      logisticsCurrentPage: 1,
      isLoaderActive: true,
      mustNotIncludeLogistics: [],
      isSorting: true,
      prospectLogistics: [],
      secondLevelData: [],
      clearBotton: !this.state.clearBotton,
      selectedLogisticsRowData: [],
      currentPage: 1,
      defaultPage: 1,
    });
    this.defaultData.logisticsSorting.map((item) => {
      if (column === item.value) {
        this.setState({
          logisticsSortValue: item.value,
        });
      }
    });
    setTimeout(() => {
      this.setState({
        defaultTrendsData: [],
        secondLevelData: [],
        selectedLogisticsRowData: [],
      });
      this.getUniqueLogisticsData(requestObjectType.logistics);
      this.mapSearchTableColumn();
    }, 200);
  };
  // end of above code
  // below code is for handling sort in unique importer and unique exporter grid
  handleImporterSorting = (type, column, sortDirection) => {
    if ((column && column.key && column.key.includes("doc_count")) || (typeof column?.selector !== "function" && column?.selector?.includes("doc_count"))) {
      if (this.state.trendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsSortByShipments);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSortByShipments);
      }
    } else if ((column && column.key && column.key.includes("teu")) || (typeof column?.selector !== "function" && column?.selector?.includes("teu"))) {
      if (this.state.trendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsSortByTeus);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSortByTeus);
      }
    } else if ((column && column.key && column.key.includes("weight")) || (typeof column?.selector !== "function" && column?.selector?.includes("weight"))) {
      if (this.state.trendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsSortByWeight);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSortByWeight);
      }
    } else if ((column && column.key && column.key.includes("value")) || (typeof column?.selector !== "function" && column?.selector?.includes("value"))) {
      if (this.state.trendsTab === true) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsSortByValue);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSortByValue);
      }
    }
    this.setState({
      importerSortOrderValue: sortDirection,
      importerCurrentPage: 1,
      isLoaderActive: true,
      mustNotIncludeImporter: [],
      isSorting: true,
      prospectImporter: [],
      secondLevelData: [],
      clearBotton: !this.state.clearBotton,
      selectedImporterRowData: [],
      currentPage: 1,
      defaultPage: 1,
    });
    this.defaultData.importerSorting.map((item) => {
      if (column.selector === item.columnKey) {
        this.setState({
          importerSortValue: item.value,
        });
      } else if (column.key === item.columnKey) {
        this.setState({
          importerSortValue: item.value,
        });
      }
    });
    setTimeout(() => {
      this.setState({
        defaultTrendsData: [],
        secondLevelData: [],
      });
      this.getUniqueImporterData(requestObjectType.importers);
      this.mapSearchTableColumn();
    }, 200);
  };

  handleImporterSortingClone = (column, sortDirection) => {
    this.setState({
      importerSortOrderValue: sortDirection,
      importerCurrentPage: 1,
      isLoaderActive: true,
      mustNotIncludeImporter: [],
      isSorting: true,
      prospectImporter: [],
      secondLevelData: [],
      clearBotton: !this.state.clearBotton,
      selectedImporterRowData: [],
      currentPage: 1,
      defaultPage: 1,
    });
    this.defaultData.importerSorting.map((item) => {
      if (column === item.value) {
        this.setState({
          importerSortValue: item.value,
        });
      }
    });
    setTimeout(() => {
      this.setState({
        defaultTrendsData: [],
        secondLevelData: [],
        selectedImporterRowData: [],
      });
      this.getUniqueImporterData(requestObjectType.importers);
      this.mapSearchTableColumn();
    }, 200);
  };

  handlePerRowsChangeExporterClone = (currentPage) => {
    if (currentPage > this.state.exporterCurrentPage) {
      if (this.state.ueTwoLevel) {
        if (this.state.exporterTrendsTab === true) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsPaginationForward);
        }
      }
    } else if (currentPage < this.state.exporterCurrentPage) {
      if (this.state.ueTwoLevel) {
        if (this.state.exporterTrendsTab === true) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsPaginationBackward);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalyticsPaginationBackward);
        }
      }
    }
    const requiredValue = currentPage * this.state.exporterPerPage;
    if (!(!!this.state.uniqueExportersData[requiredValue + 1] && this.state.uniqueExportersData[requiredValue + 1] !== "") && requiredValue + 1 < this.state.totalUniqueExporter) {
      if (this.showUiTrends) {
        this.getUniqueExporterData(requestObjectType.exporters, "pagination");
      } else {
        this.getUniqueExporterData(requestObjectType.exporters);
      }
    }
    this.setState({
      exporterCurrentPage: currentPage,
      isLoaderActive: true,
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 700);
  };
  // End of the above code
  // Below code is for handing the Per Rows Change
  handlePerRowsChangeImporter = (currentPage) => {
    const requiredValue = currentPage * this.state.importerPerPage;
    if (!(!!this.state.uniqueImportersData[requiredValue + 1] && this.state.uniqueImportersData[requiredValue + 1] !== "") && requiredValue + 1 < this.state.totalUniqueImporter) {
      if (this.showUiTrends) {
        this.getUniqueImporterData(requestObjectType.importers, "pagination");
      } else {
        this.getUniqueImporterData(requestObjectType.importers);
      }
    }
    this.setState({
      importerCurrentPage: currentPage,
      isLoaderActive: true,
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 700);
  };

  handlePerRowsChangeImporterClone = (currentPage) => {
    const requiredValue = currentPage * this.state.importerPerPage;
    if (!(!!this.state.uniqueImportersData[requiredValue + 1] && this.state.uniqueImportersData[requiredValue + 1] !== "") && requiredValue + 1 < this.state.totalUniqueImporter) {
      if (this.showUiTrends) {
        this.getUniqueImporterData(requestObjectType.importers, "pagination");
      } else {
        this.getUniqueImporterData(requestObjectType.importers);
      }
    }

    this.setState({
      importerCurrentPage: currentPage,
    });
  };

  //logistics start
  handlePerRowsChangeLogistics = (currentPage) => {
    const requiredValue = currentPage * this.state.logisticsPerPage;
    if (!(!!this.state.uniqueLogisticsData[requiredValue + 1] && this.state.uniqueLogisticsData[requiredValue + 1] !== "") && requiredValue + 1 < this.state.totalUniqueLogistics) {
      if (this.showUiTrends) {
        this.getUniqueLogisticsData(requestObjectType.logistics, "pagination");
      } else {
        this.getUniqueLogisticsData(requestObjectType.logistics);
      }
    }
    this.setState({
      logisticsCurrentPage: currentPage,
      isLoaderActive: true,
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 700);
  };

  handlePerRowsChangeLogisticsClone = (currentPage) => {
    const requiredValue = currentPage * this.state.logisticsPerPage;
    if (!(!!this.state.uniqueLogisticsData[requiredValue + 1] && this.state.uniqueLogisticsData[requiredValue + 1] !== "") && requiredValue + 1 < this.state.totalUniqueLogistics) {
      if (this.showUiTrends) {
        this.getUniqueLogisticsData(requestObjectType.logistics, "pagination");
      } else {
        this.getUniqueLogisticsData(requestObjectType.logistics);
      }
    }

    this.setState({
      logisticsCurrentPage: currentPage,
    });
  };
  //logistics end

  // End of the above code
  // Below code is handling the search per rows change
  handleSearchPerRowsExporterChange = (data) => {
    if (this.state.ueTwoLevel && this.state.exporterTrendsTab === false) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalyticsPaginationResultPerPage);
    }
    let array = [];
    this.setState({
      exporterPerPage: data,
      secondLevelData: [],
      isLoaderActive: true,
      defaultPage: 1,
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 500);
    setTimeout(() => {
      array = JSON.parse(JSON.stringify(setLevelTwoDatahandler(this.state.defaultTrendsData, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value)));
      this.setState({
        secondLevelData: array,
      });
    }, 200);
  };

  handleSearchPerRowsExporterChangeClone = (data) => {
    if (this.state.ueTwoLevel && this.state.exporterTrendsTab === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsPaginationResultPerPage);
    }
    if (this.isUEGridNew && !this.state.ueTwoLevel) {
      this.setState({
        exporterPerPage: data,
        isLoaderActive: true,
      });
      setTimeout(() => {
        this.setState({
          isLoaderActive: false,
        });
      }, 500);
    } else {
      this.handleSearchPerRowsExporterChange(data);
    }
  };
  // End of the above code
  // Below code is handling the search per rows change
  handleSearchPerRowsImporterChange = (data) => {
    if (this.state.uiTwoLevel && this.state.trendsTab === false) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalyticsPaginationResultPerPage);
    }
    let array = [];
    this.setState({
      importerPerPage: data,
      isLoaderActive: true,
      secondLevelData: [],
      defaultPage: 1,
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 500);
    setTimeout(() => {
      array = JSON.parse(JSON.stringify(setLevelTwoDatahandler(this.state.defaultTrendsData, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value)));

      this.setState({
        secondLevelData: array,
      });
    }, 200);
  };

  handleSearchPerRowsImporterChangeClone = (data) => {
    if (this.state.uiTwoLevel && this.state.trendsTab === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends2ndLevelAnalyticsPaginationResultPerPage);
    } else if (this.state.trendsTab === true) {
      // this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsPaginationResultPerPage);
    }
    if (this.isUIGridNew && !this.state.uiTwoLevel) {
      this.setState({
        importerPerPage: data,
        isLoaderActive: true,
      });
      setTimeout(() => {
        this.setState({
          isLoaderActive: false,
        });
      }, 500);
    } else {
      this.handleSearchPerRowsImporterChange(data);
    }
  };

  //logistics start
  handleSearchPerRowsLogisticsChange = (data) => {
    if (this.state.ulTwoLevel && this.state.logisticsTrendsTab === false) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank2ndLevelAnalyticsPaginationResultPerPage);
    }
    let array = [];
    this.setState({
      logisticsPerPage: data,
      isLoaderActive: true,
      secondLevelData: [],
      defaultPage: 1,
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 500);
    setTimeout(() => {
      array = JSON.parse(JSON.stringify(setLevelTwoDatahandler(this.state.defaultTrendsData, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value)));
      this.setState({
        secondLevelData: array,
      });
    }, 200);
  };

  handleSearchPerRowsLogisticsChangeClone = (data) => {
    if (this.state.ulTwoLevel && this.state.logisticsTrendsTab === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends2ndLevelAnalyticsPaginationResultPerPage);
    } else if (this.state.logisticsTrendsTab === true) {
      // this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsPaginationResultPerPage);
    }
    if (this.isUIGridNew && !this.state.ulTwoLevel) {
      this.setState({
        logisticsPerPage: data,
        isLoaderActive: true,
      });
      setTimeout(() => {
        this.setState({
          isLoaderActive: false,
        });
      }, 500);
    } else {
      this.handleSearchPerRowsLogisticsChange(data);
    }
  };
  //logistics end

  // Below method is used for download shipment from the popup
  downloadShipmentFromPopup = (downloadFromValue, downloadToValue, selectAll, downloadShipmentPopupClose, isCustomGridDownload) => {
    if (selectAll === true) {
      // this is for the select all Feature
      if (this.state.totalSearchCount >= this.state.creditQuota.download_credits.credit_limit - this.state.creditQuota.download_credits.credits_consumed) {
        downloadShipmentPopupClose();
        toast.error("You do not have sufficient credits available to download XXX shipments.".replace("XXX", this.state.totalSearchCount));
        return false;
      }
      if (this.state.totalSearchCount > 500) {
        // this is for emailing the shipments
        let emailXlsRequestObj = this.creatingRequestObject(requestObjectType.filter);
        emailXlsRequestObj.isCustomGridDownload = isCustomGridDownload;
        emailXlsRequestObj.size = this.state.totalSearchCount;
        emailXlsRequestObj.email = true;
        emailXlsRequestObj.companyType = this.state.currentTab === tabKeywords.exporters ? "shipper" : this.state.currentTab === tabKeywords.importers ? "consignee" : "";
        this.emailXls(emailXlsRequestObj, downloadShipmentPopupClose);
      } else {
        // this is for download xls using API having email true
        let downloadXlsRequestObj = this.creatingRequestObject(requestObjectType.filter);
        downloadXlsRequestObj.isCustomGridDownload = isCustomGridDownload;
        downloadXlsRequestObj.size = this.state.totalSearchCount;
        downloadXlsRequestObj.email = false;
        downloadXlsRequestObj.companyType = this.state.currentTab === tabKeywords.exporters ? "shipper" : this.state.currentTab === tabKeywords.importers ? "consignee" : "";
        this.downloadingNotHavingData(downloadXlsRequestObj, downloadShipmentPopupClose);
      }
    } else {
      if (+downloadToValue < +downloadFromValue) {
        toast.error("TO value must be greater than FROM value");
        return false;
      }
      if (downloadToValue - downloadFromValue >= this.state.creditQuota.download_credits.credit_limit - this.state.creditQuota.download_credits.credits_consumed) {
        downloadShipmentPopupClose();
        toast.error("You do not have sufficient credits available to download XXX shipments.".replace("XXX", downloadToValue - downloadFromValue + 1));
        return false;
      }
      // this is for download xls using API having email true
      if (downloadToValue - downloadFromValue + 1 > 500) {
        // call for email shipments with to and from value using email variable as true
        let downloadXlsRequestObj = this.creatingRequestObject(requestObjectType.filter);
        if (this.defaultData && this.defaultData.oldPayloadType) {
          downloadXlsRequestObj.from = +downloadFromValue > 1 ? +downloadFromValue : 1;
        } else {
          downloadXlsRequestObj.from = +downloadFromValue - 1 > 0 ? +downloadFromValue - 1 : 0;
        }
        downloadXlsRequestObj.size = downloadToValue - downloadFromValue + 1;
        downloadXlsRequestObj.isCustomGridDownload = isCustomGridDownload;
        downloadXlsRequestObj.email = true;
        downloadXlsRequestObj.companyType = this.state.currentTab === tabKeywords.exporters ? "shipper" : this.state.currentTab === tabKeywords.importers ? "consignee" : "";
        this.emailXls(downloadXlsRequestObj, downloadShipmentPopupClose);
      } else {
        // call for download shipment with to and from value using email variable as false
        let downloadXlsRequestObj = this.creatingRequestObject(requestObjectType.filter);
        if (this.defaultData && this.defaultData.oldPayloadType) {
          downloadXlsRequestObj.from = +downloadFromValue > 1 ? +downloadFromValue : 1;
        } else {
          downloadXlsRequestObj.from = +downloadFromValue - 1 > 0 ? +downloadFromValue - 1 : 0;
        }
        downloadXlsRequestObj.size = downloadToValue > this.state.totalSearchCount ? this.state.totalSearchCount - downloadFromValue + 1 : downloadToValue - downloadFromValue + 1;
        downloadXlsRequestObj.isCustomGridDownload = isCustomGridDownload;
        downloadXlsRequestObj.email = false;
        downloadXlsRequestObj.companyType = this.state.currentTab === tabKeywords.exporters ? "shipper" : this.state.currentTab === tabKeywords.importers ? "consignee" : "";
        this.downloadingNotHavingData(downloadXlsRequestObj, downloadShipmentPopupClose);
        // end of the above logic
      }
    }
  };
  // End of the above code
  // Below code is used for the Close the View All Popup of Anaytics
  hideAnalyticsViewAllModal = (data) => {
    if (!!data && data === true) {
      this.setState({
        viewAllAnalyticsFlag: true,
      });
    }
  };
  // End of the above code
  // below code is for the
  fetchSummaryViewAllData = async (reqData, data, isReport = false) => {
    this.setState({
      currentKeyViewTrendItem: data ? data : [],
      isFilterApplied: true,
    });
    const analyticsFieldKeys = [...this.defaultData.analyticsFieldsMapping];
    let tempIncludeFilter = [...this.state.includeFilter];
    let tempExcludeFilter = [...this.state.excludeFilter];
    let appliedStateClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.appliedFilter));
    if (!!reqData && !!reqData.filter_value1 && reqData.filter_value1 !== "") {
      analyticsFieldKeys.forEach((item) => {
        if (!!item.type && (item.type === analyticsType.horizontalBar || item.type === analyticsType.verticalBar || item.type === analyticsType.horizontalCountry || item.type === analyticsType.pieChart)) {
          if (reqData.analyticsViewAllKey === item.key) {
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey);
            appliedStateClone[item.filterKey] = [reqData.filter_value1].flat(2);
            this.setState({
              includeFilter: tempIncludeFilter,
              excludeFilter: tempExcludeFilter,
            });
          }
        } else if (!!item.type && item.type === analyticsType.hsCode && (item.key === "derived_secondary_notify_parties" || item.key === "notify_party_name" || item.key === "sections" || item.key === "derived_sections" || item.key === "section" || item.key === "six_digit_hs_code")) {
          if (reqData.analyticsViewAllKey === item.key) {
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey);
            this.setState({
              includeFilter: tempIncludeFilter,
              excludeFilter: tempExcludeFilter,
            });
            appliedStateClone[item.filterKey] = [reqData.filter_value1].flat(2);
          }
        } else if (!!item.type && item.type === analyticsType.hsCode) {
          if (reqData.analyticsViewAllKey === item.key) {
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey);
            appliedStateClone[item.filterKey] = [reqData.filter_value1].flat(2);
            this.setState({
              includeFilter: tempIncludeFilter,
              excludeFilter: tempExcludeFilter,
            });
          }
        } else if (!!item.type && item.type === analyticsType.topTwo) {
          if (reqData.analyticsViewAllKey === item.key && !!this.state.filterObj[item.filterKey1] && !!this.state.filterObj[item.filterKey2]) {
            this.setState({
              isLoaderActive: true,
              isFilterApplied: true,
            });
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey1);
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey2);
            appliedStateClone[item.filterKey1] = [reqData.filter_value1].flat(2);
            if (item.profileType !== redirectingProfileEnum.tradeLane.key) {
              appliedStateClone[item.filterKey2] = [reqData.filter_value2].flat(2);
            }
            this.setState({
              includeFilter: tempIncludeFilter,
              excludeFilter: tempExcludeFilter,
            });
          }
        } else if (!!item.type && item.type === analyticsType.topThree) {
          if (reqData.analyticsViewAllKey === item.key && !!this.state.filterObj[item.filterKey1] && !!this.state.filterObj[item.filterKey2] && !!this.state.filterObj[item.filterKey3]) {
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey1);
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey2);
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey3);
            appliedStateClone[item.filterKey1] = [reqData.filter_value1].flat(2);
            appliedStateClone[item.filterKey2] = [reqData.filter_value2].flat(2);
            appliedStateClone[item.filterKey3] = [reqData.filter_value3].flat(2);
            this.setState({
              includeFilter: tempIncludeFilter,
              excludeFilter: tempExcludeFilter,
            });
          }
        } else if (!!item.type && item.type === analyticsType.topFour) {
          if (reqData.analyticsViewAllKey === item.key && !!this.state.filterObj[item.filterKey1] && !!this.state.filterObj[item.filterKey2] && !!this.state.filterObj[item.filterKey3] && !!this.state.filterObj[item.filterKey4]) {
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey1);
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey2);
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey3);
            [tempIncludeFilter, tempExcludeFilter] = this.handleIncludeExcludeAnalytics(tempIncludeFilter, tempExcludeFilter, item.filterKey4);
            appliedStateClone[item.filterKey1] = [reqData.filter_value1].flat(2);
            appliedStateClone[item.filterKey2] = [reqData.filter_value2].flat(2);
            appliedStateClone[item.filterKey3] = [reqData.filter_value3].flat(2);
            appliedStateClone[item.filterKey4] = [reqData.filter_value4].flat(2);

            this.setState({
              includeFilter: tempIncludeFilter,
              excludeFilter: tempExcludeFilter,
            });
          }
        }
      });
    }
    await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, ...appliedStateClone });
    if (!!reqData && !!reqData.filter_value1 && reqData.filter_value1 !== "") {
      this.setState(
        {
          data: [...[]],
          currentPage: 1,
          defaultPage: 1,
        },
        () => {
          this.callingSearchResult(requestObjectType.filter, reqData.analysisOption);
        }
      );
    } else {
      let tempReqObj = this.state.finalReqObj;
      tempReqObj.analyticsField = reqData.analyticsViewAllKey;
      tempReqObj.analysis = reqData.analysisOption;
      this.setState({
        viewAllAnalyticsFlag: !isReport ? false : true,
        viewAllFinalSearchReqObj: tempReqObj,
      });
    }
  };
  // end of above code
  //Below code is used to hide the trends modal of Analytics
  handleClose = (data) => {
    if (!!data && data === true) {
      this.setState({
        viewAllTrends: false,
      });
    }
  };
  //End of the above code
  fetchSummaryTrendsData = (reqdata, currentKeyViewTrendItem, isReport = false) => {
    setTimeout(() => {
      let tempReqObj = this.state.finalReqObj;
      tempReqObj.analyticsField = reqdata.analyticsViewAllKey;
      tempReqObj.analysis = reqdata.analysisOption;
      this.setState({
        viewAllFinalSearchReqObj: tempReqObj,
        viewAllTrends: !isReport ? true : false,
        currentKeyViewTrendItem: currentKeyViewTrendItem ? currentKeyViewTrendItem : [],
      });
    }, 100);
  };
  //above code is for analytics view trend
  setRangeValue = async (e, type, item) => {
    if (e && type) {
      let tempFilterOb = JSON.parse(JSON.stringify(this.state.filterObj));
      let tempSelectedLabel = JSON.parse(JSON.stringify(this.state.selectedFilterLabelObject));
      let tempBoxFilterobj = JSON.parse(JSON.stringify(this.state.selectedBoxFilterObj));

      if (e.min || e.min === 0) {
        if (tempFilterOb[type]) tempFilterOb[type][0] = e.min;
        tempSelectedLabel[type][0] = e.min;
        tempBoxFilterobj[type][0] = e.min;
      } else {
        if (tempFilterOb[type]) tempFilterOb[type][0] = this.state.appliedBoxFilterObj[type][0];
        tempSelectedLabel[type][0] = this.state.appliedBoxFilterObj[type][0];
        tempBoxFilterobj[type][0] = this.state.appliedBoxFilterObj[type][0];
      }
      if (e.max || e.max === 0) {
        if (tempFilterOb[type]) tempFilterOb[type][1] = e.max;
        tempSelectedLabel[type][1] = e.max;
        tempBoxFilterobj[type][1] = e.max;
      } else {
        if (tempFilterOb[type]) tempFilterOb[type][1] = this.state.appliedBoxFilterObj[type][1];
        tempSelectedLabel[type][1] = this.state.appliedBoxFilterObj[type][1];
        tempBoxFilterobj[type][1] = this.state.appliedBoxFilterObj[type][1];
      }
      await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [type]: tempBoxFilterobj[type] });
      this.trackFilterEvent(item ?? type, "apply");
      await this.callForFilter(type, item);
    }
  };

  setMultiRangeValue = async (thisData, type, includeFilter, item) => {
    let tempSelectedLabel = JSON.parse(JSON.stringify(this.state.selectedFilterLabelObject));
    let tempBoxFilterobj = JSON.parse(JSON.stringify(this.state.selectedBoxFilterObj));
    let finalDataArr = [];
    if (thisData && type) {
      for (let i = 0; i < thisData.length; i++) {
        let tempData = thisData[i];
        if (tempData.dropdown) {
          let min = tempData.input1;
          let max = tempData.input2;
          if (tempData.input1 === null) {
            min = tempData.dropdown.range[0];
          }
          if (tempData.input2 === null) {
            max = tempData.dropdown.range[1];
          }
          finalDataArr.push({
            key: tempData.dropdown.value,
            range: [+min, +max],
          });
        }
      }
    }
    let tempIncludeFilter = [...this.state.includeFilter];
    let tempExcludeFilter = [...this.state.excludeFilter];

    if (tempIncludeFilter.includes(type) && includeFilter === "false") {
      tempIncludeFilter = tempIncludeFilter.filter((data) => data !== type);
    }
    if (tempIncludeFilter.includes(type) === false && includeFilter === "true") {
      tempIncludeFilter.push(type);
    }
    if (tempExcludeFilter.includes(type) && includeFilter === "true") {
      tempExcludeFilter = tempExcludeFilter.filter((data) => data !== type);
    }
    if (tempExcludeFilter.includes(type) === false && includeFilter === "false") {
      tempExcludeFilter.push(type);
    }
    if (item.hasOwnProperty("additionalType") && item.additionalType === "multiSelectRangeFilter") {
      tempIncludeFilter = tempIncludeFilter.filter((data) => data !== item.key);
    }
    this.setState({
      includeFilter: tempIncludeFilter,
      excludeFilter: tempExcludeFilter,
    });
    tempSelectedLabel[type] = finalDataArr;
    tempBoxFilterobj[type] = finalDataArr;
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.applyFilter);
    this.trackFilterEvent(item, "apply");
    if (item.hasOwnProperty("additionalType") && item.additionalType === "multiSelectRangeFilter") {
      await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [type]: tempBoxFilterobj[type], [item.key]: [] });
    } else await this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, [type]: tempBoxFilterobj[type] });
    await this.callForFilter(type);
  };

  componentDidUpdate() {
    secondUIUEStyleHandler(this.state.secondLevelData, this.state.uiTwoLevel, this.state.ueTwoLevel, this.state.ulTwoLevel, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.totalUniqueImporter, this.state.totalUniqueExporter, this.state.totalUniqueLogistics, this.state.defaultPage, this.state.dataCount, this.state.viewAllPerPage, this.state.secondLevelRowDropdownValue.value);
  }

  mappingUniqueImporterExporter = (type, data, closeDownloadFromModal) => {
    let currentData;
    if (data.toLowerCase() === "importer".toLowerCase()) {
      currentData = this.state.prospectImporter;
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabSelectionStripDownloadConfirm);
    } else if (data.toLowerCase() === "exporter".toLowerCase()) {
      currentData = this.state.prospectExporter;
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabSelectionStripDownloadConfirm);
    } else if (data.toLowerCase() === "logistics".toLowerCase()) {
      currentData = this.state.prospectLogistics;
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabSelectionStripDownloadConfirm);
    }

    if (currentData.length <= 0) {
      toast.error(data.toLowerCase() === "importer".toLowerCase() ? "Please select atleast one importer." : data.toLowerCase() === "exporter".toLowerCase() ? "Please select atleast one exporter." : "Please select atleast one logistics.");
      return false;
    }
    // call API for xls
    if (type === "XLS") {
      const downloadXlsRequestObj = {
        data_download: currentData,
        is_range: "false",
        is_email: "false",
        companyType: data.toLowerCase() === "importer".toLowerCase() ? "consignee" : data.toLowerCase() === "exporter".toLowerCase() ? "shipper" : "logistic",
      };
      if (this.showUiTrends) {
        downloadXlsRequestObj._payload = this.creatingRequestObject(data.toLowerCase() === "importer" ? requestObjectType.importers : data.toLowerCase() === "exporter" ? requestObjectType.exporters : requestObjectType.logistics);
        downloadXlsRequestObj._payload.isTrends = true;
        downloadXlsRequestObj._payload.trendType = tabKeywords.importers === "importers" ? this.state.currentTimeFrame.value : tabKeywords.exporters === "exporters" ? this.state.currentExporterFrame.value : this.state.currentLogisticsFrame.value;
        downloadXlsRequestObj.data_download = downloadXlsRequestObj.data_download.map((item, index) => ({
          ...item,
          s_no: index + 1,
        }));
        if (this.state.trendsTab || this.state.exporterTrendsTab || this.state.logisticsTrendsTab) {
          downloadXlsRequestObj.headers = this.state.currentTab === tabKeywords.importers ? this.state.dynamicImporterTrendsData : this.state.currentTab === tabKeywords.exporters ? this.state.dynamicExporterTrendsData : this.state.dynamicLogisticsTrendsData;
        }
        downloadXlsRequestObj.data_download.forEach((item) => {
          if (item.shipment_value) {
            item.shipment_value = item.shipment_value.value === 0 ? { value: item.shipment_value.value } : { value: item.shipment_value };
          }
          if (item.teu) {
            item.teu = item.teu.value === 0 ? { value: item.teu.value } : { value: item.teu };
          }
          if (item.weight) {
            item.weight = item.weight.value === 0 ? { value: item.weight.value } : { value: item.weight };
          }
        });
      }
      this.downloadUniqueImporterExporter(downloadXlsRequestObj, data);
      closeDownloadFromModal();
    }
  };
  downloadUniqueImporterExporter = (requestObj, data) => {
    const userCreditData = { ...this.state.userCredit };
    if (!!data && data !== "") {
      requestObj.file_name = "Unique" + `${data}s` + "_" + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    }
    requestObj.plan_id = userCreditData.user_active_plan;
    const downloadShipmentApiUrl = this.defaultData.apiEndPoints.downloadUniqueImporterExporter;

    axios
      .post(downloadShipmentApiUrl, requestObj)
      .then(({ data }) => {
        window.open(data?.file_url);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong. Please try again later !!!");
      })
      .finally(() => {
        this.getUserPlan("Download");
      });
  };
  // below code is for the Analytics Download
  downloadAnalyticsPDF = () => {
    // ::Tracking: Below code is for the Tracking of the Search Button Event
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.downloadAnalyticsPdf);
    // End of the above code
    this.setState({
      isLoaderActive: true,
    });
    let tempReqObj = {
      pdfData: {
        _payload: this.creatingRequestObject(requestObjectType.filter),
        _source: this.state.analyticsData,
      },
    };
    const apiUrl = this.defaultData.apiEndPoints.renderToPdfAnalytics;
    axios.post(apiUrl, tempReqObj).then(
      (response) => {
        let obj = document.createElement("object");
        obj.type = "application/pdf";
        obj.data = "data:application/pdf;base64," + response.data;
        document.body.appendChild(obj);
        // Insert a link that allows the user to download the PDF file
        let link = document.createElement("a");
        let fileName = "Analytics";
        link.setAttribute("id", fileName);
        link.href = "data:application/octet-stream;base64," + response.data;
        link.download = fileName + ".pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(document.getElementById(fileName));
        this.setState({
          isLoaderActive: false,
        });
      },
      () => {
        toast.error("Something went wrong. Please try again after sometime!!!");

        this.setState({
          isLoaderActive: false,
        });
      }
    );
  };
  downloadImpExpConfirm = (data, downloadFromValue, downloadToValue, closeDownloadFromModal) => {
    if (data.toLowerCase() === "importer".toLowerCase()) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabDownloadExcelDownloadConfirm);
    } else if (data.toLowerCase() === "exporter".toLowerCase()) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabDownloadExcelDownloadConfirm);
    } else if (data.toLowerCase() === "logistics".toLowerCase()) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabDownloadExcelDownloadConfirm);
    }
    //please check
    let currentCount = 0;
    if (data.toLowerCase() === "importer".toLowerCase()) {
      currentCount = this.state.totalUniqueImporter;
    } else if (data.toLowerCase() === "exporter".toLowerCase()) {
      currentCount = this.state.totalUniqueExporter;
    } else if (data.toLowerCase() === "logistics".toLowerCase()) {
      currentCount = this.state.totalUniqueLogistics;
    }
    if (downloadToValue - downloadFromValue > 499) {
      let search_us_payload;
      let downloadXlsRequestObj;
      if (this.defaultData && this.defaultData.oldPayloadType) {
        search_us_payload = this.state.finalReqObj;
        downloadXlsRequestObj = {};
        downloadXlsRequestObj.is_range = "True";
        downloadXlsRequestObj.is_email = "true";
        downloadXlsRequestObj.key = search_us_payload && search_us_payload.key ? search_us_payload.key : "entire_bill_of_lading";
        downloadXlsRequestObj.queryType = search_us_payload && search_us_payload.queryType ? search_us_payload.queryType : "contains";
        downloadXlsRequestObj.search = search_us_payload && search_us_payload.search ? search_us_payload.search : "";
        downloadXlsRequestObj.from_id = +downloadFromValue;
        if (this.showUiTrends) {
          downloadXlsRequestObj._payload = search_us_payload;
          downloadXlsRequestObj._payload.from = downloadFromValue - 1;
          downloadXlsRequestObj._payload.isTrends = true;
          downloadXlsRequestObj._payload.trendType = tabKeywords.importers === this.state.currentTab ? this.state.currentTimeFrame.value : this.state.currentTab === tabKeywords.exporters ? this.state.currentExporterFrame.value : this.state.currentLogisticsFrame.value;
        } else {
          downloadXlsRequestObj.search_us_payload = search_us_payload;
        }
        //this is fix, don't remove it.
        downloadXlsRequestObj._payload.companyType = data.toLowerCase() === "importers".toLowerCase() || data.toLowerCase() === "importer".toLowerCase() ? "consignee" : data.toLowerCase() === "exporters".toLowerCase() || data.toLowerCase() === "exporter".toLowerCase() ? "shipper" : "logistic";
        //
      } else {
        downloadXlsRequestObj = this.state.finalReqObj;
        if (this.showUiTrends) {
          downloadXlsRequestObj.isTrends = true;
          downloadXlsRequestObj.trendType = tabKeywords.importers === this.state.currentTab ? this.state.currentTimeFrame.value : this.state.currentTab === tabKeywords.exporters ? this.state.currentExporterFrame.value : this.state.currentLogisticsFrame.value;
        }
        downloadXlsRequestObj.email = true;
        downloadXlsRequestObj.from = +downloadFromValue - 1 > 0 ? +downloadFromValue - 1 : 0;
        downloadXlsRequestObj.companyType = data.toLowerCase() === "importers".toLowerCase() || data.toLowerCase() === "importer".toLowerCase() ? "consignee" : data.toLowerCase() === "exporters".toLowerCase() || data.toLowerCase() === "exporter".toLowerCase() ? "shipper" : "logistic";
      }
      downloadXlsRequestObj.size = downloadToValue > currentCount ? currentCount - downloadFromValue + 1 : downloadToValue - downloadFromValue + 1;
      if (!!this.state.searchInclude && this.state.searchInclude === true) {
        downloadXlsRequestObj.search_includes = [];
      }
      if (this.state.trendsTab || this.state.exporterTrendsTab || this.state.logisticsTrendsTab) {
        downloadXlsRequestObj.headers = this.state.currentTab === tabKeywords.importers ? this.state.dynamicImporterTrendsData : this.state.currentTab === tabKeywords.exporters ? this.state.dynamicExporterTrendsData : this.state.dynamicLogisticsTrendsData;
      }
      this.impexpEmailXls(downloadXlsRequestObj, data);
      closeDownloadFromModal();
    } else {
      let search_us_payload;
      let downloadXlsRequestObj = {};
      if (this.defaultData && this.defaultData.oldPayloadType) {
        search_us_payload = this.state.finalReqObj;
        downloadXlsRequestObj = {};
        downloadXlsRequestObj.is_range = "True";
        downloadXlsRequestObj.is_email = "false";
        downloadXlsRequestObj.key = search_us_payload && search_us_payload.key ? search_us_payload.key : "entire_bill_of_lading";
        downloadXlsRequestObj.queryType = search_us_payload && search_us_payload.queryType ? search_us_payload.queryType : "contains";
        downloadXlsRequestObj.search = search_us_payload && search_us_payload.search ? search_us_payload.search : "";
        downloadXlsRequestObj.from_id = +downloadFromValue;
        if (this.showUiTrends) {
          downloadXlsRequestObj._payload = search_us_payload;
          downloadXlsRequestObj._payload.isTrends = true;
          downloadXlsRequestObj._payload.trendType = tabKeywords.importers === this.state.currentTab ? this.state.currentTimeFrame.value : this.state.currentTab === tabKeywords.exporters ? this.state.currentExporterFrame.value : this.state.currentLogisticsFrame.value;
        } else {
          downloadXlsRequestObj.search_us_payload = search_us_payload;
        }
        //this is fix, don't remove it.
        downloadXlsRequestObj._payload.companyType = data.toLowerCase() === "importers".toLowerCase() || data.toLowerCase() === "importer".toLowerCase() ? "consignee" : data.toLowerCase() === "exporters".toLowerCase() || data.toLowerCase() === "exporter".toLowerCase() ? "shipper" : "logistic";
        //
      } else {
        if (this.showUiTrends) {
          downloadXlsRequestObj = this.state.finalReqObj;
          downloadXlsRequestObj.isTrends = true;
          downloadXlsRequestObj.trendType = tabKeywords.importers === this.state.currentTab ? this.state.currentTimeFrame.value : this.state.currentTab === tabKeywords.exporters ? this.state.currentExporterFrame.value : this.state.currentLogisticsFrame.value;
        } else {
          downloadXlsRequestObj = this.state.finalReqObj;
          downloadXlsRequestObj.from = +downloadFromValue - 1 > 0 ? +downloadFromValue - 1 : 0;
        }
        downloadXlsRequestObj.companyType = data.toLowerCase() === "importers".toLowerCase() || data.toLowerCase() === "importer".toLowerCase() ? "consignee" : data.toLowerCase() === "exporters".toLowerCase() || data.toLowerCase() === "exporter".toLowerCase() ? "shipper" : "logistic";
        downloadXlsRequestObj.email = false;
      }
      // call for download shipment with to and from value using email variable as false
      downloadXlsRequestObj.size = downloadToValue > currentCount ? currentCount - downloadFromValue + 1 : downloadToValue - downloadFromValue + 1;
      if (!!this.state.searchInclude && this.state.searchInclude === true) {
        downloadXlsRequestObj.search_includes = [];
      }
      if (!!this.showUiTrends && (this.state.trendsTab || this.state.exporterTrendsTab || this.state.logisticsTrendsTab)) {
        downloadXlsRequestObj.headers = this.state.currentTab === tabKeywords.importers ? this.state.dynamicImporterTrendsData : this.state.currentTab === tabKeywords.exporters ? this.state.dynamicExporterTrendsData : this.state.dynamicLogisticsTrendsData;
      }
      if (downloadXlsRequestObj.hasOwnProperty("from")) {
        downloadXlsRequestObj.from = +downloadFromValue - 1;
        if (!!this.state.redirectingCompanyImporterId && !!this.state.redirectingCompanyImporterId.length && this.state.isMerged) {
          downloadXlsRequestObj.isMerged = true;
          downloadXlsRequestObj.mergedID = this.state.mergedId;
        }
        if (!!this.state.redirectingCompanyExporterId && !!this.state.redirectingCompanyExporterId.length && this.state.isMerged) {
          downloadXlsRequestObj.isMerged = true;
          downloadXlsRequestObj.mergedID = this.state.mergedId;
        }
        if (!!this.state.redirectingCompanyLogisticsId && !!this.state.redirectingCompanyLogisticsId.length && this.state.isMerged) {
          downloadXlsRequestObj.isMerged = true;
          downloadXlsRequestObj.mergedID = this.state.mergedId;
        }

        if (this.state.isSubsidiaryIncluded) {
          downloadXlsRequestObj.isSubsidiaryIncluded = true;
        }
      } else if (!!downloadXlsRequestObj && !!downloadXlsRequestObj._payload && downloadXlsRequestObj._payload.hasOwnProperty("from")) {
        downloadXlsRequestObj._payload.from = +downloadFromValue - 1;
        if (!!this.state.redirectingCompanyImporterId && !!this.state.redirectingCompanyImporterId.length && this.state.isMerged) {
          downloadXlsRequestObj._payload.isMerged = true;
          downloadXlsRequestObj._payload.mergedID = this.state.mergedId;
        }
        if (!!this.state.redirectingCompanyExporterId && !!this.state.redirectingCompanyExporterId.length && this.state.isMerged) {
          downloadXlsRequestObj._payload.isMerged = true;
          downloadXlsRequestObj._payload.mergedID = this.state.mergedId;
        }
        if (!!this.state.redirectingCompanyLogisticsId && !!this.state.redirectingCompanyLogisticsId.length && this.state.isMerged) {
          downloadXlsRequestObj._payload.isMerged = true;
          downloadXlsRequestObj._payload.mergedID = this.state.mergedId;
        }
        if (this.state.isSubsidiaryIncluded) {
          downloadXlsRequestObj.isSubsidiaryIncluded = true;
        }
      }
      if (this.defaultData.showUiUeLevelTwo && (this.state.ueTwoLevel || this.state.uiTwoLevel || this.state.ulTwoLevel)) {
        if (this.defaultData.oldPayloadType) {
          downloadXlsRequestObj._payload.isSecondLevelAnalytics = true;
          downloadXlsRequestObj._payload.subAnalyticsField = this.state.currentTab === tabKeywords.logistics ? this.state.defaultUlTwoLevelSelectedHeading : this.state.defaultUiUeTwoLevelSelctedHeading;
          downloadXlsRequestObj._payload.sub_data_size = this.state.secondLevelRowDropdownValue.value;
        } else {
          downloadXlsRequestObj.isSecondLevelAnalytics = true;
          downloadXlsRequestObj.subAnalyticsField = this.state.currentTab === tabKeywords.logistics ? this.state.defaultUlTwoLevelSelectedHeading : this.state.defaultUiUeTwoLevelSelctedHeading;
          downloadXlsRequestObj.sub_data_size = this.state.secondLevelRowDropdownValue.value;
        }
      }
      this.downloadUniqueImporterExporter(downloadXlsRequestObj, data);
      closeDownloadFromModal();
    }
  };

  impexpEmailXls = (requestObj, data) => {
    const userCreditData = { ...this.state.userCredit };
    this.setState({
      isDownloadLoaderActive: true,
    });
    requestObj.file_name = "Unique " + `${data}s` + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    requestObj.plan_id = userCreditData.user_active_plan;
    requestObj.must_not = [];
    const downloadShipmentApiUrl = this.defaultData.apiEndPoints.downloadUniqueImporterExporter;
    if (this.defaultData.showUiUeLevelTwo && (this.state.ueTwoLevel || this.state.uiTwoLevel || this.state.ulTwoLevel)) {
      if (this.defaultData.oldPayloadType) {
        requestObj._payload.isSecondLevelAnalytics = true;
        requestObj._payload.subAnalyticsField = this.state.currentTab === tabKeywords.logistics ? this.state.defaultUlTwoLevelSelectedHeading : this.state.defaultUiUeTwoLevelSelctedHeading;
      } else {
        requestObj.isSecondLevelAnalytics = true;
        requestObj.subAnalyticsField = this.state.currentTab === tabKeywords.logistics ? this.state.defaultUlTwoLevelSelectedHeading : this.state.defaultUiUeTwoLevelSelctedHeading;
      }
    }
    axios.post(downloadShipmentApiUrl, requestObj).then(
      (res) => {
        this.setState({
          isDownloadLoaderActive: false,
        });
        if (!!res && !!res.data && !!res.data.status && res.data.status === "success") {
          toast.success(res.data.message);
          this.getUserPlan("Download");
          this.downloadImpExpPopupClose();
        } else {
          toast.success(res.data.message);
        }
      },
      () => {
        toast.error("Something went wrong. Please try again later !!!");
        this.setState({
          isDownloadLoaderActive: false,
        });
      }
    );
  };
  // End of the above code
  checkforFilters = (filterObj, callingFrom) => {
    let flag = false;
    if (filterObj) {
      for (let key in filterObj) {
        if (!this.defaultBooleanFilterObject[key] && filterObj[key].length !== 0) {
          flag = true;
          break;
        }
      }
    }
    if (callingFrom && callingFrom === "apply") {
      let tempBooleanObj = { ...this.state.selecetedBooleanFilterObject };
      if (tempBooleanObj && this.state.appliedBooleanFilterObject) {
        for (let key1 in this.state.appliedBooleanFilterObject) {
          if (this.state.appliedBooleanFilterObject[key1] !== tempBooleanObj[key1]) {
            flag = true;
            break;
          }
        }
      }
    } else {
      let tempBooleanObj = { ...this.state.appliedBooleanFilterObject };
      if (tempBooleanObj && this.defaultBooleanFilterObject) {
        for (let key1 in this.defaultBooleanFilterObject) {
          if (this.defaultBooleanFilterObject[key1] !== tempBooleanObj[key1]) {
            flag = true;
            break;
          }
        }
      }
    }
    if (this.state.proximityApplied) flag = true;
    return flag;
  };
  // Below code is used to map the arrival date
  monthRangePickerDismiss = (value) => {
    let tempMonthObject = { ...this.state.monthObject };
    tempMonthObject.rangeValue = value;

    this.setState(
      {
        monthObject: tempMonthObject,
        fromAccutalArrivalDate: moment(value.from.year + "-" + value.from.month, "YYYY-MM").toDate(),
        toAccutalArrivalDate: moment(value.to.year + "-" + value.to.month, "YYYY-MM").toDate(),
      },
      () => {
        if (this.state.isReloadSearchClicked) {
          this.searchBottonCalled(this.state.searchedItem, this.state.searchInclude, this.state.currentKey, this.state.matchType);
        } else {
          const { searchedItem, searchInclude, currentKey, matchType } = this.state.searchCardParams;
          this.searchBottonCalled(searchedItem, searchInclude, currentKey, matchType);
        }
      }
    );
  };
  //below code is to clear the selected table data
  toggleClearButton = (type) => {
    if (!!type && type !== "" && type.toLowerCase() === "importers") {
      if (!!this && !!this.defaultData && !!this.defaultData.isUIGridNew && this.defaultData.isUIGridNew === true) {
        this.setState({
          selectedSearchRowData: [...[]],
          importerToggleRows: !this.state.importerToggleRows,
          prospectImporter: [],
        });
        setTimeout(() => {
          this.setState({
            importerToggleRows: !this.state.importerToggleRows,
          });
        }, 200);
      } else {
        this.setState({
          selectedSearchRowData: [...[]],
          importerToggleRows: !this.state.importerToggleRows,
        });
      }
      this.setState({
        importerToggleRows: !this.state.importerToggleRows,
        clearButton: !this.state.clearButton,
      });
    } else if (!!type && type !== "" && type.toLowerCase() === "exporters") {
      if (!!this && !!this.defaultData && !!this.defaultData.isUEGridNew && this.defaultData.isUEGridNew === true) {
        this.setState({
          selectedSearchRowData: [...[]],
          exporterToggleRows: !this.state.exporterToggleRows,
          prospectExporter: [],
        });
        setTimeout(() => {
          this.setState({
            exporterToggleRows: !this.state.exporterToggleRows,
          });
        }, 200);
      } else {
        this.setState({
          selectedSearchRowData: [...[]],
          exporterToggleRows: !this.state.exporterToggleRows,
        });
      }
      this.setState({
        exporterToggleRows: !this.state.exporterToggleRows,
        clearButton: !this.state.clearButton,
      });
    } else if (!!type && type !== "" && type.toLowerCase() === "shipments") {
      if (!!this && !!this.defaultData && !!this.defaultData.isShipmentGridNew && this.defaultData.isShipmentGridNew === true) {
        this.setState({
          selectedSearchRowData: [...[]],
          shipmentToggleRows: !this.state.shipmentToggleRows,
        });
        setTimeout(() => {
          this.setState({
            shipmentToggleRows: !this.state.shipmentToggleRows,
          });
        }, 200);
      } else {
        this.setState({
          selectedSearchRowData: [...[]],
          shipmentToggleRows: !this.state.shipmentToggleRows,
        });
      }
    } else if (!!type && type !== "" && type.toLowerCase() === "logistics") {
      if (!!this && !!this.defaultData && !!this.defaultData.isUIGridNew && this.defaultData.isUIGridNew === true) {
        this.setState({
          selectedSearchRowData: [...[]],
          logisticsToggleRows: !this.state.logisticsToggleRows,
          prospectLogistics: [],
        });
        setTimeout(() => {
          this.setState({
            logisticsToggleRows: !this.state.logisticsToggleRows,
          });
        }, 200);
      } else {
        this.setState({
          selectedSearchRowData: [...[]],
          logisticsToggleRows: !this.state.logisticsToggleRows,
        });
      }
      this.setState({
        logisticsToggleRows: !this.state.logisticsToggleRows,
        clearButton: !this.state.clearButton,
      });
    }
  };
  // End of the above code
  getingUserDetails(data) {
    if (data) {
      this.setState({
        userDetails: data,
      });
      const localStorageUserDetails = {
        full_name: data.full_name,
        active_status: data.active_status,
        email_address: data.email,
        is_salesforce_active: data.is_salesforce_active,
        is_hubspot_active: data.is_hubspot_active,
        is_zoho_active: data.is_zoho_active,
      };
      this.setState({
        userInfo: localStorageUserDetails,
      });
      if (data.email_address && data.email_address.includes("@trademo.com")) {
        this.setState({
          isTrademoAccount: true,
        });
      }
      this.localStorageService.setDataToLocalStorage("userDetails", localStorageUserDetails);
    }
    if (!!data.tour_status && data.tour_status === 1) {
      this.setState({
        showToolTips: false, // set value false for sometime
      });
    } else {
      this.setState({
        showToolTips: true,
      });
    }
  }

  getUserPlanDetails = (data) => {
    const searchUrlParams = this.props.location.search;
    try {
      if (new URLSearchParams(searchUrlParams).get("comingFrom") === redirectionTypeEnum.email) {
        this.getUserPlan(redirectionTypeEnum.email, data);
      } else {
        if (new URLSearchParams(searchUrlParams).get("comingFrom") === redirectionTypeEnum.email) {
          this.getUserPlan(redirectionTypeEnum.email, data);
        } else {
          this.getUserPlan(null, data);
        }
      }
    } catch (err) {
      Sentry.captureException(err);
    }
  };
  // Below code is for the proximity Search
  fillDataHandler = (label, defaultData) => {
    const searchUrlParams = this.props.location.search;
    let filteredList;
    const redirectFrom = new URLSearchParams(searchUrlParams).get("redirectingFrom");
    const redirectingProfile = new URLSearchParams(searchUrlParams).get("redirectingProfile");
    if (redirectFrom === "logistics" && defaultData) {
      filteredList = this.filterMapList.filter((item) => item.categoryName === categoryType.carrierDetails);
    } else if (redirectFrom === "port" && defaultData) {
      filteredList = this.filterMapList.filter((item) => item.categoryName === categoryType.ports);
    } else if (redirectFrom?.includes("company") && defaultData && redirectingProfile === "consignee") {
      filteredList = this.filterMapList.filter((item) => item.categoryName === categoryType.consigneeDetails);
    } else if (defaultData && defaultData === "defaultData") {
      let checkedField = this.defaultData.countryType.toLowerCase() === "import" && this.state.categoryName.hasOwnProperty(getObjectKeyByValue(this.state.categoryName, this.state.categoryName.shipperDetails)) ? categoryType.shipperDetails : this.state.categoryName.hasOwnProperty(getObjectKeyByValue(this.state.categoryName, this.state.categoryName.consigneeDetails)) ? categoryType.consigneeDetails : label;
      filteredList = this.filterMapList.filter((item) => item.categoryName === checkedField);
    } else {
      filteredList = this.filterMapList.filter((item) => item.categoryName === label);
    }
    this.setState({
      selectedFilterList: filteredList,
    });
  };

  mouseOverToolTip(label) {
    if (this.state.filterLabelOnHover !== label) {
      let filteredList = this.filterMapList.filter((item) => item.categoryName === label);
      this.setState({
        mouseFilterList: filteredList,
        filterLabelOnHover: label,
      });
    }
  }

  showCloseHandler = (name, count) => {
    let filterMapListClone = [...this.filterMapList];
    let filtteredList = filterMapListClone.filter((item) => item.categoryName === name);
    let isIncluded = false;
    let key = "";
    for (let i = 0; i < filtteredList.length; i++) {
      if (
        (this.state.isRedirect === true || this.state.isReloadFromDashboard === true) &&
        ((!!this && !!this.state && !!this.state.redirectingCompanyExporterId && this.state.redirectingCompanyExporterId.length && filtteredList[i].key === this.filterTypeEnum[this.specialFields.shipper]) || (!!this && !!this.state && !!this.state.redirectingCompanyImporterId && this.state.redirectingCompanyImporterId.length && filtteredList[i].key === this.filterTypeEnum[this.specialFields.consignee]) || (!!this && !!this.state && !!this.state.redirectingProfileId && this.state.redirectingProfileId.length && filtteredList[i].key === this.filterTypeEnum[this.state.redirectingProfileType]) || (!!this && !!this.state && !!this.state.redirectingProfilePartnerId && this.state.redirectingProfilePartnerId.length && filtteredList[i].key === this.filterTypeEnum[this.state.redirectingProfilePartnerType]) || (!!this.state.redirectionHsCodeValue && this.state.redirectionHsCodeValue.length && filtteredList[i].key === this.filterTypeEnum[this.specialFields.hscode]))
      ) {
        key = filtteredList[i].key;
        isIncluded = true;
        break;
      }
    }
    if (isIncluded) {
      if (count <= this.props.shipmentDetails.appliedFilter[key].length) {
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  };

  setSearchCardHandler = (value) => {
    this.setState({
      searchCardParams: { ...value },
    });
  };

  clearMainFilter = (label) => {
    let appliedFilterClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.appliedFilter));
    let filterObjectClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.filterObject));
    let selectedFilters = JSON.parse(JSON.stringify(this.props.shipmentDetails.selectedFilterList));
    let filterLabelName = this.filterTypeEnum[label];
    let tempExcludeFilterArr = this.state.excludeFilter.filter((item) => item !== filterLabelName);
    let tempIncludeFilterArr = this.state.includeFilter.filter((item) => item !== filterLabelName);
    let filteredList = this.filterMapList.filter((item) => item.categoryName === label);
    filteredList.forEach((filterName) => {
      tempExcludeFilterArr = tempExcludeFilterArr.filter((item) => item !== this.filterTypeEnum[filterName.key]);
      tempIncludeFilterArr = tempIncludeFilterArr.filter((item) => item !== this.filterTypeEnum[filterName.key]);
      tempIncludeFilterArr = tempIncludeFilterArr?.filter((item) => item !== this.filterTypeEnum[filterName?.additionalKey]);
      if (filterName.type === filterType.radioFilter) {
        appliedFilterClone[filterName.key] = false;
      } else {
        appliedFilterClone[filterName.key] = [];
        filterObjectClone[filterName.key] = [];
        selectedFilters[filterName.key] = [];
      }
      if (filterName.hasOwnProperty("additionalKey")) {
        appliedFilterClone[filterName.additionalKey] = [];
        filterObjectClone[filterName.additionalKey] = [];
        selectedFilters[filterName.additionalKey] = [];
      }
      if (filterName.key === this.specialFields.shipper) {
        this.setState({
          derivedShipperMasterNameAndIdMapping: [],
        });
      } else if (filterName.key === this.specialFields.consignee) {
        this.setState({
          derivedConsigneeMasterNameAndIdMapping: [],
        });
      }
    });
    this.props.selectedFilterListHandler({ ...this.props.shipmentDetails.selectedFilterList, ...selectedFilters });
    this.props.appliedFilterHandler({ ...this.props.shipmentDetails.appliedFilter, ...appliedFilterClone });
    this.props.filterObjectHandler({ ...filterObjectClone });

    this.setState(
      {
        includeFilter: tempIncludeFilterArr,
        excludeFilter: tempExcludeFilterArr,
        isLoaderActive: true,
        uniqueImportExporterShipment: [...[]],
        uniqueImportExporterWeight: [...[]],
        uniqueImportExporterTeu: [...[]],
        uniqueImportExporterValue: [...[]],
        uniqueLogisticsTypeFilter: [...[]],
        selectedExporterRowData: [],
        selectedImporterRowData: [],
        selectedLogisticsRowData: [],
        currentPage: 1,
        defaultPage: 1,
        from: 0,
        secondLevelData: [],
        lastRequestType: requestObjectType.filter,
      },
      () => {
        this.callingSearchResult(requestObjectType.filter);
      }
    );
  };

  getUserPlanHandler = () => {
    let queryString = generateQueryString({
      product_id: this.defaultData.product_id ? this.defaultData.product_id : "trademo_US",
    });
    if (!!queryString && queryString !== "") {
      queryString = "?" + queryString;
    }
    const apiUrl = globalApiEndPoints.getUserPlanDetails + queryString;
    axios.get(apiUrl).then((res) => {
      if (!!res.data.data[0].user_active_plan && res.data.data[0].user_active_plan !== "") {
        this.setState({
          currentUserPlan: res.data.data[0].user_active_plan,
          userFirstPlan: res.data.data[0],
        });
      }
    });
  };

  setTrendsTableToggle = (thisData) => {
    if (thisData === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends);
    } else {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank);
    }

    if (thisData !== "") {
      this.setState(
        {
          trendsTab: thisData,
          isTrendsActive: true,
          clearButton: !this.state.clearButton,
          prospectImporter: [],
          prospectExporter: [],
          prospectLogistics: [],
          selectedImporterRowData: [],
          selectedExporterRowData: [],
          selectedLogisticsRowData: [],
          isImporterTableVisible: true,
          importerCurrentPage: 1,
          exporterCurrentPage: 1,
          logisticsCurrentPage: 1,
          currentPage: 1,
          defaultPage: 1,
          mustNotIncludeExporter: [...[]],
          mustNotIncludeImporter: [...[]],
          mustNotIncludeLogistics: [...[]],
        },
        () => this.getUniqueImporterData(requestObjectType.importers, "toggle")
      );
    }
    setTimeout(() => {
      this.setState({
        isTrendsActive: false,
      });
    }, 500);
  };
  setExporterTrendsToggle = (thisData) => {
    if (thisData === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends);
    } else {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank);
    }
    if (thisData !== "") {
      this.setState(
        {
          exporterTrendsTab: thisData,
          clearButton: !this.state.clearButton,
          isTrendsActive: true,
          prospectImporter: [],
          prospectExporter: [],
          prospectLogistics: [],
          selectedImporterRowData: [],
          selectedExporterRowData: [],
          selectedLogisticsRowData: [],
          isExporterTableVisible: true,
          mustNotIncludeExporter: [...[]],
          mustNotIncludeImporter: [...[]],
          mustNotIncludeLogistics: [...[]],
          importerCurrentPage: 1,
          exporterCurrentPage: 1,
          logisticsCurrentPage: 1,
          currentPage: 1,
          defaultPage: 1,
        },
        () => this.getUniqueExporterData(requestObjectType.importers, "toggle")
      );
    }
    setTimeout(() => {
      this.setState({
        isTrendsActive: false,
      });
    }, 500);
  };
  setLogisticsTrendsToggle = (thisData) => {
    if (thisData === true) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends);
    } else {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank);
    }
    if (thisData !== "") {
      this.setState(
        {
          logisticsTrendsTab: thisData,
          clearButton: !this.state.clearButton,
          isTrendsActive: true,
          prospectImporter: [],
          prospectExporter: [],
          prospectLogistics: [],
          selectedImporterRowData: [],
          selectedExporterRowData: [],
          selectedLogisticsRowData: [],
          isLogisticsTableVisible: true,
          mustNotIncludeExporter: [...[]],
          mustNotIncludeImporter: [...[]],
          mustNotIncludeLogistics: [...[]],
          importerCurrentPage: 1,
          exporterCurrentPage: 1,
          logisticsCurrentPage: 1,
          currentPage: 1,
          defaultPage: 1,
        },
        () => this.getUniqueLogisticsData(requestObjectType.logistics, "")
      );
    }
    setTimeout(() => {
      this.setState({
        isTrendsActive: false,
      });
    }, 500);
  };
  viewTrends = async (reqObject, comingFrom, type, reqObj) => {
    let array = [];
    this.setState({
      isLoaderActive: true,
      isTrendsActive: true,
    });
    let searchRequestObj = JSON.parse(JSON.stringify(reqObject));
    if (this.defaultData.showUiUeLevelTwo && reqObj) {
      searchRequestObj.isSecondLevelAnalytics = this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel;
      if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
        searchRequestObj.subAnalyticsField = this.state.currentTab === tabKeywords.logistics ? this.state.defaultUlTwoLevelSelectedHeading : this.state.defaultUiUeTwoLevelSelctedHeading;
      }
    }

    if (reqObj) {
      searchRequestObj.isSecondLevelAnalytics = reqObj.isSecondLevelAnalytics;
      // searchRequestObj.subAnalyticsField
    }
    searchRequestObj.isTrends = this.state.currentTab === tabKeywords.logistics ? true : this.state.trendsTab === true || this.state.exporterTrendsTab || this.state.logisticsTrendsTab ? true : false;
    searchRequestObj.trendType = this.state.currentTab.toUpperCase() === requestObjectType.exporters ? this.state.currentExporterFrame.value : this.state.currentTab.toUpperCase() === requestObjectType.importers ? this.state.currentTimeFrame.value : this.state.currentTab.toUpperCase() === requestObjectType.logistics ? this.state.currentLogisticsFrame.value : "";
    if (this.state.isSubs) {
      searchRequestObj.isSubsidiaryIncluded = true;
    } else {
      searchRequestObj.isSubsidiaryIncluded = false;
    }
    if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyExporterId && this.state.redirectingCompanyExporterId.length) {
      if (new URLSearchParams(window.location.search).get("isSubsidiaryIncluded")) {
        searchRequestObj[this.specialFields.shipper] = [];
      }
    } else if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyImporterId && this.state.redirectingCompanyImporterId.length) {
      if (new URLSearchParams(window.location.search).get("isSubsidiaryIncluded")) {
        searchRequestObj[this.specialFields.consignee] = [];
      }
    } else if (this.state.isRedirect === true && !!this && !!this.state && !!this.state.redirectingCompanyLogisticsId && this.state.redirectingCompanyLogisticsId.length) {
      if (new URLSearchParams(window.location.search).get("isSubsidiaryIncluded")) {
        searchRequestObj[this.specialFields.logistic] = [];
      }
    }
    this.setState({
      isIntFilterApplied: this.state.uniqueImportExporterShipment?.length > 0 || this.state.uniqueImportExporterWeight?.length > 0 || this.state.uniqueImportExporterTeu?.length > 0 || this.state.uniqueImportExporterValue?.length > 0,
    });
    searchRequestObj.is_from_autosuggest = this.state.isSelectedFromAutoSuggest ? true : false;
    searchRequestObj.redirection_profile_id = this.state.redirectionIdFromAutoSuggest[this.state.searchedItem];
    try {
      let res = await axios.post(this.defaultData.apiEndPoints.getSearchResult, searchRequestObj);
      if (!!res && !!res.data && !!res.data.data) {
        if (this.state.currentTab === tabKeywords.importers && res.data.headers && res.data.headers.length > 0) {
          this.setState({
            dynamicImporterTrendsData: res.data.headers,
          });
        } else if (this.state.currentTab === tabKeywords.exporters && res.data.headers && res.data.headers.length > 0) {
          this.setState({
            dynamicExporterTrendsData: res.data.headers,
          });
        } else if (this.state.currentTab === tabKeywords.logistics && res.data.headers && res.data.headers.length > 0) {
          this.setState({
            dynamicLogisticsTrendsData: res.data.headers,
          });
        }
        if (res?.data?.dataset_modification_info && res?.data?.dataset_modification_info?.is_date_conflict) {
          this.getUserPlanDetails();
        }
        const skipDataUpdate = reqObj !== undefined && reqObj.isSecondLevelAnalytics === false && (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel);
        if (!skipDataUpdate) {
          if ((comingFrom && comingFrom === "pagination") || searchRequestObj.must_not.length) {
            let reponse = [...this.state.defaultTrendsData, ...res.data.data];
            let val = reponse.map((data) => {
              return {
                ...data,
                teu: !!data && !!data.teu ? (!!data.teu.value && data.teu.value !== "" ? Math.round(data.teu.value * 100) / 100 : data.teu ? Math.round(data.teu * 100) / 100 : "NA") : null,
                shipment_value: !!data && !!data.shipment_value ? (!!data.shipment_value.value && data.shipment_value.value !== "" ? data.shipment_value.value : data.shipment_value ? data.shipment_value : "NA") : null,
                weight: !!data && !!data.weight ? (!!data.weight.value && data.weight.value !== "" ? data.weight.value : data.weight ? data.weight : "NA") : null,
                parent_teu: !!data && !!data.teu ? (!!data.teu.value && data.teu.value !== "" ? Math.round(data.teu.value * 100) / 100 : data.teu ? data.teu : "NA") : null,
                parent_shipment_value: !!data && !!data.shipment_value ? (!!data.shipment_value.value && data.shipment_value.value !== "" ? data.shipment_value.value : data.shipment_value ? data.shipment_value : "NA") : null,
                parent_weight: !!data && !!data.weight ? (!!data.weight.value && data.weight.value !== "" ? data.weight.value : data.weight ? data.weight : "NA") : null,
                parent_doc_count: data.doc_count,
                company_type: data.company_type,
              };
            });
            if (this.state.currentTab === tabKeywords.importers) {
              let importerCachingClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.importerCaching));
              if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
                importerCachingClone.secondLevelData = setLevelTwoDatahandler(reponse, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage);
              } else {
                importerCachingClone.data = JSON.parse(JSON.stringify(val));
              }
              this.props.importerCachingHandler(importerCachingClone);
            } else if (this.state.currentTab === tabKeywords.exporters) {
              let exporterCachingClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.exporterCaching));
              if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
                exporterCachingClone.secondLevelData = setLevelTwoDatahandler(reponse, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage);
              } else {
                exporterCachingClone.data = JSON.parse(JSON.stringify(val));
              }
              this.props.exporterCachingHandler(exporterCachingClone);
            } else if (this.state.currentTab === tabKeywords.logistics) {
              let logisticsCachingClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.logisticsCaching));
              if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
                logisticsCachingClone.secondLevelData = setLevelTwoDatahandler(reponse, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage);
              } else {
                logisticsCachingClone.data = JSON.parse(JSON.stringify(val));
              }
              this.props.logisticsCachingHandler(logisticsCachingClone);
            }
            this.setState({
              defaultTrendsData: val,
              secondLevelData: setLevelTwoDatahandler(reponse, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value),
            });
          } else {
            let data = res.data.data;
            //the below array is of second level data
            array = JSON.parse(JSON.stringify(setLevelTwoDatahandler(data, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value)));
            let val = res.data.data.map((data) => {
              return {
                ...data,
                teu: !!data.teu && !!data.teu.value ? data.teu.value : data.teu,
                shipment_value: !!data.shipment_value && data.shipment_value.value !== undefined && data.shipment_value.value !== null && data.shipment_value.value !== "" ? data.shipment_value.value : data.shipment_value,
                weight: !!data.weight && data.weight.value !== undefined && data.weight.value !== null && data.weight.value !== "" ? data.weight.value : data.weight,
                parent_teu: !!data.teu && !!data.teu.value ? data.teu.value : data.teu,
                parent_shipment_value: !!data.shipment_value && data.shipment_value.value !== undefined && data.shipment_value.value !== null && data.shipment_value.value !== "" ? data.shipment_value.value : data.shipment_value,
                parent_weight: !!data.weight && data.weight.value !== undefined && data.weight.value !== null && data.weight.value !== "" ? data.weight.value : data.weight,
                parent_doc_count: data.doc_count,
                company_type: data.company_type,
              };
            });
            if (this.state.currentTab === tabKeywords.importers) {
              let importerCachingClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.importerCaching));
              if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
                importerCachingClone.secondLevelData = JSON.parse(JSON.stringify(array));
              } else {
                importerCachingClone.data = JSON.parse(JSON.stringify(val));
              }
              this.props.importerCachingHandler(importerCachingClone);
            } else if (this.state.currentTab === tabKeywords.exporters) {
              let exporterCachingClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.exporterCaching));
              if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
                exporterCachingClone.secondLevelData = JSON.parse(JSON.stringify(array));
              } else {
                exporterCachingClone.data = JSON.parse(JSON.stringify(val));
              }
              this.props.exporterCachingHandler(exporterCachingClone);
            } else if (this.state.currentTab === tabKeywords.logistics) {
              let logisiticsCachingClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.logisticsCaching));
              if (this.state.uiTwoLevel || this.state.ueTwoLevel || this.state.ulTwoLevel) {
                logisiticsCachingClone.secondLevelData = JSON.parse(JSON.stringify(array));
              } else {
                logisiticsCachingClone.data = JSON.parse(JSON.stringify(val));
              }
              this.props.logisticsCachingHandler(logisiticsCachingClone);
            }
            this.setState(
              {
                defaultTrendsData: val,
                secondLevelData: array,
              },
              () => this.handleNudgePopup("second_level", "event")
            );
          }
        }
      }
      if (tabKeywords.importers === this.state.currentTab) {
        if (!!res.data.data && res.data.data.length > 0) {
          let tempMustNotIncludeImporter1 = this.state.mustNotIncludeImporter.concat(res.data.must_not);
          const newConsigneearr = res.data.data.filter(function (a) {
            return a.key !== "";
          });
          let tempUniqueConsigneesData;
          if (!!this.state.importerCurrentPage && this.state.importerCurrentPage !== 1) {
            tempUniqueConsigneesData = this.state.uniqueImportersData.concat(newConsigneearr);
          } else {
            tempUniqueConsigneesData = newConsigneearr;
          }
          if (type !== requestObjectType.filter) {
            this.setState({
              localUniqueConsigneeData: tempUniqueConsigneesData,
              localTotalUniqueImporter: res.data.importerCount,
            });
          }
          this.setState({
            mustNotIncludeImporter: tempMustNotIncludeImporter1,
            importerMongoIds: tempMustNotIncludeImporter1,
          });
          this.setState({
            isLoaderActive: false,
            uniqueImportersData: tempUniqueConsigneesData,
          });
          if (!searchRequestObj.isSecondLevelAnalytics) {
            this.setState({
              totalUniqueImporter: res.data.importerCount,
            });
          }
        } else {
          this.setState({
            isLoaderActive: false,
            uniqueImportersData: [],
          });
        }
      } else if (tabKeywords.exporters === this.state.currentTab) {
        if (!!res.data.data && res.data.data.length > 0) {
          let tempMustNotIncludeExporter1 = this.state.mustNotIncludeExporter.concat(res.data.must_not);
          const newShipperarr = res.data.data.filter(function (a) {
            return a.key !== "";
          });
          let tempUniqueShippersData;
          if (!!this.state.exporterCurrentPage && this.state.exporterCurrentPage !== 1) {
            tempUniqueShippersData = this.state.uniqueExportersData.concat(newShipperarr);
          } else {
            tempUniqueShippersData = newShipperarr;
          }
          if (type !== requestObjectType.filter) {
            this.setState({
              localUniqueShippersData: tempUniqueShippersData,
              localTotalUniqueExporter: res.data.exporterCount,
            });
          }
          this.setState({
            mustNotIncludeExporter: tempMustNotIncludeExporter1,
            exporterMongoIds: tempMustNotIncludeExporter1,
          });
          this.setState({
            isLoaderActive: false,
            uniqueExportersData: tempUniqueShippersData,
          });
          if (!searchRequestObj.isSecondLevelAnalytics) {
            this.setState({
              totalUniqueExporter: res.data.exporterCount,
            });
          }
        } else {
          this.setState({
            isLoaderActive: false,
            uniqueExportersData: [],
            ...(searchRequestObj.isSecondLevelAnalytics ? {} : { totalUniqueExporter: 0 }),
          });
        }
      } else if (tabKeywords.logistics === this.state.currentTab) {
        if (!!res.data.data && res.data.data.length > 0) {
          let tempMustNotIncludeLogistics1 = this.state.mustNotIncludeLogistics.concat(res.data.must_not);
          const newLogisticsarr = res.data.data.filter(function (a) {
            return a.key !== "";
          });
          let tempUniqueLogisticsData;
          if (!!this.state.logisticsCurrentPage && this.state.logisticsCurrentPage !== 1) {
            tempUniqueLogisticsData = this.state.uniqueLogisticsData.concat(newLogisticsarr);
          } else {
            tempUniqueLogisticsData = newLogisticsarr;
          }
          if (type !== requestObjectType.filter) {
            this.setState({
              localUniqueLogisticsData: tempUniqueLogisticsData,
              localTotalUniqueLogistics: res.data.logisticsCount,
            });
          }
          this.setState({
            mustNotIncludeLogistics: tempMustNotIncludeLogistics1,
          });
          this.setState({
            isLoaderActive: false,
            uniqueLogisticsData: tempUniqueLogisticsData,
            totalUniqueLogistics: res.data.logisticsCount,
          });
        } else {
          this.setState({
            isLoaderActive: false,
            uniqueLogisticsData: [],
            totalUniqueLogistics: 0,
          });
        }
      }
      setTimeout(() => {
        this.mapSearchTableColumn();
      }, 100);

      return res;
    } catch (error) {
      Sentry.captureException(error);
    } finally {
      this.setState({
        isTrendsActive: false,
        twoLevelLoader: false,
        isLoaderActive: false,
      });
    }
  };

  handleTrendsSorting = (sortField, sortDirection) => {
    if (tabKeywords.importers === this.state.currentTab) {
      this.setState({
        importerSortOrderValue: sortDirection,
        impDefaultSort: sortField.key,
      });
      this.handleImporterSorting(requestObjectType.importers, sortField, sortDirection);
    } else if (tabKeywords.exporters === this.state.currentTab) {
      this.setState({
        exporterSortOrderValue: sortDirection,
        expDefaultSort: sortField.key,
      });
      this.handleExporterSorting(requestObjectType.exporters, sortField, sortDirection);
    } else if (tabKeywords.logistics === this.state.currentTab) {
      this.setState({
        logisticsSortOrderValue: sortDirection,
        logisticsDefaultSort: sortField.key,
      });
      this.handleLogisticsSorting(requestObjectType.logistics, sortField, sortDirection);
    }
  };
  // End of the above code
  // Below code is for the New Data Table
  handleTrademoTablePageChange = (page, perPage) => {
    // End of the above code
    // The shared table component (react-table-trademo) sometimes asks for the page *after* the one
    // it's actually navigating to (a read-ahead optimization tuned for the old fixed 60-row backend
    // batch). The backend now returns exactly `size` records starting at `from`, so if we only asked
    // for this one page, the page actually being displayed could be skipped entirely. Detect that gap
    // the same way the original code did (checking whether the page just before this one is already
    // cached) and, if not, widen this fetch to cover both the requested page and the one before it,
    // instead of relying on the old hardcoded "-60" cushion that assumed a fixed backend batch size.
    const requiredValue = page * perPage;
    let finalRequiredValue = requiredValue;
    let fetchSize = perPage;
    if (!(this.state.data[requiredValue - perPage] && this.state.data[requiredValue - perPage].s_no !== undefined)) {
      finalRequiredValue = Math.max(0, requiredValue - 2 * perPage);
      // Guard against requiredValue being 0 or small (e.g. landing back on the first page after a
      // page-size change) where requiredValue - finalRequiredValue would otherwise collapse to a
      // tiny or zero size and the grid would come back empty.
      fetchSize = Math.max(perPage, requiredValue - finalRequiredValue);
    }
    this.setState({
      from: finalRequiredValue,
      paginationFetchSize: fetchSize,
      isLoaderActive: true,
      currentPage: page,
      perPage: perPage,
    });
    setTimeout(() => {
      const requestObject = this.creatingRequestObject(requestObjectType.pagination);
      this.callingSearchAPI(requestObject, requestObjectType.pagination);
    }, 100);
  };
  // Below code is used to get the Setected Search Row
  selectedNewTableData = (data) => {
    this.setState({
      selectedSearchRowData: [...data],
    });
  };
  // End of the above code
  // Below code is used for Per Page Change
  handleTrademoTableSearchPerRowsChange = (data) => {
    this.setState({
      perPage: data,
    });
  };

  handleTrademoTableUIPerRowsChange = (data) => {
    this.setState({
      perPage: data,
    });
  };
  // End of the above code
  // Below is the code for updating the page change
  updateTrademoTableObject = (data) => {
    if (this.state.perPage !== data.perPage) {
      this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabPaginationResultPerPage);
    } else {
      if (this.state.currentPage <= data.currentPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabPaginationForwardButton);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.shipmentsTabPaginationBackwardButton);
      }
    }
    this.setState({
      perPage: data.perPage,
      currentPage: data.currentPage + 1,
      istableLoader: true,
    });
    setTimeout(() => {
      this.setState({
        istableLoader: false,
      });
    }, 100);
  };

  updateTrademoUITableObjectClone = (data) => {
    if (this.state.trendsTab) {
      if (this.state.importerPerPage !== data.perPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsPaginationResultPerPage);
      } else {
        if (this.state.importerCurrentPage <= data.currentPage) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsPaginationForwardButton);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrendsPaginationBackwardButton);
        }
      }
    } else {
      if (this.state.importerPerPage !== data.perPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRankPaginationResultPerPage);
      } else {
        if (this.state.importerCurrentPage <= data.currentPage) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRankPaginationForwardButton);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRankPaginationBackwardButton);
        }
      }
    }

    this.setState({
      importerPerPage: data.perPage,
      importerCurrentPage: data.currentPage + 1,
      istableLoader: true,
    });
    setTimeout(() => {
      this.setState({
        istableLoader: false,
      });
    }, 100);
  };

  //logistics start
  updateTrademoULTableObjectClone = (data) => {
    if (this.state.logisticsTrendsTab) {
      if (this.state.logisticsPerPage !== data.perPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsPaginationResultPerPage);
      } else {
        if (this.state.logisticsCurrentPage <= data.currentPage) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsPaginationForwardButton);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrendsPaginationBackwardButton);
        }
      }
    } else {
      if (this.state.logisticsPerPage !== data.perPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRankPaginationResultPerPage);
      } else {
        if (this.state.logisticsCurrentPage <= data.currentPage) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRankPaginationForwardButton);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRankPaginationBackwardButton);
        }
      }
    }

    this.setState({
      logisticsPerPage: data.perPage,
      logisticsCurrentPage: data.currentPage + 1,
      istableLoader: true,
    });
    setTimeout(() => {
      this.setState({
        istableLoader: false,
      });
    }, 100);
  };
  //logistics end

  updateTrademoUETableObjectClone = (data) => {
    if (this.state.exporterTrendsTab) {
      if (this.state.exporterPerPage !== data.perPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsPaginationResultPerPage);
      } else {
        if (this.state.exporterCurrentPage <= data.currentPage) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsPaginationForwardButton);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsPaginationBackwardButton);
        }
      }
    } else {
      if (this.state.exporterPerPage !== data.perPage) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRankPaginationResultPerPage);
      } else {
        if (this.state.exporterCurrentPage <= data.currentPage) {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsPaginationForwardButton);
        } else {
          this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrendsPaginationBackwardButton);
        }
      }
    }

    this.setState({
      exporterPerPage: data.perPage,
      exporterCurrentPage: data.currentPage + 1,
      istableLoader: true,
    });
    setTimeout(() => {
      this.setState({
        istableLoader: false,
      });
    }, 100);
  };
  // End of the above code
  zeroCaseHandler = () => {
    if (this.state.zeroCountData === this.state.zeroFilterData) {
      return "Removing the applied filters - " + getInternationalNumberSystem(this.state.zeroCountData) + " Shipments";
    } else {
      return `Extending date range to Last ${this.state.zeroCountyear}${new Date().getFullYear() - this.state.zeroCountyear > 1 ? "s" : ""} - ${getInternationalNumberSystem(this.state.zeroCountData)} shipments`;
    }
  };
  ZeroCaseDescriptionHandler = () => {
    if (this.state.zeroCountData === this.state.zeroFilterData) {
      return (
        <p>
          No results found for the combination of <strong>“Searched Keyword”</strong> and <strong>“Applied Filters”</strong>
        </p>
      );
    } else {
      return (
        <p>
          No results found for the combination of <strong>“Searched Keyword”</strong> <strong>{this.state.isFilterApplied ? "and “Applied Filters” " : ""}</strong>
        </p>
      );
    }
  };
  selectSortDefaltValueHandler = (type) => {
    let trendsDropdownOptionsClone = JSON.parse(JSON.stringify(this.importer_exporter_graph_sort__options));
    let index = trendsDropdownOptionsClone.findIndex((val) => {
      return val.value1 ? type === val.value1 : type === val.value;
    });
    if (index > -1) {
      return trendsDropdownOptionsClone[index];
    } else {
      return trendsDropdownOptionsClone[0];
    }
  };
  selectedUiUeTwoLevelHeading = (data) => {
    this.setState({
      defaultUiUeTwoLevelSelctedHeading: data,
      defaultUlTwoLevelSelectedHeading: data,
      defaultTrendsData: [],
    });
  };
  selectedUlTwoLevelHeading = (data) => {
    this.setState({
      defaultUlTwoLevelSelectedHeading: data,
      defaultTrendsData: [],
    });
  };
  nextSecondLevelHandler = () => {
    if (this.state.uiTwoLevel) {
      if (this.state.trendsTab) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends2ndLevelAnalyticsPaginationForward);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalyticsPaginationForward);
      }
    } else if (this.state.ueTwoLevel) {
      if (this.state.exporterTrendsTab) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsPaginationForward);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalyticsPaginationForward);
      }
    } else if (this.state.ulTwoLevel) {
      if (this.state.logisticsTrendsTab) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends2ndLevelAnalyticsPaginationForward);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank2ndLevelAnalyticsPaginationForward);
      }
    }

    this.setState({
      isLoaderActive: true,
    });
    let totalData = tabKeywords.importers === this.state.currentTab ? this.state.totalUniqueImporter : tabKeywords.exporters === this.state.currentTab ? this.state.totalUniqueExporter : this.state.totalUniqueLogistics;
    let perPage = tabKeywords.importers === this.state.currentTab ? this.state.importerPerPage : tabKeywords.exporters === this.state.currentTab ? this.state.exporterPerPage : this.state.logisticsPerPage;
    let defaultTrendsDataClone = JSON.parse(JSON.stringify(this.state.defaultTrendsData));
    let currentPage = this.state.defaultPage + 1;
    if (secondLevelRowsDropdown.map((item) => item.value * 5).includes(perPage) && totalData % 5 !== 0) {
      totalData = Math.ceil(totalData / 5) * 5;
    }
    if (secondLevelRowsDropdown.map((item) => item.value * 2).includes(perPage) && totalData % 5 !== 0) {
      totalData = Math.ceil(totalData / 2) * 2;
    }
    if ((perPage / this.state.secondLevelRowDropdownValue.value) * (currentPage - 1) > totalData) {
      return;
    }
    if (!this.state.defaultTrendsData[currentPage * (perPage / this.state.secondLevelRowDropdownValue.value) - 1] && currentPage * (perPage / this.state.secondLevelRowDropdownValue.value) < totalData && (this.state.currentTab === tabKeywords.importers || this.state.currentTab === tabKeywords.exporters)) {
      this.setState({
        isLoaderActive: false,
      });
      return toast.error("Pagination limit reached. Please download to view more records.");
    }
    this.setState({
      defaultPage: this.state.defaultPage + 1,
    });
    if (this.state.defaultPage >= this.state.maxPaginate) {
      this.setState({
        maxPaginate: this.state.maxPaginate + 1,
      });
    }
    this.setState({
      setPagination: "next",
      secondLevelData: [],
    });
    setTimeout(() => {
      this.setState({
        isLoaderActive: false,
      });
    }, 500);
    if (!this.state.defaultTrendsData[currentPage * (perPage / this.state.secondLevelRowDropdownValue.value) - 1] && currentPage * (perPage / this.state.secondLevelRowDropdownValue.value) < totalData) {
      let req = JSON.parse(JSON.stringify(this.state.finalReqObj));
      let must_not = tabKeywords.importers === this.state.currentTab ? this.state.mustNotIncludeImporter : this.state.currentTab === tabKeywords.exporters ? this.state.mustNotIncludeExporter : this.state.mustNotIncludeLogistics;
      req.must_not = must_not;
      req.sub_data_size = this.state.secondLevelRowDropdownValue.value;
      this.viewTrends(req, "pagination", "");
    } else {
      setTimeout(() => {
        this.setState({
          secondLevelData: setLevelTwoDatahandler(defaultTrendsDataClone, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value),
          defaultTrendsData: defaultTrendsDataClone,
        });
      }, 200);
    }
  };

  gettingAllData = (data) => {
    if (this.state.currentTab.toUpperCase() === "IMPORTERS") {
      this.setState({
        importerTab: data,
      });
    } else if (this.state.currentTab.toUpperCase() === "EXPORTERS") {
      this.setState({
        exporterTab: data,
      });
    } else if (this.state.currentTab.toUpperCase() === "LOGISTICS") {
      this.setState({
        logisticsTab: data,
      });
    }
  };

  prevSecondLevelHandler = () => {
    if (this.state.uiTwoLevel) {
      if (this.state.trendsTab) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabTrends2ndLevelAnalyticsPaginationBackward);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueImportersTabRank2ndLevelAnalyticsPaginationBackward);
      }
    } else if (this.state.ueTwoLevel) {
      if (this.state.exporterTrendsTab) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabTrends2ndLevelAnalyticsPaginationBackward);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueExportersTabRank2ndLevelAnalyticsPaginationBackward);
      }
    } else if (this.state.ulTwoLevel) {
      if (this.state.logisticsTrendsTab) {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabTrends2ndLevelAnalyticsPaginationBackward);
      } else {
        this.checkPendoEventForCompanyRedirection(trackingEventDictionary.uniqueLogisticsTabRank2ndLevelAnalyticsPaginationBackward);
      }
    }

    if (this.state.defaultPage > 1) {
      this.setState({
        isLoaderActive: true,
        defaultPage: this.state.defaultPage - 1,
        setPagination: "prev",
        secondLevelData: [],
      });
      setTimeout(() => {
        this.setState({
          isLoaderActive: false,
        });
      }, 500);
      setTimeout(() => {
        this.setState({
          secondLevelData: setLevelTwoDatahandler(this.state.defaultTrendsData, this.state.currentTab, this.state.importerPerPage, this.state.exporterPerPage, this.state.logisticsPerPage, this.state.defaultPage, this.state.secondLevelRowDropdownValue.value),
        });
      }, 200);
    }
  };
  updatingMustNot = () => {
    if (this.state.currentTab === tabKeywords.importers) {
      this.setState({
        mustNotIncludeImporter: [],
      });
    }
    if (this.state.currentTab === tabKeywords.exporters) {
      this.setState({
        mustNotIncludeExporter: [],
      });
    }
    if (this.state.currentTab === tabKeywords.logistics) {
      this.setState({
        mustNotIncludeLogistics: [],
      });
    }
  };

  mapSelectedValue(data) {
    if (data) {
      this.setState({
        selectedRows: [...data],
      });
    }
  }

  checkPendoEventForCompanyRedirection = (event) => {
    globalPendoEventForCompanyRedirection(event, this.state.isRedirect, this.state.redirectingCompanyExporterId, this.state.redirectingCompanyImporterId, this.defaultData.analyticsCountryID, this.props.location.pathname, this.state.currentUserPlan, this.state.redirectionHsCodeValue);
  };

  trackFilterEvent = (keyOrItem, action) => {
    const item = keyOrItem && typeof keyOrItem === "object" ? keyOrItem : this.filterMapList.find((filter) => filter.key === keyOrItem || filter.additionalKey === keyOrItem);
    const eventName = buildFilterTrackingEvent(item?.label ?? item?.key ?? keyOrItem, action);
    if (!eventName) return;
    this.checkPendoEventForCompanyRedirection(eventName);
  };
  trackingDateRangePicker = () => {
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.datePicker);
  };

  // below function is for hs code select handle
  handleHsCodeSelectCall = (e, type) => {
    this.setState({
      hsCodeList: [...e],
    });
    if (type) {
      setTimeout(() => this.resetFilter(), 500);
    }
  };
  // end of above code
  // Below code is used for handling the tracking events
  callingTrackingEvents = (eventName, path) => {
    trademoTrackingEvents(eventName, generateTrackingObject(this.defaultData.analyticsCountryID, !!window && !!window.location && !!window.location.pathname && window.location.pathname !== "" ? window.location.pathname : "", this.state.currentUserPlan));
    if (!!path && path !== "") {
      window.location.href = getIntelUrl() + path;
    }
  };

  handleIncludeExcludeAnalytics = (includeFilter, excludeFilter, filterLabel) => {
    if (excludeFilter.includes(filterLabel) || includeFilter.includes(filterLabel) === false) {
      if (excludeFilter.includes(filterLabel)) {
        this.clearIndividualFilter(filterLabel);
        setTimeout(() => {
          toast.success("Filter selection replaced with new added filter");
        }, 1000);
      }
      excludeFilter = excludeFilter.filter((data) => data !== filterLabel);
      includeFilter.push(filterLabel);
    }
    return [includeFilter, excludeFilter];
  };

  showCrmListModal = () => {
    this.setState({
      showCrmPopuList: true,
    });
  };

  callConfirmGetInTouch = (data) => {
    this.handleNudgePopup("crm", "popup", "close");
    this.setState({
      showCrmPopuList: false,
      showCrmNudgePopup: false,
    });
    const params = {
      planId: this.localStorageService && this.localStorageService.getUseurrentPlan() ? this.localStorageService.getUserCurrentPlan() : "",
      countries: data,
      from_crm: true,
    };
    axios
      .get(globalApiEndPoints.notifySales, { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      });
  };

  updateMultiCountryDataSourceHandler = () => {
    this.setState(
      {
        data: [],
        mustNotIncludeExporter: [...[]],
        mustNotIncludeImporter: [...[]],
        mustNotIncludeLogistics: [...[]],
      },
      () => {
        const requestObject = this.creatingRequestObject(requestObjectType.filter);
        this.callingSearchAPI(requestObject, requestObjectType.filter);
        setTimeout(() => {
          this.getAnalyticsData();
          this.setState({
            currentTab: tabKeywords.shipments,
          });
        }, 100);
      }
    );
  };

  reportTabClick = () => {
    this.setState({ currentTab: tabKeywords.reports });
    this.checkPendoEventForCompanyRedirection(trackingEventDictionary.reportsTab);
  };

  onTabChangeHandler = (tab) => {
    if (tab === tabKeywords.analytics) {
      if (this.props.shipmentDetails?.analyticsCaching) {
        this.setState({
          currentTab: tabKeywords.analytics,
          analyticsData: this.props.shipmentDetails.analyticsCaching,
          ueTwoLevel: false,
          uiTwoLevel: false,
          ulTwoLevel: false,
          trendsTab: false,
          isImporterTableVisible: true,
          isExporterTableVisible: true,
          isLogisticsTableVisible: true,
          importerCurrentPage: 1,
          logisticsCurrentPage: 1,
          defaultPage: 1,
          exporterCurrentPage: 1,
        });
      } else {
        this.setState(
          {
            currentTab: tabKeywords.analytics,
            uiTwoLevel: false,
            ueTwoLevel: false,
            ulTwoLevel: false,
            importerCurrentPage: 1,
            defaultPage: 1,
            exporterCurrentPage: 1,
            logisticsCurrentPage: 1,
            mustNotIncludeImporter: [],
            mustNotIncludeExporter: [],
            mustNotIncludeLogistics: [],
            defaultTrendsData: [],
          },
          () => this.fetchSummaryData()
        );
      }
    } else if (tab === tabKeywords.exporters) {
      if (this.props.shipmentDetails.exporterCaching?.data) {
        this.setState({
          currentTab: tabKeywords.exporters,
          defaultTrendsData: this.props.shipmentDetails.exporterCaching?.data,
          secondLevelData: this.props.shipmentDetails.exporterCaching?.secondLevelData,
          uniqueExportersData: this.props.shipmentDetails.exporterCaching?.data,
          ueTwoLevel: false,
          uiTwoLevel: false,
          ulTwoLevel: false,
          trendsTab: false,
          isExporterTableVisible: true,
          importerCurrentPage: 1,
          defaultPage: 1,
          exporterCurrentPage: 1,
          logisticsCurrentPage: 1,
          finalReqObj: { ...this.state.finalReqObj, companyType: "shipper" },
        });
      } else {
        this.setState(
          {
            currentTab: tabKeywords.exporters,
            ueTwoLevel: false,
            uiTwoLevel: false,
            ulTwoLevel: false,
            importerCurrentPage: 1,
            defaultPage: 1,
            exporterCurrentPage: 1,
            logisticsCurrentPage: 1,
            mustNotIncludeImporter: [],
            mustNotIncludeExporter: [],
            mustNotIncludeLogistics: [],
            defaultTrendsData: [],
          },
          () => this.getUniqueExporterData()
        );
      }
    } else if (tab === tabKeywords.importers) {
      if (this.props.shipmentDetails.importerCaching?.data) {
        this.setState({
          currentTab: tabKeywords.importers,
          defaultTrendsData: this.props.shipmentDetails.importerCaching?.data,
          uniqueImportersData: this.props.shipmentDetails.importerCaching?.data,
          secondLevelData: this.props.shipmentDetails.importerCaching?.secondLevelData,
          ueTwoLevel: false,
          uiTwoLevel: false,
          ulTwoLevel: false,
          trendsTab: false,
          isImporterTableVisible: true,
          importerCurrentPage: 1,
          defaultPage: 1,
          exporterCurrentPage: 1,
          logisticsCurrentPage: 1,
          finalReqObj: { ...this.state.finalReqObj, companyType: "consignee" },
        });
      } else {
        this.setState(
          {
            currentTab: tabKeywords.importers,
            ueTwoLevel: false,
            uiTwoLevel: false,
            ulTwoLevel: false,
            importerCurrentPage: 1,
            defaultPage: 1,
            exporterCurrentPage: 1,
            logisticsCurrentPage: 1,
            mustNotIncludeLogistics: [],
            mustNotIncludeImporter: [],
            mustNotIncludeExporter: [],
            defaultTrendsData: [],
          },
          () => this.getUniqueImporterData()
        );
      }
    } else if (tab === tabKeywords.logistics) {
      if (this.props.shipmentDetails.logisticsCaching?.data) {
        this.setState({
          currentTab: tabKeywords.logistics,
          defaultTrendsData: this.props.shipmentDetails.logisticsCaching?.data,
          secondLevelData: this.props.shipmentDetails.logisticsCaching?.secondLevelData,
          uniqueLogisticsData: this.props.shipmentDetails.logisticsCaching?.data,
          ueTwoLevel: false,
          uiTwoLevel: false,
          ulTwoLevel: false,
          trendsTab: false,
          isLogisticsTableVisible: true,
          importerCurrentPage: 1,
          defaultPage: 1,
          exporterCurrentPage: 1,
          logisticsCurrentPage: 1,
        });
      } else {
        this.setState(
          {
            currentTab: tabKeywords.logistics,
            ueTwoLevel: false,
            uiTwoLevel: false,
            ulTwoLevel: false,
            importerCurrentPage: 1,
            defaultPage: 1,
            exporterCurrentPage: 1,
            logisticsCurrentPage: 1,
            mustNotIncludeLogistics: [],
            mustNotIncludeImporter: [],
            mustNotIncludeExporter: [],
            defaultTrendsData: [],
          },
          () => this.getUniqueLogisticsData(requestObjectType.logistics)
        );
      }
    }
  };

  changeUITwoLevelHandler = (e) => {
    this.setState(
      {
        isLoaderActive: true,
        twoLevelLoader: true,
        importerPerPage: 25,
        uiTwoLevel: e.target.checked,
        defaultPage: 1,
        mustNotIncludeImporter: [],
        defaultTrendsData: this.props.shipmentDetails.importerCaching?.data,
        selectedRows: [],
        selectedImporterRowData: [],
        showDropdown: false,
        secondLevelData: this.props.shipmentDetails.importerCaching?.secondLevelData,
        importerToggleRows: !this.state.importerToggleRows,
        prospectImporter: [],
        importerCurrentPage: 1,
        secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
      },
      () => this.getUniqueImporterData(requestObjectType.importers)
    );
    setTimeout(() => {
      this.setState({
        importerToggleRows: false,
      });
    }, 100);
  };

  changeUETwoLevelHandler = (e) => {
    this.setState(
      {
        isLoaderActive: true,
        twoLevelLoader: true,
        exporterPerPage: 25,
        ueTwoLevel: e.target.checked,
        defaultPage: 1,
        mustNotIncludeExporter: [],
        defaultTrendsData: this.props.shipmentDetails.exporterCaching?.data,
        selectedRows: [],
        selectedExporterRowData: [],
        showDropdown: false,
        secondLevelData: this.props.shipmentDetails.exporterCaching?.secondLevelData,
        exporterToggleRows: !this.state.exporterToggleRows,
        prospectExporter: [],
        exporterCurrentPage: 1,
        secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
      },
      () => this.getUniqueExporterData(requestObjectType.exporters)
    );
    setTimeout(() => {
      this.setState({
        exporterToggleRows: false,
      });
    }, 100);
  };
  changeULTwoLevelHandler = (e) => {
    this.setState(
      {
        isLoaderActive: true,
        twoLevelLoader: true,
        logisticsPerPage: 25,
        ulTwoLevel: e.target.checked,
        defaultPage: 1,
        mustNotIncludeLogistics: [],
        defaultTrendsData: this.props.shipmentDetails.logisticsCaching?.data,
        selectedRows: [],
        selectedLogisticsRowData: [],
        showDropdown: false,
        secondLevelData: this.props.shipmentDetails.logisticsCaching?.secondLevelData,
        logisticsToggleRows: !this.state.logisticsToggleRows,
        prospectLogistics: [],
        logisticsCurrentPage: 1,
        secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
      },
      () => this.getUniqueLogisticsData(requestObjectType.logistics)
    );
    setTimeout(() => {
      this.setState({
        logisticsToggleRows: false,
      });
    }, 100);
  };
  applyUIUEFilterHandler = (filters) => {
    this.props.resetCachingData();
    let appliedFiltersClone = JSON.parse(JSON.stringify(this.props.shipmentDetails.appliedFilter));
    if (this.state.currentTab === tabKeywords.importers) {
      this.setState({
        derivedConsigneeMasterNameAndIdMapping: filters,
      });
      appliedFiltersClone[this.filterTypeEnum[this.specialFields.consignee]] = filters.map((row) => row.company_name);
    } else if (this.state.currentTab === tabKeywords.exporters) {
      this.setState({
        derivedShipperMasterNameAndIdMapping: filters,
      });
      appliedFiltersClone[this.filterTypeEnum[this.specialFields.shipper]] = filters.map((row) => row.company_name);
    }
    this.props.appliedFilterHandler(appliedFiltersClone);
    this.callingSearchResult(requestObjectType.filter);
  };

  handleGetInTouchClose = () => {
    this.setState({ showGetInTouch: false });
  };

  handleGetInTouchOpen = () => {
    const STARTERPLAN = this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter");
    const searchDisable = STARTERPLAN && this.props.shipmentDetails?.planDetails?.search_starter_current_count >= this.props.shipmentDetails?.planDetails?.search_starter_max_count;
    if (searchDisable) {
      this.setState({
        showGetInTouch: true,
      });
    }
  };

  handleSetCurrOnboarding = (val, origin) => {
    if (val !== "" && origin !== "") {
      this.setState({
        currOnboardingObj: val,
        onboardingInitiator: origin,
      });
    }
  };

  updatingOnboardingData = (data) => {
    this.setState({
      onboardingData: data,
    });
  };

  render() {
    return (
      <div
        onClick={() => {
          this.setState({
            showMoreOptions: false,
            showHeaderDropdown: false,
            showReloadLastSearch: false,
            showDataSource: false,
            continentList: this.state.appliedContinentList,
          });
        }}>
        <ContextData.Provider
          value={{
            defaultType: this.state.defaultType,
            customShipmentGridCostomizeOption: this.state.type === "bol" ? this.state.customShipmentGridConfigurationListBol : JSON.parse(JSON.stringify(this.state.customShipmentGridConfigurationList)),
            customShipmentGridSelectedList: this.state.type === "bol" ? this.state.customShipmentGridSelectedListBol : JSON.parse(JSON.stringify(this.state.customShipmentGridSelectedList)),
            setCustomShipmentGridList: (data, isReset, type) => this.applyCustomShipmentGrid(data, isReset, type),
            isSideBarOpen: this.state.isSideBarOpen,
            setIsSideBarOpen: (val) =>
              this.setState({
                isSideBarOpen: val,
              }),
            updateMultiCountryDataSourceHandler: () => this.updateMultiCountryDataSourceHandler(),
            customTypeLoader: this.state.customTypeLoader,
            // setContinentList
            type: this.state.type,
            setType: (val) =>
              this.setState({
                type: val,
              }),
            setCustomLoader: (val) =>
              this.setState({
                customTypeLoader: val,
              }),
          }}
          callingTrackingEvents={(e) => this.callingTrackingEvents(e)}>
          <IntelLayout
            pageTitle={`${this.defaultData.name} | Trademo Intel`}
            userCredit={this.state.userCredit}
            setNotification={(val) => {
              this.setState({
                showNotification: val,
              });
            }}
            country={this.defaultData.country_small}
            handleNudgePopup={(event, key) => this.handleNudgePopup(event, key)}
            showNotification={this.state.showNotification}
            setCountry={(val) => {
              this.setState({
                country: val,
              });
            }}
            isDateChanged={this.state.isDateChanged}
            searchedItem={this.props.shipmentDetails?.searchParameters?.searchedItem}
            isSearchButtonCalled={this.state.isSearchButtonCalled}
            checkforFilters={this.checkforFilters}
            appliedFilter={this.props.shipmentDetails.appliedFilter}
            callingTrackingEvents={(e) => this.callingTrackingEvents(e)}
            showMultiCountryTopNudge={this.state.showMultiCountryTopNudge}
            setShowMultiCountryTopNudge={(val) => this.setState({ showMultiCountryTopNudge: val })}
            planId={this.state.planId}
            setPlanId={(val) => this.setState({ planId: val })}
            intelHeaderDataSource={this.state.intelHeaderDataSource}
            setIntelHeaderDataSource={(val) => this.setState({ intelHeaderDataSource: val })}
            callNudgeHandler={(key, event) => {
              this.handleNudgePopup(key, "popup", "close", event);
            }}
            nudgePopupStateObj={this.state.nudgePopupStateObj}
            dataList={this.state.dataList}
            count={this.state.count}
            userDetails={(e) => this.getingUserDetails(e)}
            hsCodeApplyCalled={(e, type) => this.handleHsCodeSelectCall(e, type)}
            dataSourceOption={this.state.dataSourceOption}
            setDataSourceOption={(val) => {
              this.setState({
                dataSourceOption: val,
                options: val.output,
              });
            }}
            currentProduct={this.state.currentProduct}
            setCurrentProduct={(val) => {
              this.setState({ currentProduct: val });
            }}
            userProductAccess={this.state.userProductAccess}
            setUserProductAccess={(val) => {
              this.setState({ userProductAccess: val });
            }}
            updatingOnboardingData={(val) => this.updatingOnboardingData(val)}
            handleSetCurrOnboarding={(e, trigger, data) => this.handleSetCurrOnboarding(e, trigger, data)}
            showGetInTouch={this.state.showGetInTouch}
            handleGetInTouchClose={() => this.handleGetInTouchClose()}
            handleGetInTouchOpen={() => this.handleGetInTouchOpen()}
            pageLabel="Shipments">
            <div
              onClick={() => {
                clearAllNudgePopupTimers();
                this.setState({
                  showPopup: false,
                  showDropdown: false,
                  addToFaV: false,
                  showExportOptions: false,
                  showMergePopUp: false,
                });
                setTimeout(() => {
                  this.mapSearchTableColumn();
                }, 100);
              }}>
              <div className={`tw-flex tw-gap-1 tw-relative`}>
                {/* <div className={`tw-flex tw-gap-1 tw-relative ${(this.defaultData.country_small === 'multicountry' || this.defaultData.country_small === 'global data') && this.props.userDetails?.userData?.email?.includes("trademo.com") && this.props.userDetails?.creditDetails?.data?.[0].user_active_plan?.includes('enterprise') ? "tw-pr-5" : ""}`}> */}
                <div className={this.state.showNudgePopup === true && this.state.currentNudgePopupKey && this.state.nudgePopupStateObj && this.state.nudgePopupStateObj.hasOwnProperty(this.state.currentNudgePopupKey) && this.state.nudgePopupStateObj[this.state.currentNudgePopupKey].shouldPop === true ? "container-fluid p-0 disable-scroll" : "container-fluid p-0"}>
                  <div className={`${this.state.showMultiCountryTopNudge ? "search-container-due-to-nudge" : "search-container"}`}>
                    <div>
                      <PrimarySearchCard
                        handleGetInTouchOpen={this.handleGetInTouchOpen}
                        countryType={this.defaultData.countryType}
                        analyticsCountryID={this.defaultData.analyticsCountryID}
                        isMirror={this.defaultData.isMirror}
                        setSearchCardHandler={(value) => this.setSearchCardHandler(value)}
                        defaultData={this.defaultData}
                        searchedItem={this.state.searchedItem}
                        searchKey={this.state.searchKey}
                        isReloadSearchClicked={this.state.isReloadSearchClicked}
                        gettingPostSearchResults={this.state.gettingPostSearchResults}
                        searchCardOptions={this.searchCardHeaderOptions}
                        searchBottonCalled={(searchedItem, searchInclude, currentKey, matchType, isSelectedFromAutoSuggest, redirectionId) => this.searchSubmitClicked(searchedItem, searchInclude, currentKey, matchType, isSelectedFromAutoSuggest, redirectionId)}
                        searchBottonCalledForChemical={(data) => this.searchBottonCalledForChemical(data)}
                        isShipmentLoader={this.state.isShipmentLoader}
                        newIntelLoader={this.state.newIntelLoader}
                        searchButtonLoaderHandler={this.searchButtonLoaderHandler}
                        closeLoader={() => {
                          this.setState({
                            isShipmentLoader: false,
                            newIntelLoader: false,
                          });
                        }}
                        updateMultiCountryDataSourceHandler={this.updateMultiCountryDataSourceHandler}
                        callingPendoEvent={(event) => this.checkPendoEventForCompanyRedirection(event)}
                        resetAll={this.resetAll}
                        settingSearchButtonClicked={this.settingSearchButtonClicked}
                        showReset={this.checkforFilters(this.props.shipmentDetails.appliedFilter) || this.state.searchedItem !== "" ? true : false}
                        setClickPostSearchSugg={(e) =>
                          this.setState({
                            isClickedPostSearchSugg: e,
                          })
                        }
                      />
                      <PanelTopFilter
                        handleGetInTouchOpen={this.handleGetInTouchOpen}
                        appliedBooleanFilterObject={this.state.appliedBooleanFilterObject}
                        isFilterApplied={this.state.isFilterApplied}
                        currentPlanAccess={this.state.currentPlanAccess}
                        filterMapList={this.filterMapList}
                        includeFilter={this.state.includeFilter}
                        excludeFilter={this.state.excludeFilter}
                        userCredit={this.state.userCredit}
                        fromAccutalArrivalDate={this.state.fromAccutalArrivalDate}
                        toAccutalArrivalDate={this.state.toAccutalArrivalDate}
                        paidPlanDateRange={this.state.paidPlanDateRange}
                        defaultData={this.defaultData}
                        monthObject={this.state.monthObject}
                        monthRangePickerDismiss={(e) => this.monthRangePickerDismiss(e)}
                        monthRangePickerChange={(e) => this.monthRangePickerChange(e)}
                        selectDateRangePicker={(e) => this.selectDateRangePicker(e)}
                        latestActualArrivalDate={this.state.latestActualArrivalDate}
                        zeroFilterData={this.state.zeroFilterData}
                        checkforFilters={this.checkforFilters}
                        appliedStateFilterObject={this.props.shipmentDetails.appliedFilter}
                        resetFilter={this.resetFilter}
                        checkPendoEventForCompanyRedirection={this.checkPendoEventForCompanyRedirection}
                        categoryName={this.state.categoryName}
                        mouseFilterList={this.state.mouseFilterList}
                        specialTooltipKeywords={this.specialTooltipKeywords}
                        mouseOverToolTip={(item) => this.mouseOverToolTip(item)}
                        fillDataHandler={(item) => this.fillDataHandler(item)}
                        searchedProximityFilterData={this.state.searchedProximityFilterData}
                        appliedBoxFilterObj={this.state.appliedBoxFilterObj}
                        defaultBoxFilterObj={this.defaultBoxFilterObj}
                        selectedFilterList={this.state.selectedFilterList}
                        viewAllFilter={this.viewAllFilter}
                        filterTypeEnum={this.filterTypeEnum}
                        showCloseHandler={this.showCloseHandler}
                        isRedirect={this.state.isRedirect}
                        isReloadFromDashboard={this.state.isReloadFromDashboard}
                        redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                        redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                        specialFields={this.specialFields}
                        filterModuleSelected={this.state.filterModuleSelected}
                        selectedFilterLabelObject={this.state.selectedFilterLabelObject}
                        proximityApplied={this.state.proximityApplied}
                        clearIndividualFilter={this.clearIndividualFilter}
                        saveSelectedFilter={this.saveSelectedFilter}
                        closeViewAllFilter={this.closeViewAllFilter}
                        selectAllObj={this.state.selectAllObj}
                        searchedFilter={this.state.searchedFilter}
                        excludedFilter={this.state.excludedFilter}
                        selectAllChecked={this.state.selectAllChecked}
                        emptyFilterTextEnum={this.emptyFilterTextEnum}
                        setSelectAllChecked={(val) =>
                          this.setState({
                            selectAllChecked: val,
                          })
                        }
                        clearMainFilter={this.clearMainFilter}
                        proximityClicked={this.state.proximityClicked}
                        existingSearchReqObj={this.state.existingSearchReqObj}
                        buildRequestObj={() => this.creatingRequestObject(requestObjectType.search)}
                        setRangeValue={this.setRangeValue}
                        setMultiRangeValue={this.setMultiRangeValue}
                        searchHscodeInFilter={this.searchHscodeInFilter}
                        mapBooleanFilter={this.mapBooleanFilter}
                        booleanFilterObject={this.booleanFilterObject}
                        setSearchedProximityFilterData={(filterValue) => {
                          this.setState({
                            searchedProximityFilterData: JSON.parse(JSON.stringify(filterValue)),
                          });
                        }}
                        setAppliedStateFilterObject={(appliedFilter) => {
                          this.setState({
                            appliedStateFilterObject: JSON.parse(JSON.stringify(appliedFilter)),
                          });
                        }}
                        redirectingProfileType={this.state.redirectingProfileType}
                        redirectingProfilePartnerType={this.state.redirectingProfilePartnerType}
                        lastRequestType={this.state.lastRequestType}
                      />
                      {!!this.state.isTableVisible && this.state.isTableVisible === true ? (
                        <PostSearchResults
                          data={this.state.postSearchData}
                          isSelectedFromAutoSuggest={this.state.isSelectedFromAutoSuggest}
                          isClickedPostSearchSugg={this.state.isClickedPostSearchSugg}
                          setClickPostSearchSugg={(e) =>
                            this.setState({
                              isClickedPostSearchSugg: e,
                            })
                          }
                          search={this.state.searchCardParams.searchedItem}
                          searchCategory={this.state.searchKey}
                          callingSearch={(a, b, c, d) => this.callingSearchResult(a, b, c, d)}
                          currentTab={this.state.currentTab}
                          tabKeyWords={this.defaultData.tabKeyWords}
                          recentSearchData={this.state.recentSearchData}
                        />
                      ) : (
                        // const isOnlyMirrorSubscribed = !!this.props.userDetails?.creditDetails?.data?.filter((item) => item?.product_id !== "trademo_MC" && item.navigate !== "upgrade").every((dataset) => dataset?.is_active && countryDetails[dataset?.product_id]?.name?.toLowerCase()?.includes("mirror"));
                        <div className="tw-h-[calc(100vh-220px)] tw-py-[6vh]">
                          <div className="tw-flex tw-h-full tw-gap-5 tw-max-w-[1440px] tw-mx-auto">
                            <div className="tw-w-1/2 tw-h-full tw-min-h-0 tw-flex tw-flex-col">
                              <div className="tw-text-sm tw-font-semibold tw-mb-2 tw-flex tw-items-center tw-gap-2">
                                <div className="tw-w-7 tw-h-7 tw-rounded-[6px] tw-bg-primary-purple-50 tw-flex tw-items-center tw-justify-center tw-shrink-0">
                                  <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#7143f1">
                                    <path d="m618.92-298.92 42.16-42.16L510-492.16V-680h-60v212.15l168.92 168.93ZM480.07-100q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Z" />
                                  </svg>
                                </div>
                                Recent Searches
                              </div>
                              <RecentSearches fromShipments={true} onReload={(data, url) => this.handleHistoryReload("recent", data, url)} multipleSearchSeparators={multipleSearchSeparators} isLoading={this.state.isSearchHistoryLoading} recentSearchData={this.state.searchHistoryData?.recentSearchResponse} />
                            </div>
                            <div className="tw-w-1/2 tw-flex tw-flex-col tw-h-full tw-min-h-0 tw-gap-5">
                              <div className={`tw-flex tw-flex-col tw-flex-1 tw-min-h-0`}>
                                <div className="tw-text-sm tw-font-semibold tw-mb-2 tw-flex tw-items-center tw-gap-2">
                                  <div className="tw-w-7 tw-h-7 tw-rounded-[6px] tw-bg-saved-icon-bg tw-flex tw-items-center tw-justify-center tw-shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#617cff">
                                      <path d="M220-150v-597.69Q220-778 241-799q21-21 51.31-21h375.38Q698-820 719-799q21 21 21 51.31V-150L480-261.54 220-150Z" />
                                    </svg>
                                  </div>
                                  Saved Searches
                                </div>
                                <SavedSearches
                                  fromShipments={true}
                                  onReload={(data, url) => this.handleHistoryReload("saved", data, url)}
                                  isLoading={this.state.isSearchHistoryLoading}
                                  savedSearchData={this.state.searchHistoryData?.saveSearchResponse}
                                  getDashboardContacts={() => {
                                    this.setState({ searchHistoryData: { ...this.state.searchHistoryData, saveSearchResponse: [] }, isSearchHistoryLoading: true });
                                    this.getRecentSearches();
                                  }}
                                />
                              </div>
                              {/* {!isOnlyMirrorSubscribed && (
                                    <div className="tw-flex tw-flex-col tw-flex-[2] tw-min-h-0">
                                      <div className="tw-text-sm tw-font-semibold tw-mb-2 tw-flex tw-items-center tw-gap-2">
                                        <div className="tw-w-7 tw-h-7 tw-rounded-[6px] tw-bg-top-icon-bg tw-flex tw-items-center tw-justify-center tw-shrink-0">
                                          <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#d97706">
                                            <path d="M115.39-140v-440h193.07v440H115.39Zm264.23 0v-680h200.76v680H379.62Zm271.92 0v-360h193.07v360H651.54Z" />
                                          </svg>
                                        </div>
                                        Top Searches
                                      </div>
                                      <TopSearches fromShipments={true} onReload={(data, url) => this.handleHistoryReload("top", data, url)} multipleSearchSeparators={multipleSearchSeparators} isLoading={this.state.isSearchHistoryLoading} topSearchData={this.state.searchHistoryData?.topSearchResponse} />
                                    </div>
                                  )} */}
                            </div>
                          </div>
                        </div>
                      )}
                      {this.state.showOnboardingModal && this.state?.onboardingData?.onboarding_details !== undefined && this.state.onboardingInitiator === "landing" && this?.props?.userDetails?.userData?.show_onboarding_popup === true ? (
                        <Supademo
                          comingFrom={"shipments"}
                          onboardingInitiator={this.state.onboardingInitiator}
                          onboardingData={this.state?.onboardingData}
                          type="modal"
                          url={this.state.onboardingData.onboarding_details[this.state.currOnboardingObj].supademoUrl}
                          modalHeading={this.state.onboardingData.onboarding_details[this.state.currOnboardingObj].title}
                          description={this.state.onboardingData.onboarding_details[this.state.currOnboardingObj].brief}
                          currOnboardingObj={this.state.currOnboardingObj}
                          handleSetCurrOnboarding={(e, trigger, data) => this.handleSetCurrOnboarding(e, trigger, data)}
                          updatingOnboardingData={(val) => this.updatingOnboardingData(val)}
                          closeModal={(e) => {
                            this.handleNudgePopup("hs_classifier", "event");
                            this.handleNudgePopup("compare_tariff", "event");
                            if (!this.props.userDetails?.creditDetails?.data?.[0]?.user_active_plan?.includes("starter")) {
                              this.handleNudgePopup("company_search", "event");
                            }
                            if (this.isIntelHubNudgeEligible()) {
                              this.handleNudgePopup("intel_hub", "event");
                            }
                            this.handleNudgePopup("hermes_chat", "event");
                            this.onboardingPopupClose(e);
                            handlePatch("onboarding", this.state.currOnboardingObj);
                            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.onboardingCancelIcon);
                          }}
                          checkPendoEventForCompanyRedirection={this.checkPendoEventForCompanyRedirection}
                        />
                      ) : this.state.currOnboardingObj !== "" && this.state?.onboardingData?.onboarding_details && this.state.onboardingInitiator === "dropdown" && !this?.props?.userDetails?.userData?.show_onboarding_popup ? (
                        <Supademo
                          comingFrom="shipments"
                          onboardingInitiator={this.state.onboardingInitiator}
                          onboardingData={this.state?.onboardingData}
                          type="modal"
                          url={this.state.onboardingData.onboarding_details[this.state.currOnboardingObj].supademoUrl}
                          modalHeading={this.state.onboardingData.onboarding_details[this.state.currOnboardingObj].title}
                          description={this.state.onboardingData.onboarding_details[this.state.currOnboardingObj].brief}
                          currOnboardingObj={this.state.currOnboardingObj}
                          handleSetCurrOnboarding={(e, trigger, data) => this.handleSetCurrOnboarding(e, trigger, data)}
                          updatingOnboardingData={(val) => this.updatingOnboardingData(val)}
                          closeModal={() => {
                            this.setState({
                              currOnboardingObj: "",
                            });
                            this.checkPendoEventForCompanyRedirection(trackingEventDictionary.onboardingCancelIcon);
                          }}
                          checkPendoEventForCompanyRedirection={this.checkPendoEventForCompanyRedirection}
                        />
                      ) : (
                        <></>
                      )}

                      {this.state.showGetInTouch ? <GetInTouchLimit showGetInTouchPopup={this.state.showGetInTouch} handleGetInTouchClose={() => this.handleGetInTouchClose()} profileType={profileTypeEnum.company} notifyCountry={this.defaultData.country_small} blockAccessType={"connect"} /> : null}
                    </div>
                    {!!this.state.isTableVisible && this.state.isTableVisible === true ? (
                      <div className={`d-flex intel_data_container tw-pt-3`}>
                        <div className="right_parent_container">
                          {this.state.searchedItem &&
                            this.state.searchedItem !== "" &&
                            !this.state.searchedItem.includes("||") &&
                            this.state.redirectionIdFromAutoSuggest?.hasOwnProperty(this.state.searchedItem) &&
                            this.state.redirectionIdFromAutoSuggest[this.state.searchedItem] &&
                            (this.state.searchKey === "product_hscode" ? (
                              <span className="view_profile_search_container">
                                Discover more insights about{" "}
                                <span className="profile_details cursor-pointer text-capitalize">
                                  <HSCodeText hsCodeFieldObject={{ selector: ["hscodeId"], label_name: "HS Code" }} rowData={{ companyName: this.state.searchedItem, hscodeId: this.state.redirectionIdFromAutoSuggest[this.state.searchedItem] }} type={hsCodeTypeDictionary.shipment} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} currentUserPlan={this.state.currentUserPlan} dataSource={this.defaultData.analyticsCountryID} showHSLabel={true} />
                                </span>
                              </span>
                            ) : this.state.redirectionTypeKey && this.state.redirectionTypeKey !== "importers" && this.state.redirectionTypeKey !== "exporters" ? (
                              <RedirectProfile profileType={redirectionTypeKey[this.state.redirectionTypeKey]} profileId={this.state.redirectionIdFromAutoSuggest[this.state.searchedItem]} profileName={this.state.searchedItem} dataSource={this.defaultData.analyticsCountryID} countryName={this.defaultData.countryCaps} countryType={this.defaultData.countryType} fromShipments={true} />
                            ) : this.state.redirectionTypeKey && (this.state.redirectionTypeKey === "importers" || this.state.redirectionTypeKey === "exporters") ? (
                              <span className="view_profile_search_container">
                                Discover more insights about{" "}
                                <span className="profile_details cursor-pointer text-capitalize">
                                  <ShipmentsCompanyName name={this.state.searchedItem} rowData={{ companyName: this.state.searchedItem, companyKey: this.state.redirectionIdFromAutoSuggest[this.state.searchedItem] }} companyKey={"companyName"} companyIdKey={"companyKey"} countryName={this.defaultData?.countryShortHand || this.defaultData.country_small} countryType={this.defaultData.countryType} type={this.defaultData.countryTypeCode} analyticsCountryID={this.defaultData.analyticsCountryID} pathname={this.props.location.pathname} isRedirect={true} currentUserPlan={this.state.currentUserPlan} redirectingCompanyExporterId={this.state.redirectingCompanyExporterId} redirectingCompanyImporterId={this.state.redirectingCompanyImporterId} shipmentConsigneeStandardizedName={trackingEventDictionary.consigneeCompanyProfileRedirectionFromAutosuggest} shipmentShipperStandardizedName={trackingEventDictionary.shipperCompanyProfileRedirectionFromAutosuggest} />
                                </span>
                              </span>
                            ) : (
                              <></>
                            ))}
                          <div className="px-md-0">
                            <RightPanel
                              activeDateRange={[...Object.keys(this.state.paidPlanDateRange), ...[`Custom Date Range: ${moment(this.state.fromAccutalArrivalDate).format("MMM DD, YYYY")} to ${moment(this.state.toAccutalArrivalDate).format("MMM DD, YYYY")} `]]}
                              addToFaV={this.state.addToFaV}
                              analyticsData={this.state.analyticsData}
                              analyticsLoader={this.state.analyticsLoader}
                              analyticsTrends_mustnot_Data={this.state.analyticsTrends_mustnot_Data}
                              analyticDropdownOptions={this.analyticDropdownOptions}
                              analyticsType={analyticsType}
                              appliedBooleanFilterObject={this.state.appliedBooleanFilterObject}
                              appliedStateFilterObject={this.props.shipmentDetails.appliedFilter}
                              applyUIUEFilterHandler={this.applyUIUEFilterHandler}
                              callNavigationToPlans={this.callNavigationToPlans}
                              changeUEDuration={(e) => {
                                this.setState(
                                  {
                                    currentExporterFrame: e,
                                    currentPage: 1,
                                    defaultPage: 1,
                                    secondLevelData: [],
                                    mustNotIncludeExporter: [],
                                    defaultTrendsData: [],
                                    currentTab: tabKeywords.exporters,
                                    exporterPerPage: 25,
                                    secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
                                  },
                                  () => this.changeDurationHandler(e.value)
                                );
                              }}
                              changeUETwoLevelHandler={this.changeUETwoLevelHandler}
                              changeUITwoLevelHandler={this.changeUITwoLevelHandler}
                              changeULTwoLevelHandler={this.changeULTwoLevelHandler}
                              changeUniqueImporterDuration={(e) => {
                                this.setState(
                                  {
                                    currentTimeFrame: e,
                                    currentPage: 1,
                                    defaultPage: 1,
                                    secondLevelData: [],
                                    mustNotIncludeImporter: [],
                                    defaultTrendsData: [],
                                    importerPerPage: 25,
                                    currentTab: tabKeywords.importers,
                                    secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
                                  },
                                  () => this.changeDurationHandler(e.value)
                                );
                              }}
                              changeUniqueLogisticsDuration={(e) => {
                                this.setState(
                                  {
                                    currentLogisticsFrame: e,
                                    currentPage: 1,
                                    defaultPage: 1,
                                    secondLevelData: [],
                                    mustNotIncludeLogistics: [],
                                    defaultTrendsData: [],
                                    logisticsPerPage: 25,
                                    secondLevelRowDropdownValue: secondLevelRowsDropdown[0],
                                    currentTab: tabKeywords.logistics,
                                  },
                                  () => this.changeDurationHandler(e.value)
                                );
                              }}
                              checkforFilters={this.checkforFilters}
                              checkPendoEventForCompanyRedirection={this.checkPendoEventForCompanyRedirection}
                              clearButton={() => {
                                this.setState({
                                  clearButton: !this.state.clearButton,
                                });
                              }}
                              clearButtonState={this.state.clearButton}
                              clearFilter={() => {
                                this.setState({
                                  tempObj: {},
                                });
                              }}
                              clearFilterUE={() => {
                                this.setState({
                                  expTempObj: {},
                                });
                              }}
                              currentExporterFrame={this.state.currentExporterFrame}
                              currentKeyViewTrendItem={this.state.currentKeyViewTrendItem}
                              currentLogisticsFrame={this.state.currentLogisticsFrame}
                              currentPage={this.state.currentPage}
                              currentPlanAccess={this.state.currentPlanAccess}
                              currentTab={this.state.currentTab}
                              currentTimeFrame={this.state.currentTimeFrame}
                              currentUserPlan={this.state.currentUserPlan}
                              creditQuota={this.state.creditQuota}
                              data={this.state.data}
                              defaultBooleanFilterObject={this.defaultBooleanFilterObject}
                              defaultData={this.defaultData}
                              defaultPage={this.state.defaultPage}
                              defaultTrendsData={this.state.defaultTrendsData}
                              defaultUiUeTwoLevelSelctedHeading={this.state.defaultUiUeTwoLevelSelctedHeading}
                              defaultUlTwoLevelSelectedHeading={this.state.defaultUlTwoLevelSelectedHeading}
                              displayShipmentTab={this.displayShipmentTab}
                              downloadAnalyticsPDF={this.downloadAnalyticsPDF}
                              downloadImpExpConfirm={this.downloadImpExpConfirm}
                              downloadSearch={this.downloadSearch}
                              downloadShipmentFromPopup={this.downloadShipmentFromPopup}
                              dynamicTrendsData={this.state.currentTab === tabKeywords.importers ? this.state.dynamicImporterTrendsData : this.state.currentTab === tabKeywords.exporters ? this.state.dynamicExporterTrendsData : this.state.dynamicLogisticsTrendsData}
                              excludeFilter={this.state.excludeFilter}
                              emptyFilterObj={{ ...this.emptyFilterObj }}
                              existingSearchReqObj={this.state.existingSearchReqObj}
                              existingUniqueImpExpReqObj={this.state.existingUniqueImpExpReqObj}
                              expDefaultSort={this.state.expDefaultSort}
                              exporterCurrentPage={this.state.exporterCurrentPage}
                              exporterDefaultSortValue={this.exporterDefaultSortValue}
                              exporterPerPage={this.state.exporterPerPage}
                              exporterSortOrderValue={this.state.exporterSortOrderValue}
                              exporterSortValue={this.state.exporterSortValue}
                              exporterTab={this.state.exporterTab}
                              exporterTableColumn={this.state.exporterTableColumn}
                              exporterToggleRows={this.state.exporterToggleRows}
                              exporterTrendsTab={this.state.exporterTrendsTab}
                              fetchSummaryTrendsData={this.fetchSummaryTrendsData}
                              fetchSummaryViewAllData={this.fetchSummaryViewAllData}
                              filterData={this.state.filterData}
                              filterMapList={this.filterMapList}
                              filterObj={this.state.filterObj}
                              finalReqObj={this.state.finalReqObj}
                              fixedLengthUptoTrend={this.state.fixedLengthUptoTrend}
                              getAnalyticsData={this.getAnalyticsData}
                              gettingAllData={this.gettingAllData}
                              gettingDataFromUIEFilter={this.gettingDataFromUIEFilter}
                              getUniqueExporterData={this.getUniqueExporterData.bind(this)}
                              getUniqueImporterData={this.getUniqueImporterData.bind(this)}
                              getUniqueLogisticsData={this.getUniqueLogisticsData.bind(this)}
                              getUserPlanHandler={this.getUserPlanHandler}
                              goBackRedirectUser={this.goBackRedirectUser}
                              handleClose={this.handleClose}
                              handleExporterSorting={this.handleExporterSorting}
                              handleExporterSortingClone={this.handleExporterSortingClone}
                              handleGoToAllCategory={() => this.handleGoToAllCategory()}
                              handleGoToAllDatasets={() => this.handleGoToAllDatasets()}
                              handleImporterSorting={this.handleImporterSorting}
                              handleImporterSortingClone={this.handleImporterSortingClone}
                              handleLogisticsSortingClone={this.handleLogisticsSortingClone}
                              handleNudgePopup={this.handleNudgePopup}
                              handlePerRowsChangeExporterClone={this.handlePerRowsChangeExporterClone}
                              handlePerRowsChangeImporter={this.handlePerRowsChangeImporter}
                              handlePerRowsChangeImporterClone={this.handlePerRowsChangeImporterClone}
                              handlePerRowsChangeLogistics={this.handlePerRowsChangeLogistics}
                              handlePerRowsChangeLogisticsClone={this.handlePerRowsChangeLogisticsClone}
                              handleSearchPerRowsExporterChange={this.handleSearchPerRowsExporterChange}
                              handleSearchPerRowsExporterChangeClone={this.handleSearchPerRowsExporterChangeClone}
                              handleSearchPerRowsImporterChange={this.handleSearchPerRowsImporterChange}
                              handleSearchPerRowsImporterChangeClone={this.handleSearchPerRowsImporterChangeClone}
                              handleSearchPerRowsLogisticsChange={this.handleSearchPerRowsLogisticsChange}
                              handleSearchPerRowsLogisticsChangeClone={this.handleSearchPerRowsLogisticsChangeClone}
                              handleSortingClone={this.handleSortingClone}
                              handleTrademoTablePageChange={this.handleTrademoTablePageChange}
                              handleTrademoTableSearchPerRowsChange={this.handleTrademoTableSearchPerRowsChange}
                              handleTrendsSorting={this.handleTrendsSorting}
                              handleZeroDataSearch={this.handleZeroDataSearch}
                              hideAnalyticsViewAllModal={this.hideAnalyticsViewAllModal}
                              impDefaultSort={this.state.impDefaultSort}
                              importer_exporter_graph_sort__options={this.state.importer_exporter_graph_sort__options}
                              importerCurrentPage={this.state.importerCurrentPage}
                              importerDefaultSortValue={this.importerDefaultSortValue}
                              importerPerPage={this.state.importerPerPage}
                              importerSortOrderValue={this.state.importerSortOrderValue}
                              importerSortValue={this.state.importerSortValue}
                              importerTab={this.state.importerTab}
                              importerTableColumn={this.state.importerTableColumn}
                              importerToggleRows={this.state.importerToggleRows}
                              includeFilter={this.state.includeFilter}
                              isActiveLoader={this.state.isActiveLoader}
                              isChemicalPresent={this.state.isChemicalPresent}
                              isDownloadLoaderActive={this.state.isDownloadLoaderActive}
                              isExporterTableVisible={this.state.isExporterTableVisible}
                              isFilterApplied={this.state.isFilterApplied}
                              isImporterTableVisible={this.state.isImporterTableVisible}
                              isLoaderActive={this.state.isLoaderActive}
                              isLogisticsTableVisible={this.state.isLogisticsTableVisible}
                              isMerged={this.state.isMerged}
                              isIntFilterApplied={this.state.isIntFilterApplied}
                              isParentCompany={this.state.isParentCompany}
                              isRedirect={this.state.isRedirect}
                              isSalesForceRedirection={this.state.isSalesForceRedirection}
                              isSearchButtonCalled={this.state.isSearchButtonCalled}
                              isTrademoAccount={this.state.isTrademoAccount}
                              isTrendsActive={this.state.isTrendsActive}
                              isUEGridNew={this.isUEGridNew}
                              isUIGridNew={this.isUIGridNew}
                              isZeroDataSource={this.state.isZeroDataSource}
                              logisticsCurrentPage={this.state.logisticsCurrentPage}
                              logisticsDefaultSort={this.state.logisticsDefaultSort}
                              logisticsDefaultSortValue={this.state.logisticsDefaultSortValue}
                              logisticsPerPage={this.state.logisticsPerPage}
                              logisticsSortOrderValue={this.state.logisticsSortOrderValue}
                              logisticsSortValue={this.state.logisticsSortValue}
                              logisticsTableColumn={this.state.logisticsTableColumn}
                              logisticsToggleRows={this.state.logisticsToggleRows}
                              logisticsTrendsTab={this.state.logisticsTrendsTab}
                              mainLabelOptions={this.mainLabelOptions}
                              mapSelectedValue={this.mapSelectedValue}
                              mappingUniqueImporterExporter={this.mappingUniqueImporterExporter}
                              modalHeading={this.state.modalHeading}
                              nextSecondLevelHandler={this.nextSecondLevelHandler}
                              onSecondLevelExporterRowDropdownChange={(value) =>
                                this.setState(
                                  {
                                    secondLevelRowDropdownValue: value,
                                    mustNotIncludeExporter: [],
                                    defaultTrendsData: [],
                                    selectedRows: [],
                                    showDropdown: false,
                                    secondLevelData: [],
                                    exporterPerPage: value.value * 5,
                                    currentPage: 1,
                                    defaultPage: 1,
                                  },
                                  () => {
                                    this.getUniqueExporterData(requestObjectType.exporters);
                                  }
                                )
                              }
                              onSecondLevelImporterRowDropdownChange={(value) =>
                                this.setState(
                                  {
                                    secondLevelRowDropdownValue: value,
                                    mustNotIncludeImporter: [],
                                    defaultTrendsData: [],
                                    selectedRows: [],
                                    showDropdown: false,
                                    secondLevelData: [],
                                    importerPerPage: value.value * 5,
                                    currentPage: 1,
                                    defaultPage: 1,
                                  },
                                  () => {
                                    this.getUniqueImporterData(requestObjectType.importers);
                                  }
                                )
                              }
                              onSecondLevelLogisticsRowDropdownChange={(value) =>
                                this.setState(
                                  {
                                    secondLevelRowDropdownValue: value,
                                    mustNotIncludeLogistics: [],
                                    defaultTrendsData: [],
                                    selectedRows: [],
                                    showDropdown: false,
                                    secondLevelData: [],
                                    logisticsPerPage: value.value * 5,
                                    currentPage: 1,
                                    defaultPage: 1,
                                  },
                                  () => {
                                    this.getUniqueLogisticsData(requestObjectType.logistics);
                                  }
                                )
                              }
                              onTabChangeHandler={this.onTabChangeHandler}
                              parentCompanyNames={this.state.parentCompanyNames}
                              perPage={this.state.perPage}
                              prevSecondLevelHandler={this.prevSecondLevelHandler}
                              prospectExporter={this.state.prospectExporter}
                              prospectImporter={this.state.prospectImporter}
                              prospectLogistics={this.state.prospectLogistics}
                              redirectingCompanyExporterId={this.state.redirectingCompanyExporterId}
                              redirectingCompanyImporterId={this.state.redirectingCompanyImporterId}
                              redirectingCompanyName={this.state.redirectingCompanyName}
                              redirectingCompanyType={this.state.redirectionCompanyType}
                              reportTabClick={this.reportTabClick}
                              resetFilter={this.resetFilter}
                              resetSecondLevel={() => {
                                this.setState({
                                  secondLevelData: [],
                                  defaultPage: 1,
                                });
                              }}
                              savedSearchShow={this.state.savedSearchShow}
                              searchedItem={this.state.searchedItem}
                              searchKey={this.state.searchKey}
                              searchQueryType={this.state.searchQueryType}
                              searchTableColumns={this.state.searchTableColumns}
                              searchTypeStr={this.state.searchTypeStr}
                              secondLevelData={this.state.secondLevelData}
                              secondLevelRowDropdownValue={this.state.secondLevelRowDropdownValue}
                              selectedExporterRowData={this.state.selectedExporterRowData}
                              selectedExporterRowFun={this.selectedExporterRowFun}
                              selectedFilterLabelObject={this.state.selectedFilterLabelObject}
                              selectedImporterRowData={this.state.selectedImporterRowData}
                              selectedImporterRowFunClone={this.selectedImporterRowFunClone}
                              selectedLogisticsRowData={this.state.selectedLogisticsRowData}
                              selectedLogisticsRowFun={this.selectedLogisticsRowFun}
                              selectedLogisticsRowFunClone={this.selectedLogisticsRowFunClone}
                              selectedNewTableData={this.selectedNewTableData}
                              selectedRows={this.state.selectedRows}
                              selectedSearchRowData={this.state.selectedSearchRowData}
                              selectedUiUeTwoLevelHeading={this.selectedUiUeTwoLevelHeading}
                              selectedUlTwoLevelHeading={this.selectedUlTwoLevelHeading}
                              selectSortDefaltValueHandler={this.selectSortDefaltValueHandler}
                              setAddtoFav={(val) => {
                                this.setState({
                                  addToFaV: val,
                                });
                              }}
                              setCurrentTabHandler={(currentTab) => {
                                this.setState({
                                  currentTab: currentTab,
                                  trendsTab: false,
                                  exporterTrendsTab: false,
                                  logisticsTrendsTab: false,
                                });
                              }}
                              setExporterTableToggle={this.setExporterTableToggle}
                              setExporterTrendsToggle={this.setExporterTrendsToggle}
                              setLogisticsTrendsToggle={this.setLogisticsTrendsToggle}
                              setSavedSearchShow={(show) =>
                                this.setState({
                                  savedSearchShow: show,
                                })
                              }
                              setShowDataSource={() => {
                                this.setState({
                                  showDataSource: !this.state.showDataSource,
                                });
                              }}
                              setShowNudgePopup={(show) =>
                                this.setState({
                                  showNudgePopup: show,
                                })
                              }
                              setShowPopUp={(val) => {
                                this.setState({
                                  showPopup: val,
                                });
                              }}
                              setTrendsTableToggle={this.setTrendsTableToggle}
                              shipmentToggleRows={this.state.shipmentToggleRows}
                              showBolFilter={this.showBolFilter}
                              showDataSource={this.state.showDataSource}
                              showPopup={this.state.showPopup}
                              showTwoLevel={this.showTwoLevel}
                              showUiTrends={this.showUiTrends}
                              sortOrderValue={this.state.sortOrderValue}
                              sortValue={this.state.sortValue}
                              toggleClearButton={this.toggleClearButton}
                              totalCustomShipments={this.state.totalCustomShipments}
                              totalSearchCount={this.state.totalSearchCount}
                              totalUniqueExporter={this.state.totalUniqueExporter}
                              totalUniqueImporter={this.state.totalUniqueImporter}
                              totalUniqueLogistics={this.state.totalUniqueLogistics}
                              trendsDropdownOptions={this.trendsDropdownOptions}
                              trendsTab={this.state.trendsTab}
                              type={this.state.type}
                              ueTwoLevel={this.state.ueTwoLevel}
                              UEHandlerPerPage={(e) => {
                                this.setState({
                                  exporterCurrentPage: e,
                                  isLoaderActive: true,
                                });
                                setTimeout(() => {
                                  this.setState({
                                    isLoaderActive: false,
                                  });
                                }, 500);
                              }}
                              UIHandlerPerPage={(e) => {
                                this.setState({
                                  isLoaderActive: true,
                                  importerCurrentPage: e,
                                });
                                setTimeout(() => {
                                  this.setState({
                                    isLoaderActive: false,
                                  });
                                }, 500);
                              }}
                              uiTwoLevel={this.state.uiTwoLevel}
                              ULHandlerPerPage={(e) => {
                                this.setState({
                                  isLoaderActive: true,
                                  logisticsCurrentPage: e,
                                });
                                setTimeout(() => {
                                  this.setState({
                                    isLoaderActive: false,
                                  });
                                }, 500);
                              }}
                              ulTwoLevel={this.state.ulTwoLevel}
                              uniqueImportExporterShipment={this.state.uniqueImportExporterShipment}
                              uniqueImportExporterTeu={this.state.uniqueImportExporterTeu}
                              uniqueImportExporterValue={this.state.uniqueImportExporterValue}
                              uniqueImportExporterWeight={this.state.uniqueImportExporterWeight}
                              updateTrademoTableObject={this.updateTrademoTableObject}
                              updateTrademoUETableObjectClone={this.updateTrademoUETableObjectClone}
                              updateTrademoUITableObjectClone={this.updateTrademoUITableObjectClone}
                              updateTrademoULTableObjectClone={this.updateTrademoULTableObjectClone}
                              updatingMustNot={this.updatingMustNot}
                              upgradeNow={this.upgradeNow}
                              upgradePlansDictionary={this.upgradePlansDictionary}
                              userCredit={this.state.userCredit}
                              userDetails={this.state.userDetails}
                              userFirstPlan={this.state.userFirstPlan}
                              viewAllFinalSearchReqObj={this.state.viewAllFinalSearchReqObj}
                              viewAllPerPage={this.state.viewAllPerPage}
                              viewReportFlag={this.state.viewReportFlag}
                              zeroCaseHandler={this.zeroCaseHandler}
                              zeroCountDataObj={this.state.zeroCountDataObj}
                              zeroCountDateRange={this.state.zeroCountDateRange}
                              zeroCountData={this.state.zeroCountData}
                              zeroCountUpgrade={this.state.zeroCountUpgrade}
                              zeroCountyear={this.state.zeroCountyear}
                              zeroFilterData={this.state.zeroFilterData}
                              fromAccutalArrivalDate={this.state.fromAccutalArrivalDate}
                              toAccutalArrivalDate={this.state.toAccutalArrivalDate}
                            />
                          </div>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

              {this.state.isLoaderActive || this.state.isDownloadLoaderActive || this.state.isTrendsActive || this.state.analyticsLoader || this.state.isShipmentLoader || this.state.customTypeLoader || this.state.newIntelLoader || this.state.twoLevelLoader ? (
                <div className="loader-container">
                  <div className="loader-block">
                    <img src={LoaderImg} alt="description of gif" />
                  </div>
                </div>
              ) : (
                <></>
              )}
              <Modal size="sm" centered show={this.state.showUpgradeModal} onHide={this.upgradePopupClose} animation={false}>
                <Modal.Header closeButton>
                  <Modal.Title>Upgrade Now</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="row m-0">
                    <div className="col-12 p-0">
                      <span className="upgrade-text">
                        {this.state.upgradeText} {this.state.upgradePopopContent}
                      </span>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button type="button" className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2" onClick={this.upgradePopupClose}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={(e) => this.upgradeNow(e)}>
                    Upgrade Now
                  </button>
                </Modal.Footer>
              </Modal>
              {this.state.showNudgePopup ? <NudgePopup handleNudgePopup={(event) => this.handleNudgePopup(this.state.currentNudgePopupKey, "popup", event)} nudgePopupStateObj={this.state.nudgePopupStateObj} currentNudgePopupKey={this.state.currentNudgePopupKey} /> : <div className="d-none" />}
              {!!this && !!this.state && this.state.viewAllAnalyticsFlag === false ? (
                <ViewAllAnalyticsComponent
                  currentKeyViewTrendItem={this.state.currentKeyViewTrendItem}
                  analyticsViewAllData={this.fetchSummaryViewAllData.bind(this)}
                  viewAllFinalSearchReqObj={this.state.viewAllFinalSearchReqObj}
                  hideViewAllModal={this.hideAnalyticsViewAllModal.bind(this)}
                  dropdownOptions={this.analyticDropdownOptions}
                  from={this.defaultData.analyticsCountryID}
                  tradeDirection={this.defaultData.countryTypeCode}
                  country={this.defaultData.countryCaps}
                  twoColumnMapping={this.defaultData.twoColumnMapping}
                  analyticsType={analyticsType}
                  analyticsRangeDownloadPresent={this.defaultData.analyticsRangeDownloadPresent}
                  viewAllAPI={this.defaultData.apiEndPoints.getAnalyticsViewAll}
                  isViewAllGridNew={this.defaultData.isViewAllGridNew}
                  pathname={this.props.location.pathname}
                  analyticsCountryID={this.defaultData.analyticsCountryID}
                  currentUserPlan={this.state.currentUserPlan}
                  userDetails={this.props.userDetails}
                  setShowFavModal={(val) =>
                    this.setState({
                      showFavModal: val,
                    })
                  }
                  setAnalytcisSelectedRows={(val) =>
                    this.setState({
                      analytcisSelectedRows: val,
                    })
                  }
                  secondLevelRowDropdownValue={this.state.secondLevelRowDropdownValue}
                  setSecondLevelRowDropDownValue={(value) =>
                    this.setState({
                      secondLevelRowDropdownValue: value,
                    })
                  }
                />
              ) : (
                <></>
              )}
              {!!this && !!this.state && this.state.viewAllTrends ? (
                <ViewAllTrends
                  setShowFavModal={(val) =>
                    this.setState({
                      showFavModal: val,
                    })
                  }
                  userDetails={this.props.userDetails}
                  setAnalytcisSelectedRows={(val) =>
                    this.setState({
                      analytcisSelectedRows: val,
                    })
                  }
                  analyticsViewAllData={this.fetchSummaryViewAllData}
                  trendsAPI={this.defaultData.apiEndPoints.getAnalyticsViewAll}
                  handleClose={this.handleClose.bind(this)}
                  viewTrendsFinalSearchReqObj={this.state.viewAllFinalSearchReqObj}
                  tradeDirection={this.defaultData.countryTypeCode}
                  country={this.defaultData.countryCaps}
                  currentKeyViewTrendItem={this.state.currentKeyViewTrendItem}
                  twoColumnMapping={this.defaultData.twoColumnMapping}
                  trendsDropdownOptions={this.trendsDropdownOptions}
                  analyticsRangeDownloadPresent={this.defaultData.analyticsRangeDownloadPresent}
                  pathname={this.props.location.pathname}
                  analyticsCountryID={this.defaultData.analyticsCountryID}
                  currentUserPlan={this.state.currentUserPlan}
                  secondLevelRowDropdownValue={this.state.secondLevelRowDropdownValue}
                  setSecondLevelRowDropDownValue={(value) =>
                    this.setState({
                      secondLevelRowDropdownValue: value,
                    })
                  }
                />
              ) : (
                <></>
              )}
              <FilterInfoModal
                show={this.state.showInfoModal}
                modalFilterContent={this.state.modalFilterContent}
                closePopup={() =>
                  this.setState({
                    showInfoModal: false,
                  })
                }
              />
              {this.state.showFavModal ? (
                <AddFavModal
                  currentKeyViewTrendItem={this.state.currentKeyViewTrendItem}
                  profileType={this.state.currentKeyViewTrendItem?.profileTypeKey || profileType.logistics}
                  show={this.state.showFavModal}
                  handleClose={(val) =>
                    this.setState({
                      showFavModal: val,
                    })
                  }
                  prospectData={this.state.analytcisSelectedRows}
                  tradeDirection={this.defaultData.countryType}
                  country={this.defaultData.country_small}
                  dataSource={this.defaultData.country_small}
                />
              ) : (
                <></>
              )}
              {!!this && !!this.state && !!this.state.nudgePopupStateObj && !!this.state.nudgePopupStateObj.crm && !!this.state.nudgePopupStateObj.crm.shouldPop && !!this.state.showCrmNudgePopup ? (
                <div className="crm-promotion p-3" id="crm">
                  <div className="background-image mb-4 d-flex justify-content-center align-items-center">
                    <img src={this.state.nudgePopupStateObj.crm.iconUrl} />
                  </div>
                  <div className="content my-4">
                    <h3>{this.state.nudgePopupStateObj.crm.header}</h3>
                    <span>{this.state.nudgePopupStateObj.crm.description}</span>
                  </div>
                  <hr />
                  <div className="d-flex justify-content-between align-items-center">
                    <button type="button" className="d-flex justify-content-center align-items-center btn btn-secondary" onClick={() => this.handleNudgePopup("crm", "popup", "close")}>
                      Not Interested
                    </button>
                    <button type="button" className="d-flex justify-content-center align-items-center btn btn-primary trademo-new-btn" onClick={() => this.showCrmListModal()}>
                      Get In Touch
                    </button>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <Modal className="crm-list" centered show={this.state.showCrmPopuList} onHide={() => this.setState({ showCrmListModal: false })} animation={false}>
                <Modal.Header>
                  <Modal.Title>Select the CRM you are interested in</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="row m-0 ">
                    <div className="custom-right-radio mx-3 d-flex flex-column">
                      {crmList.map((item) => (
                        <React.Fragment key={item}>
                          <div className="form-check px-3 my-2">
                            <input
                              className="form-check-input"
                              name={"crm-list"}
                              type="radio"
                              onChange={(event) =>
                                this.setState({
                                  currentSelectedCrm: event.target.value,
                                })
                              }
                              value={item}
                            />
                            <span className="pseudo-checkmark" />
                            <label className="form-check-label label-md-regular" htmlFor={"include"}>
                              {item}
                            </label>
                          </div>
                          {!!this && !!this.state && !!this.state.currentSelectedCrm && this.state.currentSelectedCrm === "Other" && item === this.state.currentSelectedCrm ? (
                            <input
                              type="text"
                              className="manual-crm-input"
                              onChange={(event) => {
                                this.setState({
                                  currentSelectedCrmOther: event.target.value,
                                });
                              }}
                              placeholder="Please enter your choice of CRM here"
                            />
                          ) : (
                            <></>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <div className="col-4 p-0 m-0 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-outline-secondary trademo-outline-btn btn-sm mr-2"
                      onClick={() =>
                        this.setState({
                          showCrmPopuList: false,
                          currentSelectedCrm: "",
                          currentSelectedCrmOther: "",
                        })
                      }>
                      Cancel
                    </button>
                    <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={() => this.callConfirmGetInTouch(this.state.currentSelectedCrm === "Other" ? this.state.currentSelectedCrmOther : this.state.currentSelectedCrm)} disabled={!!this.state.currentSelectedCrm && this.state.currentSelectedCrm === "Other" && !!this.state.currentSelectedCrmOther ? false : this.state.currentSelectedCrm !== "Other" && !!this.state.currentSelectedCrm ? false : true}>
                      Confirm
                    </button>
                  </div>
                </Modal.Footer>
              </Modal>
            </div>
          </IntelLayout>
        </ContextData.Provider>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { userDetails, shipmentDetails } = state;
  return { userDetails: userDetails, shipmentDetails: shipmentDetails, redirectionIdsArr: userDetails?.redirectionIdsArr ?? [] };
}
const mapDispatchToProps = {
  getCreditsByPlan: () => getCreditsByPlanHandler(),
  getUserProfile: (data) => getUserProfileHandler(data),
  getSidebarCount: () => getSidebarCountData(),
  appliedSelectAllDataSource: (data) => appliedSelectAllHandler(data),
  setRedirectionIdsArrayHandler: (data) => setRedirectionIdsArrayHandler(data),
  filterObjectHandler,
  appliedFilterHandler,
  selectedFilterListHandler,
  filterLoaderHandler,
  filterMustNotHandler,
  shipmentsCachingHandler,
  importerCachingHandler,
  exporterCachingHandler,
  logisticsCachingHandler,
  analyticsCachingData,
  resetCachingData,
  analyticsDashletConfig,
  selectedAnalyticsDashlet,
  searchParametersHandler,
  dateParametersHandler,
  planDetailsHandler,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Shipments));
